!(function (t) {
  var e = {};
  function i(a) {
    if (e[a]) return e[a].exports;
    var n = (e[a] = { i: a, l: !1, exports: {} });
    return t[a].call(n.exports, n, n.exports, i), (n.l = !0), n.exports;
  }
  (i.m = t),
    (i.c = e),
    (i.d = function (t, e, a) {
      i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: a });
    }),
    (i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (i.t = function (t, e) {
      if ((1 & e && (t = i(t)), 8 & e)) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var a = Object.create(null);
      if ((i.r(a), Object.defineProperty(a, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
        for (var n in t)
          i.d(
            a,
            n,
            function (e) {
              return t[e];
            }.bind(null, n)
          );
      return a;
    }),
    (i.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return i.d(e, "a", e), e;
    }),
    (i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (i.p = ""),
    i((i.s = 17));
})([
  function (t, e) {
    (t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    function i(t, e) {
      for (var i = 0; i < e.length; i++) {
        var a = e[i];
        (a.enumerable = a.enumerable || !1), (a.configurable = !0), "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
      }
    }
    (t.exports = function (t, e, a) {
      return e && i(t.prototype, e), a && i(t, a), t;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    function i(e) {
      return (
        (t.exports = i = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        (t.exports.default = t.exports),
        (t.exports.__esModule = !0),
        i(e)
      );
    }
    (t.exports = i), (t.exports.default = t.exports), (t.exports.__esModule = !0);
  },
  function (t, e, i) {
    var a = i(22);
    (t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), e && a(t, e);
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, i) {
    var a = i(5).default,
      n = i(23);
    (t.exports = function (t, e) {
      return !e || ("object" !== a(e) && "function" != typeof e) ? n(t) : e;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e) {
    function i(e) {
      "@babel/helpers - typeof";
      return (
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? ((t.exports = i = function (t) {
              return typeof t;
            }),
            (t.exports.default = t.exports),
            (t.exports.__esModule = !0))
          : ((t.exports = i = function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }),
            (t.exports.default = t.exports),
            (t.exports.__esModule = !0)),
        i(e)
      );
    }
    (t.exports = i), (t.exports.default = t.exports), (t.exports.__esModule = !0);
  },
  function (t, e, i) {
    var a, n;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */ !(function (r) {
      if ((void 0 === (n = "function" == typeof (a = r) ? a.call(e, i, e, t) : a) || (t.exports = n), !0, (t.exports = r()), !!0)) {
        var s = window.Cookies,
          o = (window.Cookies = r());
        o.noConflict = function () {
          return (window.Cookies = s), o;
        };
      }
    })(function () {
      function t() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
          var i = arguments[t];
          for (var a in i) e[a] = i[a];
        }
        return e;
      }
      function e(t) {
        return t.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      return (function i(a) {
        function n() {}
        function r(e, i, r) {
          if ("undefined" != typeof document) {
            "number" == typeof (r = t({ path: "/" }, n.defaults, r)).expires && (r.expires = new Date(1 * new Date() + 864e5 * r.expires)), (r.expires = r.expires ? r.expires.toUTCString() : "");
            try {
              var s = JSON.stringify(i);
              /^[\{\[]/.test(s) && (i = s);
            } catch (t) {}
            (i = a.write ? a.write(i, e) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
              (e = encodeURIComponent(String(e))
                .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                .replace(/[\(\)]/g, escape));
            var o = "";
            for (var l in r) r[l] && ((o += "; " + l), !0 !== r[l] && (o += "=" + r[l].split(";")[0]));
            return (document.cookie = e + "=" + i + o);
          }
        }
        function s(t, i) {
          if ("undefined" != typeof document) {
            for (var n = {}, r = document.cookie ? document.cookie.split("; ") : [], s = 0; s < r.length; s++) {
              var o = r[s].split("="),
                l = o.slice(1).join("=");
              i || '"' !== l.charAt(0) || (l = l.slice(1, -1));
              try {
                var c = e(o[0]);
                if (((l = (a.read || a)(l, c) || e(l)), i))
                  try {
                    l = JSON.parse(l);
                  } catch (t) {}
                if (((n[c] = l), t === c)) break;
              } catch (t) {}
            }
            return t ? n[t] : n;
          }
        }
        return (
          (n.set = r),
          (n.get = function (t) {
            return s(t, !1);
          }),
          (n.getJSON = function (t) {
            return s(t, !0);
          }),
          (n.remove = function (e, i) {
            r(e, "", t(i, { expires: -1 }));
          }),
          (n.defaults = {}),
          (n.withConverter = i),
          n
        );
      })(function () {});
    });
  },
  function (t, e) {
    var i = /^(?:submit|button|image|reset|file)$/i,
      a = /^(?:input|select|textarea|keygen)/i,
      n = /(\[[^\[\]]*\])/g;
    function r(t, e, i) {
      if (e.match(n)) {
        !(function t(e, i, a) {
          if (0 === i.length) return (e = a);
          var n = i.shift(),
            r = n.match(/^\[(.+?)\]$/);
          if ("[]" === n) return (e = e || []), Array.isArray(e) ? e.push(t(null, i, a)) : ((e._values = e._values || []), e._values.push(t(null, i, a))), e;
          if (r) {
            var s = r[1],
              o = +s;
            isNaN(o) ? ((e = e || {})[s] = t(e[s], i, a)) : ((e = e || [])[o] = t(e[o], i, a));
          } else e[n] = t(e[n], i, a);
          return e;
        })(
          t,
          (function (t) {
            var e = [],
              i = new RegExp(n),
              a = /^([^\[\]]*)/.exec(t);
            for (a[1] && e.push(a[1]); null !== (a = i.exec(t)); ) e.push(a[1]);
            return e;
          })(e),
          i
        );
      } else {
        var a = t[e];
        a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(i)) : (t[e] = i);
      }
      return t;
    }
    function s(t, e, i) {
      return (i = i.replace(/(\r)?\n/g, "\r\n")), (i = (i = encodeURIComponent(i)).replace(/%20/g, "+")), t + (t ? "&" : "") + encodeURIComponent(e) + "=" + i;
    }
    t.exports = function (t, e) {
      "object" != typeof e ? (e = { hash: !!e }) : void 0 === e.hash && (e.hash = !0);
      for (var n = e.hash ? {} : "", o = e.serializer || (e.hash ? r : s), l = t && t.elements ? t.elements : [], c = Object.create(null), h = 0; h < l.length; ++h) {
        var u = l[h];
        if ((e.disabled || !u.disabled) && u.name && a.test(u.nodeName) && !i.test(u.type)) {
          var d = u.name,
            p = u.value;
          if ((("checkbox" !== u.type && "radio" !== u.type) || u.checked || (p = void 0), e.empty)) {
            if (("checkbox" !== u.type || u.checked || (p = ""), "radio" === u.type && (c[u.name] || u.checked ? u.checked && (c[u.name] = !0) : (c[u.name] = !1)), void 0 == p && "radio" == u.type)) continue;
          } else if (!p) continue;
          if ("select-multiple" !== u.type) n = o(n, d, p);
          else {
            p = [];
            for (var f = u.options, m = !1, g = 0; g < f.length; ++g) {
              var y = f[g],
                v = e.empty && !y.value,
                A = y.value || v;
              y.selected && A && ((m = !0), (n = e.hash && "[]" !== d.slice(d.length - 2) ? o(n, d + "[]", y.value) : o(n, d, y.value)));
            }
            !m && e.empty && (n = o(n, d, ""));
          }
        }
      }
      if (e.empty) for (var d in c) c[d] || (n = o(n, d, ""));
      return n;
    };
  },
  function (t, e, i) {
    var a, n;
    "undefined" != typeof navigator &&
      ((n = window || {}),
      void 0 ===
        (a = function () {
          return (function (t) {
            "use strict";
            var e,
              i = "http://www.w3.org/2000/svg",
              a = "",
              n = -999999,
              r = !0,
              s = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
              o = Math.pow,
              l = Math.sqrt,
              c = Math.floor,
              h = (Math.max, Math.min),
              u = {};
            !(function () {
              var t,
                e = [
                  "abs",
                  "acos",
                  "acosh",
                  "asin",
                  "asinh",
                  "atan",
                  "atanh",
                  "atan2",
                  "ceil",
                  "cbrt",
                  "expm1",
                  "clz32",
                  "cos",
                  "cosh",
                  "exp",
                  "floor",
                  "fround",
                  "hypot",
                  "imul",
                  "log",
                  "log1p",
                  "log2",
                  "log10",
                  "max",
                  "min",
                  "pow",
                  "random",
                  "round",
                  "sign",
                  "sin",
                  "sinh",
                  "sqrt",
                  "tan",
                  "tanh",
                  "trunc",
                  "E",
                  "LN10",
                  "LN2",
                  "LOG10E",
                  "LOG2E",
                  "PI",
                  "SQRT1_2",
                  "SQRT2",
                ],
                i = e.length;
              for (t = 0; t < i; t += 1) u[e[t]] = Math[e[t]];
            })(),
              (u.random = Math.random),
              (u.abs = function (t) {
                if ("object" == typeof t && t.length) {
                  var e,
                    i = P(t.length),
                    a = t.length;
                  for (e = 0; e < a; e += 1) i[e] = Math.abs(t[e]);
                  return i;
                }
                return Math.abs(t);
              });
            var d = 150,
              p = Math.PI / 180,
              f = 0.5519;
            function m(t) {
              t && Math.round;
            }
            function g(t, e, i, a) {
              (this.type = t), (this.currentTime = e), (this.totalTime = i), (this.direction = a < 0 ? -1 : 1);
            }
            function y(t, e) {
              (this.type = t), (this.direction = e < 0 ? -1 : 1);
            }
            function v(t, e, i, a) {
              (this.type = t), (this.currentLoop = i), (this.totalLoops = e), (this.direction = a < 0 ? -1 : 1);
            }
            function A(t, e, i) {
              (this.type = t), (this.firstFrame = e), (this.totalFrames = i);
            }
            function b(t, e) {
              (this.type = t), (this.target = e);
            }
            m(!1);
            var w,
              C =
                ((w = 0),
                function () {
                  return "__lottie_element_" + (w += 1);
                });
            function S(t, e, i) {
              var a, n, r, s, o, l, c, h;
              switch (((l = i * (1 - e)), (c = i * (1 - (o = 6 * t - (s = Math.floor(6 * t))) * e)), (h = i * (1 - (1 - o) * e)), s % 6)) {
                case 0:
                  (a = i), (n = h), (r = l);
                  break;
                case 1:
                  (a = c), (n = i), (r = l);
                  break;
                case 2:
                  (a = l), (n = i), (r = h);
                  break;
                case 3:
                  (a = l), (n = c), (r = i);
                  break;
                case 4:
                  (a = h), (n = l), (r = i);
                  break;
                case 5:
                  (a = i), (n = l), (r = c);
              }
              return [a, n, r];
            }
            function k(t, e, i) {
              var a,
                n = Math.max(t, e, i),
                r = Math.min(t, e, i),
                s = n - r,
                o = 0 === n ? 0 : s / n,
                l = n / 255;
              switch (n) {
                case r:
                  a = 0;
                  break;
                case t:
                  (a = e - i + s * (e < i ? 6 : 0)), (a /= 6 * s);
                  break;
                case e:
                  (a = i - t + 2 * s), (a /= 6 * s);
                  break;
                case i:
                  (a = t - e + 4 * s), (a /= 6 * s);
              }
              return [a, o, l];
            }
            function E(t, e) {
              var i = k(255 * t[0], 255 * t[1], 255 * t[2]);
              return (i[1] += e), 1 < i[1] ? (i[1] = 1) : i[1] <= 0 && (i[1] = 0), S(i[0], i[1], i[2]);
            }
            function x(t, e) {
              var i = k(255 * t[0], 255 * t[1], 255 * t[2]);
              return (i[2] += e), 1 < i[2] ? (i[2] = 1) : i[2] < 0 && (i[2] = 0), S(i[0], i[1], i[2]);
            }
            function _(t, e) {
              var i = k(255 * t[0], 255 * t[1], 255 * t[2]);
              return (i[0] += e / 360), 1 < i[0] ? (i[0] -= 1) : i[0] < 0 && (i[0] += 1), S(i[0], i[1], i[2]);
            }
            function T() {}
            !(function () {
              var t,
                e,
                i = [];
              for (t = 0; t < 256; t += 1) (e = t.toString(16)), (i[t] = 1 === e.length ? "0" + e : e);
            })(),
              (T.prototype = {
                triggerEvent: function (t, e) {
                  if (this._cbs[t]) for (var i = this._cbs[t].length, a = 0; a < i; a += 1) this._cbs[t][a](e);
                },
                addEventListener: function (t, e) {
                  return (
                    this._cbs[t] || (this._cbs[t] = []),
                    this._cbs[t].push(e),
                    function () {
                      this.removeEventListener(t, e);
                    }.bind(this)
                  );
                },
                removeEventListener: function (t, e) {
                  if (e) {
                    if (this._cbs[t]) {
                      for (var i = 0, a = this._cbs[t].length; i < a; ) this._cbs[t][i] === e && (this._cbs[t].splice(i, 1), (i -= 1), (a -= 1)), (i += 1);
                      this._cbs[t].length || (this._cbs[t] = null);
                    }
                  } else this._cbs[t] = null;
                },
              });
            var M = (function () {
              function t(t, e) {
                var i,
                  a = 0,
                  n = [];
                switch (t) {
                  case "int16":
                  case "uint8c":
                    i = 1;
                    break;
                  default:
                    i = 1.1;
                }
                for (a = 0; a < e; a += 1) n.push(i);
                return n;
              }
              return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array
                ? function (e, i) {
                    return "float32" === e ? new Float32Array(i) : "int16" === e ? new Int16Array(i) : "uint8c" === e ? new Uint8ClampedArray(i) : t(e, i);
                  }
                : t;
            })();
            function P(t) {
              return Array.apply(null, { length: t });
            }
            function D(t) {
              return document.createElementNS(i, t);
            }
            function I(t) {
              return document.createElement(t);
            }
            function L() {}
            L.prototype = {
              addDynamicProperty: function (t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), (this._isAnimated = !0));
              },
              iterateDynamicProperties: function () {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for (t = 0; t < e; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
              },
              initDynamicPropertyContainer: function (t) {
                (this.container = t), (this.dynamicProperties = []), (this._mdf = !1), (this._isAnimated = !1);
              },
            };
            var R,
              F =
                ((R = {
                  0: "source-over",
                  1: "multiply",
                  2: "screen",
                  3: "overlay",
                  4: "darken",
                  5: "lighten",
                  6: "color-dodge",
                  7: "color-burn",
                  8: "hard-light",
                  9: "soft-light",
                  10: "difference",
                  11: "exclusion",
                  12: "hue",
                  13: "saturation",
                  14: "color",
                  15: "luminosity",
                }),
                function (t) {
                  return R[t] || "";
                }),
              O = (function () {
                var t = Math.cos,
                  e = Math.sin,
                  i = Math.tan,
                  a = Math.round;
                function n() {
                  return (
                    (this.props[0] = 1),
                    (this.props[1] = 0),
                    (this.props[2] = 0),
                    (this.props[3] = 0),
                    (this.props[4] = 0),
                    (this.props[5] = 1),
                    (this.props[6] = 0),
                    (this.props[7] = 0),
                    (this.props[8] = 0),
                    (this.props[9] = 0),
                    (this.props[10] = 1),
                    (this.props[11] = 0),
                    (this.props[12] = 0),
                    (this.props[13] = 0),
                    (this.props[14] = 0),
                    (this.props[15] = 1),
                    this
                  );
                }
                function r(i) {
                  if (0 === i) return this;
                  var a = t(i),
                    n = e(i);
                  return this._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function s(i) {
                  if (0 === i) return this;
                  var a = t(i),
                    n = e(i);
                  return this._t(1, 0, 0, 0, 0, a, -n, 0, 0, n, a, 0, 0, 0, 0, 1);
                }
                function o(i) {
                  if (0 === i) return this;
                  var a = t(i),
                    n = e(i);
                  return this._t(a, 0, n, 0, 0, 1, 0, 0, -n, 0, a, 0, 0, 0, 0, 1);
                }
                function l(i) {
                  if (0 === i) return this;
                  var a = t(i),
                    n = e(i);
                  return this._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function c(t, e) {
                  return this._t(1, e, t, 1, 0, 0);
                }
                function h(t, e) {
                  return this.shear(i(t), i(e));
                }
                function u(a, n) {
                  var r = t(n),
                    s = e(n);
                  return this._t(r, s, 0, 0, -s, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, i(a), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(r, -s, 0, 0, s, r, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                }
                function d(t, e, i) {
                  return i || 0 === i || (i = 1), 1 === t && 1 === e && 1 === i ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, i, 0, 0, 0, 0, 1);
                }
                function p(t, e, i, a, n, r, s, o, l, c, h, u, d, p, f, m) {
                  return (
                    (this.props[0] = t),
                    (this.props[1] = e),
                    (this.props[2] = i),
                    (this.props[3] = a),
                    (this.props[4] = n),
                    (this.props[5] = r),
                    (this.props[6] = s),
                    (this.props[7] = o),
                    (this.props[8] = l),
                    (this.props[9] = c),
                    (this.props[10] = h),
                    (this.props[11] = u),
                    (this.props[12] = d),
                    (this.props[13] = p),
                    (this.props[14] = f),
                    (this.props[15] = m),
                    this
                  );
                }
                function f(t, e, i) {
                  return (i = i || 0), 0 !== t || 0 !== e || 0 !== i ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, i, 1) : this;
                }
                function m(t, e, i, a, n, r, s, o, l, c, h, u, d, p, f, m) {
                  var g = this.props;
                  if (1 === t && 0 === e && 0 === i && 0 === a && 0 === n && 1 === r && 0 === s && 0 === o && 0 === l && 0 === c && 1 === h && 0 === u)
                    return (g[12] = g[12] * t + g[15] * d), (g[13] = g[13] * r + g[15] * p), (g[14] = g[14] * h + g[15] * f), (g[15] *= m), (this._identityCalculated = !1), this;
                  var y = g[0],
                    v = g[1],
                    A = g[2],
                    b = g[3],
                    w = g[4],
                    C = g[5],
                    S = g[6],
                    k = g[7],
                    E = g[8],
                    x = g[9],
                    _ = g[10],
                    T = g[11],
                    M = g[12],
                    P = g[13],
                    D = g[14],
                    I = g[15];
                  return (
                    (g[0] = y * t + v * n + A * l + b * d),
                    (g[1] = y * e + v * r + A * c + b * p),
                    (g[2] = y * i + v * s + A * h + b * f),
                    (g[3] = y * a + v * o + A * u + b * m),
                    (g[4] = w * t + C * n + S * l + k * d),
                    (g[5] = w * e + C * r + S * c + k * p),
                    (g[6] = w * i + C * s + S * h + k * f),
                    (g[7] = w * a + C * o + S * u + k * m),
                    (g[8] = E * t + x * n + _ * l + T * d),
                    (g[9] = E * e + x * r + _ * c + T * p),
                    (g[10] = E * i + x * s + _ * h + T * f),
                    (g[11] = E * a + x * o + _ * u + T * m),
                    (g[12] = M * t + P * n + D * l + I * d),
                    (g[13] = M * e + P * r + D * c + I * p),
                    (g[14] = M * i + P * s + D * h + I * f),
                    (g[15] = M * a + P * o + D * u + I * m),
                    (this._identityCalculated = !1),
                    this
                  );
                }
                function g() {
                  return (
                    this._identityCalculated ||
                      ((this._identity = !(
                        1 !== this.props[0] ||
                        0 !== this.props[1] ||
                        0 !== this.props[2] ||
                        0 !== this.props[3] ||
                        0 !== this.props[4] ||
                        1 !== this.props[5] ||
                        0 !== this.props[6] ||
                        0 !== this.props[7] ||
                        0 !== this.props[8] ||
                        0 !== this.props[9] ||
                        1 !== this.props[10] ||
                        0 !== this.props[11] ||
                        0 !== this.props[12] ||
                        0 !== this.props[13] ||
                        0 !== this.props[14] ||
                        1 !== this.props[15]
                      )),
                      (this._identityCalculated = !0)),
                    this._identity
                  );
                }
                function y(t) {
                  for (var e = 0; e < 16; ) {
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                  }
                  return !0;
                }
                function v(t) {
                  var e;
                  for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
                  return t;
                }
                function A(t) {
                  var e;
                  for (e = 0; e < 16; e += 1) this.props[e] = t[e];
                }
                function b(t, e, i) {
                  return {
                    x: t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14],
                  };
                }
                function w(t, e, i) {
                  return t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12];
                }
                function C(t, e, i) {
                  return t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13];
                }
                function S(t, e, i) {
                  return t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14];
                }
                function k() {
                  var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
                    e = this.props[5] / t,
                    i = -this.props[1] / t,
                    a = -this.props[4] / t,
                    n = this.props[0] / t,
                    r = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
                    s = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
                    o = new O();
                  return (o.props[0] = e), (o.props[1] = i), (o.props[4] = a), (o.props[5] = n), (o.props[12] = r), (o.props[13] = s), o;
                }
                function E(t) {
                  return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
                }
                function x(t) {
                  var e,
                    i = t.length,
                    a = [];
                  for (e = 0; e < i; e += 1) a[e] = E(t[e]);
                  return a;
                }
                function _(t, e, i) {
                  var a = M("float32", 6);
                  if (this.isIdentity()) (a[0] = t[0]), (a[1] = t[1]), (a[2] = e[0]), (a[3] = e[1]), (a[4] = i[0]), (a[5] = i[1]);
                  else {
                    var n = this.props[0],
                      r = this.props[1],
                      s = this.props[4],
                      o = this.props[5],
                      l = this.props[12],
                      c = this.props[13];
                    (a[0] = t[0] * n + t[1] * s + l), (a[1] = t[0] * r + t[1] * o + c), (a[2] = e[0] * n + e[1] * s + l), (a[3] = e[0] * r + e[1] * o + c), (a[4] = i[0] * n + i[1] * s + l), (a[5] = i[0] * r + i[1] * o + c);
                  }
                  return a;
                }
                function T(t, e, i) {
                  return this.isIdentity()
                    ? [t, e, i]
                    : [
                        t * this.props[0] + e * this.props[4] + i * this.props[8] + this.props[12],
                        t * this.props[1] + e * this.props[5] + i * this.props[9] + this.props[13],
                        t * this.props[2] + e * this.props[6] + i * this.props[10] + this.props[14],
                      ];
                }
                function P(t, e) {
                  if (this.isIdentity()) return t + "," + e;
                  var i = this.props;
                  return Math.round(100 * (t * i[0] + e * i[4] + i[12])) / 100 + "," + Math.round(100 * (t * i[1] + e * i[5] + i[13])) / 100;
                }
                function D() {
                  for (var t = 0, e = this.props, i = "matrix3d("; t < 16; ) (i += a(1e4 * e[t]) / 1e4), (i += 15 === t ? ")" : ","), (t += 1);
                  return i;
                }
                function I(t) {
                  return (t < 1e-6 && 0 < t) || (-1e-6 < t && t < 0) ? a(1e4 * t) / 1e4 : t;
                }
                function L() {
                  var t = this.props;
                  return "matrix(" + I(t[0]) + "," + I(t[1]) + "," + I(t[4]) + "," + I(t[5]) + "," + I(t[12]) + "," + I(t[13]) + ")";
                }
                return function () {
                  (this.reset = n),
                    (this.rotate = r),
                    (this.rotateX = s),
                    (this.rotateY = o),
                    (this.rotateZ = l),
                    (this.skew = h),
                    (this.skewFromAxis = u),
                    (this.shear = c),
                    (this.scale = d),
                    (this.setTransform = p),
                    (this.translate = f),
                    (this.transform = m),
                    (this.applyToPoint = b),
                    (this.applyToX = w),
                    (this.applyToY = C),
                    (this.applyToZ = S),
                    (this.applyToPointArray = T),
                    (this.applyToTriplePoints = _),
                    (this.applyToPointStringified = P),
                    (this.toCSS = D),
                    (this.to2dCSS = L),
                    (this.clone = v),
                    (this.cloneFromProps = A),
                    (this.equals = y),
                    (this.inversePoints = x),
                    (this.inversePoint = E),
                    (this.getInverseMatrix = k),
                    (this._t = this.transform),
                    (this.isIdentity = g),
                    (this._identity = !0),
                    (this._identityCalculated = !1),
                    (this.props = M("float32", 16)),
                    this.reset();
                };
              })();
            !(function (t, e) {
              var i = this,
                a = 256,
                n = "random",
                r = e.pow(a, 6),
                s = e.pow(2, 52),
                o = 2 * s,
                l = a - 1;
              function c(t, e) {
                return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
              }
              function h(t, e) {
                for (var i, a = t + "", n = 0; n < a.length; ) e[l & n] = l & ((i ^= 19 * e[l & n]) + a.charCodeAt(n++));
                return u(e);
              }
              function u(t) {
                return String.fromCharCode.apply(0, t);
              }
              (e["seed" + n] = function (d, p, f) {
                var m = [],
                  g = h(
                    (function t(e, i) {
                      var a,
                        n = [],
                        r = typeof e;
                      if (i && "object" == r)
                        for (a in e)
                          try {
                            n.push(t(e[a], i - 1));
                          } catch (t) {}
                      return n.length ? n : "string" == r ? e : e + "\0";
                    })(
                      (p = !0 === p ? { entropy: !0 } : p || {}).entropy
                        ? [d, u(t)]
                        : null === d
                        ? (function () {
                            try {
                              var e = new Uint8Array(a);
                              return (i.crypto || i.msCrypto).getRandomValues(e), u(e);
                            } catch (e) {
                              var n = i.navigator,
                                r = n && n.plugins;
                              return [+new Date(), i, r, i.screen, u(t)];
                            }
                          })()
                        : d,
                      3
                    ),
                    m
                  ),
                  y = new (function (t) {
                    var e,
                      i = t.length,
                      n = this,
                      r = 0,
                      s = (n.i = n.j = 0),
                      o = (n.S = []);
                    for (i || (t = [i++]); r < a; ) o[r] = r++;
                    for (r = 0; r < a; r++) (o[r] = o[(s = l & (s + t[r % i] + (e = o[r])))]), (o[s] = e);
                    n.g = function (t) {
                      for (var e, i = 0, r = n.i, s = n.j, o = n.S; t--; ) (e = o[(r = l & (r + 1))]), (i = i * a + o[l & ((o[r] = o[(s = l & (s + e))]) + (o[s] = e))]);
                      return (n.i = r), (n.j = s), i;
                    };
                  })(m),
                  v = function () {
                    for (var t = y.g(6), e = r, i = 0; t < s; ) (t = (t + i) * a), (e *= a), (i = y.g(1));
                    for (; o <= t; ) (t /= 2), (e /= 2), (i >>>= 1);
                    return (t + i) / e;
                  };
                return (
                  (v.int32 = function () {
                    return 0 | y.g(4);
                  }),
                  (v.quick = function () {
                    return y.g(4) / 4294967296;
                  }),
                  (v.double = v),
                  h(u(y.S), t),
                  (
                    p.pass ||
                    f ||
                    function (t, i, a, r) {
                      return (
                        r &&
                          (r.S && c(r, y),
                          (t.state = function () {
                            return c(y, {});
                          })),
                        a ? ((e[n] = t), i) : t
                      );
                    }
                  )(v, g, "global" in p ? p.global : this == e, p.state)
                );
              }),
                h(e.random(), t);
            })([], u);
            var B = (function () {
              var t = {
                  getBezierEasing: function (t, i, a, n, r) {
                    var s = r || ("bez_" + t + "_" + i + "_" + a + "_" + n).replace(/\./g, "p");
                    if (e[s]) return e[s];
                    var o = new h([t, i, a, n]);
                    return (e[s] = o);
                  },
                },
                e = {},
                i = 11,
                a = 1 / (i - 1),
                n = "function" == typeof Float32Array;
              function r(t, e) {
                return 1 - 3 * e + 3 * t;
              }
              function s(t, e) {
                return 3 * e - 6 * t;
              }
              function o(t) {
                return 3 * t;
              }
              function l(t, e, i) {
                return ((r(e, i) * t + s(e, i)) * t + o(e)) * t;
              }
              function c(t, e, i) {
                return 3 * r(e, i) * t * t + 2 * s(e, i) * t + o(e);
              }
              function h(t) {
                (this._p = t), (this._mSampleValues = n ? new Float32Array(i) : new Array(i)), (this._precomputed = !1), (this.get = this.get.bind(this));
              }
              return (
                (h.prototype = {
                  get: function (t) {
                    var e = this._p[0],
                      i = this._p[1],
                      a = this._p[2],
                      n = this._p[3];
                    return this._precomputed || this._precompute(), e === i && a === n ? t : 0 === t ? 0 : 1 === t ? 1 : l(this._getTForX(t), i, n);
                  },
                  _precompute: function () {
                    var t = this._p[0],
                      e = this._p[1],
                      i = this._p[2],
                      a = this._p[3];
                    (this._precomputed = !0), (t === e && i === a) || this._calcSampleValues();
                  },
                  _calcSampleValues: function () {
                    for (var t = this._p[0], e = this._p[2], n = 0; n < i; ++n) this._mSampleValues[n] = l(n * a, t, e);
                  },
                  _getTForX: function (t) {
                    for (var e = this._p[0], n = this._p[2], r = this._mSampleValues, s = 0, o = 1, h = i - 1; o !== h && r[o] <= t; ++o) s += a;
                    var u = s + ((t - r[--o]) / (r[o + 1] - r[o])) * a,
                      d = c(u, e, n);
                    return 0.001 <= d
                      ? (function (t, e, i, a) {
                          for (var n = 0; n < 4; ++n) {
                            var r = c(e, i, a);
                            if (0 === r) return e;
                            e -= (l(e, i, a) - t) / r;
                          }
                          return e;
                        })(t, u, e, n)
                      : 0 === d
                      ? u
                      : (function (t, e, i, a, n) {
                          for (var r, s, o = 0; 0 < (r = l((s = e + (i - e) / 2), a, n) - t) ? (i = s) : (e = s), 1e-7 < Math.abs(r) && ++o < 10; );
                          return s;
                        })(t, s, s + a, e, n);
                  },
                }),
                t
              );
            })();
            function q(t, e) {
              var i,
                a,
                n = t.length;
              for (i = 0; i < n; i += 1) for (var r in (a = t[i].prototype)) Object.prototype.hasOwnProperty.call(a, r) && (e.prototype[r] = a[r]);
            }
            !(function () {
              for (var e = 0, i = ["ms", "moz", "webkit", "o"], a = 0; a < i.length && !t.requestAnimationFrame; ++a)
                (t.requestAnimationFrame = t[i[a] + "RequestAnimationFrame"]), (t.cancelAnimationFrame = t[i[a] + "CancelAnimationFrame"] || t[i[a] + "CancelRequestAnimationFrame"]);
              t.requestAnimationFrame ||
                (t.requestAnimationFrame = function (t) {
                  var i = new Date().getTime(),
                    a = Math.max(0, 16 - (i - e)),
                    n = setTimeout(function () {
                      t(i + a);
                    }, a);
                  return (e = i + a), n;
                }),
                t.cancelAnimationFrame ||
                  (t.cancelAnimationFrame = function (t) {
                    clearTimeout(t);
                  });
            })();
            var N = (function () {
                var t = Math;
                function e(t, e, i, a, n, r) {
                  var s = t * a + e * n + i * r - n * a - r * t - i * e;
                  return -0.001 < s && s < 0.001;
                }
                var i = function (t, e, i, a) {
                  var n,
                    r,
                    s,
                    c,
                    h,
                    u,
                    p = d,
                    f = 0,
                    m = [],
                    g = [],
                    y = Tt.newElement();
                  for (s = i.length, n = 0; n < p; n += 1) {
                    for (h = n / (p - 1), r = u = 0; r < s; r += 1) (c = o(1 - h, 3) * t[r] + 3 * o(1 - h, 2) * h * i[r] + 3 * (1 - h) * o(h, 2) * a[r] + o(h, 3) * e[r]), (m[r] = c), null !== g[r] && (u += o(m[r] - g[r], 2)), (g[r] = m[r]);
                    u && (f += u = l(u)), (y.percents[n] = h), (y.lengths[n] = f);
                  }
                  return (y.addedLength = f), y;
                };
                function a(t, e) {
                  (this.partialLength = t), (this.point = e);
                }
                var n,
                  r =
                    ((n = {}),
                    function (t, i, r, s) {
                      var c = (t[0] + "_" + t[1] + "_" + i[0] + "_" + i[1] + "_" + r[0] + "_" + r[1] + "_" + s[0] + "_" + s[1]).replace(/\./g, "p");
                      if (!n[c]) {
                        var h,
                          u,
                          p,
                          f,
                          m,
                          g,
                          y,
                          v = d,
                          A = 0,
                          b = null;
                        2 === t.length && (t[0] !== i[0] || t[1] !== i[1]) && e(t[0], t[1], i[0], i[1], t[0] + r[0], t[1] + r[1]) && e(t[0], t[1], i[0], i[1], i[0] + s[0], i[1] + s[1]) && (v = 2);
                        var w = new (function (t) {
                          (this.segmentLength = 0), (this.points = new Array(t));
                        })(v);
                        for (p = r.length, h = 0; h < v; h += 1) {
                          for (y = P(p), m = h / (v - 1), u = g = 0; u < p; u += 1)
                            (f = o(1 - m, 3) * t[u] + 3 * o(1 - m, 2) * m * (t[u] + r[u]) + 3 * (1 - m) * o(m, 2) * (i[u] + s[u]) + o(m, 3) * i[u]), (y[u] = f), null !== b && (g += o(y[u] - b[u], 2));
                          (A += g = l(g)), (w.points[h] = new a(g, y)), (b = y);
                        }
                        (w.segmentLength = A), (n[c] = w);
                      }
                      return n[c];
                    });
                function s(t, e) {
                  var i = e.percents,
                    a = e.lengths,
                    n = i.length,
                    r = c((n - 1) * t),
                    s = t * e.addedLength,
                    o = 0;
                  if (r === n - 1 || 0 === r || s === a[r]) return i[r];
                  for (var l = a[r] > s ? -1 : 1, h = !0; h; )
                    if ((a[r] <= s && a[r + 1] > s ? ((o = (s - a[r]) / (a[r + 1] - a[r])), (h = !1)) : (r += l), r < 0 || n - 1 <= r)) {
                      if (r === n - 1) return i[r];
                      h = !1;
                    }
                  return i[r] + (i[r + 1] - i[r]) * o;
                }
                var h = M("float32", 8);
                return {
                  getSegmentsLength: function (t) {
                    var e,
                      a = _t.newElement(),
                      n = t.c,
                      r = t.v,
                      s = t.o,
                      o = t.i,
                      l = t._length,
                      c = a.lengths,
                      h = 0;
                    for (e = 0; e < l - 1; e += 1) (c[e] = i(r[e], r[e + 1], s[e], o[e + 1])), (h += c[e].addedLength);
                    return n && l && ((c[e] = i(r[e], r[0], s[e], o[0])), (h += c[e].addedLength)), (a.totalLength = h), a;
                  },
                  getNewSegment: function (e, i, a, n, r, o, l) {
                    r < 0 ? (r = 0) : 1 < r && (r = 1);
                    var c,
                      u = s(r, l),
                      d = s((o = 1 < o ? 1 : o), l),
                      p = e.length,
                      f = 1 - u,
                      m = 1 - d,
                      g = f * f * f,
                      y = u * f * f * 3,
                      v = u * u * f * 3,
                      A = u * u * u,
                      b = f * f * m,
                      w = u * f * m + f * u * m + f * f * d,
                      C = u * u * m + f * u * d + u * f * d,
                      S = u * u * d,
                      k = f * m * m,
                      E = u * m * m + f * d * m + f * m * d,
                      x = u * d * m + f * d * d + u * m * d,
                      _ = u * d * d,
                      T = m * m * m,
                      M = d * m * m + m * d * m + m * m * d,
                      P = d * d * m + m * d * d + d * m * d,
                      D = d * d * d;
                    for (c = 0; c < p; c += 1)
                      (h[4 * c] = t.round(1e3 * (g * e[c] + y * a[c] + v * n[c] + A * i[c])) / 1e3),
                        (h[4 * c + 1] = t.round(1e3 * (b * e[c] + w * a[c] + C * n[c] + S * i[c])) / 1e3),
                        (h[4 * c + 2] = t.round(1e3 * (k * e[c] + E * a[c] + x * n[c] + _ * i[c])) / 1e3),
                        (h[4 * c + 3] = t.round(1e3 * (T * e[c] + M * a[c] + P * n[c] + D * i[c])) / 1e3);
                    return h;
                  },
                  getPointInSegment: function (e, i, a, n, r, o) {
                    var l = s(r, o),
                      c = 1 - l;
                    return [
                      t.round(1e3 * (c * c * c * e[0] + (l * c * c + c * l * c + c * c * l) * a[0] + (l * l * c + c * l * l + l * c * l) * n[0] + l * l * l * i[0])) / 1e3,
                      t.round(1e3 * (c * c * c * e[1] + (l * c * c + c * l * c + c * c * l) * a[1] + (l * l * c + c * l * l + l * c * l) * n[1] + l * l * l * i[1])) / 1e3,
                    ];
                  },
                  buildBezierData: r,
                  pointOnLine2D: e,
                  pointOnLine3D: function (i, a, n, r, s, o, l, c, h) {
                    if (0 === n && 0 === o && 0 === h) return e(i, a, r, s, l, c);
                    var u,
                      d = t.sqrt(t.pow(r - i, 2) + t.pow(s - a, 2) + t.pow(o - n, 2)),
                      p = t.sqrt(t.pow(l - i, 2) + t.pow(c - a, 2) + t.pow(h - n, 2)),
                      f = t.sqrt(t.pow(l - r, 2) + t.pow(c - s, 2) + t.pow(h - o, 2));
                    return -1e-4 < (u = p < d ? (f < d ? d - p - f : f - p - d) : p < f ? f - p - d : p - d - f) && u < 1e-4;
                  },
                };
              })(),
              V = (function () {
                function t(n, r, s) {
                  var o,
                    l,
                    c,
                    h,
                    u,
                    d,
                    p,
                    f = n.length;
                  for (l = 0; l < f; l += 1)
                    if ("ks" in (o = n[l]) && !o.completed) {
                      if (((o.completed = !0), o.tt && (n[l - 1].td = o.tt), o.hasMask)) {
                        var m = o.masksProperties;
                        for (h = m.length, c = 0; c < h; c += 1)
                          if (m[c].pt.k.i) a(m[c].pt.k);
                          else for (d = m[c].pt.k.length, u = 0; u < d; u += 1) m[c].pt.k[u].s && a(m[c].pt.k[u].s[0]), m[c].pt.k[u].e && a(m[c].pt.k[u].e[0]);
                      }
                      0 === o.ty ? ((o.layers = e(o.refId, r)), t(o.layers, r, s)) : 4 === o.ty ? i(o.shapes) : 5 === o.ty && (0 !== (p = o).t.a.length || "m" in p.t.p || (p.singleShape = !0));
                    }
                }
                function e(t, e) {
                  for (var i = 0, a = e.length; i < a; ) {
                    if (e[i].id === t) return e[i].layers.__used ? JSON.parse(JSON.stringify(e[i].layers)) : ((e[i].layers.__used = !0), e[i].layers);
                    i += 1;
                  }
                  return null;
                }
                function i(t) {
                  var e, n, r;
                  for (e = t.length - 1; 0 <= e; e -= 1)
                    if ("sh" === t[e].ty)
                      if (t[e].ks.k.i) a(t[e].ks.k);
                      else for (r = t[e].ks.k.length, n = 0; n < r; n += 1) t[e].ks.k[n].s && a(t[e].ks.k[n].s[0]), t[e].ks.k[n].e && a(t[e].ks.k[n].e[0]);
                    else "gr" === t[e].ty && i(t[e].it);
                }
                function a(t) {
                  var e,
                    i = t.i.length;
                  for (e = 0; e < i; e += 1) (t.i[e][0] += t.v[e][0]), (t.i[e][1] += t.v[e][1]), (t.o[e][0] += t.v[e][0]), (t.o[e][1] += t.v[e][1]);
                }
                function n(t, e) {
                  var i = e ? e.split(".") : [100, 100, 100];
                  return t[0] > i[0] || (!(i[0] > t[0]) && (t[1] > i[1] || (!(i[1] > t[1]) && (t[2] > i[2] || (!(i[2] > t[2]) && null)))));
                }
                var r,
                  s = (function () {
                    var t = [4, 4, 14];
                    function e(t) {
                      var e,
                        i,
                        a,
                        n = t.length;
                      for (e = 0; e < n; e += 1) 5 === t[e].ty && ((i = t[e]), (a = i.t.d), (i.t.d = { k: [{ s: a, t: 0 }] }));
                    }
                    return function (i) {
                      if (n(t, i.v) && (e(i.layers), i.assets)) {
                        var a,
                          r = i.assets.length;
                        for (a = 0; a < r; a += 1) i.assets[a].layers && e(i.assets[a].layers);
                      }
                    };
                  })(),
                  o =
                    ((r = [4, 7, 99]),
                    function (t) {
                      if (t.chars && !n(r, t.v)) {
                        var e,
                          i,
                          s,
                          o,
                          l,
                          c = t.chars.length;
                        for (e = 0; e < c; e += 1) if (t.chars[e].data && t.chars[e].data.shapes) for (s = (l = t.chars[e].data.shapes[0].it).length, i = 0; i < s; i += 1) (o = l[i].ks.k).__converted || (a(l[i].ks.k), (o.__converted = !0));
                      }
                    }),
                  l = (function () {
                    var t = [4, 1, 9];
                    function e(t) {
                      var i,
                        a,
                        n,
                        r = t.length;
                      for (i = 0; i < r; i += 1)
                        if ("gr" === t[i].ty) e(t[i].it);
                        else if ("fl" === t[i].ty || "st" === t[i].ty)
                          if (t[i].c.k && t[i].c.k[0].i)
                            for (n = t[i].c.k.length, a = 0; a < n; a += 1)
                              t[i].c.k[a].s && ((t[i].c.k[a].s[0] /= 255), (t[i].c.k[a].s[1] /= 255), (t[i].c.k[a].s[2] /= 255), (t[i].c.k[a].s[3] /= 255)),
                                t[i].c.k[a].e && ((t[i].c.k[a].e[0] /= 255), (t[i].c.k[a].e[1] /= 255), (t[i].c.k[a].e[2] /= 255), (t[i].c.k[a].e[3] /= 255));
                          else (t[i].c.k[0] /= 255), (t[i].c.k[1] /= 255), (t[i].c.k[2] /= 255), (t[i].c.k[3] /= 255);
                    }
                    function i(t) {
                      var i,
                        a = t.length;
                      for (i = 0; i < a; i += 1) 4 === t[i].ty && e(t[i].shapes);
                    }
                    return function (e) {
                      if (n(t, e.v) && (i(e.layers), e.assets)) {
                        var a,
                          r = e.assets.length;
                        for (a = 0; a < r; a += 1) e.assets[a].layers && i(e.assets[a].layers);
                      }
                    };
                  })(),
                  c = (function () {
                    var t = [4, 4, 18];
                    function e(t) {
                      var i, a, n;
                      for (i = t.length - 1; 0 <= i; i -= 1)
                        if ("sh" === t[i].ty)
                          if (t[i].ks.k.i) t[i].ks.k.c = t[i].closed;
                          else for (n = t[i].ks.k.length, a = 0; a < n; a += 1) t[i].ks.k[a].s && (t[i].ks.k[a].s[0].c = t[i].closed), t[i].ks.k[a].e && (t[i].ks.k[a].e[0].c = t[i].closed);
                        else "gr" === t[i].ty && e(t[i].it);
                    }
                    function i(t) {
                      var i,
                        a,
                        n,
                        r,
                        s,
                        o,
                        l = t.length;
                      for (a = 0; a < l; a += 1) {
                        if ((i = t[a]).hasMask) {
                          var c = i.masksProperties;
                          for (r = c.length, n = 0; n < r; n += 1)
                            if (c[n].pt.k.i) c[n].pt.k.c = c[n].cl;
                            else for (o = c[n].pt.k.length, s = 0; s < o; s += 1) c[n].pt.k[s].s && (c[n].pt.k[s].s[0].c = c[n].cl), c[n].pt.k[s].e && (c[n].pt.k[s].e[0].c = c[n].cl);
                        }
                        4 === i.ty && e(i.shapes);
                      }
                    }
                    return function (e) {
                      if (n(t, e.v) && (i(e.layers), e.assets)) {
                        var a,
                          r = e.assets.length;
                        for (a = 0; a < r; a += 1) e.assets[a].layers && i(e.assets[a].layers);
                      }
                    };
                  })(),
                  h = {
                    completeData: function (e, i) {
                      e.__complete || (l(e), s(e), o(e), c(e), t(e.layers, e.assets, i), (e.__complete = !0));
                    },
                  };
                return (h.checkColors = l), (h.checkChars = o), (h.checkShapes = c), (h.completeLayers = t), h;
              })();
            function W(t) {
              for (var e = t.fStyle ? t.fStyle.split(" ") : [], i = "normal", a = "normal", n = e.length, r = 0; r < n; r += 1)
                switch (e[r].toLowerCase()) {
                  case "italic":
                    a = "italic";
                    break;
                  case "bold":
                    i = "700";
                    break;
                  case "black":
                    i = "900";
                    break;
                  case "medium":
                    i = "500";
                    break;
                  case "regular":
                  case "normal":
                    i = "400";
                    break;
                  case "light":
                  case "thin":
                    i = "200";
                }
              return { style: a, weight: t.fWeight || i };
            }
            var U = (function () {
                var t = { w: 0, size: 0, shapes: [] },
                  e = [];
                function i(t, e) {
                  var i = I("span");
                  i.setAttribute("aria-hidden", !0), (i.style.fontFamily = e);
                  var a = I("span");
                  (a.innerText = "giItT1WQy@!-/#"),
                    (i.style.position = "absolute"),
                    (i.style.left = "-10000px"),
                    (i.style.top = "-10000px"),
                    (i.style.fontSize = "300px"),
                    (i.style.fontVariant = "normal"),
                    (i.style.fontStyle = "normal"),
                    (i.style.fontWeight = "normal"),
                    (i.style.letterSpacing = "0"),
                    i.appendChild(a),
                    document.body.appendChild(i);
                  var n = a.offsetWidth;
                  return (
                    (a.style.fontFamily =
                      (function (t) {
                        var e,
                          i = t.split(","),
                          a = i.length,
                          n = [];
                        for (e = 0; e < a; e += 1) "sans-serif" !== i[e] && "monospace" !== i[e] && n.push(i[e]);
                        return n.join(",");
                      })(t) +
                      ", " +
                      e),
                    { node: a, w: n, parent: i }
                  );
                }
                function a(t, e) {
                  var i = D("text");
                  i.style.fontSize = "100px";
                  var a = W(e);
                  return (
                    i.setAttribute("font-family", e.fFamily),
                    i.setAttribute("font-style", a.style),
                    i.setAttribute("font-weight", a.weight),
                    (i.textContent = "1"),
                    e.fClass ? ((i.style.fontFamily = "inherit"), i.setAttribute("class", e.fClass)) : (i.style.fontFamily = e.fFamily),
                    t.appendChild(i),
                    (I("canvas").getContext("2d").font = e.fWeight + " " + e.fStyle + " 100px " + e.fFamily),
                    i
                  );
                }
                e = e.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
                var n = function () {
                  (this.fonts = []),
                    (this.chars = null),
                    (this.typekitLoaded = 0),
                    (this.isLoaded = !1),
                    (this._warned = !1),
                    (this.initTime = Date.now()),
                    (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
                    (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
                };
                return (
                  (n.getCombinedCharacterCodes = function () {
                    return e;
                  }),
                  (n.prototype = {
                    addChars: function (t) {
                      if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var i,
                          a,
                          n = t.length,
                          r = this.chars.length;
                        for (e = 0; e < n; e += 1) {
                          for (i = 0, a = !1; i < r; ) this.chars[i].style === t[e].style && this.chars[i].fFamily === t[e].fFamily && this.chars[i].ch === t[e].ch && (a = !0), (i += 1);
                          a || (this.chars.push(t[e]), (r += 1));
                        }
                      }
                    },
                    addFonts: function (t, e) {
                      if (t) {
                        if (this.chars) return (this.isLoaded = !0), void (this.fonts = t.list);
                        var n,
                          r = t.list,
                          s = r.length,
                          o = s;
                        for (n = 0; n < s; n += 1) {
                          var l,
                            c,
                            h = !0;
                          if (((r[n].loaded = !1), (r[n].monoCase = i(r[n].fFamily, "monospace")), (r[n].sansCase = i(r[n].fFamily, "sans-serif")), r[n].fPath)) {
                            if ("p" === r[n].fOrigin || 3 === r[n].origin) {
                              if ((0 < (l = document.querySelectorAll('style[f-forigin="p"][f-family="' + r[n].fFamily + '"], style[f-origin="3"][f-family="' + r[n].fFamily + '"]')).length && (h = !1), h)) {
                                var u = I("style");
                                u.setAttribute("f-forigin", r[n].fOrigin),
                                  u.setAttribute("f-origin", r[n].origin),
                                  u.setAttribute("f-family", r[n].fFamily),
                                  (u.type = "text/css"),
                                  (u.innerText = "@font-face {font-family: " + r[n].fFamily + "; font-style: normal; src: url('" + r[n].fPath + "');}"),
                                  e.appendChild(u);
                              }
                            } else if ("g" === r[n].fOrigin || 1 === r[n].origin) {
                              for (l = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), c = 0; c < l.length; c += 1) -1 !== l[c].href.indexOf(r[n].fPath) && (h = !1);
                              if (h) {
                                var d = I("link");
                                d.setAttribute("f-forigin", r[n].fOrigin), d.setAttribute("f-origin", r[n].origin), (d.type = "text/css"), (d.rel = "stylesheet"), (d.href = r[n].fPath), document.body.appendChild(d);
                              }
                            } else if ("t" === r[n].fOrigin || 2 === r[n].origin) {
                              for (l = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), c = 0; c < l.length; c += 1) r[n].fPath === l[c].src && (h = !1);
                              if (h) {
                                var p = I("link");
                                p.setAttribute("f-forigin", r[n].fOrigin), p.setAttribute("f-origin", r[n].origin), p.setAttribute("rel", "stylesheet"), p.setAttribute("href", r[n].fPath), e.appendChild(p);
                              }
                            }
                          } else (r[n].loaded = !0), (o -= 1);
                          (r[n].helper = a(e, r[n])), (r[n].cache = {}), this.fonts.push(r[n]);
                        }
                        0 === o ? (this.isLoaded = !0) : setTimeout(this.checkLoadedFonts.bind(this), 100);
                      } else this.isLoaded = !0;
                    },
                    getCharData: function (e, i, a) {
                      for (var n = 0, r = this.chars.length; n < r; ) {
                        if (this.chars[n].ch === e && this.chars[n].style === i && this.chars[n].fFamily === a) return this.chars[n];
                        n += 1;
                      }
                      return (("string" == typeof e && 13 !== e.charCodeAt(0)) || !e) && console && console.warn && !this._warned && ((this._warned = !0), console.warn("Missing character from exported characters list: ", e, i, a)), t;
                    },
                    getFontByName: function (t) {
                      for (var e = 0, i = this.fonts.length; e < i; ) {
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                      }
                      return this.fonts[0];
                    },
                    measureText: function (t, e, i) {
                      var a = this.getFontByName(e),
                        n = t.charCodeAt(0);
                      if (!a.cache[n + 1]) {
                        var r = a.helper;
                        if (" " === t) {
                          r.textContent = "|" + t + "|";
                          var s = r.getComputedTextLength();
                          r.textContent = "||";
                          var o = r.getComputedTextLength();
                          a.cache[n + 1] = (s - o) / 100;
                        } else (r.textContent = t), (a.cache[n + 1] = r.getComputedTextLength() / 100);
                      }
                      return a.cache[n + 1] * i;
                    },
                    checkLoadedFonts: function () {
                      var t,
                        e,
                        i,
                        a = this.fonts.length,
                        n = a;
                      for (t = 0; t < a; t += 1)
                        this.fonts[t].loaded
                          ? (n -= 1)
                          : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
                          ? (this.fonts[t].loaded = !0)
                          : ((e = this.fonts[t].monoCase.node),
                            (i = this.fonts[t].monoCase.w),
                            e.offsetWidth !== i ? ((n -= 1), (this.fonts[t].loaded = !0)) : ((e = this.fonts[t].sansCase.node), (i = this.fonts[t].sansCase.w), e.offsetWidth !== i && ((n -= 1), (this.fonts[t].loaded = !0))),
                            this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                      0 !== n && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                    },
                    setIsLoaded: function () {
                      this.isLoaded = !0;
                    },
                  }),
                  n
                );
              })(),
              J = (function () {
                var t = n,
                  e = Math.abs;
                function i(t, e) {
                  var i,
                    n = this.offsetTime;
                  "multidimensional" === this.propType && (i = M("float32", this.pv.length));
                  for (var r, s, o, l, c, h, u, d, f = e.lastIndex, m = f, g = this.keyframes.length - 1, y = !0; y; ) {
                    if (((r = this.keyframes[m]), (s = this.keyframes[m + 1]), m === g - 1 && t >= s.t - n)) {
                      r.h && (r = s), (f = 0);
                      break;
                    }
                    if (s.t - n > t) {
                      f = m;
                      break;
                    }
                    m < g - 1 ? (m += 1) : ((f = 0), (y = !1));
                  }
                  var v,
                    A,
                    b,
                    w,
                    C,
                    S,
                    k,
                    E,
                    x,
                    _,
                    T = s.t - n,
                    P = r.t - n;
                  if (r.to) {
                    r.bezierData || (r.bezierData = N.buildBezierData(r.s, s.s || r.e, r.to, r.ti));
                    var D = r.bezierData;
                    if (T <= t || t < P) {
                      var I = T <= t ? D.points.length - 1 : 0;
                      for (l = D.points[I].point.length, o = 0; o < l; o += 1) i[o] = D.points[I].point[o];
                    } else {
                      r.__fnct ? (d = r.__fnct) : ((d = B.getBezierEasing(r.o.x, r.o.y, r.i.x, r.i.y, r.n).get), (r.__fnct = d)), (c = d((t - P) / (T - P)));
                      var L,
                        R = D.segmentLength * c,
                        F = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastAddedLength : 0;
                      for (u = e.lastFrame < t && e._lastKeyframeIndex === m ? e._lastPoint : 0, y = !0, h = D.points.length; y; ) {
                        if (((F += D.points[u].partialLength), 0 === R || 0 === c || u === D.points.length - 1)) {
                          for (l = D.points[u].point.length, o = 0; o < l; o += 1) i[o] = D.points[u].point[o];
                          break;
                        }
                        if (F <= R && R < F + D.points[u + 1].partialLength) {
                          for (L = (R - F) / D.points[u + 1].partialLength, l = D.points[u].point.length, o = 0; o < l; o += 1) i[o] = D.points[u].point[o] + (D.points[u + 1].point[o] - D.points[u].point[o]) * L;
                          break;
                        }
                        u < h - 1 ? (u += 1) : (y = !1);
                      }
                      (e._lastPoint = u), (e._lastAddedLength = F - D.points[u].partialLength), (e._lastKeyframeIndex = m);
                    }
                  } else {
                    var O, q, V, W, U;
                    if (((g = r.s.length), (v = s.s || r.e), this.sh && 1 !== r.h))
                      if (T <= t) (i[0] = v[0]), (i[1] = v[1]), (i[2] = v[2]);
                      else if (t <= P) (i[0] = r.s[0]), (i[1] = r.s[1]), (i[2] = r.s[2]);
                      else {
                        var J = a(r.s),
                          z = a(v);
                        (A = i),
                          (b = (function (t, e, i) {
                            var a,
                              n,
                              r,
                              s,
                              o,
                              l = [],
                              c = t[0],
                              h = t[1],
                              u = t[2],
                              d = t[3],
                              p = e[0],
                              f = e[1],
                              m = e[2],
                              g = e[3];
                            return (
                              (n = c * p + h * f + u * m + d * g) < 0 && ((n = -n), (p = -p), (f = -f), (m = -m), (g = -g)),
                              (o = 1e-6 < 1 - n ? ((a = Math.acos(n)), (r = Math.sin(a)), (s = Math.sin((1 - i) * a) / r), Math.sin(i * a) / r) : ((s = 1 - i), i)),
                              (l[0] = s * c + o * p),
                              (l[1] = s * h + o * f),
                              (l[2] = s * u + o * m),
                              (l[3] = s * d + o * g),
                              l
                            );
                          })(J, z, (t - P) / (T - P))),
                          (w = b[0]),
                          (C = b[1]),
                          (S = b[2]),
                          (k = b[3]),
                          (E = Math.atan2(2 * C * k - 2 * w * S, 1 - 2 * C * C - 2 * S * S)),
                          (x = Math.asin(2 * w * C + 2 * S * k)),
                          (_ = Math.atan2(2 * w * k - 2 * C * S, 1 - 2 * w * w - 2 * S * S)),
                          (A[0] = E / p),
                          (A[1] = x / p),
                          (A[2] = _ / p);
                      }
                    else
                      for (m = 0; m < g; m += 1)
                        1 !== r.h &&
                          (c =
                            T <= t
                              ? 1
                              : t < P
                              ? 0
                              : (r.o.x.constructor === Array
                                  ? (r.__fnct || (r.__fnct = []),
                                    r.__fnct[m]
                                      ? (d = r.__fnct[m])
                                      : ((O = void 0 === r.o.x[m] ? r.o.x[0] : r.o.x[m]),
                                        (q = void 0 === r.o.y[m] ? r.o.y[0] : r.o.y[m]),
                                        (V = void 0 === r.i.x[m] ? r.i.x[0] : r.i.x[m]),
                                        (W = void 0 === r.i.y[m] ? r.i.y[0] : r.i.y[m]),
                                        (d = B.getBezierEasing(O, q, V, W).get),
                                        (r.__fnct[m] = d)))
                                  : r.__fnct
                                  ? (d = r.__fnct)
                                  : ((O = r.o.x), (q = r.o.y), (V = r.i.x), (W = r.i.y), (d = B.getBezierEasing(O, q, V, W).get), (r.__fnct = d)),
                                d((t - P) / (T - P)))),
                          (v = s.s || r.e),
                          (U = 1 === r.h ? r.s[m] : r.s[m] + (v[m] - r.s[m]) * c),
                          "multidimensional" === this.propType ? (i[m] = U) : (i = U);
                  }
                  return (e.lastIndex = f), i;
                }
                function a(t) {
                  var e = t[0] * p,
                    i = t[1] * p,
                    a = t[2] * p,
                    n = Math.cos(e / 2),
                    r = Math.cos(i / 2),
                    s = Math.cos(a / 2),
                    o = Math.sin(e / 2),
                    l = Math.sin(i / 2),
                    c = Math.sin(a / 2);
                  return [o * l * s + n * r * c, o * r * s + n * l * c, n * l * s - o * r * c, n * r * s - o * l * c];
                }
                function r() {
                  var e = this.comp.renderedFrame - this.offsetTime,
                    i = this.keyframes[0].t - this.offsetTime,
                    a = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
                  if (!(e === this._caching.lastFrame || (this._caching.lastFrame !== t && ((this._caching.lastFrame >= a && a <= e) || (this._caching.lastFrame < i && e < i))))) {
                    this._caching.lastFrame >= e && ((this._caching._lastKeyframeIndex = -1), (this._caching.lastIndex = 0));
                    var n = this.interpolateValue(e, this._caching);
                    this.pv = n;
                  }
                  return (this._caching.lastFrame = e), this.pv;
                }
                function s(t) {
                  var i;
                  if ("unidimensional" === this.propType) (i = t * this.mult), 1e-5 < e(this.v - i) && ((this.v = i), (this._mdf = !0));
                  else for (var a = 0, n = this.v.length; a < n; ) (i = t[a] * this.mult), 1e-5 < e(this.v[a] - i) && ((this.v[a] = i), (this._mdf = !0)), (a += 1);
                }
                function o() {
                  if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length)
                    if (this.lock) this.setVValue(this.pv);
                    else {
                      var t;
                      (this.lock = !0), (this._mdf = this._isFirstFrame);
                      var e = this.effectsSequence.length,
                        i = this.kf ? this.pv : this.data.k;
                      for (t = 0; t < e; t += 1) i = this.effectsSequence[t](i);
                      this.setVValue(i), (this._isFirstFrame = !1), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                    }
                }
                function l(t) {
                  this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                }
                return {
                  getProp: function (e, a, n, c, h) {
                    var u;
                    if (a.k.length)
                      if ("number" == typeof a.k[0])
                        u = new (function (t, e, i, a) {
                          var n;
                          (this.propType = "multidimensional"), (this.mult = i || 1), (this.data = e), (this._mdf = !1), (this.elem = t), (this.container = a), (this.comp = t.comp), (this.k = !1), (this.kf = !1), (this.frameId = -1);
                          var r = e.k.length;
                          for (this.v = M("float32", r), this.pv = M("float32", r), this.vel = M("float32", r), n = 0; n < r; n += 1) (this.v[n] = e.k[n] * this.mult), (this.pv[n] = e.k[n]);
                          (this._isFirstFrame = !0), (this.effectsSequence = []), (this.getValue = o), (this.setVValue = s), (this.addEffect = l);
                        })(e, a, c, h);
                      else
                        switch (n) {
                          case 0:
                            u = new (function (e, a, n, c) {
                              (this.propType = "unidimensional"),
                                (this.keyframes = a.k),
                                (this.offsetTime = e.data.st),
                                (this.frameId = -1),
                                (this._caching = { lastFrame: t, lastIndex: 0, value: 0, _lastKeyframeIndex: -1 }),
                                (this.k = !0),
                                (this.kf = !0),
                                (this.data = a),
                                (this.mult = n || 1),
                                (this.elem = e),
                                (this.container = c),
                                (this.comp = e.comp),
                                (this.v = t),
                                (this.pv = t),
                                (this._isFirstFrame = !0),
                                (this.getValue = o),
                                (this.setVValue = s),
                                (this.interpolateValue = i),
                                (this.effectsSequence = [r.bind(this)]),
                                (this.addEffect = l);
                            })(e, a, c, h);
                            break;
                          case 1:
                            u = new (function (e, a, n, c) {
                              var h;
                              this.propType = "multidimensional";
                              var u,
                                d,
                                p,
                                f,
                                m = a.k.length;
                              for (h = 0; h < m - 1; h += 1)
                                a.k[h].to &&
                                  a.k[h].s &&
                                  a.k[h + 1] &&
                                  a.k[h + 1].s &&
                                  ((u = a.k[h].s),
                                  (d = a.k[h + 1].s),
                                  (p = a.k[h].to),
                                  (f = a.k[h].ti),
                                  ((2 === u.length && (u[0] !== d[0] || u[1] !== d[1]) && N.pointOnLine2D(u[0], u[1], d[0], d[1], u[0] + p[0], u[1] + p[1]) && N.pointOnLine2D(u[0], u[1], d[0], d[1], d[0] + f[0], d[1] + f[1])) ||
                                    (3 === u.length &&
                                      (u[0] !== d[0] || u[1] !== d[1] || u[2] !== d[2]) &&
                                      N.pointOnLine3D(u[0], u[1], u[2], d[0], d[1], d[2], u[0] + p[0], u[1] + p[1], u[2] + p[2]) &&
                                      N.pointOnLine3D(u[0], u[1], u[2], d[0], d[1], d[2], d[0] + f[0], d[1] + f[1], d[2] + f[2]))) &&
                                    ((a.k[h].to = null), (a.k[h].ti = null)),
                                  u[0] === d[0] && u[1] === d[1] && 0 === p[0] && 0 === p[1] && 0 === f[0] && 0 === f[1] && (2 === u.length || (u[2] === d[2] && 0 === p[2] && 0 === f[2])) && ((a.k[h].to = null), (a.k[h].ti = null)));
                              (this.effectsSequence = [r.bind(this)]),
                                (this.data = a),
                                (this.keyframes = a.k),
                                (this.offsetTime = e.data.st),
                                (this.k = !0),
                                (this.kf = !0),
                                (this._isFirstFrame = !0),
                                (this.mult = n || 1),
                                (this.elem = e),
                                (this.container = c),
                                (this.comp = e.comp),
                                (this.getValue = o),
                                (this.setVValue = s),
                                (this.interpolateValue = i),
                                (this.frameId = -1);
                              var g = a.k[0].s.length;
                              for (this.v = M("float32", g), this.pv = M("float32", g), h = 0; h < g; h += 1) (this.v[h] = t), (this.pv[h] = t);
                              (this._caching = { lastFrame: t, lastIndex: 0, value: M("float32", g) }), (this.addEffect = l);
                            })(e, a, c, h);
                        }
                    else
                      u = new (function (t, e, i, a) {
                        (this.propType = "unidimensional"),
                          (this.mult = i || 1),
                          (this.data = e),
                          (this.v = i ? e.k * i : e.k),
                          (this.pv = e.k),
                          (this._mdf = !1),
                          (this.elem = t),
                          (this.container = a),
                          (this.comp = t.comp),
                          (this.k = !1),
                          (this.kf = !1),
                          (this.vel = 0),
                          (this.effectsSequence = []),
                          (this._isFirstFrame = !0),
                          (this.getValue = o),
                          (this.setVValue = s),
                          (this.addEffect = l);
                      })(e, a, c, h);
                    return u.effectsSequence.length && h.addDynamicProperty(u), u;
                  },
                };
              })(),
              z = (function () {
                var t = [0, 0];
                function e(t, e, i) {
                  if (
                    ((this.elem = t),
                    (this.frameId = -1),
                    (this.propType = "transform"),
                    (this.data = e),
                    (this.v = new O()),
                    (this.pre = new O()),
                    (this.appliedTransformations = 0),
                    this.initDynamicPropertyContainer(i || t),
                    e.p && e.p.s
                      ? ((this.px = J.getProp(t, e.p.x, 0, 0, this)), (this.py = J.getProp(t, e.p.y, 0, 0, this)), e.p.z && (this.pz = J.getProp(t, e.p.z, 0, 0, this)))
                      : (this.p = J.getProp(t, e.p || { k: [0, 0, 0] }, 1, 0, this)),
                    e.rx)
                  ) {
                    if (((this.rx = J.getProp(t, e.rx, 0, p, this)), (this.ry = J.getProp(t, e.ry, 0, p, this)), (this.rz = J.getProp(t, e.rz, 0, p, this)), e.or.k[0].ti)) {
                      var a,
                        n = e.or.k.length;
                      for (a = 0; a < n; a += 1) (e.or.k[a].to = null), (e.or.k[a].ti = null);
                    }
                    (this.or = J.getProp(t, e.or, 1, p, this)), (this.or.sh = !0);
                  } else this.r = J.getProp(t, e.r || { k: 0 }, 0, p, this);
                  e.sk && ((this.sk = J.getProp(t, e.sk, 0, p, this)), (this.sa = J.getProp(t, e.sa, 0, p, this))),
                    (this.a = J.getProp(t, e.a || { k: [0, 0, 0] }, 1, 0, this)),
                    (this.s = J.getProp(t, e.s || { k: [100, 100, 100] }, 1, 0.01, this)),
                    e.o ? (this.o = J.getProp(t, e.o, 0, 0.01, t)) : (this.o = { _mdf: !1, v: 1 }),
                    (this._isDirty = !0),
                    this.dynamicProperties.length || this.getValue(!0);
                }
                return (
                  (e.prototype = {
                    applyToMatrix: function (t) {
                      var e = this._mdf;
                      this.iterateDynamicProperties(),
                        (this._mdf = this._mdf || e),
                        this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                        this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                        this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
                        this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                        this.data.p.s ? (this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0)) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                    },
                    getValue: function (e) {
                      if (this.elem.globalData.frameId !== this.frameId) {
                        if ((this._isDirty && (this.precalculateMatrix(), (this._isDirty = !1)), this.iterateDynamicProperties(), this._mdf || e)) {
                          var i;
                          if (
                            (this.v.cloneFromProps(this.pre.props),
                            this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                            this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                            this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v),
                            this.r && this.appliedTransformations < 4
                              ? this.v.rotate(-this.r.v)
                              : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]),
                            this.autoOriented)
                          ) {
                            var a, n;
                            if (((i = this.elem.globalData.frameRate), this.p && this.p.keyframes && this.p.getValueAtTime))
                              n =
                                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t
                                  ? ((a = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / i, 0)), this.p.getValueAtTime(this.p.keyframes[0].t / i, 0))
                                  : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t
                                  ? ((a = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / i, 0)), this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / i, 0))
                                  : ((a = this.p.pv), this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / i, this.p.offsetTime));
                            else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                              (a = []), (n = []);
                              var r = this.px,
                                s = this.py;
                              r._caching.lastFrame + r.offsetTime <= r.keyframes[0].t
                                ? ((a[0] = r.getValueAtTime((r.keyframes[0].t + 0.01) / i, 0)),
                                  (a[1] = s.getValueAtTime((s.keyframes[0].t + 0.01) / i, 0)),
                                  (n[0] = r.getValueAtTime(r.keyframes[0].t / i, 0)),
                                  (n[1] = s.getValueAtTime(s.keyframes[0].t / i, 0)))
                                : r._caching.lastFrame + r.offsetTime >= r.keyframes[r.keyframes.length - 1].t
                                ? ((a[0] = r.getValueAtTime(r.keyframes[r.keyframes.length - 1].t / i, 0)),
                                  (a[1] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / i, 0)),
                                  (n[0] = r.getValueAtTime((r.keyframes[r.keyframes.length - 1].t - 0.01) / i, 0)),
                                  (n[1] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - 0.01) / i, 0)))
                                : ((a = [r.pv, s.pv]), (n[0] = r.getValueAtTime((r._caching.lastFrame + r.offsetTime - 0.01) / i, r.offsetTime)), (n[1] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - 0.01) / i, s.offsetTime)));
                            } else a = n = t;
                            this.v.rotate(-Math.atan2(a[1] - n[1], a[0] - n[0]));
                          }
                          this.data.p && this.data.p.s ? (this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0)) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                      }
                    },
                    precalculateMatrix: function () {
                      if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), (this.appliedTransformations = 1), !this.s.effectsSequence.length)) {
                        if ((this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), (this.appliedTransformations = 2), this.sk)) {
                          if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                          this.pre.skewFromAxis(-this.sk.v, this.sa.v), (this.appliedTransformations = 3);
                        }
                        this.r
                          ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), (this.appliedTransformations = 4))
                          : this.rz.effectsSequence.length ||
                            this.ry.effectsSequence.length ||
                            this.rx.effectsSequence.length ||
                            this.or.effectsSequence.length ||
                            (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), (this.appliedTransformations = 4));
                      }
                    },
                    autoOrient: function () {},
                  }),
                  q([L], e),
                  (e.prototype.addDynamicProperty = function (t) {
                    this._addDynamicProperty(t), this.elem.addDynamicProperty(t), (this._isDirty = !0);
                  }),
                  (e.prototype._addDynamicProperty = L.prototype.addDynamicProperty),
                  {
                    getTransformProperty: function (t, i, a) {
                      return new e(t, i, a);
                    },
                  }
                );
              })();
            function K() {
              (this.c = !1), (this._length = 0), (this._maxLength = 8), (this.v = P(this._maxLength)), (this.o = P(this._maxLength)), (this.i = P(this._maxLength));
            }
            (K.prototype.setPathData = function (t, e) {
              (this.c = t), this.setLength(e);
              for (var i = 0; i < e; ) (this.v[i] = kt.newElement()), (this.o[i] = kt.newElement()), (this.i[i] = kt.newElement()), (i += 1);
            }),
              (K.prototype.setLength = function (t) {
                for (; this._maxLength < t; ) this.doubleArrayLength();
                this._length = t;
              }),
              (K.prototype.doubleArrayLength = function () {
                (this.v = this.v.concat(P(this._maxLength))), (this.i = this.i.concat(P(this._maxLength))), (this.o = this.o.concat(P(this._maxLength))), (this._maxLength *= 2);
              }),
              (K.prototype.setXYAt = function (t, e, i, a, n) {
                var r;
                switch (((this._length = Math.max(this._length, a + 1)), this._length >= this._maxLength && this.doubleArrayLength(), i)) {
                  case "v":
                    r = this.v;
                    break;
                  case "i":
                    r = this.i;
                    break;
                  case "o":
                    r = this.o;
                    break;
                  default:
                    r = [];
                }
                (!r[a] || (r[a] && !n)) && (r[a] = kt.newElement()), (r[a][0] = t), (r[a][1] = e);
              }),
              (K.prototype.setTripleAt = function (t, e, i, a, n, r, s, o) {
                this.setXYAt(t, e, "v", s, o), this.setXYAt(i, a, "o", s, o), this.setXYAt(n, r, "i", s, o);
              }),
              (K.prototype.reverse = function () {
                var t = new K();
                t.setPathData(this.c, this._length);
                var e = this.v,
                  i = this.o,
                  a = this.i,
                  n = 0;
                this.c && (t.setTripleAt(e[0][0], e[0][1], a[0][0], a[0][1], i[0][0], i[0][1], 0, !1), (n = 1));
                var r,
                  s = this._length - 1,
                  o = this._length;
                for (r = n; r < o; r += 1) t.setTripleAt(e[s][0], e[s][1], a[s][0], a[s][1], i[s][0], i[s][1], r, !1), (s -= 1);
                return t;
              });
            var G,
              j,
              H = (function () {
                var t = -999999;
                function e(t, e, i) {
                  var a,
                    n,
                    r,
                    s,
                    o,
                    l,
                    c,
                    h,
                    u,
                    d = i.lastIndex,
                    p = this.keyframes;
                  if (t < p[0].t - this.offsetTime) (a = p[0].s[0]), (r = !0), (d = 0);
                  else if (t >= p[p.length - 1].t - this.offsetTime) (a = p[p.length - 1].s ? p[p.length - 1].s[0] : p[p.length - 2].e[0]), (r = !0);
                  else {
                    for (var f, m, g = d, y = p.length - 1, v = !0; v && ((f = p[g]), !((m = p[g + 1]).t - this.offsetTime > t)); ) g < y - 1 ? (g += 1) : (v = !1);
                    if (((d = g), !(r = 1 === f.h))) {
                      if (t >= m.t - this.offsetTime) h = 1;
                      else if (t < f.t - this.offsetTime) h = 0;
                      else {
                        var A;
                        f.__fnct ? (A = f.__fnct) : ((A = B.getBezierEasing(f.o.x, f.o.y, f.i.x, f.i.y).get), (f.__fnct = A)), (h = A((t - (f.t - this.offsetTime)) / (m.t - this.offsetTime - (f.t - this.offsetTime))));
                      }
                      n = m.s ? m.s[0] : f.e[0];
                    }
                    a = f.s[0];
                  }
                  for (l = e._length, c = a.i[0].length, i.lastIndex = d, s = 0; s < l; s += 1)
                    for (o = 0; o < c; o += 1)
                      (u = r ? a.i[s][o] : a.i[s][o] + (n.i[s][o] - a.i[s][o]) * h),
                        (e.i[s][o] = u),
                        (u = r ? a.o[s][o] : a.o[s][o] + (n.o[s][o] - a.o[s][o]) * h),
                        (e.o[s][o] = u),
                        (u = r ? a.v[s][o] : a.v[s][o] + (n.v[s][o] - a.v[s][o]) * h),
                        (e.v[s][o] = u);
                }
                function i() {
                  this.paths = this.localShapeCollection;
                }
                function a(t) {
                  (function (t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var i,
                      a = t._length;
                    for (i = 0; i < a; i += 1) if (t.v[i][0] !== e.v[i][0] || t.v[i][1] !== e.v[i][1] || t.o[i][0] !== e.o[i][0] || t.o[i][1] !== e.o[i][1] || t.i[i][0] !== e.i[i][0] || t.i[i][1] !== e.i[i][1]) return !1;
                    return !0;
                  })(this.v, t) || ((this.v = Et.clone(t)), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), (this._mdf = !0), (this.paths = this.localShapeCollection));
                }
                function n() {
                  if (this.elem.globalData.frameId !== this.frameId)
                    if (this.effectsSequence.length)
                      if (this.lock) this.setVValue(this.pv);
                      else {
                        var t, e;
                        (this.lock = !0), (this._mdf = !1), (t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k);
                        var i = this.effectsSequence.length;
                        for (e = 0; e < i; e += 1) t = this.effectsSequence[e](t);
                        this.setVValue(t), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                      }
                    else this._mdf = !1;
                }
                function r(t, e, a) {
                  (this.propType = "shape"), (this.comp = t.comp), (this.container = t), (this.elem = t), (this.data = e), (this.k = !1), (this.kf = !1), (this._mdf = !1);
                  var n = 3 === a ? e.pt.k : e.ks.k;
                  (this.v = Et.clone(n)),
                    (this.pv = Et.clone(this.v)),
                    (this.localShapeCollection = xt.newShapeCollection()),
                    (this.paths = this.localShapeCollection),
                    this.paths.addShape(this.v),
                    (this.reset = i),
                    (this.effectsSequence = []);
                }
                function s(t) {
                  this.effectsSequence.push(t), this.container.addDynamicProperty(this);
                }
                function o(e, a, n) {
                  (this.propType = "shape"), (this.comp = e.comp), (this.elem = e), (this.container = e), (this.offsetTime = e.data.st), (this.keyframes = 3 === n ? a.pt.k : a.ks.k), (this.k = !0), (this.kf = !0);
                  var r = this.keyframes[0].s[0].i.length;
                  (this.v = Et.newElement()),
                    this.v.setPathData(this.keyframes[0].s[0].c, r),
                    (this.pv = Et.clone(this.v)),
                    (this.localShapeCollection = xt.newShapeCollection()),
                    (this.paths = this.localShapeCollection),
                    this.paths.addShape(this.v),
                    (this.lastFrame = t),
                    (this.reset = i),
                    (this._caching = { lastFrame: t, lastIndex: 0 }),
                    (this.effectsSequence = [
                      function () {
                        var e = this.comp.renderedFrame - this.offsetTime,
                          i = this.keyframes[0].t - this.offsetTime,
                          a = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
                          n = this._caching.lastFrame;
                        return (
                          (n !== t && ((n < i && e < i) || (a < n && a < e))) || ((this._caching.lastIndex = n < e ? this._caching.lastIndex : 0), this.interpolateShape(e, this.pv, this._caching)), (this._caching.lastFrame = e), this.pv
                        );
                      }.bind(this),
                    ]);
                }
                (r.prototype.interpolateShape = e),
                  (r.prototype.getValue = n),
                  (r.prototype.setVValue = a),
                  (r.prototype.addEffect = s),
                  (o.prototype.getValue = n),
                  (o.prototype.interpolateShape = e),
                  (o.prototype.setVValue = a),
                  (o.prototype.addEffect = s);
                var l = (function () {
                    var t = f;
                    function e(t, e) {
                      (this.v = Et.newElement()),
                        this.v.setPathData(!0, 4),
                        (this.localShapeCollection = xt.newShapeCollection()),
                        (this.paths = this.localShapeCollection),
                        this.localShapeCollection.addShape(this.v),
                        (this.d = e.d),
                        (this.elem = t),
                        (this.comp = t.comp),
                        (this.frameId = -1),
                        this.initDynamicPropertyContainer(t),
                        (this.p = J.getProp(t, e.p, 1, 0, this)),
                        (this.s = J.getProp(t, e.s, 1, 0, this)),
                        this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertEllToPath());
                    }
                    return (
                      (e.prototype = {
                        reset: i,
                        getValue: function () {
                          this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                        },
                        convertEllToPath: function () {
                          var e = this.p.v[0],
                            i = this.p.v[1],
                            a = this.s.v[0] / 2,
                            n = this.s.v[1] / 2,
                            r = 3 !== this.d,
                            s = this.v;
                          (s.v[0][0] = e),
                            (s.v[0][1] = i - n),
                            (s.v[1][0] = r ? e + a : e - a),
                            (s.v[1][1] = i),
                            (s.v[2][0] = e),
                            (s.v[2][1] = i + n),
                            (s.v[3][0] = r ? e - a : e + a),
                            (s.v[3][1] = i),
                            (s.i[0][0] = r ? e - a * t : e + a * t),
                            (s.i[0][1] = i - n),
                            (s.i[1][0] = r ? e + a : e - a),
                            (s.i[1][1] = i - n * t),
                            (s.i[2][0] = r ? e + a * t : e - a * t),
                            (s.i[2][1] = i + n),
                            (s.i[3][0] = r ? e - a : e + a),
                            (s.i[3][1] = i + n * t),
                            (s.o[0][0] = r ? e + a * t : e - a * t),
                            (s.o[0][1] = i - n),
                            (s.o[1][0] = r ? e + a : e - a),
                            (s.o[1][1] = i + n * t),
                            (s.o[2][0] = r ? e - a * t : e + a * t),
                            (s.o[2][1] = i + n),
                            (s.o[3][0] = r ? e - a : e + a),
                            (s.o[3][1] = i - n * t);
                        },
                      }),
                      q([L], e),
                      e
                    );
                  })(),
                  c = (function () {
                    function t(t, e) {
                      (this.v = Et.newElement()),
                        this.v.setPathData(!0, 0),
                        (this.elem = t),
                        (this.comp = t.comp),
                        (this.data = e),
                        (this.frameId = -1),
                        (this.d = e.d),
                        this.initDynamicPropertyContainer(t),
                        1 === e.sy ? ((this.ir = J.getProp(t, e.ir, 0, 0, this)), (this.is = J.getProp(t, e.is, 0, 0.01, this)), (this.convertToPath = this.convertStarToPath)) : (this.convertToPath = this.convertPolygonToPath),
                        (this.pt = J.getProp(t, e.pt, 0, 0, this)),
                        (this.p = J.getProp(t, e.p, 1, 0, this)),
                        (this.r = J.getProp(t, e.r, 0, p, this)),
                        (this.or = J.getProp(t, e.or, 0, 0, this)),
                        (this.os = J.getProp(t, e.os, 0, 0.01, this)),
                        (this.localShapeCollection = xt.newShapeCollection()),
                        this.localShapeCollection.addShape(this.v),
                        (this.paths = this.localShapeCollection),
                        this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertToPath());
                    }
                    return (
                      (t.prototype = {
                        reset: i,
                        getValue: function () {
                          this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                        },
                        convertStarToPath: function () {
                          var t,
                            e,
                            i,
                            a,
                            n = 2 * Math.floor(this.pt.v),
                            r = (2 * Math.PI) / n,
                            s = !0,
                            o = this.or.v,
                            l = this.ir.v,
                            c = this.os.v,
                            h = this.is.v,
                            u = (2 * Math.PI * o) / (2 * n),
                            d = (2 * Math.PI * l) / (2 * n),
                            p = -Math.PI / 2;
                          p += this.r.v;
                          var f = 3 === this.data.d ? -1 : 1;
                          for (t = this.v._length = 0; t < n; t += 1) {
                            (i = s ? c : h), (a = s ? u : d);
                            var m = (e = s ? o : l) * Math.cos(p),
                              g = e * Math.sin(p),
                              y = 0 === m && 0 === g ? 0 : g / Math.sqrt(m * m + g * g),
                              v = 0 === m && 0 === g ? 0 : -m / Math.sqrt(m * m + g * g);
                            (m += +this.p.v[0]), (g += +this.p.v[1]), this.v.setTripleAt(m, g, m - y * a * i * f, g - v * a * i * f, m + y * a * i * f, g + v * a * i * f, t, !0), (s = !s), (p += r * f);
                          }
                        },
                        convertPolygonToPath: function () {
                          var t,
                            e = Math.floor(this.pt.v),
                            i = (2 * Math.PI) / e,
                            a = this.or.v,
                            n = this.os.v,
                            r = (2 * Math.PI * a) / (4 * e),
                            s = 0.5 * -Math.PI,
                            o = 3 === this.data.d ? -1 : 1;
                          for (s += this.r.v, t = this.v._length = 0; t < e; t += 1) {
                            var l = a * Math.cos(s),
                              c = a * Math.sin(s),
                              h = 0 === l && 0 === c ? 0 : c / Math.sqrt(l * l + c * c),
                              u = 0 === l && 0 === c ? 0 : -l / Math.sqrt(l * l + c * c);
                            (l += +this.p.v[0]), (c += +this.p.v[1]), this.v.setTripleAt(l, c, l - h * r * n * o, c - u * r * n * o, l + h * r * n * o, c + u * r * n * o, t, !0), (s += i * o);
                          }
                          (this.paths.length = 0), (this.paths[0] = this.v);
                        },
                      }),
                      q([L], t),
                      t
                    );
                  })(),
                  u = (function () {
                    function t(t, e) {
                      (this.v = Et.newElement()),
                        (this.v.c = !0),
                        (this.localShapeCollection = xt.newShapeCollection()),
                        this.localShapeCollection.addShape(this.v),
                        (this.paths = this.localShapeCollection),
                        (this.elem = t),
                        (this.comp = t.comp),
                        (this.frameId = -1),
                        (this.d = e.d),
                        this.initDynamicPropertyContainer(t),
                        (this.p = J.getProp(t, e.p, 1, 0, this)),
                        (this.s = J.getProp(t, e.s, 1, 0, this)),
                        (this.r = J.getProp(t, e.r, 0, 0, this)),
                        this.dynamicProperties.length ? (this.k = !0) : ((this.k = !1), this.convertRectToPath());
                    }
                    return (
                      (t.prototype = {
                        convertRectToPath: function () {
                          var t = this.p.v[0],
                            e = this.p.v[1],
                            i = this.s.v[0] / 2,
                            a = this.s.v[1] / 2,
                            n = h(i, a, this.r.v),
                            r = n * (1 - f);
                          (this.v._length = 0),
                            2 === this.d || 1 === this.d
                              ? (this.v.setTripleAt(t + i, e - a + n, t + i, e - a + n, t + i, e - a + r, 0, !0),
                                this.v.setTripleAt(t + i, e + a - n, t + i, e + a - r, t + i, e + a - n, 1, !0),
                                0 !== n
                                  ? (this.v.setTripleAt(t + i - n, e + a, t + i - n, e + a, t + i - r, e + a, 2, !0),
                                    this.v.setTripleAt(t - i + n, e + a, t - i + r, e + a, t - i + n, e + a, 3, !0),
                                    this.v.setTripleAt(t - i, e + a - n, t - i, e + a - n, t - i, e + a - r, 4, !0),
                                    this.v.setTripleAt(t - i, e - a + n, t - i, e - a + r, t - i, e - a + n, 5, !0),
                                    this.v.setTripleAt(t - i + n, e - a, t - i + n, e - a, t - i + r, e - a, 6, !0),
                                    this.v.setTripleAt(t + i - n, e - a, t + i - r, e - a, t + i - n, e - a, 7, !0))
                                  : (this.v.setTripleAt(t - i, e + a, t - i + r, e + a, t - i, e + a, 2), this.v.setTripleAt(t - i, e - a, t - i, e - a + r, t - i, e - a, 3)))
                              : (this.v.setTripleAt(t + i, e - a + n, t + i, e - a + r, t + i, e - a + n, 0, !0),
                                0 !== n
                                  ? (this.v.setTripleAt(t + i - n, e - a, t + i - n, e - a, t + i - r, e - a, 1, !0),
                                    this.v.setTripleAt(t - i + n, e - a, t - i + r, e - a, t - i + n, e - a, 2, !0),
                                    this.v.setTripleAt(t - i, e - a + n, t - i, e - a + n, t - i, e - a + r, 3, !0),
                                    this.v.setTripleAt(t - i, e + a - n, t - i, e + a - r, t - i, e + a - n, 4, !0),
                                    this.v.setTripleAt(t - i + n, e + a, t - i + n, e + a, t - i + r, e + a, 5, !0),
                                    this.v.setTripleAt(t + i - n, e + a, t + i - r, e + a, t + i - n, e + a, 6, !0),
                                    this.v.setTripleAt(t + i, e + a - n, t + i, e + a - n, t + i, e + a - r, 7, !0))
                                  : (this.v.setTripleAt(t - i, e - a, t - i + r, e - a, t - i, e - a, 1, !0),
                                    this.v.setTripleAt(t - i, e + a, t - i, e + a - r, t - i, e + a, 2, !0),
                                    this.v.setTripleAt(t + i, e + a, t + i - r, e + a, t + i, e + a, 3, !0)));
                        },
                        getValue: function () {
                          this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                        },
                        reset: i,
                      }),
                      q([L], t),
                      t
                    );
                  })(),
                  d = {
                    getShapeProp: function (t, e, i) {
                      var a;
                      return (
                        3 === i || 4 === i ? (a = (3 === i ? e.pt : e.ks).k.length ? new o(t, e, i) : new r(t, e, i)) : 5 === i ? (a = new u(t, e)) : 6 === i ? (a = new l(t, e)) : 7 === i && (a = new c(t, e)),
                        a.k && t.addDynamicProperty(a),
                        a
                      );
                    },
                    getConstructorFunction: function () {
                      return r;
                    },
                    getKeyframedConstructorFunction: function () {
                      return o;
                    },
                  };
                return d;
              })(),
              Y =
                ((j = {}),
                ((G = {}).registerModifier = function (t, e) {
                  j[t] || (j[t] = e);
                }),
                (G.getModifier = function (t, e, i) {
                  return new j[t](e, i);
                }),
                G);
            function Q() {}
            function X() {}
            function Z() {}
            function $() {}
            function tt() {}
            function et() {
              (this._length = 0), (this._maxLength = 4), (this.shapes = P(this._maxLength));
            }
            function it(t, e, i, a) {
              var n;
              (this.elem = t),
                (this.frameId = -1),
                (this.dataProps = P(e.length)),
                (this.renderer = i),
                (this.k = !1),
                (this.dashStr = ""),
                (this.dashArray = M("float32", e.length ? e.length - 1 : 0)),
                (this.dashoffset = M("float32", 1)),
                this.initDynamicPropertyContainer(a);
              var r,
                s = e.length || 0;
              for (n = 0; n < s; n += 1) (r = J.getProp(t, e[n].v, 0, 0, this)), (this.k = r.k || this.k), (this.dataProps[n] = { n: e[n].n, p: r });
              this.k || this.getValue(!0), (this._isAnimated = this.k);
            }
            function at(t, e, i) {
              (this.data = e), (this.c = M("uint8c", 4 * e.p));
              var a = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
              (this.o = M("float32", a)),
                (this._cmdf = !1),
                (this._omdf = !1),
                (this._collapsable = this.checkCollapsable()),
                (this._hasOpacity = a),
                this.initDynamicPropertyContainer(i),
                (this.prop = J.getProp(t, e.k, 1, null, this)),
                (this.k = this.prop.k),
                this.getValue(!0);
            }
            (Q.prototype.initModifierProperties = function () {}),
              (Q.prototype.addShapeToModifier = function () {}),
              (Q.prototype.addShape = function (t) {
                if (!this.closed) {
                  t.sh.container.addDynamicProperty(t.sh);
                  var e = { shape: t.sh, data: t, localShapeCollection: xt.newShapeCollection() };
                  this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
                }
              }),
              (Q.prototype.init = function (t, e) {
                (this.shapes = []),
                  (this.elem = t),
                  this.initDynamicPropertyContainer(t),
                  this.initModifierProperties(t, e),
                  (this.frameId = n),
                  (this.closed = !1),
                  (this.k = !1),
                  this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
              }),
              (Q.prototype.processKeys = function () {
                this.elem.globalData.frameId !== this.frameId && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties());
              }),
              q([L], Q),
              q([Q], X),
              (X.prototype.initModifierProperties = function (t, e) {
                (this.s = J.getProp(t, e.s, 0, 0.01, this)),
                  (this.e = J.getProp(t, e.e, 0, 0.01, this)),
                  (this.o = J.getProp(t, e.o, 0, 0, this)),
                  (this.sValue = 0),
                  (this.eValue = 0),
                  (this.getValue = this.processKeys),
                  (this.m = e.m),
                  (this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length);
              }),
              (X.prototype.addShapeToModifier = function (t) {
                t.pathsData = [];
              }),
              (X.prototype.calculateShapeEdges = function (t, e, i, a, n) {
                var r = [];
                e <= 1 ? r.push({ s: t, e }) : 1 <= t ? r.push({ s: t - 1, e: e - 1 }) : (r.push({ s: t, e: 1 }), r.push({ s: 0, e: e - 1 }));
                var s,
                  o,
                  l = [],
                  c = r.length;
                for (s = 0; s < c; s += 1) {
                  var h, u;
                  (o = r[s]).e * n < a || o.s * n > a + i || ((h = o.s * n <= a ? 0 : (o.s * n - a) / i), (u = o.e * n >= a + i ? 1 : (o.e * n - a) / i), l.push([h, u]));
                }
                return l.length || l.push([0, 0]), l;
              }),
              (X.prototype.releasePathsData = function (t) {
                var e,
                  i = t.length;
                for (e = 0; e < i; e += 1) _t.release(t[e]);
                return (t.length = 0), t;
              }),
              (X.prototype.processShapes = function (t) {
                var e, i, a, n;
                if (this._mdf || t) {
                  var r = (this.o.v % 360) / 360;
                  if ((r < 0 && (r += 1), (e = 1 < this.s.v ? 1 + r : this.s.v < 0 ? 0 + r : this.s.v + r), (i = 1 < this.e.v ? 1 + r : this.e.v < 0 ? 0 + r : this.e.v + r) < e)) {
                    var s = e;
                    (e = i), (i = s);
                  }
                  (e = 1e-4 * Math.round(1e4 * e)), (i = 1e-4 * Math.round(1e4 * i)), (this.sValue = e), (this.eValue = i);
                } else (e = this.sValue), (i = this.eValue);
                var o,
                  l,
                  c,
                  h,
                  u,
                  d = this.shapes.length,
                  p = 0;
                if (i === e)
                  for (n = 0; n < d; n += 1)
                    this.shapes[n].localShapeCollection.releaseShapes(), (this.shapes[n].shape._mdf = !0), (this.shapes[n].shape.paths = this.shapes[n].localShapeCollection), this._mdf && (this.shapes[n].pathsData.length = 0);
                else if ((1 === i && 0 === e) || (0 === i && 1 === e)) {
                  if (this._mdf) for (n = 0; n < d; n += 1) (this.shapes[n].pathsData.length = 0), (this.shapes[n].shape._mdf = !0);
                } else {
                  var f,
                    m,
                    g = [];
                  for (n = 0; n < d; n += 1)
                    if ((f = this.shapes[n]).shape._mdf || this._mdf || t || 2 === this.m) {
                      if (((l = (a = f.shape.paths)._length), (u = 0), !f.shape._mdf && f.pathsData.length)) u = f.totalShapeLength;
                      else {
                        for (c = this.releasePathsData(f.pathsData), o = 0; o < l; o += 1) (h = N.getSegmentsLength(a.shapes[o])), c.push(h), (u += h.totalLength);
                        (f.totalShapeLength = u), (f.pathsData = c);
                      }
                      (p += u), (f.shape._mdf = !0);
                    } else f.shape.paths = f.localShapeCollection;
                  var y,
                    v = e,
                    A = i,
                    b = 0;
                  for (n = d - 1; 0 <= n; n -= 1)
                    if ((f = this.shapes[n]).shape._mdf) {
                      for (
                        (m = f.localShapeCollection).releaseShapes(), 2 === this.m && 1 < d ? ((y = this.calculateShapeEdges(e, i, f.totalShapeLength, b, p)), (b += f.totalShapeLength)) : (y = [[v, A]]), l = y.length, o = 0;
                        o < l;
                        o += 1
                      ) {
                        (v = y[o][0]),
                          (A = y[o][1]),
                          (g.length = 0),
                          A <= 1
                            ? g.push({ s: f.totalShapeLength * v, e: f.totalShapeLength * A })
                            : 1 <= v
                            ? g.push({ s: f.totalShapeLength * (v - 1), e: f.totalShapeLength * (A - 1) })
                            : (g.push({ s: f.totalShapeLength * v, e: f.totalShapeLength }), g.push({ s: 0, e: f.totalShapeLength * (A - 1) }));
                        var w = this.addShapes(f, g[0]);
                        if (g[0].s !== g[0].e) {
                          if (1 < g.length)
                            if (f.shape.paths.shapes[f.shape.paths._length - 1].c) {
                              var C = w.pop();
                              this.addPaths(w, m), (w = this.addShapes(f, g[1], C));
                            } else this.addPaths(w, m), (w = this.addShapes(f, g[1]));
                          this.addPaths(w, m);
                        }
                      }
                      f.shape.paths = m;
                    }
                }
              }),
              (X.prototype.addPaths = function (t, e) {
                var i,
                  a = t.length;
                for (i = 0; i < a; i += 1) e.addShape(t[i]);
              }),
              (X.prototype.addSegment = function (t, e, i, a, n, r, s) {
                n.setXYAt(e[0], e[1], "o", r), n.setXYAt(i[0], i[1], "i", r + 1), s && n.setXYAt(t[0], t[1], "v", r), n.setXYAt(a[0], a[1], "v", r + 1);
              }),
              (X.prototype.addSegmentFromArray = function (t, e, i, a) {
                e.setXYAt(t[1], t[5], "o", i), e.setXYAt(t[2], t[6], "i", i + 1), a && e.setXYAt(t[0], t[4], "v", i), e.setXYAt(t[3], t[7], "v", i + 1);
              }),
              (X.prototype.addShapes = function (t, e, i) {
                var a,
                  n,
                  r,
                  s,
                  o,
                  l,
                  c,
                  h,
                  u = t.pathsData,
                  d = t.shape.paths.shapes,
                  p = t.shape.paths._length,
                  f = 0,
                  m = [],
                  g = !0;
                for (h = i ? ((o = i._length), i._length) : ((i = Et.newElement()), (o = 0)), m.push(i), a = 0; a < p; a += 1) {
                  for (l = u[a].lengths, i.c = d[a].c, r = d[a].c ? l.length : l.length + 1, n = 1; n < r; n += 1)
                    if (f + (s = l[n - 1]).addedLength < e.s) (f += s.addedLength), (i.c = !1);
                    else {
                      if (f > e.e) {
                        i.c = !1;
                        break;
                      }
                      e.s <= f && e.e >= f + s.addedLength
                        ? (this.addSegment(d[a].v[n - 1], d[a].o[n - 1], d[a].i[n], d[a].v[n], i, o, g), (g = !1))
                        : ((c = N.getNewSegment(d[a].v[n - 1], d[a].v[n], d[a].o[n - 1], d[a].i[n], (e.s - f) / s.addedLength, (e.e - f) / s.addedLength, l[n - 1])), this.addSegmentFromArray(c, i, o, g), (g = !1), (i.c = !1)),
                        (f += s.addedLength),
                        (o += 1);
                    }
                  if (d[a].c && l.length) {
                    if (((s = l[n - 1]), f <= e.e)) {
                      var y = l[n - 1].addedLength;
                      e.s <= f && e.e >= f + y
                        ? (this.addSegment(d[a].v[n - 1], d[a].o[n - 1], d[a].i[0], d[a].v[0], i, o, g), (g = !1))
                        : ((c = N.getNewSegment(d[a].v[n - 1], d[a].v[0], d[a].o[n - 1], d[a].i[0], (e.s - f) / y, (e.e - f) / y, l[n - 1])), this.addSegmentFromArray(c, i, o, g), (g = !1), (i.c = !1));
                    } else i.c = !1;
                    (f += s.addedLength), (o += 1);
                  }
                  if ((i._length && (i.setXYAt(i.v[h][0], i.v[h][1], "i", h), i.setXYAt(i.v[i._length - 1][0], i.v[i._length - 1][1], "o", i._length - 1)), f > e.e)) break;
                  a < p - 1 && ((i = Et.newElement()), (g = !0), m.push(i), (o = 0));
                }
                return m;
              }),
              Y.registerModifier("tm", X),
              q([Q], Z),
              (Z.prototype.initModifierProperties = function (t, e) {
                (this.getValue = this.processKeys), (this.rd = J.getProp(t, e.r, 0, null, this)), (this._isAnimated = !!this.rd.effectsSequence.length);
              }),
              (Z.prototype.processPath = function (t, e) {
                var i,
                  a = Et.newElement();
                a.c = t.c;
                var n,
                  r,
                  s,
                  o,
                  l,
                  c,
                  h,
                  u,
                  d,
                  p,
                  m,
                  g,
                  y = t._length,
                  v = 0;
                for (i = 0; i < y; i += 1)
                  (n = t.v[i]),
                    (s = t.o[i]),
                    (r = t.i[i]),
                    n[0] === s[0] && n[1] === s[1] && n[0] === r[0] && n[1] === r[1]
                      ? (0 !== i && i !== y - 1) || t.c
                        ? ((o = 0 === i ? t.v[y - 1] : t.v[i - 1]),
                          (c = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0),
                          (h = m = n[0] + (o[0] - n[0]) * c),
                          (u = g = n[1] - (n[1] - o[1]) * c),
                          (d = h - (h - n[0]) * f),
                          (p = u - (u - n[1]) * f),
                          a.setTripleAt(h, u, d, p, m, g, v),
                          (v += 1),
                          (o = i === y - 1 ? t.v[0] : t.v[i + 1]),
                          (c = (l = Math.sqrt(Math.pow(n[0] - o[0], 2) + Math.pow(n[1] - o[1], 2))) ? Math.min(l / 2, e) / l : 0),
                          (h = d = n[0] + (o[0] - n[0]) * c),
                          (u = p = n[1] + (o[1] - n[1]) * c),
                          (m = h - (h - n[0]) * f),
                          (g = u - (u - n[1]) * f),
                          a.setTripleAt(h, u, d, p, m, g, v))
                        : a.setTripleAt(n[0], n[1], s[0], s[1], r[0], r[1], v)
                      : a.setTripleAt(t.v[i][0], t.v[i][1], t.o[i][0], t.o[i][1], t.i[i][0], t.i[i][1], v),
                    (v += 1);
                return a;
              }),
              (Z.prototype.processShapes = function (t) {
                var e,
                  i,
                  a,
                  n,
                  r,
                  s,
                  o = this.shapes.length,
                  l = this.rd.v;
                if (0 !== l)
                  for (i = 0; i < o; i += 1) {
                    if (((s = (r = this.shapes[i]).localShapeCollection), r.shape._mdf || this._mdf || t))
                      for (s.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, n = r.shape.paths._length, a = 0; a < n; a += 1) s.addShape(this.processPath(e[a], l));
                    r.shape.paths = r.localShapeCollection;
                  }
                this.dynamicProperties.length || (this._mdf = !1);
              }),
              Y.registerModifier("rd", Z),
              q([Q], $),
              ($.prototype.initModifierProperties = function (t, e) {
                (this.getValue = this.processKeys), (this.amount = J.getProp(t, e.a, 0, null, this)), (this._isAnimated = !!this.amount.effectsSequence.length);
              }),
              ($.prototype.processPath = function (t, e) {
                var i = e / 100,
                  a = [0, 0],
                  n = t._length,
                  r = 0;
                for (r = 0; r < n; r += 1) (a[0] += t.v[r][0]), (a[1] += t.v[r][1]);
                (a[0] /= n), (a[1] /= n);
                var s,
                  o,
                  l,
                  c,
                  h,
                  u,
                  d = Et.newElement();
                for (d.c = t.c, r = 0; r < n; r += 1)
                  (s = t.v[r][0] + (a[0] - t.v[r][0]) * i),
                    (o = t.v[r][1] + (a[1] - t.v[r][1]) * i),
                    (l = t.o[r][0] + (a[0] - t.o[r][0]) * -i),
                    (c = t.o[r][1] + (a[1] - t.o[r][1]) * -i),
                    (h = t.i[r][0] + (a[0] - t.i[r][0]) * -i),
                    (u = t.i[r][1] + (a[1] - t.i[r][1]) * -i),
                    d.setTripleAt(s, o, l, c, h, u, r);
                return d;
              }),
              ($.prototype.processShapes = function (t) {
                var e,
                  i,
                  a,
                  n,
                  r,
                  s,
                  o = this.shapes.length,
                  l = this.amount.v;
                if (0 !== l)
                  for (i = 0; i < o; i += 1) {
                    if (((s = (r = this.shapes[i]).localShapeCollection), r.shape._mdf || this._mdf || t))
                      for (s.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, n = r.shape.paths._length, a = 0; a < n; a += 1) s.addShape(this.processPath(e[a], l));
                    r.shape.paths = r.localShapeCollection;
                  }
                this.dynamicProperties.length || (this._mdf = !1);
              }),
              Y.registerModifier("pb", $),
              q([Q], tt),
              (tt.prototype.initModifierProperties = function (t, e) {
                (this.getValue = this.processKeys),
                  (this.c = J.getProp(t, e.c, 0, null, this)),
                  (this.o = J.getProp(t, e.o, 0, null, this)),
                  (this.tr = z.getTransformProperty(t, e.tr, this)),
                  (this.so = J.getProp(t, e.tr.so, 0, 0.01, this)),
                  (this.eo = J.getProp(t, e.tr.eo, 0, 0.01, this)),
                  (this.data = e),
                  this.dynamicProperties.length || this.getValue(!0),
                  (this._isAnimated = !!this.dynamicProperties.length),
                  (this.pMatrix = new O()),
                  (this.rMatrix = new O()),
                  (this.sMatrix = new O()),
                  (this.tMatrix = new O()),
                  (this.matrix = new O());
              }),
              (tt.prototype.applyTransforms = function (t, e, i, a, n, r) {
                var s = r ? -1 : 1,
                  o = a.s.v[0] + (1 - a.s.v[0]) * (1 - n),
                  l = a.s.v[1] + (1 - a.s.v[1]) * (1 - n);
                t.translate(a.p.v[0] * s * n, a.p.v[1] * s * n, a.p.v[2]),
                  e.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]),
                  e.rotate(-a.r.v * s * n),
                  e.translate(a.a.v[0], a.a.v[1], a.a.v[2]),
                  i.translate(-a.a.v[0], -a.a.v[1], a.a.v[2]),
                  i.scale(r ? 1 / o : o, r ? 1 / l : l),
                  i.translate(a.a.v[0], a.a.v[1], a.a.v[2]);
              }),
              (tt.prototype.init = function (t, e, i, a) {
                for (
                  this.elem = t, this.arr = e, this.pos = i, this.elemsData = a, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[i]);
                  0 < i;

                )
                  (i -= 1), this._elements.unshift(e[i]);
                this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
              }),
              (tt.prototype.resetElements = function (t) {
                var e,
                  i = t.length;
                for (e = 0; e < i; e += 1) (t[e]._processed = !1), "gr" === t[e].ty && this.resetElements(t[e].it);
              }),
              (tt.prototype.cloneElements = function (t) {
                var e = JSON.parse(JSON.stringify(t));
                return this.resetElements(e), e;
              }),
              (tt.prototype.changeGroupRender = function (t, e) {
                var i,
                  a = t.length;
                for (i = 0; i < a; i += 1) (t[i]._render = e), "gr" === t[i].ty && this.changeGroupRender(t[i].it, e);
              }),
              (tt.prototype.processShapes = function (t) {
                var e,
                  i,
                  a,
                  n,
                  r,
                  s = !1;
                if (this._mdf || t) {
                  var o,
                    l = Math.ceil(this.c.v);
                  if (this._groups.length < l) {
                    for (; this._groups.length < l; ) {
                      var c = { it: this.cloneElements(this._elements), ty: "gr" };
                      c.it.push({
                        a: { a: 0, ix: 1, k: [0, 0] },
                        nm: "Transform",
                        o: { a: 0, ix: 7, k: 100 },
                        p: { a: 0, ix: 2, k: [0, 0] },
                        r: {
                          a: 1,
                          ix: 6,
                          k: [
                            { s: 0, e: 0, t: 0 },
                            { s: 0, e: 0, t: 1 },
                          ],
                        },
                        s: { a: 0, ix: 3, k: [100, 100] },
                        sa: { a: 0, ix: 5, k: 0 },
                        sk: { a: 0, ix: 4, k: 0 },
                        ty: "tr",
                      }),
                        this.arr.splice(0, 0, c),
                        this._groups.splice(0, 0, c),
                        (this._currentCopies += 1);
                    }
                    this.elem.reloadShapes(), (s = !0);
                  }
                  for (a = r = 0; a <= this._groups.length - 1; a += 1) {
                    if (((o = r < l), (this._groups[a]._render = o), this.changeGroupRender(this._groups[a].it, o), !o)) {
                      var h = this.elemsData[a].it,
                        u = h[h.length - 1];
                      0 !== u.transform.op.v ? ((u.transform.op._mdf = !0), (u.transform.op.v = 0)) : (u.transform.op._mdf = !1);
                    }
                    r += 1;
                  }
                  this._currentCopies = l;
                  var d = this.o.v,
                    p = d % 1,
                    f = 0 < d ? Math.floor(d) : Math.ceil(d),
                    m = this.pMatrix.props,
                    g = this.rMatrix.props,
                    y = this.sMatrix.props;
                  this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                  var v,
                    A,
                    b = 0;
                  if (0 < d) {
                    for (; b < f; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), (b += 1);
                    p && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, p, !1), (b += p));
                  } else if (d < 0) {
                    for (; f < b; ) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), (b -= 1);
                    p && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -p, !0), (b -= p));
                  }
                  for (a = 1 === this.data.m ? 0 : this._currentCopies - 1, n = 1 === this.data.m ? 1 : -1, r = this._currentCopies; r; ) {
                    if (
                      ((A = (i = (e = this.elemsData[a].it)[e.length - 1].transform.mProps.v.props).length),
                      (e[e.length - 1].transform.mProps._mdf = !0),
                      (e[e.length - 1].transform.op._mdf = !0),
                      (e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (a / (this._currentCopies - 1))),
                      0 !== b)
                    ) {
                      for (
                        ((0 !== a && 1 === n) || (a !== this._currentCopies - 1 && -1 === n)) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1),
                          this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]),
                          this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]),
                          this.matrix.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]),
                          v = 0;
                        v < A;
                        v += 1
                      )
                        i[v] = this.matrix.props[v];
                      this.matrix.reset();
                    } else for (this.matrix.reset(), v = 0; v < A; v += 1) i[v] = this.matrix.props[v];
                    (b += 1), (r -= 1), (a += n);
                  }
                } else
                  for (r = this._currentCopies, a = 0, n = 1; r; )
                    (i = (e = this.elemsData[a].it)[e.length - 1].transform.mProps.v.props), (e[e.length - 1].transform.mProps._mdf = !1), (e[e.length - 1].transform.op._mdf = !1), (r -= 1), (a += n);
                return s;
              }),
              (tt.prototype.addShape = function () {}),
              Y.registerModifier("rp", tt),
              (et.prototype.addShape = function (t) {
                this._length === this._maxLength && ((this.shapes = this.shapes.concat(P(this._maxLength))), (this._maxLength *= 2)), (this.shapes[this._length] = t), (this._length += 1);
              }),
              (et.prototype.releaseShapes = function () {
                var t;
                for (t = 0; t < this._length; t += 1) Et.release(this.shapes[t]);
                this._length = 0;
              }),
              (it.prototype.getValue = function (t) {
                if ((this.elem.globalData.frameId !== this.frameId || t) && ((this.frameId = this.elem.globalData.frameId), this.iterateDynamicProperties(), (this._mdf = this._mdf || t), this._mdf)) {
                  var e = 0,
                    i = this.dataProps.length;
                  for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < i; e += 1)
                    "o" !== this.dataProps[e].n ? ("svg" === this.renderer ? (this.dashStr += " " + this.dataProps[e].p.v) : (this.dashArray[e] = this.dataProps[e].p.v)) : (this.dashoffset[0] = this.dataProps[e].p.v);
                }
              }),
              q([L], it),
              (at.prototype.comparePoints = function (t, e) {
                for (var i = 0, a = this.o.length / 2; i < a; ) {
                  if (0.01 < Math.abs(t[4 * i] - t[4 * e + 2 * i])) return !1;
                  i += 1;
                }
                return !0;
              }),
              (at.prototype.checkCollapsable = function () {
                if (this.o.length / 2 != this.c.length / 4) return !1;
                if (this.data.k.k[0].s)
                  for (var t = 0, e = this.data.k.k.length; t < e; ) {
                    if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                    t += 1;
                  }
                else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
                return !0;
              }),
              (at.prototype.getValue = function (t) {
                if ((this.prop.getValue(), (this._mdf = !1), (this._cmdf = !1), (this._omdf = !1), this.prop._mdf || t)) {
                  var e,
                    i,
                    a,
                    n = 4 * this.data.p;
                  for (e = 0; e < n; e += 1) (i = e % 4 == 0 ? 100 : 255), (a = Math.round(this.prop.v[e] * i)), this.c[e] !== a && ((this.c[e] = a), (this._cmdf = !t));
                  if (this.o.length)
                    for (n = this.prop.v.length, e = 4 * this.data.p; e < n; e += 1)
                      (i = e % 2 == 0 ? 100 : 1), (a = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e]), this.o[e - 4 * this.data.p] !== a && ((this.o[e - 4 * this.data.p] = a), (this._omdf = !t));
                  this._mdf = !t;
                }
              }),
              q([L], at);
            var nt,
              rt,
              st = function (t, e, i, a) {
                if (0 === e) return "";
                var n,
                  r = t.o,
                  s = t.i,
                  o = t.v,
                  l = " M" + a.applyToPointStringified(o[0][0], o[0][1]);
                for (n = 1; n < e; n += 1) l += " C" + a.applyToPointStringified(r[n - 1][0], r[n - 1][1]) + " " + a.applyToPointStringified(s[n][0], s[n][1]) + " " + a.applyToPointStringified(o[n][0], o[n][1]);
                return i && e && ((l += " C" + a.applyToPointStringified(r[n - 1][0], r[n - 1][1]) + " " + a.applyToPointStringified(s[0][0], s[0][1]) + " " + a.applyToPointStringified(o[0][0], o[0][1])), (l += "z")), l;
              },
              ot = (function () {
                function t(t) {
                  (this.audios = []), (this.audioFactory = t), (this._volume = 1), (this._isMuted = !1);
                }
                return (
                  (t.prototype = {
                    addAudio: function (t) {
                      this.audios.push(t);
                    },
                    pause: function () {
                      var t,
                        e = this.audios.length;
                      for (t = 0; t < e; t += 1) this.audios[t].pause();
                    },
                    resume: function () {
                      var t,
                        e = this.audios.length;
                      for (t = 0; t < e; t += 1) this.audios[t].resume();
                    },
                    setRate: function (t) {
                      var e,
                        i = this.audios.length;
                      for (e = 0; e < i; e += 1) this.audios[e].setRate(t);
                    },
                    createAudio: function (t) {
                      return this.audioFactory
                        ? this.audioFactory(t)
                        : Howl
                        ? new Howl({ src: [t] })
                        : {
                            isPlaying: !1,
                            play: function () {
                              this.isPlaying = !0;
                            },
                            seek: function () {
                              this.isPlaying = !1;
                            },
                            playing: function () {},
                            rate: function () {},
                            setVolume: function () {},
                          };
                    },
                    setAudioFactory: function (t) {
                      this.audioFactory = t;
                    },
                    setVolume: function (t) {
                      (this._volume = t), this._updateVolume();
                    },
                    mute: function () {
                      (this._isMuted = !0), this._updateVolume();
                    },
                    unmute: function () {
                      (this._isMuted = !1), this._updateVolume();
                    },
                    getVolume: function () {
                      return this._volume;
                    },
                    _updateVolume: function () {
                      var t,
                        e = this.audios.length;
                      for (t = 0; t < e; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                    },
                  }),
                  function () {
                    return new t();
                  }
                );
              })(),
              lt = (function () {
                var t = (function () {
                  var t = I("canvas");
                  (t.width = 1), (t.height = 1);
                  var e = t.getContext("2d");
                  return (e.fillStyle = "rgba(0,0,0,0)"), e.fillRect(0, 0, 1, 1), t;
                })();
                function e() {
                  (this.loadedAssets += 1), this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                }
                function i() {
                  (this.loadedFootagesCount += 1), this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
                }
                function a(t, e, i) {
                  var a = "";
                  if (t.e) a = t.p;
                  else if (e) {
                    var n = t.p;
                    -1 !== n.indexOf("images/") && (n = n.split("/")[1]), (a = e + n);
                  } else (a = i), (a += t.u ? t.u : ""), (a += t.p);
                  return a;
                }
                function n() {
                  (this._imageLoaded = e.bind(this)),
                    (this._footageLoaded = i.bind(this)),
                    (this.testImageLoaded = function (t) {
                      var e = 0,
                        i = setInterval(
                          function () {
                            (t.getBBox().width || 500 < e) && (this._imageLoaded(), clearInterval(i)), (e += 1);
                          }.bind(this),
                          50
                        );
                    }.bind(this)),
                    (this.createFootageData = function (t) {
                      var e = { assetData: t },
                        i = a(t, this.assetsPath, this.path);
                      return (
                        ut.load(
                          i,
                          function (t) {
                            (e.img = t), this._footageLoaded();
                          }.bind(this),
                          function () {
                            (e.img = {}), this._footageLoaded();
                          }.bind(this)
                        ),
                        e
                      );
                    }.bind(this)),
                    (this.assetsPath = ""),
                    (this.path = ""),
                    (this.totalImages = 0),
                    (this.totalFootages = 0),
                    (this.loadedAssets = 0),
                    (this.loadedFootagesCount = 0),
                    (this.imagesLoadedCb = null),
                    (this.images = []);
                }
                return (
                  (n.prototype = {
                    loadAssets: function (t, e) {
                      var i;
                      this.imagesLoadedCb = e;
                      var a = t.length;
                      for (i = 0; i < a; i += 1)
                        t[i].layers || (t[i].t ? 3 === t[i].t && ((this.totalFootages += 1), this.images.push(this.createFootageData(t[i]))) : ((this.totalImages += 1), this.images.push(this._createImageData(t[i]))));
                    },
                    setAssetsPath: function (t) {
                      this.assetsPath = t || "";
                    },
                    setPath: function (t) {
                      this.path = t || "";
                    },
                    loadedImages: function () {
                      return this.totalImages === this.loadedAssets;
                    },
                    loadedFootages: function () {
                      return this.totalFootages === this.loadedFootagesCount;
                    },
                    destroy: function () {
                      (this.imagesLoadedCb = null), (this.images.length = 0);
                    },
                    getAsset: function (t) {
                      for (var e = 0, i = this.images.length; e < i; ) {
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                      }
                      return null;
                    },
                    createImgData: function (e) {
                      var i = a(e, this.assetsPath, this.path),
                        n = I("img");
                      (n.crossOrigin = "anonymous"),
                        n.addEventListener("load", this._imageLoaded, !1),
                        n.addEventListener(
                          "error",
                          function () {
                            (r.img = t), this._imageLoaded();
                          }.bind(this),
                          !1
                        ),
                        (n.src = i);
                      var r = { img: n, assetData: e };
                      return r;
                    },
                    createImageData: function (e) {
                      var i = a(e, this.assetsPath, this.path),
                        n = D("image");
                      s ? this.testImageLoaded(n) : n.addEventListener("load", this._imageLoaded, !1),
                        n.addEventListener(
                          "error",
                          function () {
                            (r.img = t), this._imageLoaded();
                          }.bind(this),
                          !1
                        ),
                        n.setAttributeNS("http://www.w3.org/1999/xlink", "href", i),
                        this._elementHelper.append ? this._elementHelper.append(n) : this._elementHelper.appendChild(n);
                      var r = { img: n, assetData: e };
                      return r;
                    },
                    imageLoaded: e,
                    footageLoaded: i,
                    setCacheType: function (t, e) {
                      this._createImageData = "svg" === t ? ((this._elementHelper = e), this.createImageData.bind(this)) : this.createImgData.bind(this);
                    },
                  }),
                  n
                );
              })(),
              ct = ((nt = { maskType: !0 }), (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (nt.maskType = !1), nt),
              ht =
                (((rt = {}).createFilter = function (t, e) {
                  var i = D("filter");
                  return i.setAttribute("id", t), !0 !== e && (i.setAttribute("filterUnits", "objectBoundingBox"), i.setAttribute("x", "0%"), i.setAttribute("y", "0%"), i.setAttribute("width", "100%"), i.setAttribute("height", "100%")), i;
                }),
                (rt.createAlphaToLuminanceFilter = function () {
                  var t = D("feColorMatrix");
                  return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
                }),
                rt),
              ut = (function () {
                function t(t) {
                  return t.response && "object" == typeof t.response ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                }
                return {
                  load: function (e, i, a) {
                    var n,
                      r = new XMLHttpRequest();
                    try {
                      r.responseType = "json";
                    } catch (e) {}
                    (r.onreadystatechange = function () {
                      if (4 === r.readyState)
                        if (200 === r.status) (n = t(r)), i(n);
                        else
                          try {
                            (n = t(r)), i(n);
                          } catch (t) {
                            a && a(t);
                          }
                    }),
                      r.open("GET", e, !0),
                      r.send();
                  },
                };
              })();
            function dt(t, e, i) {
              (this._isFirstFrame = !0),
                (this._hasMaskedPath = !1),
                (this._frameId = -1),
                (this._textData = t),
                (this._renderType = e),
                (this._elem = i),
                (this._animatorsData = P(this._textData.a.length)),
                (this._pathData = {}),
                (this._moreOptions = { alignment: {} }),
                (this.renderedLetters = []),
                (this.lettersChangedFlag = !1),
                this.initDynamicPropertyContainer(i);
            }
            function pt(t, e, i) {
              var a = { propType: !1 },
                n = J.getProp,
                r = e.a;
              (this.a = {
                r: r.r ? n(t, r.r, 0, p, i) : a,
                rx: r.rx ? n(t, r.rx, 0, p, i) : a,
                ry: r.ry ? n(t, r.ry, 0, p, i) : a,
                sk: r.sk ? n(t, r.sk, 0, p, i) : a,
                sa: r.sa ? n(t, r.sa, 0, p, i) : a,
                s: r.s ? n(t, r.s, 1, 0.01, i) : a,
                a: r.a ? n(t, r.a, 1, 0, i) : a,
                o: r.o ? n(t, r.o, 0, 0.01, i) : a,
                p: r.p ? n(t, r.p, 1, 0, i) : a,
                sw: r.sw ? n(t, r.sw, 0, 0, i) : a,
                sc: r.sc ? n(t, r.sc, 1, 0, i) : a,
                fc: r.fc ? n(t, r.fc, 1, 0, i) : a,
                fh: r.fh ? n(t, r.fh, 0, 0, i) : a,
                fs: r.fs ? n(t, r.fs, 0, 0.01, i) : a,
                fb: r.fb ? n(t, r.fb, 0, 0.01, i) : a,
                t: r.t ? n(t, r.t, 0, 0, i) : a,
              }),
                (this.s = wt.getTextSelectorProp(t, e.s, i)),
                (this.s.t = e.s.t);
            }
            function ft(t, e, i, a, n, r) {
              (this.o = t), (this.sw = e), (this.sc = i), (this.fc = a), (this.m = n), (this.p = r), (this._mdf = { o: !0, sw: !!e, sc: !!i, fc: !!a, m: !0, p: !0 });
            }
            function mt(t, e) {
              (this._frameId = n),
                (this.pv = ""),
                (this.v = ""),
                (this.kf = !1),
                (this._isFirstFrame = !0),
                (this._mdf = !1),
                (this.data = e),
                (this.elem = t),
                (this.comp = this.elem.comp),
                (this.keysIndex = 0),
                (this.canResize = !1),
                (this.minimumFontSize = 1),
                (this.effectsSequence = []),
                (this.currentData = {
                  ascent: 0,
                  boxWidth: this.defaultBoxWidth,
                  f: "",
                  fStyle: "",
                  fWeight: "",
                  fc: "",
                  j: "",
                  justifyOffset: "",
                  l: [],
                  lh: 0,
                  lineWidths: [],
                  ls: "",
                  of: "",
                  s: "",
                  sc: "",
                  sw: 0,
                  t: 0,
                  tr: 0,
                  sz: 0,
                  ps: null,
                  fillColorAnim: !1,
                  strokeColorAnim: !1,
                  strokeWidthAnim: !1,
                  yOffset: 0,
                  finalSize: 0,
                  finalText: [],
                  finalLineHeight: 0,
                  __complete: !1,
                }),
                this.copyData(this.currentData, this.data.d.k[0].s),
                this.searchProperty() || this.completeTextData(this.currentData);
            }
            (dt.prototype.searchProperties = function () {
              var t,
                e,
                i = this._textData.a.length,
                a = J.getProp;
              for (t = 0; t < i; t += 1) (e = this._textData.a[t]), (this._animatorsData[t] = new pt(this._elem, e, this));
              this._textData.p && "m" in this._textData.p
                ? ((this._pathData = { f: a(this._elem, this._textData.p.f, 0, 0, this), l: a(this._elem, this._textData.p.l, 0, 0, this), r: this._textData.p.r, m: this._elem.maskManager.getMaskProperty(this._textData.p.m) }),
                  (this._hasMaskedPath = !0))
                : (this._hasMaskedPath = !1),
                (this._moreOptions.alignment = a(this._elem, this._textData.m.a, 1, 0, this));
            }),
              (dt.prototype.getMeasures = function (t, e) {
                if (((this.lettersChangedFlag = e), this._mdf || this._isFirstFrame || e || (this._hasMaskedPath && this._pathData.m._mdf))) {
                  this._isFirstFrame = !1;
                  var i,
                    a,
                    n,
                    r,
                    s,
                    o,
                    l,
                    c,
                    h,
                    u,
                    d,
                    p,
                    f,
                    m,
                    g,
                    y,
                    v,
                    A,
                    b,
                    w = this._moreOptions.alignment.v,
                    C = this._animatorsData,
                    S = this._textData,
                    k = this.mHelper,
                    T = this._renderType,
                    M = this.renderedLetters.length,
                    P = t.l;
                  if (this._hasMaskedPath) {
                    if (((b = this._pathData.m), !this._pathData.n || this._pathData._mdf)) {
                      var D,
                        I = b.v;
                      for (this._pathData.r && (I = I.reverse()), s = { tLength: 0, segments: [] }, r = I._length - 1, n = y = 0; n < r; n += 1)
                        (D = N.buildBezierData(I.v[n], I.v[n + 1], [I.o[n][0] - I.v[n][0], I.o[n][1] - I.v[n][1]], [I.i[n + 1][0] - I.v[n + 1][0], I.i[n + 1][1] - I.v[n + 1][1]])),
                          (s.tLength += D.segmentLength),
                          s.segments.push(D),
                          (y += D.segmentLength);
                      (n = r),
                        b.v.c &&
                          ((D = N.buildBezierData(I.v[n], I.v[0], [I.o[n][0] - I.v[n][0], I.o[n][1] - I.v[n][1]], [I.i[0][0] - I.v[0][0], I.i[0][1] - I.v[0][1]])), (s.tLength += D.segmentLength), s.segments.push(D), (y += D.segmentLength)),
                        (this._pathData.pi = s);
                    }
                    if (((s = this._pathData.pi), (o = this._pathData.f.v), (u = 1), (h = !(c = d = 0)), (m = s.segments), o < 0 && b.v.c))
                      for (s.tLength < Math.abs(o) && (o = -Math.abs(o) % s.tLength), u = (f = m[(d = m.length - 1)].points).length - 1; o < 0; ) (o += f[u].partialLength), (u -= 1) < 0 && (u = (f = m[(d -= 1)].points).length - 1);
                    (p = (f = m[d].points)[u - 1]), (g = (l = f[u]).partialLength);
                  }
                  (r = P.length), (a = i = 0);
                  var L,
                    R,
                    F,
                    O,
                    B,
                    q = 1.2 * t.finalSize * 0.714,
                    V = !0;
                  F = C.length;
                  var W,
                    U,
                    J,
                    z,
                    K,
                    G,
                    j,
                    H,
                    Y,
                    Q,
                    X,
                    Z,
                    $ = -1,
                    tt = o,
                    et = d,
                    it = u,
                    at = -1,
                    nt = "",
                    rt = this.defaultPropsArray;
                  if (2 === t.j || 1 === t.j) {
                    var st = 0,
                      ot = 0,
                      lt = 2 === t.j ? -0.5 : -1,
                      ct = 0,
                      ht = !0;
                    for (n = 0; n < r; n += 1)
                      if (P[n].n) {
                        for (st && (st += ot); ct < n; ) (P[ct].animatorJustifyOffset = st), (ct += 1);
                        ht = !(st = 0);
                      } else {
                        for (R = 0; R < F; R += 1) (L = C[R].a).t.propType && (ht && 2 === t.j && (ot += L.t.v * lt), (B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)).length ? (st += L.t.v * B[0] * lt) : (st += L.t.v * B * lt));
                        ht = !1;
                      }
                    for (st && (st += ot); ct < n; ) (P[ct].animatorJustifyOffset = st), (ct += 1);
                  }
                  for (n = 0; n < r; n += 1) {
                    if ((k.reset(), (z = 1), P[n].n))
                      (i = 0),
                        (a += t.yOffset),
                        (a += V ? 1 : 0),
                        (o = tt),
                        (V = !1),
                        this._hasMaskedPath && ((u = it), (p = (f = m[(d = et)].points)[u - 1]), (g = (l = f[u]).partialLength), (c = 0)),
                        (Z = Y = X = nt = ""),
                        (rt = this.defaultPropsArray);
                    else {
                      if (this._hasMaskedPath) {
                        if (at !== P[n].line) {
                          switch (t.j) {
                            case 1:
                              o += y - t.lineWidths[P[n].line];
                              break;
                            case 2:
                              o += (y - t.lineWidths[P[n].line]) / 2;
                          }
                          at = P[n].line;
                        }
                        $ !== P[n].ind && (P[$] && (o += P[$].extra), (o += P[n].an / 2), ($ = P[n].ind)), (o += w[0] * P[n].an * 0.005);
                        var ut = 0;
                        for (R = 0; R < F; R += 1)
                          (L = C[R].a).p.propType && ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)).length ? (ut += L.p.v[0] * B[0]) : (ut += L.p.v[0] * B)),
                            L.a.propType && ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)).length ? (ut += L.a.v[0] * B[0]) : (ut += L.a.v[0] * B));
                        for (h = !0; h; )
                          o + ut <= c + g || !f
                            ? ((v = (o + ut - c) / l.partialLength), (U = p.point[0] + (l.point[0] - p.point[0]) * v), (J = p.point[1] + (l.point[1] - p.point[1]) * v), k.translate(-w[0] * P[n].an * 0.005, -w[1] * q * 0.01), (h = !1))
                            : f &&
                              ((c += l.partialLength), (u += 1) >= f.length && ((u = 0), (f = m[(d += 1)] ? m[d].points : b.v.c ? m[(d = u = 0)].points : ((c -= l.partialLength), null))), f && ((p = l), (g = (l = f[u]).partialLength)));
                        (W = P[n].an / 2 - P[n].add), k.translate(-W, 0, 0);
                      } else (W = P[n].an / 2 - P[n].add), k.translate(-W, 0, 0), k.translate(-w[0] * P[n].an * 0.005, -w[1] * q * 0.01, 0);
                      for (R = 0; R < F; R += 1)
                        (L = C[R].a).t.propType &&
                          ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)),
                          (0 === i && 0 === t.j) || (this._hasMaskedPath ? (B.length ? (o += L.t.v * B[0]) : (o += L.t.v * B)) : B.length ? (i += L.t.v * B[0]) : (i += L.t.v * B)));
                      for (t.strokeWidthAnim && (G = t.sw || 0), t.strokeColorAnim && (K = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (j = [t.fc[0], t.fc[1], t.fc[2]]), R = 0; R < F; R += 1)
                        (L = C[R].a).a.propType &&
                          ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)).length ? k.translate(-L.a.v[0] * B[0], -L.a.v[1] * B[1], L.a.v[2] * B[2]) : k.translate(-L.a.v[0] * B, -L.a.v[1] * B, L.a.v[2] * B));
                      for (R = 0; R < F; R += 1)
                        (L = C[R].a).s.propType &&
                          ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)).length ? k.scale(1 + (L.s.v[0] - 1) * B[0], 1 + (L.s.v[1] - 1) * B[1], 1) : k.scale(1 + (L.s.v[0] - 1) * B, 1 + (L.s.v[1] - 1) * B, 1));
                      for (R = 0; R < F; R += 1) {
                        if (
                          ((L = C[R].a),
                          (B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)),
                          L.sk.propType && (B.length ? k.skewFromAxis(-L.sk.v * B[0], L.sa.v * B[1]) : k.skewFromAxis(-L.sk.v * B, L.sa.v * B)),
                          L.r.propType && (B.length ? k.rotateZ(-L.r.v * B[2]) : k.rotateZ(-L.r.v * B)),
                          L.ry.propType && (B.length ? k.rotateY(L.ry.v * B[1]) : k.rotateY(L.ry.v * B)),
                          L.rx.propType && (B.length ? k.rotateX(L.rx.v * B[0]) : k.rotateX(L.rx.v * B)),
                          L.o.propType && (B.length ? (z += (L.o.v * B[0] - z) * B[0]) : (z += (L.o.v * B - z) * B)),
                          t.strokeWidthAnim && L.sw.propType && (B.length ? (G += L.sw.v * B[0]) : (G += L.sw.v * B)),
                          t.strokeColorAnim && L.sc.propType)
                        )
                          for (H = 0; H < 3; H += 1) B.length ? (K[H] += (L.sc.v[H] - K[H]) * B[0]) : (K[H] += (L.sc.v[H] - K[H]) * B);
                        if (t.fillColorAnim && t.fc) {
                          if (L.fc.propType) for (H = 0; H < 3; H += 1) B.length ? (j[H] += (L.fc.v[H] - j[H]) * B[0]) : (j[H] += (L.fc.v[H] - j[H]) * B);
                          L.fh.propType && (j = B.length ? _(j, L.fh.v * B[0]) : _(j, L.fh.v * B)),
                            L.fs.propType && (j = B.length ? E(j, L.fs.v * B[0]) : E(j, L.fs.v * B)),
                            L.fb.propType && (j = B.length ? x(j, L.fb.v * B[0]) : x(j, L.fb.v * B));
                        }
                      }
                      for (R = 0; R < F; R += 1)
                        (L = C[R].a).p.propType &&
                          ((B = C[R].s.getMult(P[n].anIndexes[R], S.a[R].s.totalChars)),
                          this._hasMaskedPath
                            ? B.length
                              ? k.translate(0, L.p.v[1] * B[0], -L.p.v[2] * B[1])
                              : k.translate(0, L.p.v[1] * B, -L.p.v[2] * B)
                            : B.length
                            ? k.translate(L.p.v[0] * B[0], L.p.v[1] * B[1], -L.p.v[2] * B[2])
                            : k.translate(L.p.v[0] * B, L.p.v[1] * B, -L.p.v[2] * B));
                      if (
                        (t.strokeWidthAnim && (Y = G < 0 ? 0 : G),
                        t.strokeColorAnim && (Q = "rgb(" + Math.round(255 * K[0]) + "," + Math.round(255 * K[1]) + "," + Math.round(255 * K[2]) + ")"),
                        t.fillColorAnim && t.fc && (X = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"),
                        this._hasMaskedPath)
                      ) {
                        if ((k.translate(0, -t.ls), k.translate(0, w[1] * q * 0.01 + a, 0), S.p.p)) {
                          A = (l.point[1] - p.point[1]) / (l.point[0] - p.point[0]);
                          var dt = (180 * Math.atan(A)) / Math.PI;
                          l.point[0] < p.point[0] && (dt += 180), k.rotate((-dt * Math.PI) / 180);
                        }
                        k.translate(U, J, 0), (o -= w[0] * P[n].an * 0.005), P[n + 1] && $ !== P[n + 1].ind && ((o += P[n].an / 2), (o += 0.001 * t.tr * t.finalSize));
                      } else {
                        switch ((k.translate(i, a, 0), t.ps && k.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j)) {
                          case 1:
                            k.translate(P[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[P[n].line]), 0, 0);
                            break;
                          case 2:
                            k.translate(P[n].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[P[n].line]) / 2, 0, 0);
                        }
                        k.translate(0, -t.ls), k.translate(W, 0, 0), k.translate(w[0] * P[n].an * 0.005, w[1] * q * 0.01, 0), (i += P[n].l + 0.001 * t.tr * t.finalSize);
                      }
                      "html" === T
                        ? (nt = k.toCSS())
                        : "svg" === T
                        ? (nt = k.to2dCSS())
                        : (rt = [k.props[0], k.props[1], k.props[2], k.props[3], k.props[4], k.props[5], k.props[6], k.props[7], k.props[8], k.props[9], k.props[10], k.props[11], k.props[12], k.props[13], k.props[14], k.props[15]]),
                        (Z = z);
                    }
                    this.lettersChangedFlag = M <= n ? ((O = new ft(Z, Y, Q, X, nt, rt)), this.renderedLetters.push(O), (M += 1), !0) : (O = this.renderedLetters[n]).update(Z, Y, Q, X, nt, rt) || this.lettersChangedFlag;
                  }
                }
              }),
              (dt.prototype.getValue = function () {
                this._elem.globalData.frameId !== this._frameId && ((this._frameId = this._elem.globalData.frameId), this.iterateDynamicProperties());
              }),
              (dt.prototype.mHelper = new O()),
              (dt.prototype.defaultPropsArray = []),
              q([L], dt),
              (ft.prototype.update = function (t, e, i, a, n, r) {
                (this._mdf.o = !1), (this._mdf.sw = !1), (this._mdf.sc = !1), (this._mdf.fc = !1), (this._mdf.m = !1);
                var s = (this._mdf.p = !1);
                return (
                  this.o !== t && ((this.o = t), (s = this._mdf.o = !0)),
                  this.sw !== e && ((this.sw = e), (s = this._mdf.sw = !0)),
                  this.sc !== i && ((this.sc = i), (s = this._mdf.sc = !0)),
                  this.fc !== a && ((this.fc = a), (s = this._mdf.fc = !0)),
                  this.m !== n && ((this.m = n), (s = this._mdf.m = !0)),
                  !r.length || (this.p[0] === r[0] && this.p[1] === r[1] && this.p[4] === r[4] && this.p[5] === r[5] && this.p[12] === r[12] && this.p[13] === r[13]) || ((this.p = r), (s = this._mdf.p = !0)),
                  s
                );
              }),
              (mt.prototype.defaultBoxWidth = [0, 0]),
              (mt.prototype.copyData = function (t, e) {
                for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                return t;
              }),
              (mt.prototype.setCurrentData = function (t) {
                t.__complete || this.completeTextData(t), (this.currentData = t), (this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth), (this._mdf = !0);
              }),
              (mt.prototype.searchProperty = function () {
                return this.searchKeyframes();
              }),
              (mt.prototype.searchKeyframes = function () {
                return (this.kf = 1 < this.data.d.k.length), this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
              }),
              (mt.prototype.addEffect = function (t) {
                this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
              }),
              (mt.prototype.getValue = function (t) {
                if ((this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) || t) {
                  this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                  var e = this.currentData,
                    i = this.keysIndex;
                  if (this.lock) this.setCurrentData(this.currentData);
                  else {
                    var a;
                    (this.lock = !0), (this._mdf = !1);
                    var n = this.effectsSequence.length,
                      r = t || this.data.d.k[this.keysIndex].s;
                    for (a = 0; a < n; a += 1) r = i !== this.keysIndex ? this.effectsSequence[a](r, r.t) : this.effectsSequence[a](this.currentData, r.t);
                    e !== r && this.setCurrentData(r), (this.v = this.currentData), (this.pv = this.v), (this.lock = !1), (this.frameId = this.elem.globalData.frameId);
                  }
                }
              }),
              (mt.prototype.getKeyframeValue = function () {
                for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, i = 0, a = t.length; i <= a - 1 && !(i === a - 1 || t[i + 1].t > e); ) i += 1;
                return this.keysIndex !== i && (this.keysIndex = i), this.data.d.k[this.keysIndex].s;
              }),
              (mt.prototype.buildFinalText = function (t) {
                for (var e, i = U.getCombinedCharacterCodes(), a = [], n = 0, r = t.length; n < r; )
                  (e = t.charCodeAt(n)),
                    -1 !== i.indexOf(e) ? (a[a.length - 1] += t.charAt(n)) : 55296 <= e && e <= 56319 && 56320 <= (e = t.charCodeAt(n + 1)) && e <= 57343 ? (a.push(t.substr(n, 2)), (n += 1)) : a.push(t.charAt(n)),
                    (n += 1);
                return a;
              }),
              (mt.prototype.completeTextData = function (t) {
                t.__complete = !0;
                var e,
                  i,
                  a,
                  n,
                  r,
                  s,
                  o,
                  l = this.elem.globalData.fontManager,
                  c = this.data,
                  h = [],
                  u = 0,
                  d = c.m.g,
                  p = 0,
                  f = 0,
                  m = 0,
                  g = [],
                  y = 0,
                  v = 0,
                  A = l.getFontByName(t.f),
                  b = 0,
                  w = W(A);
                (t.fWeight = w.weight), (t.fStyle = w.style), (t.finalSize = t.s), (t.finalText = this.buildFinalText(t.t)), (i = t.finalText.length), (t.finalLineHeight = t.lh);
                var C,
                  S = (t.tr / 1e3) * t.finalSize;
                if (t.sz)
                  for (var k, E, x = !0, _ = t.sz[0], T = t.sz[1]; x; ) {
                    (y = k = 0), (i = (E = this.buildFinalText(t.t)).length), (S = (t.tr / 1e3) * t.finalSize);
                    var M = -1;
                    for (e = 0; e < i; e += 1)
                      (C = E[e].charCodeAt(0)),
                        (a = !1),
                        " " === E[e] ? (M = e) : (13 !== C && 3 !== C) || ((a = !(y = 0)), (k += t.finalLineHeight || 1.2 * t.finalSize)),
                        _ < y + (b = l.chars ? ((o = l.getCharData(E[e], A.fStyle, A.fFamily)), a ? 0 : (o.w * t.finalSize) / 100) : l.measureText(E[e], t.f, t.finalSize)) && " " !== E[e]
                          ? (-1 === M ? (i += 1) : (e = M), (k += t.finalLineHeight || 1.2 * t.finalSize), E.splice(e, M === e ? 1 : 0, "\r"), (M = -1), (y = 0))
                          : ((y += b), (y += S));
                    (k += (A.ascent * t.finalSize) / 100),
                      this.canResize && t.finalSize > this.minimumFontSize && T < k ? ((t.finalSize -= 1), (t.finalLineHeight = (t.finalSize * t.lh) / t.s)) : ((t.finalText = E), (i = t.finalText.length), (x = !1));
                  }
                y = -S;
                var P,
                  D = (b = 0);
                for (e = 0; e < i; e += 1)
                  if (
                    ((a = !1),
                    13 === (C = (P = t.finalText[e]).charCodeAt(0)) || 3 === C ? ((D = 0), g.push(y), (v = v < y ? y : v), (y = -2 * S), (a = !(n = "")), (m += 1)) : (n = P),
                    (b = l.chars ? ((o = l.getCharData(P, A.fStyle, l.getFontByName(t.f).fFamily)), a ? 0 : (o.w * t.finalSize) / 100) : l.measureText(n, t.f, t.finalSize)),
                    " " === P ? (D += b + S) : ((y += b + S + D), (D = 0)),
                    h.push({ l: b, an: b, add: p, n: a, anIndexes: [], val: n, line: m, animatorJustifyOffset: 0 }),
                    2 == d)
                  ) {
                    if (((p += b), "" === n || " " === n || e === i - 1)) {
                      for (("" !== n && " " !== n) || (p -= b); f <= e; ) (h[f].an = p), (h[f].ind = u), (h[f].extra = b), (f += 1);
                      (u += 1), (p = 0);
                    }
                  } else if (3 == d) {
                    if (((p += b), "" === n || e === i - 1)) {
                      for ("" === n && (p -= b); f <= e; ) (h[f].an = p), (h[f].ind = u), (h[f].extra = b), (f += 1);
                      (p = 0), (u += 1);
                    }
                  } else (h[u].ind = u), (h[u].extra = 0), (u += 1);
                if (((t.l = h), (v = v < y ? y : v), g.push(y), t.sz)) (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
                else
                  switch (((t.boxWidth = v), t.j)) {
                    case 1:
                      t.justifyOffset = -t.boxWidth;
                      break;
                    case 2:
                      t.justifyOffset = -t.boxWidth / 2;
                      break;
                    default:
                      t.justifyOffset = 0;
                  }
                t.lineWidths = g;
                var I,
                  L,
                  R,
                  F,
                  O = c.a;
                s = O.length;
                var B = [];
                for (r = 0; r < s; r += 1) {
                  for ((I = O[r]).a.sc && (t.strokeColorAnim = !0), I.a.sw && (t.strokeWidthAnim = !0), (I.a.fc || I.a.fh || I.a.fs || I.a.fb) && (t.fillColorAnim = !0), F = 0, R = I.s.b, e = 0; e < i; e += 1)
                    ((L = h[e]).anIndexes[r] = F),
                      ((1 == R && "" !== L.val) || (2 == R && "" !== L.val && " " !== L.val) || (3 == R && (L.n || " " == L.val || e == i - 1)) || (4 == R && (L.n || e == i - 1))) && (1 === I.s.rn && B.push(F), (F += 1));
                  c.a[r].s.totalChars = F;
                  var q,
                    N = -1;
                  if (1 === I.s.rn) for (e = 0; e < i; e += 1) N != (L = h[e]).anIndexes[r] && ((N = L.anIndexes[r]), (q = B.splice(Math.floor(Math.random() * B.length), 1)[0])), (L.anIndexes[r] = q);
                }
                (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize), (t.ls = t.ls || 0), (t.ascent = (A.ascent * t.finalSize) / 100);
              }),
              (mt.prototype.updateDocumentData = function (t, e) {
                e = void 0 === e ? this.keysIndex : e;
                var i = this.copyData({}, this.data.d.k[e].s);
                (i = this.copyData(i, t)), (this.data.d.k[e].s = i), this.recalculate(e), this.elem.addDynamicProperty(this);
              }),
              (mt.prototype.recalculate = function (t) {
                var e = this.data.d.k[t].s;
                (e.__complete = !1), (this.keysIndex = 0), (this._isFirstFrame = !0), this.getValue(e);
              }),
              (mt.prototype.canResizeFont = function (t) {
                (this.canResize = t), this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
              }),
              (mt.prototype.setMinimumFontSize = function (t) {
                (this.minimumFontSize = Math.floor(t) || 1), this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
              });
            var gt,
              yt,
              vt,
              At,
              bt,
              wt = (function () {
                var t = Math.max,
                  e = Math.min,
                  i = Math.floor;
                function a(t, e) {
                  (this._currentTextLength = -1),
                    (this.k = !1),
                    (this.data = e),
                    (this.elem = t),
                    (this.comp = t.comp),
                    (this.finalS = 0),
                    (this.finalE = 0),
                    this.initDynamicPropertyContainer(t),
                    (this.s = J.getProp(t, e.s || { k: 0 }, 0, 0, this)),
                    (this.e = "e" in e ? J.getProp(t, e.e, 0, 0, this) : { v: 100 }),
                    (this.o = J.getProp(t, e.o || { k: 0 }, 0, 0, this)),
                    (this.xe = J.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
                    (this.ne = J.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
                    (this.a = J.getProp(t, e.a, 0, 0.01, this)),
                    this.dynamicProperties.length || this.getValue();
                }
                return (
                  (a.prototype = {
                    getMult: function (a) {
                      this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                      var n = 0,
                        r = 0,
                        s = 1,
                        o = 1;
                      0 < this.ne.v ? (n = this.ne.v / 100) : (r = -this.ne.v / 100), 0 < this.xe.v ? (s = 1 - this.xe.v / 100) : (o = 1 + this.xe.v / 100);
                      var l = B.getBezierEasing(n, r, s, o).get,
                        c = 0,
                        h = this.finalS,
                        u = this.finalE,
                        d = this.data.sh;
                      if (2 === d) c = l((c = u === h ? (u <= a ? 1 : 0) : t(0, e(0.5 / (u - h) + (a - h) / (u - h), 1))));
                      else if (3 === d) c = l((c = u === h ? (u <= a ? 0 : 1) : 1 - t(0, e(0.5 / (u - h) + (a - h) / (u - h), 1))));
                      else if (4 === d) u === h ? (c = 0) : (c = t(0, e(0.5 / (u - h) + (a - h) / (u - h), 1))) < 0.5 ? (c *= 2) : (c = 1 - 2 * (c - 0.5)), (c = l(c));
                      else if (5 === d) {
                        if (u === h) c = 0;
                        else {
                          var p = u - h,
                            f = -p / 2 + (a = e(t(0, a + 0.5 - h), u - h)),
                            m = p / 2;
                          c = Math.sqrt(1 - (f * f) / (m * m));
                        }
                        c = l(c);
                      } else c = 6 === d ? l((c = u === h ? 0 : ((a = e(t(0, a + 0.5 - h), u - h)), (1 + Math.cos(Math.PI + (2 * Math.PI * a) / (u - h))) / 2))) : (a >= i(h) && (c = t(0, e(a - h < 0 ? e(u, 1) - (h - a) : u - a, 1))), l(c));
                      return c * this.a.v;
                    },
                    getValue: function (t) {
                      this.iterateDynamicProperties(), (this._mdf = t || this._mdf), (this._currentTextLength = this.elem.textProperty.currentData.l.length || 0), t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                      var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
                        i = this.o.v / e,
                        a = this.s.v / e + i,
                        n = this.e.v / e + i;
                      if (n < a) {
                        var r = a;
                        (a = n), (n = r);
                      }
                      (this.finalS = a), (this.finalE = n);
                    },
                  }),
                  q([L], a),
                  {
                    getTextSelectorProp: function (t, e, i) {
                      return new a(t, e, i);
                    },
                  }
                );
              })(),
              Ct = function (t, e, i) {
                var a = 0,
                  n = t,
                  r = P(n);
                return {
                  newElement: function () {
                    return a ? r[(a -= 1)] : e();
                  },
                  release: function (t) {
                    a === n && ((r = St.double(r)), (n *= 2)), i && i(t), (r[a] = t), (a += 1);
                  },
                };
              },
              St = {
                double: function (t) {
                  return t.concat(P(t.length));
                },
              },
              kt = Ct(8, function () {
                return M("float32", 2);
              }),
              Et =
                (((gt = Ct(
                  4,
                  function () {
                    return new K();
                  },
                  function (t) {
                    var e,
                      i = t._length;
                    for (e = 0; e < i; e += 1) kt.release(t.v[e]), kt.release(t.i[e]), kt.release(t.o[e]), (t.v[e] = null), (t.i[e] = null), (t.o[e] = null);
                    (t._length = 0), (t.c = !1);
                  }
                )).clone = function (t) {
                  var e,
                    i = gt.newElement(),
                    a = void 0 === t._length ? t.v.length : t._length;
                  for (i.setLength(a), i.c = t.c, e = 0; e < a; e += 1) i.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
                  return i;
                }),
                gt),
              xt =
                ((yt = {
                  newShapeCollection: function () {
                    return vt ? bt[(vt -= 1)] : new et();
                  },
                  release: function (t) {
                    var e,
                      i = t._length;
                    for (e = 0; e < i; e += 1) Et.release(t.shapes[e]);
                    (t._length = 0), vt === At && ((bt = St.double(bt)), (At *= 2)), (bt[vt] = t), (vt += 1);
                  },
                }),
                (vt = 0),
                (bt = P((At = 4))),
                yt),
              _t = Ct(
                8,
                function () {
                  return { lengths: [], totalLength: 0 };
                },
                function (t) {
                  var e,
                    i = t.lengths.length;
                  for (e = 0; e < i; e += 1) Tt.release(t.lengths[e]);
                  t.lengths.length = 0;
                }
              ),
              Tt = Ct(8, function () {
                return { addedLength: 0, percents: M("float32", d), lengths: M("float32", d) };
              }),
              Mt = (function () {
                function t(t) {
                  for (var e, i = t.split("\r\n"), a = {}, n = 0, r = 0; r < i.length; r += 1) 2 === (e = i[r].split(":")).length && ((a[e[0]] = e[1].trim()), (n += 1));
                  if (0 === n) throw new Error();
                  return a;
                }
                return function (e) {
                  for (var i = [], a = 0; a < e.length; a += 1) {
                    var n = e[a],
                      r = { time: n.tm, duration: n.dr };
                    try {
                      r.payload = JSON.parse(e[a].cm);
                    } catch (i) {
                      try {
                        r.payload = t(e[a].cm);
                      } catch (i) {
                        r.payload = { name: e[a] };
                      }
                    }
                    i.push(r);
                  }
                  return i;
                };
              })();
            function Pt() {}
            function Dt(t, e) {
              (this.animationItem = t), (this.layers = null), (this.renderedFrame = -1), (this.svgElement = D("svg"));
              var i = "";
              if (e && e.title) {
                var a = D("title"),
                  n = C();
                a.setAttribute("id", n), (a.textContent = e.title), this.svgElement.appendChild(a), (i += n);
              }
              if (e && e.description) {
                var r = D("desc"),
                  s = C();
                r.setAttribute("id", s), (r.textContent = e.description), this.svgElement.appendChild(r), (i += " " + s);
              }
              i && this.svgElement.setAttribute("aria-labelledby", i);
              var o = D("defs");
              this.svgElement.appendChild(o);
              var l = D("g");
              this.svgElement.appendChild(l),
                (this.layerElement = l),
                (this.renderConfig = {
                  preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
                  imagePreserveAspectRatio: (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
                  progressiveLoad: (e && e.progressiveLoad) || !1,
                  hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                  viewBoxOnly: (e && e.viewBoxOnly) || !1,
                  viewBoxSize: (e && e.viewBoxSize) || !1,
                  className: (e && e.className) || "",
                  id: (e && e.id) || "",
                  focusable: e && e.focusable,
                  filterSize: {
                    width: (e && e.filterSize && e.filterSize.width) || "100%",
                    height: (e && e.filterSize && e.filterSize.height) || "100%",
                    x: (e && e.filterSize && e.filterSize.x) || "0%",
                    y: (e && e.filterSize && e.filterSize.y) || "0%",
                  },
                }),
                (this.globalData = { _mdf: !1, frameNum: -1, defs: o, renderConfig: this.renderConfig }),
                (this.elements = []),
                (this.pendingElements = []),
                (this.destroyed = !1),
                (this.rendererType = "svg");
            }
            function It(t, e, i) {
              (this.data = t), (this.element = e), (this.globalData = i), (this.storedData = []), (this.masksProperties = this.data.masksProperties || []), (this.maskElement = null);
              var n,
                r,
                s = this.globalData.defs,
                o = this.masksProperties ? this.masksProperties.length : 0;
              (this.viewData = P(o)), (this.solidPath = "");
              var l,
                c,
                h,
                u,
                d,
                p,
                f = this.masksProperties,
                m = 0,
                g = [],
                y = C(),
                v = "clipPath",
                A = "clip-path";
              for (n = 0; n < o; n += 1)
                if (
                  ((("a" !== f[n].mode && "n" !== f[n].mode) || f[n].inv || 100 !== f[n].o.k || f[n].o.x) && (A = v = "mask"),
                  ("s" !== f[n].mode && "i" !== f[n].mode) || 0 !== m
                    ? (h = null)
                    : ((h = D("rect")).setAttribute("fill", "#ffffff"), h.setAttribute("width", this.element.comp.data.w || 0), h.setAttribute("height", this.element.comp.data.h || 0), g.push(h)),
                  (r = D("path")),
                  "n" === f[n].mode)
                )
                  (this.viewData[n] = { op: J.getProp(this.element, f[n].o, 0, 0.01, this.element), prop: H.getShapeProp(this.element, f[n], 3), elem: r, lastPath: "" }), s.appendChild(r);
                else {
                  var b;
                  if (
                    ((m += 1),
                    r.setAttribute("fill", "s" === f[n].mode ? "#000000" : "#ffffff"),
                    r.setAttribute("clip-rule", "nonzero"),
                    0 !== f[n].x.k
                      ? ((A = v = "mask"),
                        (p = J.getProp(this.element, f[n].x, 0, null, this.element)),
                        (b = C()),
                        (u = D("filter")).setAttribute("id", b),
                        (d = D("feMorphology")).setAttribute("operator", "erode"),
                        d.setAttribute("in", "SourceGraphic"),
                        d.setAttribute("radius", "0"),
                        u.appendChild(d),
                        s.appendChild(u),
                        r.setAttribute("stroke", "s" === f[n].mode ? "#000000" : "#ffffff"))
                      : (p = d = null),
                    (this.storedData[n] = { elem: r, x: p, expan: d, lastPath: "", lastOperator: "", filterId: b, lastRadius: 0 }),
                    "i" === f[n].mode)
                  ) {
                    c = g.length;
                    var w = D("g");
                    for (l = 0; l < c; l += 1) w.appendChild(g[l]);
                    var S = D("mask");
                    S.setAttribute("mask-type", "alpha"), S.setAttribute("id", y + "_" + m), S.appendChild(r), s.appendChild(S), w.setAttribute("mask", "url(" + a + "#" + y + "_" + m + ")"), (g.length = 0), g.push(w);
                  } else g.push(r);
                  f[n].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()),
                    (this.viewData[n] = { elem: r, lastPath: "", op: J.getProp(this.element, f[n].o, 0, 0.01, this.element), prop: H.getShapeProp(this.element, f[n], 3), invRect: h }),
                    this.viewData[n].prop.k || this.drawPath(f[n], this.viewData[n].prop.v, this.viewData[n]);
                }
              for (this.maskElement = D(v), o = g.length, n = 0; n < o; n += 1) this.maskElement.appendChild(g[n]);
              0 < m && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(A, "url(" + a + "#" + y + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
            }
            function Lt() {}
            function Rt() {}
            function Ft() {}
            function Ot() {}
            function Bt() {}
            function qt(t, e) {
              (this.data = t), (this.type = t.ty), (this.d = ""), (this.lvl = e), (this._mdf = !1), (this.closed = !0 === t.hd), (this.pElem = D("path")), (this.msElem = null);
            }
            function Nt(t, e, i) {
              (this.caches = []), (this.styles = []), (this.transformers = t), (this.lStr = ""), (this.sh = i), (this.lvl = e), (this._isAnimated = !!i.k);
              for (var a = 0, n = t.length; a < n; ) {
                if (t[a].mProps.dynamicProperties.length) {
                  this._isAnimated = !0;
                  break;
                }
                a += 1;
              }
            }
            function Vt(t, e, i) {
              this.initDynamicPropertyContainer(t),
                (this.getValue = this.iterateDynamicProperties),
                (this.o = J.getProp(t, e.o, 0, 0.01, this)),
                (this.w = J.getProp(t, e.w, 0, null, this)),
                (this.d = new it(t, e.d || {}, "svg", this)),
                (this.c = J.getProp(t, e.c, 1, 255, this)),
                (this.style = i),
                (this._isAnimated = !!this._isAnimated);
            }
            function Wt(t, e, i) {
              this.initDynamicPropertyContainer(t), (this.getValue = this.iterateDynamicProperties), (this.o = J.getProp(t, e.o, 0, 0.01, this)), (this.c = J.getProp(t, e.c, 1, 255, this)), (this.style = i);
            }
            function Ut(t, e, i) {
              this.initDynamicPropertyContainer(t), (this.getValue = this.iterateDynamicProperties), this.initGradientData(t, e, i);
            }
            function Jt(t, e, i) {
              this.initDynamicPropertyContainer(t),
                (this.getValue = this.iterateDynamicProperties),
                (this.w = J.getProp(t, e.w, 0, null, this)),
                (this.d = new it(t, e.d || {}, "svg", this)),
                this.initGradientData(t, e, i),
                (this._isAnimated = !!this._isAnimated);
            }
            (Pt.prototype.checkLayers = function (t) {
              var e,
                i,
                a = this.layers.length;
              for (this.completeLayers = !0, e = a - 1; 0 <= e; e -= 1)
                this.elements[e] || ((i = this.layers[e]).ip - i.st <= t - this.layers[e].st && i.op - i.st > t - this.layers[e].st && this.buildItem(e)), (this.completeLayers = !!this.elements[e] && this.completeLayers);
              this.checkPendingElements();
            }),
              (Pt.prototype.createItem = function (t) {
                switch (t.ty) {
                  case 2:
                    return this.createImage(t);
                  case 0:
                    return this.createComp(t);
                  case 1:
                    return this.createSolid(t);
                  case 3:
                    return this.createNull(t);
                  case 4:
                    return this.createShape(t);
                  case 5:
                    return this.createText(t);
                  case 6:
                    return this.createAudio(t);
                  case 13:
                    return this.createCamera(t);
                  case 15:
                    return this.createFootage(t);
                  default:
                    return this.createNull(t);
                }
              }),
              (Pt.prototype.createCamera = function () {
                throw new Error("You're using a 3d camera. Try the html renderer.");
              }),
              (Pt.prototype.createAudio = function (t) {
                return new $t(t, this.globalData, this);
              }),
              (Pt.prototype.createFootage = function (t) {
                return new FootageElement(t, this.globalData, this);
              }),
              (Pt.prototype.buildAllItems = function () {
                var t,
                  e = this.layers.length;
                for (t = 0; t < e; t += 1) this.buildItem(t);
                this.checkPendingElements();
              }),
              (Pt.prototype.includeLayers = function (t) {
                var e;
                this.completeLayers = !1;
                var i,
                  a = t.length,
                  n = this.layers.length;
                for (e = 0; e < a; e += 1)
                  for (i = 0; i < n; ) {
                    if (this.layers[i].id === t[e].id) {
                      this.layers[i] = t[e];
                      break;
                    }
                    i += 1;
                  }
              }),
              (Pt.prototype.setProjectInterface = function (t) {
                this.globalData.projectInterface = t;
              }),
              (Pt.prototype.initItems = function () {
                this.globalData.progressiveLoad || this.buildAllItems();
              }),
              (Pt.prototype.buildElementParenting = function (t, e, i) {
                for (var a = this.elements, n = this.layers, r = 0, s = n.length; r < s; )
                  n[r].ind == e && (a[r] && !0 !== a[r] ? (i.push(a[r]), a[r].setAsParent(), void 0 !== n[r].parent ? this.buildElementParenting(t, n[r].parent, i) : t.setHierarchy(i)) : (this.buildItem(r), this.addPendingElement(t))),
                    (r += 1);
              }),
              (Pt.prototype.addPendingElement = function (t) {
                this.pendingElements.push(t);
              }),
              (Pt.prototype.searchExtraCompositions = function (t) {
                var e,
                  i = t.length;
                for (e = 0; e < i; e += 1)
                  if (t[e].xt) {
                    var a = this.createComp(t[e]);
                    a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
                  }
              }),
              (Pt.prototype.setupGlobalData = function (t, e) {
                (this.globalData.fontManager = new U()),
                  this.globalData.fontManager.addChars(t.chars),
                  this.globalData.fontManager.addFonts(t.fonts, e),
                  (this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem)),
                  (this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem)),
                  (this.globalData.imageLoader = this.animationItem.imagePreloader),
                  (this.globalData.audioController = this.animationItem.audioController),
                  (this.globalData.frameId = 0),
                  (this.globalData.frameRate = t.fr),
                  (this.globalData.nm = t.nm),
                  (this.globalData.compSize = { w: t.w, h: t.h });
              }),
              q([Pt], Dt),
              (Dt.prototype.createNull = function (t) {
                return new Gt(t, this.globalData, this);
              }),
              (Dt.prototype.createShape = function (t) {
                return new ie(t, this.globalData, this);
              }),
              (Dt.prototype.createText = function (t) {
                return new ee(t, this.globalData, this);
              }),
              (Dt.prototype.createImage = function (t) {
                return new Xt(t, this.globalData, this);
              }),
              (Dt.prototype.createComp = function (t) {
                return new te(t, this.globalData, this);
              }),
              (Dt.prototype.createSolid = function (t) {
                return new Zt(t, this.globalData, this);
              }),
              (Dt.prototype.configAnimation = function (t) {
                this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
                  this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
                  this.renderConfig.viewBoxOnly ||
                    (this.svgElement.setAttribute("width", t.w),
                    this.svgElement.setAttribute("height", t.h),
                    (this.svgElement.style.width = "100%"),
                    (this.svgElement.style.height = "100%"),
                    (this.svgElement.style.transform = "translate3d(0,0,0)")),
                  this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className),
                  this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id),
                  void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable),
                  this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio),
                  this.animationItem.wrapper.appendChild(this.svgElement);
                var e = this.globalData.defs;
                this.setupGlobalData(t, e), (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad), (this.data = t);
                var i = D("clipPath"),
                  n = D("rect");
                n.setAttribute("width", t.w), n.setAttribute("height", t.h), n.setAttribute("x", 0), n.setAttribute("y", 0);
                var r = C();
                i.setAttribute("id", r), i.appendChild(n), this.layerElement.setAttribute("clip-path", "url(" + a + "#" + r + ")"), e.appendChild(i), (this.layers = t.layers), (this.elements = P(t.layers.length));
              }),
              (Dt.prototype.destroy = function () {
                var t;
                this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), (this.layerElement = null), (this.globalData.defs = null);
                var e = this.layers ? this.layers.length : 0;
                for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
                (this.elements.length = 0), (this.destroyed = !0), (this.animationItem = null);
              }),
              (Dt.prototype.updateContainerSize = function () {}),
              (Dt.prototype.buildItem = function (t) {
                var i = this.elements;
                if (!i[t] && 99 !== this.layers[t].ty) {
                  i[t] = !0;
                  var a = this.createItem(this.layers[t]);
                  (i[t] = a),
                    e && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(a), a.initExpressions()),
                    this.appendElementInPos(a, t),
                    this.layers[t].tt && (this.elements[t - 1] && !0 !== this.elements[t - 1] ? a.setMatte(i[t - 1].layerId) : (this.buildItem(t - 1), this.addPendingElement(a)));
                }
              }),
              (Dt.prototype.checkPendingElements = function () {
                for (; this.pendingElements.length; ) {
                  var t = this.pendingElements.pop();
                  if ((t.checkParenting(), t.data.tt))
                    for (var e = 0, i = this.elements.length; e < i; ) {
                      if (this.elements[e] === t) {
                        t.setMatte(this.elements[e - 1].layerId);
                        break;
                      }
                      e += 1;
                    }
                }
              }),
              (Dt.prototype.renderFrame = function (t) {
                if (this.renderedFrame !== t && !this.destroyed) {
                  var e;
                  null === t ? (t = this.renderedFrame) : (this.renderedFrame = t), (this.globalData.frameNum = t), (this.globalData.frameId += 1), (this.globalData.projectInterface.currentFrame = t), (this.globalData._mdf = !1);
                  var i = this.layers.length;
                  for (this.completeLayers || this.checkLayers(t), e = i - 1; 0 <= e; e -= 1) (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                  if (this.globalData._mdf) for (e = 0; e < i; e += 1) (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
                }
              }),
              (Dt.prototype.appendElementInPos = function (t, e) {
                var i = t.getBaseElement();
                if (i) {
                  for (var a, n = 0; n < e; ) this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement() && (a = this.elements[n].getBaseElement()), (n += 1);
                  a ? this.layerElement.insertBefore(i, a) : this.layerElement.appendChild(i);
                }
              }),
              (Dt.prototype.hide = function () {
                this.layerElement.style.display = "none";
              }),
              (Dt.prototype.show = function () {
                this.layerElement.style.display = "block";
              }),
              (It.prototype.getMaskProperty = function (t) {
                return this.viewData[t].prop;
              }),
              (It.prototype.renderFrame = function (t) {
                var e,
                  i = this.element.finalTransform.mat,
                  n = this.masksProperties.length;
                for (e = 0; e < n; e += 1)
                  if (
                    ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]),
                    (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v),
                    "n" !== this.masksProperties[e].mode &&
                      (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", i.getInverseMatrix().to2dCSS()),
                      this.storedData[e].x && (this.storedData[e].x._mdf || t)))
                  ) {
                    var r = this.storedData[e].expan;
                    this.storedData[e].x.v < 0
                      ? ("erode" !== this.storedData[e].lastOperator && ((this.storedData[e].lastOperator = "erode"), this.storedData[e].elem.setAttribute("filter", "url(" + a + "#" + this.storedData[e].filterId + ")")),
                        r.setAttribute("radius", -this.storedData[e].x.v))
                      : ("dilate" !== this.storedData[e].lastOperator && ((this.storedData[e].lastOperator = "dilate"), this.storedData[e].elem.setAttribute("filter", null)),
                        this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
                  }
              }),
              (It.prototype.getMaskelement = function () {
                return this.maskElement;
              }),
              (It.prototype.createLayerSolidPath = function () {
                var t = "M0,0 ";
                return (t += " h" + this.globalData.compSize.w), (t += " v" + this.globalData.compSize.h), (t += " h-" + this.globalData.compSize.w), (t += " v-" + this.globalData.compSize.h + " ");
              }),
              (It.prototype.drawPath = function (t, e, i) {
                var a,
                  n,
                  r = " M" + e.v[0][0] + "," + e.v[0][1];
                for (n = e._length, a = 1; a < n; a += 1) r += " C" + e.o[a - 1][0] + "," + e.o[a - 1][1] + " " + e.i[a][0] + "," + e.i[a][1] + " " + e.v[a][0] + "," + e.v[a][1];
                if ((e.c && 1 < n && (r += " C" + e.o[a - 1][0] + "," + e.o[a - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), i.lastPath !== r)) {
                  var s = "";
                  i.elem && (e.c && (s = t.inv ? this.solidPath + r : r), i.elem.setAttribute("d", s)), (i.lastPath = r);
                }
              }),
              (It.prototype.destroy = function () {
                (this.element = null), (this.globalData = null), (this.maskElement = null), (this.data = null), (this.masksProperties = null);
              }),
              (Lt.prototype = {
                initHierarchy: function () {
                  (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
                },
                setHierarchy: function (t) {
                  this.hierarchy = t;
                },
                setAsParent: function () {
                  this._isParent = !0;
                },
                checkParenting: function () {
                  void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
                },
              }),
              (Rt.prototype = {
                initFrame: function () {
                  (this._isFirstFrame = !1), (this.dynamicProperties = []), (this._mdf = !1);
                },
                prepareProperties: function (t, e) {
                  var i,
                    a = this.dynamicProperties.length;
                  for (i = 0; i < a; i += 1)
                    (e || (this._isParent && "transform" === this.dynamicProperties[i].propType)) && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && ((this.globalData._mdf = !0), (this._mdf = !0)));
                },
                addDynamicProperty: function (t) {
                  -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
                },
              }),
              (Ft.prototype = {
                initTransform: function () {
                  (this.finalTransform = { mProp: this.data.ks ? z.getTransformProperty(this, this.data.ks, this) : { o: 0 }, _matMdf: !1, _opMdf: !1, mat: new O() }),
                    this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
                    this.data.ty;
                },
                renderTransform: function () {
                  if (((this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame), (this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame), this.hierarchy)) {
                    var t,
                      e = this.finalTransform.mat,
                      i = 0,
                      a = this.hierarchy.length;
                    if (!this.finalTransform._matMdf)
                      for (; i < a; ) {
                        if (this.hierarchy[i].finalTransform.mProp._mdf) {
                          this.finalTransform._matMdf = !0;
                          break;
                        }
                        i += 1;
                      }
                    if (this.finalTransform._matMdf)
                      for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), i = 0; i < a; i += 1)
                        (t = this.hierarchy[i].finalTransform.mProp.v.props), e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
                  }
                },
                globalToLocal: function (t) {
                  var e = [];
                  e.push(this.finalTransform);
                  for (var i, a = !0, n = this.comp; a; ) n.finalTransform ? (n.data.hasMask && e.splice(0, 0, n.finalTransform), (n = n.comp)) : (a = !1);
                  var r,
                    s = e.length;
                  for (i = 0; i < s; i += 1) (r = e[i].mat.applyToPointArray(0, 0, 0)), (t = [t[0] - r[0], t[1] - r[1], 0]);
                  return t;
                },
                mHelper: new O(),
              }),
              (Ot.prototype = {
                initRenderable: function () {
                  (this.isInRange = !1), (this.hidden = !1), (this.isTransparent = !1), (this.renderableComponents = []);
                },
                addRenderableComponent: function (t) {
                  -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
                },
                removeRenderableComponent: function (t) {
                  -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
                },
                prepareRenderableFrame: function (t) {
                  this.checkLayerLimits(t);
                },
                checkTransparency: function () {
                  this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && ((this.isTransparent = !0), this.hide()) : this.isTransparent && ((this.isTransparent = !1), this.show());
                },
                checkLayerLimits: function (t) {
                  this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
                    ? !0 !== this.isInRange && ((this.globalData._mdf = !0), (this._mdf = !0), (this.isInRange = !0), this.show())
                    : !1 !== this.isInRange && ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
                },
                renderRenderable: function () {
                  var t,
                    e = this.renderableComponents.length;
                  for (t = 0; t < e; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
                },
                sourceRectAtTime: function () {
                  return { top: 0, left: 0, width: 100, height: 100 };
                },
                getLayerSize: function () {
                  return 5 === this.data.ty ? { w: this.data.textData.width, h: this.data.textData.height } : { w: this.data.width, h: this.data.height };
                },
              }),
              q(
                [
                  Ot,
                  (function (t) {
                    function e() {}
                    return (
                      (e.prototype = {
                        initElement: function (t, e, i) {
                          this.initFrame(),
                            this.initBaseData(t, e, i),
                            this.initTransform(t, e, i),
                            this.initHierarchy(),
                            this.initRenderable(),
                            this.initRendererElement(),
                            this.createContainerElements(),
                            this.createRenderableComponents(),
                            this.createContent(),
                            this.hide();
                        },
                        hide: function () {
                          this.hidden || (this.isInRange && !this.isTransparent) || (((this.baseElement || this.layerElement).style.display = "none"), (this.hidden = !0));
                        },
                        show: function () {
                          this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), (this.hidden = !1), (this._isFirstFrame = !0));
                        },
                        renderFrame: function () {
                          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                        },
                        renderInnerContent: function () {},
                        prepareFrame: function (t) {
                          (this._mdf = !1), this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                        },
                        destroy: function () {
                          (this.innerElem = null), this.destroyBaseElement();
                        },
                      }),
                      e
                    );
                  })(),
                ],
                Bt
              ),
              (qt.prototype.reset = function () {
                (this.d = ""), (this._mdf = !1);
              }),
              (Nt.prototype.setAsAnimated = function () {
                this._isAnimated = !0;
              }),
              q([L], Vt),
              q([L], Wt),
              (Ut.prototype.initGradientData = function (t, e, i) {
                (this.o = J.getProp(t, e.o, 0, 0.01, this)),
                  (this.s = J.getProp(t, e.s, 1, null, this)),
                  (this.e = J.getProp(t, e.e, 1, null, this)),
                  (this.h = J.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
                  (this.a = J.getProp(t, e.a || { k: 0 }, 0, p, this)),
                  (this.g = new at(t, e.g, this)),
                  (this.style = i),
                  (this.stops = []),
                  this.setGradientData(i.pElem, e),
                  this.setGradientOpacity(e, i),
                  (this._isAnimated = !!this._isAnimated);
              }),
              (Ut.prototype.setGradientData = function (t, e) {
                var i = C(),
                  n = D(1 === e.t ? "linearGradient" : "radialGradient");
                n.setAttribute("id", i), n.setAttribute("spreadMethod", "pad"), n.setAttribute("gradientUnits", "userSpaceOnUse");
                var r,
                  s,
                  o,
                  l = [];
                for (o = 4 * e.g.p, s = 0; s < o; s += 4) (r = D("stop")), n.appendChild(r), l.push(r);
                t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + a + "#" + i + ")"), (this.gf = n), (this.cst = l);
              }),
              (Ut.prototype.setGradientOpacity = function (t, e) {
                if (this.g._hasOpacity && !this.g._collapsable) {
                  var i,
                    n,
                    r,
                    s = D("mask"),
                    o = D("path");
                  s.appendChild(o);
                  var l = C(),
                    c = C();
                  s.setAttribute("id", c);
                  var h = D(1 === t.t ? "linearGradient" : "radialGradient");
                  h.setAttribute("id", l), h.setAttribute("spreadMethod", "pad"), h.setAttribute("gradientUnits", "userSpaceOnUse"), (r = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
                  var u = this.stops;
                  for (n = 4 * t.g.p; n < r; n += 2) (i = D("stop")).setAttribute("stop-color", "rgb(255,255,255)"), h.appendChild(i), u.push(i);
                  o.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + a + "#" + l + ")"), (this.of = h), (this.ms = s), (this.ost = u), (this.maskId = c), (e.msElem = o);
                }
              }),
              q([L], Ut),
              q([Ut, L], Jt);
            var zt = (function () {
              var t = new O(),
                e = new O();
              function i(t, e, i) {
                (i || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (i || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
              }
              function a(i, a, n) {
                var r,
                  s,
                  o,
                  l,
                  c,
                  h,
                  u,
                  d,
                  p,
                  f,
                  m,
                  g = a.styles.length,
                  y = a.lvl;
                for (h = 0; h < g; h += 1) {
                  if (((l = a.sh._mdf || n), a.styles[h].lvl < y)) {
                    for (d = e.reset(), f = y - a.styles[h].lvl, m = a.transformers.length - 1; !l && 0 < f; ) (l = a.transformers[m].mProps._mdf || l), (f -= 1), (m -= 1);
                    if (l)
                      for (f = y - a.styles[h].lvl, m = a.transformers.length - 1; 0 < f; )
                        (p = a.transformers[m].mProps.v.props), d.transform(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], p[9], p[10], p[11], p[12], p[13], p[14], p[15]), (f -= 1), (m -= 1);
                  } else d = t;
                  if (((s = (u = a.sh.paths)._length), l)) {
                    for (o = "", r = 0; r < s; r += 1) (c = u.shapes[r]) && c._length && (o += st(c, c._length, c.c, d));
                    a.caches[h] = o;
                  } else o = a.caches[h];
                  (a.styles[h].d += !0 === i.hd ? "" : o), (a.styles[h]._mdf = l || a.styles[h]._mdf);
                }
              }
              function n(t, e, i) {
                var a = e.style;
                (e.c._mdf || i) && a.pElem.setAttribute("fill", "rgb(" + c(e.c.v[0]) + "," + c(e.c.v[1]) + "," + c(e.c.v[2]) + ")"), (e.o._mdf || i) && a.pElem.setAttribute("fill-opacity", e.o.v);
              }
              function r(t, e, i) {
                s(t, e, i), o(0, e, i);
              }
              function s(t, e, i) {
                var a,
                  n,
                  r,
                  s,
                  o,
                  l = e.gf,
                  c = e.g._hasOpacity,
                  h = e.s.v,
                  u = e.e.v;
                if (e.o._mdf || i) {
                  var d = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                  e.style.pElem.setAttribute(d, e.o.v);
                }
                if (e.s._mdf || i) {
                  var p = 1 === t.t ? "x1" : "cx",
                    f = "x1" === p ? "y1" : "cy";
                  l.setAttribute(p, h[0]), l.setAttribute(f, h[1]), c && !e.g._collapsable && (e.of.setAttribute(p, h[0]), e.of.setAttribute(f, h[1]));
                }
                if (e.g._cmdf || i) {
                  a = e.cst;
                  var m = e.g.c;
                  for (r = a.length, n = 0; n < r; n += 1) (s = a[n]).setAttribute("offset", m[4 * n] + "%"), s.setAttribute("stop-color", "rgb(" + m[4 * n + 1] + "," + m[4 * n + 2] + "," + m[4 * n + 3] + ")");
                }
                if (c && (e.g._omdf || i)) {
                  var g = e.g.o;
                  for (r = (a = e.g._collapsable ? e.cst : e.ost).length, n = 0; n < r; n += 1) (s = a[n]), e.g._collapsable || s.setAttribute("offset", g[2 * n] + "%"), s.setAttribute("stop-opacity", g[2 * n + 1]);
                }
                if (1 === t.t) (e.e._mdf || i) && (l.setAttribute("x2", u[0]), l.setAttribute("y2", u[1]), c && !e.g._collapsable && (e.of.setAttribute("x2", u[0]), e.of.setAttribute("y2", u[1])));
                else if (
                  ((e.s._mdf || e.e._mdf || i) && ((o = Math.sqrt(Math.pow(h[0] - u[0], 2) + Math.pow(h[1] - u[1], 2))), l.setAttribute("r", o), c && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || i)
                ) {
                  o || (o = Math.sqrt(Math.pow(h[0] - u[0], 2) + Math.pow(h[1] - u[1], 2)));
                  var y = Math.atan2(u[1] - h[1], u[0] - h[0]),
                    v = e.h.v;
                  1 <= v ? (v = 0.99) : v <= -1 && (v = -0.99);
                  var A = o * v,
                    b = Math.cos(y + e.a.v) * A + h[0],
                    w = Math.sin(y + e.a.v) * A + h[1];
                  l.setAttribute("fx", b), l.setAttribute("fy", w), c && !e.g._collapsable && (e.of.setAttribute("fx", b), e.of.setAttribute("fy", w));
                }
              }
              function o(t, e, i) {
                var a = e.style,
                  n = e.d;
                n && (n._mdf || i) && n.dashStr && (a.pElem.setAttribute("stroke-dasharray", n.dashStr), a.pElem.setAttribute("stroke-dashoffset", n.dashoffset[0])),
                  e.c && (e.c._mdf || i) && a.pElem.setAttribute("stroke", "rgb(" + c(e.c.v[0]) + "," + c(e.c.v[1]) + "," + c(e.c.v[2]) + ")"),
                  (e.o._mdf || i) && a.pElem.setAttribute("stroke-opacity", e.o.v),
                  (e.w._mdf || i) && (a.pElem.setAttribute("stroke-width", e.w.v), a.msElem && a.msElem.setAttribute("stroke-width", e.w.v));
              }
              return {
                createRenderFunction: function (t) {
                  switch (t.ty) {
                    case "fl":
                      return n;
                    case "gf":
                      return s;
                    case "gs":
                      return r;
                    case "st":
                      return o;
                    case "sh":
                    case "el":
                    case "rc":
                    case "sr":
                      return a;
                    case "tr":
                      return i;
                    default:
                      return null;
                  }
                },
              };
            })();
            function Kt() {}
            function Gt(t, e, i) {
              this.initFrame(), this.initBaseData(t, e, i), this.initFrame(), this.initTransform(t, e, i), this.initHierarchy();
            }
            function jt() {}
            function Ht() {}
            function Yt() {}
            function Qt() {}
            function Xt(t, e, i) {
              (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, i), (this.sourceRect = { top: 0, left: 0, width: this.assetData.w, height: this.assetData.h });
            }
            function Zt(t, e, i) {
              this.initElement(t, e, i);
            }
            function $t(t, e, i) {
              this.initFrame(), this.initRenderable(), (this.assetData = e.getAssetData(t.refId)), this.initBaseData(t, e, i), (this._isPlaying = !1), (this._canPlay = !1);
              var a = this.globalData.getAssetsPath(this.assetData);
              (this.audio = this.globalData.audioController.createAudio(a)), (this._currentTime = 0), this.globalData.audioController.addAudio(this), (this.tm = t.tm ? J.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
            }
            function te(t, e, i) {
              (this.layers = t.layers),
                (this.supports3d = !0),
                (this.completeLayers = !1),
                (this.pendingElements = []),
                (this.elements = this.layers ? P(this.layers.length) : []),
                this.initElement(t, e, i),
                (this.tm = t.tm ? J.getProp(this, t.tm, 0, e.frameRate, this) : { _placeholder: !0 });
            }
            function ee(t, e, i) {
              (this.textSpans = []), (this.renderType = "svg"), this.initElement(t, e, i);
            }
            function ie(t, e, i) {
              (this.shapes = []),
                (this.shapesData = t.shapes),
                (this.stylesList = []),
                (this.shapeModifiers = []),
                (this.itemsData = []),
                (this.processedElements = []),
                (this.animatedContents = []),
                this.initElement(t, e, i),
                (this.prevViewData = []);
            }
            (Kt.prototype = {
              checkMasks: function () {
                if (!this.data.hasMask) return !1;
                for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
                  if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                  t += 1;
                }
                return !1;
              },
              initExpressions: function () {
                (this.layerInterface = LayerExpressionInterface(this)), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                var t = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
                this.layerInterface.registerEffectsInterface(t),
                  0 === this.data.ty || this.data.xt
                    ? (this.compInterface = CompExpressionInterface(this))
                    : 4 === this.data.ty
                    ? ((this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface)), (this.layerInterface.content = this.layerInterface.shapeInterface))
                    : 5 === this.data.ty && ((this.layerInterface.textInterface = TextExpressionInterface(this)), (this.layerInterface.text = this.layerInterface.textInterface));
              },
              setBlendMode: function () {
                var t = F(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
              },
              initBaseData: function (t, e, i) {
                (this.globalData = e),
                  (this.comp = i),
                  (this.data = t),
                  (this.layerId = C()),
                  this.data.sr || (this.data.sr = 1),
                  (this.effectsManager = new (function () {
                    this.effectElements = [];
                  })(this.data, this, this.dynamicProperties));
              },
              getType: function () {
                return this.type;
              },
              sourceRectAtTime: function () {},
            }),
              (Gt.prototype.prepareFrame = function (t) {
                this.prepareProperties(t, !0);
              }),
              (Gt.prototype.renderFrame = function () {}),
              (Gt.prototype.getBaseElement = function () {
                return null;
              }),
              (Gt.prototype.destroy = function () {}),
              (Gt.prototype.sourceRectAtTime = function () {}),
              (Gt.prototype.hide = function () {}),
              q([Kt, Ft, Lt, Rt], Gt),
              (jt.prototype = {
                initRendererElement: function () {
                  this.layerElement = D("g");
                },
                createContainerElements: function () {
                  (this.matteElement = D("g")), (this.transformedElement = this.layerElement), (this.maskedElement = this.layerElement), (this._sizeChanged = !1);
                  var t,
                    e,
                    i,
                    n = null;
                  if (this.data.td) {
                    if (3 == this.data.td || 1 == this.data.td) {
                      var r = D("mask");
                      r.setAttribute("id", this.layerId),
                        r.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"),
                        r.appendChild(this.layerElement),
                        (n = r),
                        this.globalData.defs.appendChild(r),
                        ct.maskType ||
                          1 != this.data.td ||
                          (r.setAttribute("mask-type", "luminance"),
                          (t = C()),
                          (e = ht.createFilter(t)),
                          this.globalData.defs.appendChild(e),
                          e.appendChild(ht.createAlphaToLuminanceFilter()),
                          (i = D("g")).appendChild(this.layerElement),
                          (n = i),
                          r.appendChild(i),
                          i.setAttribute("filter", "url(" + a + "#" + t + ")"));
                    } else if (2 == this.data.td) {
                      var s = D("mask");
                      s.setAttribute("id", this.layerId), s.setAttribute("mask-type", "alpha");
                      var o = D("g");
                      s.appendChild(o), (t = C()), (e = ht.createFilter(t));
                      var l = D("feComponentTransfer");
                      l.setAttribute("in", "SourceGraphic"), e.appendChild(l);
                      var c = D("feFuncA");
                      c.setAttribute("type", "table"), c.setAttribute("tableValues", "1.0 0.0"), l.appendChild(c), this.globalData.defs.appendChild(e);
                      var h = D("rect");
                      h.setAttribute("width", this.comp.data.w),
                        h.setAttribute("height", this.comp.data.h),
                        h.setAttribute("x", "0"),
                        h.setAttribute("y", "0"),
                        h.setAttribute("fill", "#ffffff"),
                        h.setAttribute("opacity", "0"),
                        o.setAttribute("filter", "url(" + a + "#" + t + ")"),
                        o.appendChild(h),
                        o.appendChild(this.layerElement),
                        (n = o),
                        ct.maskType || (s.setAttribute("mask-type", "luminance"), e.appendChild(ht.createAlphaToLuminanceFilter()), (i = D("g")), o.appendChild(h), i.appendChild(this.layerElement), (n = i), o.appendChild(i)),
                        this.globalData.defs.appendChild(s);
                    }
                  } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), (n = this.matteElement), (this.baseElement = this.matteElement)) : (this.baseElement = this.layerElement);
                  if ((this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd)) {
                    var u = D("clipPath"),
                      d = D("path");
                    d.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var p = C();
                    if ((u.setAttribute("id", p), u.appendChild(d), this.globalData.defs.appendChild(u), this.checkMasks())) {
                      var f = D("g");
                      f.setAttribute("clip-path", "url(" + a + "#" + p + ")"), f.appendChild(this.layerElement), (this.transformedElement = f), n ? n.appendChild(this.transformedElement) : (this.baseElement = this.transformedElement);
                    } else this.layerElement.setAttribute("clip-path", "url(" + a + "#" + p + ")");
                  }
                  0 !== this.data.bm && this.setBlendMode();
                },
                renderElement: function () {
                  this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()),
                    this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
                },
                destroyBaseElement: function () {
                  (this.layerElement = null), (this.matteElement = null), this.maskManager.destroy();
                },
                getBaseElement: function () {
                  return this.data.hd ? null : this.baseElement;
                },
                createRenderableComponents: function () {
                  (this.maskManager = new It(this.data, this, this.globalData)), (this.renderableEffectsManager = new (function () {})(this));
                },
                setMatte: function (t) {
                  this.matteElement && this.matteElement.setAttribute("mask", "url(" + a + "#" + t + ")");
                },
              }),
              (Ht.prototype = {
                addShapeToModifiers: function (t) {
                  var e,
                    i = this.shapeModifiers.length;
                  for (e = 0; e < i; e += 1) this.shapeModifiers[e].addShape(t);
                },
                isShapeInAnimatedModifiers: function (t) {
                  for (var e = this.shapeModifiers.length; 0 < e; ) if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                  return !1;
                },
                renderModifiers: function () {
                  if (this.shapeModifiers.length) {
                    var t,
                      e = this.shapes.length;
                    for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
                    for (t = (e = this.shapeModifiers.length) - 1; 0 <= t && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                  }
                },
                lcEnum: { 1: "butt", 2: "round", 3: "square" },
                ljEnum: { 1: "miter", 2: "round", 3: "bevel" },
                searchProcessedElement: function (t) {
                  for (var e = this.processedElements, i = 0, a = e.length; i < a; ) {
                    if (e[i].elem === t) return e[i].pos;
                    i += 1;
                  }
                  return 0;
                },
                addProcessedElement: function (t, e) {
                  for (var i = this.processedElements, a = i.length; a; ) if (i[(a -= 1)].elem === t) return void (i[a].pos = e);
                  i.push(
                    new (function (t, e) {
                      (this.elem = t), (this.pos = e);
                    })(t, e)
                  );
                },
                prepareFrame: function (t) {
                  this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
                },
              }),
              (Yt.prototype.initElement = function (t, e, i) {
                (this.lettersChangedFlag = !0),
                  this.initFrame(),
                  this.initBaseData(t, e, i),
                  (this.textProperty = new mt(this, t.t, this.dynamicProperties)),
                  (this.textAnimator = new dt(t.t, this.renderType, this)),
                  this.initTransform(t, e, i),
                  this.initHierarchy(),
                  this.initRenderable(),
                  this.initRendererElement(),
                  this.createContainerElements(),
                  this.createRenderableComponents(),
                  this.createContent(),
                  this.hide(),
                  this.textAnimator.searchProperties(this.dynamicProperties);
              }),
              (Yt.prototype.prepareFrame = function (t) {
                (this._mdf = !1),
                  this.prepareRenderableFrame(t),
                  this.prepareProperties(t, this.isInRange),
                  (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), (this.textProperty._isFirstFrame = !1), (this.textProperty._mdf = !1));
              }),
              (Yt.prototype.createPathShape = function (t, e) {
                var i,
                  a,
                  n = e.length,
                  r = "";
                for (i = 0; i < n; i += 1) (a = e[i].ks.k), (r += st(a, a.i.length, !0, t));
                return r;
              }),
              (Yt.prototype.updateDocumentData = function (t, e) {
                this.textProperty.updateDocumentData(t, e);
              }),
              (Yt.prototype.canResizeFont = function (t) {
                this.textProperty.canResizeFont(t);
              }),
              (Yt.prototype.setMinimumFontSize = function (t) {
                this.textProperty.setMinimumFontSize(t);
              }),
              (Yt.prototype.applyTextPropertiesToMatrix = function (t, e, i, a, n) {
                switch ((t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j)) {
                  case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]), 0, 0);
                    break;
                  case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[i]) / 2, 0, 0);
                }
                e.translate(a, n, 0);
              }),
              (Yt.prototype.buildColor = function (t) {
                return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
              }),
              (Yt.prototype.emptyProp = new ft()),
              (Yt.prototype.destroy = function () {}),
              q([Kt, Ft, Lt, Rt, Bt], Qt),
              (Qt.prototype.initElement = function (t, e, i) {
                this.initFrame(),
                  this.initBaseData(t, e, i),
                  this.initTransform(t, e, i),
                  this.initRenderable(),
                  this.initHierarchy(),
                  this.initRendererElement(),
                  this.createContainerElements(),
                  this.createRenderableComponents(),
                  (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
                  this.hide();
              }),
              (Qt.prototype.prepareFrame = function (t) {
                if (((this._mdf = !1), this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt)) {
                  if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                  else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), (this.renderedFrame = e);
                  }
                  var i,
                    a = this.elements.length;
                  for (this.completeLayers || this.checkLayers(this.renderedFrame), i = a - 1; 0 <= i; i -= 1)
                    (this.completeLayers || this.elements[i]) && (this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st), this.elements[i]._mdf && (this._mdf = !0));
                }
              }),
              (Qt.prototype.renderInnerContent = function () {
                var t,
                  e = this.layers.length;
                for (t = 0; t < e; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
              }),
              (Qt.prototype.setElements = function (t) {
                this.elements = t;
              }),
              (Qt.prototype.getElements = function () {
                return this.elements;
              }),
              (Qt.prototype.destroyElements = function () {
                var t,
                  e = this.layers.length;
                for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
              }),
              (Qt.prototype.destroy = function () {
                this.destroyElements(), this.destroyBaseElement();
              }),
              q([Kt, Ft, jt, Lt, Rt, Bt], Xt),
              (Xt.prototype.createContent = function () {
                var t = this.globalData.getAssetsPath(this.assetData);
                (this.innerElem = D("image")),
                  this.innerElem.setAttribute("width", this.assetData.w + "px"),
                  this.innerElem.setAttribute("height", this.assetData.h + "px"),
                  this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio),
                  this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t),
                  this.layerElement.appendChild(this.innerElem);
              }),
              (Xt.prototype.sourceRectAtTime = function () {
                return this.sourceRect;
              }),
              q([Xt], Zt),
              (Zt.prototype.createContent = function () {
                var t = D("rect");
                t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
              }),
              ($t.prototype.prepareFrame = function (t) {
                if ((this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder)) this._currentTime = t / this.data.sr;
                else {
                  var e = this.tm.v;
                  this._currentTime = e;
                }
              }),
              q([Ot, Kt, Rt], $t),
              ($t.prototype.renderFrame = function () {
                this.isInRange &&
                  this._canPlay &&
                  (this._isPlaying
                    ? (!this.audio.playing() || 0.1 < Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek())) && this.audio.seek(this._currentTime / this.globalData.frameRate)
                    : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), (this._isPlaying = !0)));
              }),
              ($t.prototype.show = function () {}),
              ($t.prototype.hide = function () {
                this.audio.pause(), (this._isPlaying = !1);
              }),
              ($t.prototype.pause = function () {
                this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
              }),
              ($t.prototype.resume = function () {
                this._canPlay = !0;
              }),
              ($t.prototype.setRate = function (t) {
                this.audio.rate(t);
              }),
              ($t.prototype.volume = function (t) {
                this.audio.volume(t);
              }),
              ($t.prototype.getBaseElement = function () {
                return null;
              }),
              ($t.prototype.destroy = function () {}),
              ($t.prototype.sourceRectAtTime = function () {}),
              ($t.prototype.initExpressions = function () {}),
              q([Dt, Qt, jt], te),
              q([Kt, Ft, jt, Lt, Rt, Bt, Yt], ee),
              (ee.prototype.createContent = function () {
                this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = D("text"));
              }),
              (ee.prototype.buildTextContents = function (t) {
                for (var e = 0, i = t.length, a = [], n = ""; e < i; ) t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (a.push(n), (n = "")) : (n += t[e]), (e += 1);
                return a.push(n), a;
              }),
              (ee.prototype.buildNewText = function () {
                var t,
                  e,
                  i = this.textProperty.currentData;
                (this.renderedLetters = P(i ? i.l.length : 0)),
                  i.fc ? this.layerElement.setAttribute("fill", this.buildColor(i.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
                  i.sc && (this.layerElement.setAttribute("stroke", this.buildColor(i.sc)), this.layerElement.setAttribute("stroke-width", i.sw)),
                  this.layerElement.setAttribute("font-size", i.finalSize);
                var a = this.globalData.fontManager.getFontByName(i.f);
                if (a.fClass) this.layerElement.setAttribute("class", a.fClass);
                else {
                  this.layerElement.setAttribute("font-family", a.fFamily);
                  var n = i.fWeight,
                    r = i.fStyle;
                  this.layerElement.setAttribute("font-style", r), this.layerElement.setAttribute("font-weight", n);
                }
                this.layerElement.setAttribute("aria-label", i.t);
                var s,
                  o = i.l || [],
                  l = !!this.globalData.fontManager.chars;
                e = o.length;
                var c,
                  h = this.mHelper,
                  u = "",
                  d = this.data.singleShape,
                  p = 0,
                  f = 0,
                  m = !0,
                  g = 0.001 * i.tr * i.finalSize;
                if (!d || l || i.sz) {
                  var y,
                    v,
                    A = this.textSpans.length;
                  for (t = 0; t < e; t += 1)
                    (l && d && 0 !== t) ||
                      ((s = t < A ? this.textSpans[t] : D(l ? "path" : "text")),
                      A <= t && (s.setAttribute("stroke-linecap", "butt"), s.setAttribute("stroke-linejoin", "round"), s.setAttribute("stroke-miterlimit", "4"), (this.textSpans[t] = s), this.layerElement.appendChild(s)),
                      (s.style.display = "inherit")),
                      h.reset(),
                      h.scale(i.finalSize / 100, i.finalSize / 100),
                      d && (o[t].n && ((p = -g), (f += i.yOffset), (f += m ? 1 : 0), (m = !1)), this.applyTextPropertiesToMatrix(i, h, o[t].line, p, f), (p += o[t].l || 0), (p += g)),
                      l
                        ? ((c = (y = ((v = this.globalData.fontManager.getCharData(i.finalText[t], a.fStyle, this.globalData.fontManager.getFontByName(i.f).fFamily)) && v.data) || {}).shapes ? y.shapes[0].it : []),
                          d ? (u += this.createPathShape(h, c)) : s.setAttribute("d", this.createPathShape(h, c)))
                        : (d && s.setAttribute("transform", "translate(" + h.props[12] + "," + h.props[13] + ")"), (s.textContent = o[t].val), s.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"));
                  d && s && s.setAttribute("d", u);
                } else {
                  var b = this.textContainer,
                    w = "start";
                  switch (i.j) {
                    case 1:
                      w = "end";
                      break;
                    case 2:
                      w = "middle";
                      break;
                    default:
                      w = "start";
                  }
                  b.setAttribute("text-anchor", w), b.setAttribute("letter-spacing", g);
                  var C = this.buildTextContents(i.finalText);
                  for (e = C.length, f = i.ps ? i.ps[1] + i.ascent : 0, t = 0; t < e; t += 1)
                    ((s = this.textSpans[t] || D("tspan")).textContent = C[t]), s.setAttribute("x", 0), s.setAttribute("y", f), (s.style.display = "inherit"), b.appendChild(s), (this.textSpans[t] = s), (f += i.finalLineHeight);
                  this.layerElement.appendChild(b);
                }
                for (; t < this.textSpans.length; ) (this.textSpans[t].style.display = "none"), (t += 1);
                this._sizeChanged = !0;
              }),
              (ee.prototype.sourceRectAtTime = function () {
                if ((this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged)) {
                  this._sizeChanged = !1;
                  var t = this.layerElement.getBBox();
                  this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
                }
                return this.bbox;
              }),
              (ee.prototype.renderInnerContent = function () {
                if (!this.data.singleShape && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                  var t, e;
                  this._sizeChanged = !0;
                  var i,
                    a,
                    n = this.textAnimator.renderedLetters,
                    r = this.textProperty.currentData.l;
                  for (e = r.length, t = 0; t < e; t += 1)
                    r[t].n ||
                      ((i = n[t]),
                      (a = this.textSpans[t]),
                      i._mdf.m && a.setAttribute("transform", i.m),
                      i._mdf.o && a.setAttribute("opacity", i.o),
                      i._mdf.sw && a.setAttribute("stroke-width", i.sw),
                      i._mdf.sc && a.setAttribute("stroke", i.sc),
                      i._mdf.fc && a.setAttribute("fill", i.fc));
                }
              }),
              q([Kt, Ft, jt, Ht, Lt, Rt, Bt], ie),
              (ie.prototype.initSecondaryElement = function () {}),
              (ie.prototype.identityMatrix = new O()),
              (ie.prototype.buildExpressionInterface = function () {}),
              (ie.prototype.createContent = function () {
                this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
              }),
              (ie.prototype.filterUniqueShapes = function () {
                var t,
                  e,
                  i,
                  a,
                  n = this.shapes.length,
                  r = this.stylesList.length,
                  s = [],
                  o = !1;
                for (i = 0; i < r; i += 1) {
                  for (a = this.stylesList[i], o = !1, t = s.length = 0; t < n; t += 1) -1 !== (e = this.shapes[t]).styles.indexOf(a) && (s.push(e), (o = e._isAnimated || o));
                  1 < s.length && o && this.setShapesAsAnimated(s);
                }
              }),
              (ie.prototype.setShapesAsAnimated = function (t) {
                var e,
                  i = t.length;
                for (e = 0; e < i; e += 1) t[e].setAsAnimated();
              }),
              (ie.prototype.createStyleElement = function (t, e) {
                var i,
                  n = new qt(t, e),
                  r = n.pElem;
                return (
                  "st" === t.ty
                    ? (i = new Vt(this, t, n))
                    : "fl" === t.ty
                    ? (i = new Wt(this, t, n))
                    : ("gf" !== t.ty && "gs" !== t.ty) ||
                      ((i = new ("gf" === t.ty ? Ut : Jt)(this, t, n)),
                      this.globalData.defs.appendChild(i.gf),
                      i.maskId && (this.globalData.defs.appendChild(i.ms), this.globalData.defs.appendChild(i.of), r.setAttribute("mask", "url(" + a + "#" + i.maskId + ")"))),
                  ("st" !== t.ty && "gs" !== t.ty) ||
                    (r.setAttribute("stroke-linecap", this.lcEnum[t.lc] || "round"),
                    r.setAttribute("stroke-linejoin", this.ljEnum[t.lj] || "round"),
                    r.setAttribute("fill-opacity", "0"),
                    1 === t.lj && r.setAttribute("stroke-miterlimit", t.ml)),
                  2 === t.r && r.setAttribute("fill-rule", "evenodd"),
                  t.ln && r.setAttribute("id", t.ln),
                  t.cl && r.setAttribute("class", t.cl),
                  t.bm && (r.style["mix-blend-mode"] = F(t.bm)),
                  this.stylesList.push(n),
                  this.addToAnimatedContents(t, i),
                  i
                );
              }),
              (ie.prototype.createGroupElement = function (t) {
                var e = new (function () {
                  (this.it = []), (this.prevViewData = []), (this.gr = D("g"));
                })();
                return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = F(t.bm)), e;
              }),
              (ie.prototype.createTransformElement = function (t, e) {
                var i = z.getTransformProperty(this, t, this),
                  a = new (function (t, e, i) {
                    (this.transform = { mProps: t, op: e, container: i }), (this.elements = []), (this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length);
                  })(i, i.o, e);
                return this.addToAnimatedContents(t, a), a;
              }),
              (ie.prototype.createShapeElement = function (t, e, i) {
                var a = 4;
                "rc" === t.ty ? (a = 5) : "el" === t.ty ? (a = 6) : "sr" === t.ty && (a = 7);
                var n = new Nt(e, i, H.getShapeProp(this, t, a, this));
                return this.shapes.push(n), this.addShapeToModifiers(n), this.addToAnimatedContents(t, n), n;
              }),
              (ie.prototype.addToAnimatedContents = function (t, e) {
                for (var i = 0, a = this.animatedContents.length; i < a; ) {
                  if (this.animatedContents[i].element === e) return;
                  i += 1;
                }
                this.animatedContents.push({ fn: zt.createRenderFunction(t), element: e, data: t });
              }),
              (ie.prototype.setElementStyles = function (t) {
                var e,
                  i = t.styles,
                  a = this.stylesList.length;
                for (e = 0; e < a; e += 1) this.stylesList[e].closed || i.push(this.stylesList[e]);
              }),
              (ie.prototype.reloadShapes = function () {
                var t;
                this._isFirstFrame = !0;
                var e = this.itemsData.length;
                for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
                for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)
                  this.dynamicProperties[t].getValue();
                this.renderModifiers();
              }),
              (ie.prototype.searchShapes = function (t, e, i, a, n, r, s) {
                var o,
                  l,
                  c,
                  h,
                  u,
                  d,
                  p = [].concat(r),
                  f = t.length - 1,
                  m = [],
                  g = [];
                for (o = f; 0 <= o; o -= 1) {
                  if (((d = this.searchProcessedElement(t[o])) ? (e[o] = i[d - 1]) : (t[o]._render = s), "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty))
                    d ? (e[o].style.closed = !1) : (e[o] = this.createStyleElement(t[o], n)), t[o]._render && a.appendChild(e[o].style.pElem), m.push(e[o].style);
                  else if ("gr" === t[o].ty) {
                    if (d) for (c = e[o].it.length, l = 0; l < c; l += 1) e[o].prevViewData[l] = e[o].it[l];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, n + 1, p, s), t[o]._render && a.appendChild(e[o].gr);
                  } else
                    "tr" === t[o].ty
                      ? (d || (e[o] = this.createTransformElement(t[o], a)), (h = e[o].transform), p.push(h))
                      : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty
                      ? (d || (e[o] = this.createShapeElement(t[o], p, n)), this.setElementStyles(e[o]))
                      : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty
                      ? (d ? ((u = e[o]).closed = !1) : ((u = Y.getModifier(t[o].ty)).init(this, t[o]), (e[o] = u), this.shapeModifiers.push(u)), g.push(u))
                      : "rp" === t[o].ty && (d ? ((u = e[o]).closed = !0) : ((u = Y.getModifier(t[o].ty)), (e[o] = u).init(this, t, o, e), this.shapeModifiers.push(u), (s = !1)), g.push(u));
                  this.addProcessedElement(t[o], o + 1);
                }
                for (f = m.length, o = 0; o < f; o += 1) m[o].closed = !0;
                for (f = g.length, o = 0; o < f; o += 1) g[o].closed = !0;
              }),
              (ie.prototype.renderInnerContent = function () {
                var t;
                this.renderModifiers();
                var e = this.stylesList.length;
                for (t = 0; t < e; t += 1) this.stylesList[t].reset();
                for (this.renderShape(), t = 0; t < e; t += 1)
                  (this.stylesList[t]._mdf || this._isFirstFrame) &&
                    (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), (this.stylesList[t].d = "M0 0" + this.stylesList[t].d)),
                    this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
              }),
              (ie.prototype.renderShape = function () {
                var t,
                  e,
                  i = this.animatedContents.length;
                for (t = 0; t < i; t += 1) (e = this.animatedContents[t]), (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
              }),
              (ie.prototype.destroy = function () {
                this.destroyBaseElement(), (this.shapesData = null), (this.itemsData = null);
              });
            var ae = (function () {
                var e = {},
                  i = [],
                  a = 0,
                  n = 0,
                  r = 0,
                  s = !0,
                  o = !1;
                function l(t) {
                  for (var e = 0, a = t.target; e < n; ) i[e].animation === a && (i.splice(e, 1), (e -= 1), (n -= 1), a.isPaused || u()), (e += 1);
                }
                function c(t, e) {
                  if (!t) return null;
                  for (var a = 0; a < n; ) {
                    if (i[a].elem === t && null !== i[a].elem) return i[a].animation;
                    a += 1;
                  }
                  var r = new ne();
                  return d(r, t), r.setData(t, e), r;
                }
                function h() {
                  (r += 1), m();
                }
                function u() {
                  r -= 1;
                }
                function d(t, e) {
                  t.addEventListener("destroy", l), t.addEventListener("_active", h), t.addEventListener("_idle", u), i.push({ elem: e, animation: t }), (n += 1);
                }
                function p(e) {
                  var l,
                    c = e - a;
                  for (l = 0; l < n; l += 1) i[l].animation.advanceTime(c);
                  (a = e), r && !o ? t.requestAnimationFrame(p) : (s = !0);
                }
                function f(e) {
                  (a = e), t.requestAnimationFrame(p);
                }
                function m() {
                  !o && r && s && (t.requestAnimationFrame(f), (s = !1));
                }
                return (
                  (e.registerAnimation = c),
                  (e.loadAnimation = function (t) {
                    var e = new ne();
                    return d(e, null), e.setParams(t), e;
                  }),
                  (e.setSpeed = function (t, e) {
                    var a;
                    for (a = 0; a < n; a += 1) i[a].animation.setSpeed(t, e);
                  }),
                  (e.setDirection = function (t, e) {
                    var a;
                    for (a = 0; a < n; a += 1) i[a].animation.setDirection(t, e);
                  }),
                  (e.play = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.play(t);
                  }),
                  (e.pause = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.pause(t);
                  }),
                  (e.stop = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.stop(t);
                  }),
                  (e.togglePause = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.togglePause(t);
                  }),
                  (e.searchAnimations = function (t, e, i) {
                    var a,
                      n = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
                      r = n.length;
                    for (a = 0; a < r; a += 1) i && n[a].setAttribute("data-bm-type", i), c(n[a], t);
                    if (e && 0 === r) {
                      i || (i = "svg");
                      var s = document.getElementsByTagName("body")[0];
                      s.innerText = "";
                      var o = I("div");
                      (o.style.width = "100%"), (o.style.height = "100%"), o.setAttribute("data-bm-type", i), s.appendChild(o), c(o, t);
                    }
                  }),
                  (e.resize = function () {
                    var t;
                    for (t = 0; t < n; t += 1) i[t].animation.resize();
                  }),
                  (e.goToAndStop = function (t, e, a) {
                    var r;
                    for (r = 0; r < n; r += 1) i[r].animation.goToAndStop(t, e, a);
                  }),
                  (e.destroy = function (t) {
                    var e;
                    for (e = n - 1; 0 <= e; e -= 1) i[e].animation.destroy(t);
                  }),
                  (e.freeze = function () {
                    o = !0;
                  }),
                  (e.unfreeze = function () {
                    (o = !1), m();
                  }),
                  (e.setVolume = function (t, e) {
                    var a;
                    for (a = 0; a < n; a += 1) i[a].animation.setVolume(t, e);
                  }),
                  (e.mute = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.mute(t);
                  }),
                  (e.unmute = function (t) {
                    var e;
                    for (e = 0; e < n; e += 1) i[e].animation.unmute(t);
                  }),
                  (e.getRegisteredAnimations = function () {
                    var t,
                      e = i.length,
                      a = [];
                    for (t = 0; t < e; t += 1) a.push(i[t].animation);
                    return a;
                  }),
                  e
                );
              })(),
              ne = function () {
                (this._cbs = []),
                  (this.name = ""),
                  (this.path = ""),
                  (this.isLoaded = !1),
                  (this.currentFrame = 0),
                  (this.currentRawFrame = 0),
                  (this.firstFrame = 0),
                  (this.totalFrames = 0),
                  (this.frameRate = 0),
                  (this.frameMult = 0),
                  (this.playSpeed = 1),
                  (this.playDirection = 1),
                  (this.playCount = 0),
                  (this.animationData = {}),
                  (this.assets = []),
                  (this.isPaused = !0),
                  (this.autoplay = !1),
                  (this.loop = !0),
                  (this.renderer = null),
                  (this.animationID = C()),
                  (this.assetsPath = ""),
                  (this.timeCompleted = 0),
                  (this.segmentPos = 0),
                  (this.isSubframeEnabled = r),
                  (this.segments = []),
                  (this._idle = !0),
                  (this._completedLoop = !1),
                  (this.projectInterface = {}),
                  (this.imagePreloader = new lt()),
                  (this.audioController = ot()),
                  (this.markers = []);
              };
            q([T], ne),
              (ne.prototype.setParams = function (t) {
                (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
                var e = "svg";
                switch ((t.animType ? (e = t.animType) : t.renderer && (e = t.renderer), e)) {
                  case "canvas":
                    this.renderer = new CanvasRenderer(this, t.rendererSettings);
                    break;
                  case "svg":
                    this.renderer = new Dt(this, t.rendererSettings);
                    break;
                  default:
                    this.renderer = new HybridRenderer(this, t.rendererSettings);
                }
                this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
                  this.renderer.setProjectInterface(this.projectInterface),
                  (this.animType = e),
                  "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? (this.loop = !0) : !1 === t.loop ? (this.loop = !1) : (this.loop = parseInt(t.loop, 10)),
                  (this.autoplay = !("autoplay" in t) || t.autoplay),
                  (this.name = t.name ? t.name : ""),
                  (this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments),
                  (this.assetsPath = t.assetsPath),
                  (this.initialSegment = t.initialSegment),
                  t.audioFactory && this.audioController.setAudioFactory(t.audioFactory),
                  t.animationData
                    ? this.configAnimation(t.animationData)
                    : t.path &&
                      (-1 !== t.path.lastIndexOf("\\") ? (this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1)) : (this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1)),
                      (this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1)),
                      (this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"))),
                      ut.load(
                        t.path,
                        this.configAnimation.bind(this),
                        function () {
                          this.trigger("data_failed");
                        }.bind(this)
                      ));
              }),
              (ne.prototype.setData = function (t, e) {
                e && "object" != typeof e && (e = JSON.parse(e));
                var i = { wrapper: t, animationData: e },
                  a = t.attributes;
                (i.path = a.getNamedItem("data-animation-path")
                  ? a.getNamedItem("data-animation-path").value
                  : a.getNamedItem("data-bm-path")
                  ? a.getNamedItem("data-bm-path").value
                  : a.getNamedItem("bm-path")
                  ? a.getNamedItem("bm-path").value
                  : ""),
                  (i.animType = a.getNamedItem("data-anim-type")
                    ? a.getNamedItem("data-anim-type").value
                    : a.getNamedItem("data-bm-type")
                    ? a.getNamedItem("data-bm-type").value
                    : a.getNamedItem("bm-type")
                    ? a.getNamedItem("bm-type").value
                    : a.getNamedItem("data-bm-renderer")
                    ? a.getNamedItem("data-bm-renderer").value
                    : a.getNamedItem("bm-renderer")
                    ? a.getNamedItem("bm-renderer").value
                    : "canvas");
                var n = a.getNamedItem("data-anim-loop") ? a.getNamedItem("data-anim-loop").value : a.getNamedItem("data-bm-loop") ? a.getNamedItem("data-bm-loop").value : a.getNamedItem("bm-loop") ? a.getNamedItem("bm-loop").value : "";
                "false" === n ? (i.loop = !1) : "true" === n ? (i.loop = !0) : "" !== n && (i.loop = parseInt(n, 10));
                var r = a.getNamedItem("data-anim-autoplay")
                  ? a.getNamedItem("data-anim-autoplay").value
                  : a.getNamedItem("data-bm-autoplay")
                  ? a.getNamedItem("data-bm-autoplay").value
                  : !a.getNamedItem("bm-autoplay") || a.getNamedItem("bm-autoplay").value;
                (i.autoplay = "false" !== r),
                  (i.name = a.getNamedItem("data-name") ? a.getNamedItem("data-name").value : a.getNamedItem("data-bm-name") ? a.getNamedItem("data-bm-name").value : a.getNamedItem("bm-name") ? a.getNamedItem("bm-name").value : ""),
                  "false" ===
                    (a.getNamedItem("data-anim-prerender")
                      ? a.getNamedItem("data-anim-prerender").value
                      : a.getNamedItem("data-bm-prerender")
                      ? a.getNamedItem("data-bm-prerender").value
                      : a.getNamedItem("bm-prerender")
                      ? a.getNamedItem("bm-prerender").value
                      : "") && (i.prerender = !1),
                  this.setParams(i);
              }),
              (ne.prototype.includeLayers = function (t) {
                t.op > this.animationData.op && ((this.animationData.op = t.op), (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
                var i,
                  a,
                  n = this.animationData.layers,
                  r = n.length,
                  s = t.layers,
                  o = s.length;
                for (a = 0; a < o; a += 1)
                  for (i = 0; i < r; ) {
                    if (n[i].id === s[a].id) {
                      n[i] = s[a];
                      break;
                    }
                    i += 1;
                  }
                if (((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets))
                  for (r = t.assets.length, i = 0; i < r; i += 1) this.animationData.assets.push(t.assets[i]);
                (this.animationData.__complete = !1), V.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.includeLayers(t.layers), e && e.initExpressions(this), this.loadNextSegment();
              }),
              (ne.prototype.loadNextSegment = function () {
                var t = this.animationData.segments;
                if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
                var e = t.shift();
                this.timeCompleted = e.time * this.frameRate;
                var i = this.path + this.fileName + "_" + this.segmentPos + ".json";
                (this.segmentPos += 1),
                  ut.load(
                    i,
                    this.includeLayers.bind(this),
                    function () {
                      this.trigger("data_failed");
                    }.bind(this)
                  );
              }),
              (ne.prototype.loadSegments = function () {
                this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
              }),
              (ne.prototype.imagesLoaded = function () {
                this.trigger("loaded_images"), this.checkLoaded();
              }),
              (ne.prototype.preloadImages = function () {
                this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
              }),
              (ne.prototype.configAnimation = function (t) {
                if (this.renderer)
                  try {
                    (this.animationData = t),
                      this.initialSegment
                        ? ((this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0])), (this.firstFrame = Math.round(this.initialSegment[0])))
                        : ((this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip)), (this.firstFrame = Math.round(this.animationData.ip))),
                      this.renderer.configAnimation(t),
                      t.assets || (t.assets = []),
                      (this.assets = this.animationData.assets),
                      (this.frameRate = this.animationData.fr),
                      (this.frameMult = this.animationData.fr / 1e3),
                      this.renderer.searchExtraCompositions(t.assets),
                      (this.markers = Mt(t.markers || [])),
                      this.trigger("config_ready"),
                      this.preloadImages(),
                      this.loadSegments(),
                      this.updaFrameModifier(),
                      this.waitForFontsLoaded(),
                      this.isPaused && this.audioController.pause();
                  } catch (t) {
                    this.triggerConfigError(t);
                  }
              }),
              (ne.prototype.waitForFontsLoaded = function () {
                this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
              }),
              (ne.prototype.checkLoaded = function () {
                !this.isLoaded &&
                  this.renderer.globalData.fontManager.isLoaded &&
                  (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) &&
                  this.imagePreloader.loadedFootages() &&
                  ((this.isLoaded = !0),
                  V.completeData(this.animationData, this.renderer.globalData.fontManager),
                  e && e.initExpressions(this),
                  this.renderer.initItems(),
                  setTimeout(
                    function () {
                      this.trigger("DOMLoaded");
                    }.bind(this),
                    0
                  ),
                  this.gotoFrame(),
                  this.autoplay && this.play());
              }),
              (ne.prototype.resize = function () {
                this.renderer.updateContainerSize();
              }),
              (ne.prototype.setSubframe = function (t) {
                this.isSubframeEnabled = !!t;
              }),
              (ne.prototype.gotoFrame = function () {
                (this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame),
                  this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted),
                  this.trigger("enterFrame"),
                  this.renderFrame();
              }),
              (ne.prototype.renderFrame = function () {
                if (!1 !== this.isLoaded && this.renderer)
                  try {
                    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
                  } catch (t) {
                    this.triggerRenderFrameError(t);
                  }
              }),
              (ne.prototype.play = function (t) {
                (t && this.name !== t) || (!0 === this.isPaused && ((this.isPaused = !1), this.audioController.resume(), this._idle && ((this._idle = !1), this.trigger("_active"))));
              }),
              (ne.prototype.pause = function (t) {
                (t && this.name !== t) || (!1 === this.isPaused && ((this.isPaused = !0), (this._idle = !0), this.trigger("_idle"), this.audioController.pause()));
              }),
              (ne.prototype.togglePause = function (t) {
                (t && this.name !== t) || (!0 === this.isPaused ? this.play() : this.pause());
              }),
              (ne.prototype.stop = function (t) {
                (t && this.name !== t) || (this.pause(), (this.playCount = 0), (this._completedLoop = !1), this.setCurrentRawFrameValue(0));
              }),
              (ne.prototype.getMarkerData = function (t) {
                for (var e, i = 0; i < this.markers.length; i += 1) if ((e = this.markers[i]).payload && e.payload.name === t) return e;
                return null;
              }),
              (ne.prototype.goToAndStop = function (t, e, i) {
                if (!i || this.name === i) {
                  var a = Number(t);
                  if (isNaN(a)) {
                    var n = this.getMarkerData(t);
                    n && this.goToAndStop(n.time, !0);
                  } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                  this.pause();
                }
              }),
              (ne.prototype.goToAndPlay = function (t, e, i) {
                if (!i || this.name === i) {
                  var a = Number(t);
                  if (isNaN(a)) {
                    var n = this.getMarkerData(t);
                    n && (n.duration ? this.playSegments([n.time, n.time + n.duration], !0) : this.goToAndStop(n.time, !0));
                  } else this.goToAndStop(a, e, i);
                  this.play();
                }
              }),
              (ne.prototype.advanceTime = function (t) {
                if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                  var e = this.currentRawFrame + t * this.frameModifier,
                    i = !1;
                  e >= this.totalFrames - 1 && 0 < this.frameModifier
                    ? this.loop && this.playCount !== this.loop
                      ? e >= this.totalFrames
                        ? ((this.playCount += 1), this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), (this._completedLoop = !0), this.trigger("loopComplete")))
                        : this.setCurrentRawFrameValue(e)
                      : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || ((i = !0), (e = this.totalFrames - 1))
                    : e < 0
                    ? this.checkSegments(e % this.totalFrames) ||
                      (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                        ? ((i = !0), (e = 0))
                        : (this.setCurrentRawFrameValue(this.totalFrames + (e % this.totalFrames)), this._completedLoop ? this.trigger("loopComplete") : (this._completedLoop = !0)))
                    : this.setCurrentRawFrameValue(e),
                    i && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
                }
              }),
              (ne.prototype.adjustSegment = function (t, e) {
                (this.playCount = 0),
                  t[1] < t[0]
                    ? (0 < this.frameModifier && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)),
                      (this.totalFrames = t[0] - t[1]),
                      (this.timeCompleted = this.totalFrames),
                      (this.firstFrame = t[1]),
                      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
                    : t[1] > t[0] &&
                      (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)),
                      (this.totalFrames = t[1] - t[0]),
                      (this.timeCompleted = this.totalFrames),
                      (this.firstFrame = t[0]),
                      this.setCurrentRawFrameValue(0.001 + e)),
                  this.trigger("segmentStart");
              }),
              (ne.prototype.setSegment = function (t, e) {
                var i = -1;
                this.isPaused && (this.currentRawFrame + this.firstFrame < t ? (i = t) : this.currentRawFrame + this.firstFrame > e && (i = e - t)),
                  (this.firstFrame = t),
                  (this.totalFrames = e - t),
                  (this.timeCompleted = this.totalFrames),
                  -1 !== i && this.goToAndStop(i, !0);
              }),
              (ne.prototype.playSegments = function (t, e) {
                if ((e && (this.segments.length = 0), "object" == typeof t[0])) {
                  var i,
                    a = t.length;
                  for (i = 0; i < a; i += 1) this.segments.push(t[i]);
                } else this.segments.push(t);
                this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
              }),
              (ne.prototype.resetSegments = function (t) {
                (this.segments.length = 0), this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
              }),
              (ne.prototype.checkSegments = function (t) {
                return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
              }),
              (ne.prototype.destroy = function (t) {
                (t && this.name !== t) ||
                  !this.renderer ||
                  (this.renderer.destroy(),
                  this.imagePreloader.destroy(),
                  this.trigger("destroy"),
                  (this._cbs = null),
                  (this.onEnterFrame = null),
                  (this.onLoopComplete = null),
                  (this.onComplete = null),
                  (this.onSegmentStart = null),
                  (this.onDestroy = null),
                  (this.renderer = null),
                  (this.renderer = null),
                  (this.imagePreloader = null),
                  (this.projectInterface = null));
              }),
              (ne.prototype.setCurrentRawFrameValue = function (t) {
                (this.currentRawFrame = t), this.gotoFrame();
              }),
              (ne.prototype.setSpeed = function (t) {
                (this.playSpeed = t), this.updaFrameModifier();
              }),
              (ne.prototype.setDirection = function (t) {
                (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
              }),
              (ne.prototype.setVolume = function (t, e) {
                (e && this.name !== e) || this.audioController.setVolume(t);
              }),
              (ne.prototype.getVolume = function () {
                return this.audioController.getVolume();
              }),
              (ne.prototype.mute = function (t) {
                (t && this.name !== t) || this.audioController.mute();
              }),
              (ne.prototype.unmute = function (t) {
                (t && this.name !== t) || this.audioController.unmute();
              }),
              (ne.prototype.updaFrameModifier = function () {
                (this.frameModifier = this.frameMult * this.playSpeed * this.playDirection), this.audioController.setRate(this.playSpeed * this.playDirection);
              }),
              (ne.prototype.getPath = function () {
                return this.path;
              }),
              (ne.prototype.getAssetsPath = function (t) {
                var e = "";
                if (t.e) e = t.p;
                else if (this.assetsPath) {
                  var i = t.p;
                  -1 !== i.indexOf("images/") && (i = i.split("/")[1]), (e = this.assetsPath + i);
                } else (e = this.path), (e += t.u ? t.u : ""), (e += t.p);
                return e;
              }),
              (ne.prototype.getAssetData = function (t) {
                for (var e = 0, i = this.assets.length; e < i; ) {
                  if (t === this.assets[e].id) return this.assets[e];
                  e += 1;
                }
                return null;
              }),
              (ne.prototype.hide = function () {
                this.renderer.hide();
              }),
              (ne.prototype.show = function () {
                this.renderer.show();
              }),
              (ne.prototype.getDuration = function (t) {
                return t ? this.totalFrames : this.totalFrames / this.frameRate;
              }),
              (ne.prototype.trigger = function (t) {
                if (this._cbs && this._cbs[t])
                  switch (t) {
                    case "enterFrame":
                      this.triggerEvent(t, new g(t, this.currentFrame, this.totalFrames, this.frameModifier));
                      break;
                    case "loopComplete":
                      this.triggerEvent(t, new v(t, this.loop, this.playCount, this.frameMult));
                      break;
                    case "complete":
                      this.triggerEvent(t, new y(t, this.frameMult));
                      break;
                    case "segmentStart":
                      this.triggerEvent(t, new A(t, this.firstFrame, this.totalFrames));
                      break;
                    case "destroy":
                      this.triggerEvent(t, new b(t, this));
                      break;
                    default:
                      this.triggerEvent(t);
                  }
                "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new g(t, this.currentFrame, this.totalFrames, this.frameMult)),
                  "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new v(t, this.loop, this.playCount, this.frameMult)),
                  "complete" === t && this.onComplete && this.onComplete.call(this, new y(t, this.frameMult)),
                  "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new A(t, this.firstFrame, this.totalFrames)),
                  "destroy" === t && this.onDestroy && this.onDestroy.call(this, new b(t, this));
              }),
              (ne.prototype.triggerRenderFrameError = function (t) {
                var e = new (function (t, e) {
                  (this.type = "renderFrameError"), (this.nativeError = t), (this.currentTime = e);
                })(t, this.currentFrame);
                this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
              }),
              (ne.prototype.triggerConfigError = function (t) {
                var e = new (function (t) {
                  (this.type = "configError"), (this.nativeError = t);
                })(t, this.currentFrame);
                this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
              });
            var re = {};
            function se() {
              !0 === le ? ae.searchAnimations(ce, le, he) : ae.searchAnimations();
            }
            (re.play = ae.play),
              (re.pause = ae.pause),
              (re.setLocationHref = function (t) {
                a = t;
              }),
              (re.togglePause = ae.togglePause),
              (re.setSpeed = ae.setSpeed),
              (re.setDirection = ae.setDirection),
              (re.stop = ae.stop),
              (re.searchAnimations = se),
              (re.registerAnimation = ae.registerAnimation),
              (re.loadAnimation = function (t) {
                return !0 === le && (t.animationData = JSON.parse(ce)), ae.loadAnimation(t);
              }),
              (re.setSubframeRendering = function (t) {
                r = t;
              }),
              (re.resize = ae.resize),
              (re.goToAndStop = ae.goToAndStop),
              (re.destroy = ae.destroy),
              (re.setQuality = function (t) {
                if ("string" == typeof t)
                  switch (t) {
                    case "high":
                      d = 200;
                      break;
                    default:
                    case "medium":
                      d = 50;
                      break;
                    case "low":
                      d = 10;
                  }
                else !isNaN(t) && 1 < t && (d = t);
                m(!(50 <= d));
              }),
              (re.inBrowser = function () {
                return "undefined" != typeof navigator;
              }),
              (re.installPlugin = function (t, i) {
                "expressions" === t && (e = i);
              }),
              (re.freeze = ae.freeze),
              (re.unfreeze = ae.unfreeze),
              (re.setVolume = ae.setVolume),
              (re.mute = ae.mute),
              (re.unmute = ae.unmute),
              (re.getRegisteredAnimations = ae.getRegisteredAnimations),
              (re.__getFactory = function (t) {
                switch (t) {
                  case "propertyFactory":
                    return J;
                  case "shapePropertyFactory":
                    return H;
                  case "matrix":
                    return O;
                  default:
                    return null;
                }
              }),
              (re.version = "5.7.8");
            var oe,
              le = "__[STANDALONE]__",
              ce = "__[ANIMATIONDATA]__",
              he = "";
            if (le) {
              var ue = document.getElementsByTagName("script"),
                de = ue[ue.length - 1] || { src: "" };
              (oe = de.src.replace(/^[^\?]+\??/, "")),
                (he = (function (t) {
                  for (var e = oe.split("&"), i = 0; i < e.length; i += 1) {
                    var a = e[i].split("=");
                    if ("renderer" == decodeURIComponent(a[0])) return decodeURIComponent(a[1]);
                  }
                  return null;
                })());
            }
            var pe = setInterval(function () {
              "complete" === document.readyState && (clearInterval(pe), se());
            }, 100);
            return re;
          })(n);
        }.call(e, i, e, t)) || (t.exports = a));
  },
  function (t, e, i) {
    var a;
    /*! Hammer.JS - v2.0.7 - 2016-04-22
     * http://hammerjs.github.io/
     *
     * Copyright (c) 2016 Jorik Tangelder;
     * Licensed under the MIT license */
    /*! Hammer.JS - v2.0.7 - 2016-04-22
     * http://hammerjs.github.io/
     *
     * Copyright (c) 2016 Jorik Tangelder;
     * Licensed under the MIT license */
    !(function (n, r, s, o) {
      "use strict";
      var l,
        c = ["", "webkit", "Moz", "MS", "ms", "o"],
        h = r.createElement("div"),
        u = "function",
        d = Math.round,
        p = Math.abs,
        f = Date.now;
      function m(t, e, i) {
        return setTimeout(C(t, i), e);
      }
      function g(t, e, i) {
        return !!Array.isArray(t) && (y(t, i[e], i), !0);
      }
      function y(t, e, i) {
        var a;
        if (t)
          if (t.forEach) t.forEach(e, i);
          else if (t.length !== o) for (a = 0; a < t.length; ) e.call(i, t[a], a, t), a++;
          else for (a in t) t.hasOwnProperty(a) && e.call(i, t[a], a, t);
      }
      function v(t, e, i) {
        var a = "DEPRECATED METHOD: " + e + "\n" + i + " AT \n";
        return function () {
          var e = new Error("get-stack-trace"),
            i =
              e && e.stack
                ? e.stack
                    .replace(/^[^\(]+?[\n$]/gm, "")
                    .replace(/^\s+at\s+/gm, "")
                    .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
                : "Unknown Stack Trace",
            r = n.console && (n.console.warn || n.console.log);
          return r && r.call(n.console, a, i), t.apply(this, arguments);
        };
      }
      l =
        "function" != typeof Object.assign
          ? function (t) {
              if (t === o || null === t) throw new TypeError("Cannot convert undefined or null to object");
              for (var e = Object(t), i = 1; i < arguments.length; i++) {
                var a = arguments[i];
                if (a !== o && null !== a) for (var n in a) a.hasOwnProperty(n) && (e[n] = a[n]);
              }
              return e;
            }
          : Object.assign;
      var A = v(
          function (t, e, i) {
            for (var a = Object.keys(e), n = 0; n < a.length; ) (!i || (i && t[a[n]] === o)) && (t[a[n]] = e[a[n]]), n++;
            return t;
          },
          "extend",
          "Use `assign`."
        ),
        b = v(
          function (t, e) {
            return A(t, e, !0);
          },
          "merge",
          "Use `assign`."
        );
      function w(t, e, i) {
        var a,
          n = e.prototype;
        ((a = t.prototype = Object.create(n)).constructor = t), (a._super = n), i && l(a, i);
      }
      function C(t, e) {
        return function () {
          return t.apply(e, arguments);
        };
      }
      function S(t, e) {
        return typeof t == u ? t.apply((e && e[0]) || o, e) : t;
      }
      function k(t, e) {
        return t === o ? e : t;
      }
      function E(t, e, i) {
        y(M(e), function (e) {
          t.addEventListener(e, i, !1);
        });
      }
      function x(t, e, i) {
        y(M(e), function (e) {
          t.removeEventListener(e, i, !1);
        });
      }
      function _(t, e) {
        for (; t; ) {
          if (t == e) return !0;
          t = t.parentNode;
        }
        return !1;
      }
      function T(t, e) {
        return t.indexOf(e) > -1;
      }
      function M(t) {
        return t.trim().split(/\s+/g);
      }
      function P(t, e, i) {
        if (t.indexOf && !i) return t.indexOf(e);
        for (var a = 0; a < t.length; ) {
          if ((i && t[a][i] == e) || (!i && t[a] === e)) return a;
          a++;
        }
        return -1;
      }
      function D(t) {
        return Array.prototype.slice.call(t, 0);
      }
      function I(t, e, i) {
        for (var a = [], n = [], r = 0; r < t.length; ) {
          var s = e ? t[r][e] : t[r];
          P(n, s) < 0 && a.push(t[r]), (n[r] = s), r++;
        }
        return (
          i &&
            (a = e
              ? a.sort(function (t, i) {
                  return t[e] > i[e];
                })
              : a.sort()),
          a
        );
      }
      function L(t, e) {
        for (var i, a, n = e[0].toUpperCase() + e.slice(1), r = 0; r < c.length; ) {
          if ((a = (i = c[r]) ? i + n : e) in t) return a;
          r++;
        }
        return o;
      }
      var R = 1;
      function F(t) {
        var e = t.ownerDocument || t;
        return e.defaultView || e.parentWindow || n;
      }
      var O = "ontouchstart" in n,
        B = L(n, "PointerEvent") !== o,
        q = O && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
        N = 25,
        V = 1,
        W = 2,
        U = 4,
        J = 8,
        z = 1,
        K = 2,
        G = 4,
        j = 8,
        H = 16,
        Y = K | G,
        Q = j | H,
        X = Y | Q,
        Z = ["x", "y"],
        $ = ["clientX", "clientY"];
      function tt(t, e) {
        var i = this;
        (this.manager = t),
          (this.callback = e),
          (this.element = t.element),
          (this.target = t.options.inputTarget),
          (this.domHandler = function (e) {
            S(t.options.enable, [t]) && i.handler(e);
          }),
          this.init();
      }
      function et(t, e, i) {
        var a = i.pointers.length,
          n = i.changedPointers.length,
          r = e & V && a - n == 0,
          s = e & (U | J) && a - n == 0;
        (i.isFirst = !!r),
          (i.isFinal = !!s),
          r && (t.session = {}),
          (i.eventType = e),
          (function (t, e) {
            var i = t.session,
              a = e.pointers,
              n = a.length;
            i.firstInput || (i.firstInput = it(e));
            n > 1 && !i.firstMultiple ? (i.firstMultiple = it(e)) : 1 === n && (i.firstMultiple = !1);
            var r = i.firstInput,
              s = i.firstMultiple,
              l = s ? s.center : r.center,
              c = (e.center = at(a));
            (e.timeStamp = f()),
              (e.deltaTime = e.timeStamp - r.timeStamp),
              (e.angle = ot(l, c)),
              (e.distance = st(l, c)),
              (function (t, e) {
                var i = e.center,
                  a = t.offsetDelta || {},
                  n = t.prevDelta || {},
                  r = t.prevInput || {};
                (e.eventType !== V && r.eventType !== U) || ((n = t.prevDelta = { x: r.deltaX || 0, y: r.deltaY || 0 }), (a = t.offsetDelta = { x: i.x, y: i.y }));
                (e.deltaX = n.x + (i.x - a.x)), (e.deltaY = n.y + (i.y - a.y));
              })(i, e),
              (e.offsetDirection = rt(e.deltaX, e.deltaY));
            var h = nt(e.deltaTime, e.deltaX, e.deltaY);
            (e.overallVelocityX = h.x),
              (e.overallVelocityY = h.y),
              (e.overallVelocity = p(h.x) > p(h.y) ? h.x : h.y),
              (e.scale = s ? ((u = s.pointers), (d = a), st(d[0], d[1], $) / st(u[0], u[1], $)) : 1),
              (e.rotation = s
                ? (function (t, e) {
                    return ot(e[1], e[0], $) + ot(t[1], t[0], $);
                  })(s.pointers, a)
                : 0),
              (e.maxPointers = i.prevInput ? (e.pointers.length > i.prevInput.maxPointers ? e.pointers.length : i.prevInput.maxPointers) : e.pointers.length),
              (function (t, e) {
                var i,
                  a,
                  n,
                  r,
                  s = t.lastInterval || e,
                  l = e.timeStamp - s.timeStamp;
                if (e.eventType != J && (l > N || s.velocity === o)) {
                  var c = e.deltaX - s.deltaX,
                    h = e.deltaY - s.deltaY,
                    u = nt(l, c, h);
                  (a = u.x), (n = u.y), (i = p(u.x) > p(u.y) ? u.x : u.y), (r = rt(c, h)), (t.lastInterval = e);
                } else (i = s.velocity), (a = s.velocityX), (n = s.velocityY), (r = s.direction);
                (e.velocity = i), (e.velocityX = a), (e.velocityY = n), (e.direction = r);
              })(i, e);
            var u, d;
            var m = t.element;
            _(e.srcEvent.target, m) && (m = e.srcEvent.target);
            e.target = m;
          })(t, i),
          t.emit("hammer.input", i),
          t.recognize(i),
          (t.session.prevInput = i);
      }
      function it(t) {
        for (var e = [], i = 0; i < t.pointers.length; ) (e[i] = { clientX: d(t.pointers[i].clientX), clientY: d(t.pointers[i].clientY) }), i++;
        return { timeStamp: f(), pointers: e, center: at(e), deltaX: t.deltaX, deltaY: t.deltaY };
      }
      function at(t) {
        var e = t.length;
        if (1 === e) return { x: d(t[0].clientX), y: d(t[0].clientY) };
        for (var i = 0, a = 0, n = 0; n < e; ) (i += t[n].clientX), (a += t[n].clientY), n++;
        return { x: d(i / e), y: d(a / e) };
      }
      function nt(t, e, i) {
        return { x: e / t || 0, y: i / t || 0 };
      }
      function rt(t, e) {
        return t === e ? z : p(t) >= p(e) ? (t < 0 ? K : G) : e < 0 ? j : H;
      }
      function st(t, e, i) {
        i || (i = Z);
        var a = e[i[0]] - t[i[0]],
          n = e[i[1]] - t[i[1]];
        return Math.sqrt(a * a + n * n);
      }
      function ot(t, e, i) {
        i || (i = Z);
        var a = e[i[0]] - t[i[0]],
          n = e[i[1]] - t[i[1]];
        return (180 * Math.atan2(n, a)) / Math.PI;
      }
      tt.prototype = {
        handler: function () {},
        init: function () {
          this.evEl && E(this.element, this.evEl, this.domHandler), this.evTarget && E(this.target, this.evTarget, this.domHandler), this.evWin && E(F(this.element), this.evWin, this.domHandler);
        },
        destroy: function () {
          this.evEl && x(this.element, this.evEl, this.domHandler), this.evTarget && x(this.target, this.evTarget, this.domHandler), this.evWin && x(F(this.element), this.evWin, this.domHandler);
        },
      };
      var lt = { mousedown: V, mousemove: W, mouseup: U },
        ct = "mousedown",
        ht = "mousemove mouseup";
      function ut() {
        (this.evEl = ct), (this.evWin = ht), (this.pressed = !1), tt.apply(this, arguments);
      }
      w(ut, tt, {
        handler: function (t) {
          var e = lt[t.type];
          e & V && 0 === t.button && (this.pressed = !0),
            e & W && 1 !== t.which && (e = U),
            this.pressed && (e & U && (this.pressed = !1), this.callback(this.manager, e, { pointers: [t], changedPointers: [t], pointerType: "mouse", srcEvent: t }));
        },
      });
      var dt = { pointerdown: V, pointermove: W, pointerup: U, pointercancel: J, pointerout: J },
        pt = { 2: "touch", 3: "pen", 4: "mouse", 5: "kinect" },
        ft = "pointerdown",
        mt = "pointermove pointerup pointercancel";
      function gt() {
        (this.evEl = ft), (this.evWin = mt), tt.apply(this, arguments), (this.store = this.manager.session.pointerEvents = []);
      }
      n.MSPointerEvent && !n.PointerEvent && ((ft = "MSPointerDown"), (mt = "MSPointerMove MSPointerUp MSPointerCancel")),
        w(gt, tt, {
          handler: function (t) {
            var e = this.store,
              i = !1,
              a = t.type.toLowerCase().replace("ms", ""),
              n = dt[a],
              r = pt[t.pointerType] || t.pointerType,
              s = "touch" == r,
              o = P(e, t.pointerId, "pointerId");
            n & V && (0 === t.button || s) ? o < 0 && (e.push(t), (o = e.length - 1)) : n & (U | J) && (i = !0),
              o < 0 || ((e[o] = t), this.callback(this.manager, n, { pointers: e, changedPointers: [t], pointerType: r, srcEvent: t }), i && e.splice(o, 1));
          },
        });
      var yt = { touchstart: V, touchmove: W, touchend: U, touchcancel: J },
        vt = "touchstart",
        At = "touchstart touchmove touchend touchcancel";
      function bt() {
        (this.evTarget = vt), (this.evWin = At), (this.started = !1), tt.apply(this, arguments);
      }
      w(bt, tt, {
        handler: function (t) {
          var e = yt[t.type];
          if ((e === V && (this.started = !0), this.started)) {
            var i = function (t, e) {
              var i = D(t.touches),
                a = D(t.changedTouches);
              e & (U | J) && (i = I(i.concat(a), "identifier", !0));
              return [i, a];
            }.call(this, t, e);
            e & (U | J) && i[0].length - i[1].length == 0 && (this.started = !1), this.callback(this.manager, e, { pointers: i[0], changedPointers: i[1], pointerType: "touch", srcEvent: t });
          }
        },
      });
      var wt = { touchstart: V, touchmove: W, touchend: U, touchcancel: J },
        Ct = "touchstart touchmove touchend touchcancel";
      function St() {
        (this.evTarget = Ct), (this.targetIds = {}), tt.apply(this, arguments);
      }
      w(St, tt, {
        handler: function (t) {
          var e = wt[t.type],
            i = function (t, e) {
              var i = D(t.touches),
                a = this.targetIds;
              if (e & (V | W) && 1 === i.length) return (a[i[0].identifier] = !0), [i, i];
              var n,
                r,
                s = D(t.changedTouches),
                o = [],
                l = this.target;
              if (
                ((r = i.filter(function (t) {
                  return _(t.target, l);
                })),
                e === V)
              )
                for (n = 0; n < r.length; ) (a[r[n].identifier] = !0), n++;
              n = 0;
              for (; n < s.length; ) a[s[n].identifier] && o.push(s[n]), e & (U | J) && delete a[s[n].identifier], n++;
              if (!o.length) return;
              return [I(r.concat(o), "identifier", !0), o];
            }.call(this, t, e);
          i && this.callback(this.manager, e, { pointers: i[0], changedPointers: i[1], pointerType: "touch", srcEvent: t });
        },
      });
      var kt = 2500,
        Et = 25;
      function xt() {
        tt.apply(this, arguments);
        var t = C(this.handler, this);
        (this.touch = new St(this.manager, t)), (this.mouse = new ut(this.manager, t)), (this.primaryTouch = null), (this.lastTouches = []);
      }
      function _t(t) {
        var e = t.changedPointers[0];
        if (e.identifier === this.primaryTouch) {
          var i = { x: e.clientX, y: e.clientY };
          this.lastTouches.push(i);
          var a = this.lastTouches;
          setTimeout(function () {
            var t = a.indexOf(i);
            t > -1 && a.splice(t, 1);
          }, kt);
        }
      }
      w(xt, tt, {
        handler: function (t, e, i) {
          var a = "touch" == i.pointerType,
            n = "mouse" == i.pointerType;
          if (!(n && i.sourceCapabilities && i.sourceCapabilities.firesTouchEvents)) {
            if (a)
              (function (t, e) {
                t & V ? ((this.primaryTouch = e.changedPointers[0].identifier), _t.call(this, e)) : t & (U | J) && _t.call(this, e);
              }.call(this, e, i));
            else if (
              n &&
              function (t) {
                for (var e = t.srcEvent.clientX, i = t.srcEvent.clientY, a = 0; a < this.lastTouches.length; a++) {
                  var n = this.lastTouches[a],
                    r = Math.abs(e - n.x),
                    s = Math.abs(i - n.y);
                  if (r <= Et && s <= Et) return !0;
                }
                return !1;
              }.call(this, i)
            )
              return;
            this.callback(t, e, i);
          }
        },
        destroy: function () {
          this.touch.destroy(), this.mouse.destroy();
        },
      });
      var Tt = L(h.style, "touchAction"),
        Mt = Tt !== o,
        Pt = "auto",
        Dt = "manipulation",
        It = "none",
        Lt = "pan-x",
        Rt = "pan-y",
        Ft = (function () {
          if (!Mt) return !1;
          var t = {},
            e = n.CSS && n.CSS.supports;
          return (
            ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (i) {
              t[i] = !e || n.CSS.supports("touch-action", i);
            }),
            t
          );
        })();
      function Ot(t, e) {
        (this.manager = t), this.set(e);
      }
      Ot.prototype = {
        set: function (t) {
          "compute" == t && (t = this.compute()), Mt && this.manager.element.style && Ft[t] && (this.manager.element.style[Tt] = t), (this.actions = t.toLowerCase().trim());
        },
        update: function () {
          this.set(this.manager.options.touchAction);
        },
        compute: function () {
          var t = [];
          return (
            y(this.manager.recognizers, function (e) {
              S(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
            }),
            (function (t) {
              if (T(t, It)) return It;
              var e = T(t, Lt),
                i = T(t, Rt);
              if (e && i) return It;
              if (e || i) return e ? Lt : Rt;
              if (T(t, Dt)) return Dt;
              return Pt;
            })(t.join(" "))
          );
        },
        preventDefaults: function (t) {
          var e = t.srcEvent,
            i = t.offsetDirection;
          if (this.manager.session.prevented) e.preventDefault();
          else {
            var a = this.actions,
              n = T(a, It) && !Ft[It],
              r = T(a, Rt) && !Ft[Rt],
              s = T(a, Lt) && !Ft[Lt];
            if (n) {
              var o = 1 === t.pointers.length,
                l = t.distance < 2,
                c = t.deltaTime < 250;
              if (o && l && c) return;
            }
            if (!s || !r) return n || (r && i & Y) || (s && i & Q) ? this.preventSrc(e) : void 0;
          }
        },
        preventSrc: function (t) {
          (this.manager.session.prevented = !0), t.preventDefault();
        },
      };
      var Bt = 1,
        qt = 2,
        Nt = 4,
        Vt = 8,
        Wt = Vt,
        Ut = 16;
      function Jt(t) {
        (this.options = l({}, this.defaults, t || {})), (this.id = R++), (this.manager = null), (this.options.enable = k(this.options.enable, !0)), (this.state = Bt), (this.simultaneous = {}), (this.requireFail = []);
      }
      function zt(t) {
        return t & Ut ? "cancel" : t & Vt ? "end" : t & Nt ? "move" : t & qt ? "start" : "";
      }
      function Kt(t) {
        return t == H ? "down" : t == j ? "up" : t == K ? "left" : t == G ? "right" : "";
      }
      function Gt(t, e) {
        var i = e.manager;
        return i ? i.get(t) : t;
      }
      function jt() {
        Jt.apply(this, arguments);
      }
      function Ht() {
        jt.apply(this, arguments), (this.pX = null), (this.pY = null);
      }
      function Yt() {
        jt.apply(this, arguments);
      }
      function Qt() {
        Jt.apply(this, arguments), (this._timer = null), (this._input = null);
      }
      function Xt() {
        jt.apply(this, arguments);
      }
      function Zt() {
        jt.apply(this, arguments);
      }
      function $t() {
        Jt.apply(this, arguments), (this.pTime = !1), (this.pCenter = !1), (this._timer = null), (this._input = null), (this.count = 0);
      }
      function te(t, e) {
        return ((e = e || {}).recognizers = k(e.recognizers, te.defaults.preset)), new ee(t, e);
      }
      (Jt.prototype = {
        defaults: {},
        set: function (t) {
          return l(this.options, t), this.manager && this.manager.touchAction.update(), this;
        },
        recognizeWith: function (t) {
          if (g(t, "recognizeWith", this)) return this;
          var e = this.simultaneous;
          return e[(t = Gt(t, this)).id] || ((e[t.id] = t), t.recognizeWith(this)), this;
        },
        dropRecognizeWith: function (t) {
          return g(t, "dropRecognizeWith", this) ? this : ((t = Gt(t, this)), delete this.simultaneous[t.id], this);
        },
        requireFailure: function (t) {
          if (g(t, "requireFailure", this)) return this;
          var e = this.requireFail;
          return -1 === P(e, (t = Gt(t, this))) && (e.push(t), t.requireFailure(this)), this;
        },
        dropRequireFailure: function (t) {
          if (g(t, "dropRequireFailure", this)) return this;
          t = Gt(t, this);
          var e = P(this.requireFail, t);
          return e > -1 && this.requireFail.splice(e, 1), this;
        },
        hasRequireFailures: function () {
          return this.requireFail.length > 0;
        },
        canRecognizeWith: function (t) {
          return !!this.simultaneous[t.id];
        },
        emit: function (t) {
          var e = this,
            i = this.state;
          function a(i) {
            e.manager.emit(i, t);
          }
          i < Vt && a(e.options.event + zt(i)), a(e.options.event), t.additionalEvent && a(t.additionalEvent), i >= Vt && a(e.options.event + zt(i));
        },
        tryEmit: function (t) {
          if (this.canEmit()) return this.emit(t);
          this.state = 32;
        },
        canEmit: function () {
          for (var t = 0; t < this.requireFail.length; ) {
            if (!(this.requireFail[t].state & (32 | Bt))) return !1;
            t++;
          }
          return !0;
        },
        recognize: function (t) {
          var e = l({}, t);
          if (!S(this.options.enable, [this, e])) return this.reset(), void (this.state = 32);
          this.state & (Wt | Ut | 32) && (this.state = Bt), (this.state = this.process(e)), this.state & (qt | Nt | Vt | Ut) && this.tryEmit(e);
        },
        process: function (t) {},
        getTouchAction: function () {},
        reset: function () {},
      }),
        w(jt, Jt, {
          defaults: { pointers: 1 },
          attrTest: function (t) {
            var e = this.options.pointers;
            return 0 === e || t.pointers.length === e;
          },
          process: function (t) {
            var e = this.state,
              i = t.eventType,
              a = e & (qt | Nt),
              n = this.attrTest(t);
            return a && (i & J || !n) ? e | Ut : a || n ? (i & U ? e | Vt : e & qt ? e | Nt : qt) : 32;
          },
        }),
        w(Ht, jt, {
          defaults: { event: "pan", threshold: 10, pointers: 1, direction: X },
          getTouchAction: function () {
            var t = this.options.direction,
              e = [];
            return t & Y && e.push(Rt), t & Q && e.push(Lt), e;
          },
          directionTest: function (t) {
            var e = this.options,
              i = !0,
              a = t.distance,
              n = t.direction,
              r = t.deltaX,
              s = t.deltaY;
            return (
              n & e.direction || (e.direction & Y ? ((n = 0 === r ? z : r < 0 ? K : G), (i = r != this.pX), (a = Math.abs(t.deltaX))) : ((n = 0 === s ? z : s < 0 ? j : H), (i = s != this.pY), (a = Math.abs(t.deltaY)))),
              (t.direction = n),
              i && a > e.threshold && n & e.direction
            );
          },
          attrTest: function (t) {
            return jt.prototype.attrTest.call(this, t) && (this.state & qt || (!(this.state & qt) && this.directionTest(t)));
          },
          emit: function (t) {
            (this.pX = t.deltaX), (this.pY = t.deltaY);
            var e = Kt(t.direction);
            e && (t.additionalEvent = this.options.event + e), this._super.emit.call(this, t);
          },
        }),
        w(Yt, jt, {
          defaults: { event: "pinch", threshold: 0, pointers: 2 },
          getTouchAction: function () {
            return [It];
          },
          attrTest: function (t) {
            return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & qt);
          },
          emit: function (t) {
            if (1 !== t.scale) {
              var e = t.scale < 1 ? "in" : "out";
              t.additionalEvent = this.options.event + e;
            }
            this._super.emit.call(this, t);
          },
        }),
        w(Qt, Jt, {
          defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
          getTouchAction: function () {
            return [Pt];
          },
          process: function (t) {
            var e = this.options,
              i = t.pointers.length === e.pointers,
              a = t.distance < e.threshold,
              n = t.deltaTime > e.time;
            if (((this._input = t), !a || !i || (t.eventType & (U | J) && !n))) this.reset();
            else if (t.eventType & V)
              this.reset(),
                (this._timer = m(
                  function () {
                    (this.state = Wt), this.tryEmit();
                  },
                  e.time,
                  this
                ));
            else if (t.eventType & U) return Wt;
            return 32;
          },
          reset: function () {
            clearTimeout(this._timer);
          },
          emit: function (t) {
            this.state === Wt && (t && t.eventType & U ? this.manager.emit(this.options.event + "up", t) : ((this._input.timeStamp = f()), this.manager.emit(this.options.event, this._input)));
          },
        }),
        w(Xt, jt, {
          defaults: { event: "rotate", threshold: 0, pointers: 2 },
          getTouchAction: function () {
            return [It];
          },
          attrTest: function (t) {
            return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & qt);
          },
        }),
        w(Zt, jt, {
          defaults: { event: "swipe", threshold: 10, velocity: 0.3, direction: Y | Q, pointers: 1 },
          getTouchAction: function () {
            return Ht.prototype.getTouchAction.call(this);
          },
          attrTest: function (t) {
            var e,
              i = this.options.direction;
            return (
              i & (Y | Q) ? (e = t.overallVelocity) : i & Y ? (e = t.overallVelocityX) : i & Q && (e = t.overallVelocityY),
              this._super.attrTest.call(this, t) && i & t.offsetDirection && t.distance > this.options.threshold && t.maxPointers == this.options.pointers && p(e) > this.options.velocity && t.eventType & U
            );
          },
          emit: function (t) {
            var e = Kt(t.offsetDirection);
            e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
          },
        }),
        w($t, Jt, {
          defaults: { event: "tap", pointers: 1, taps: 1, interval: 300, time: 250, threshold: 9, posThreshold: 10 },
          getTouchAction: function () {
            return [Dt];
          },
          process: function (t) {
            var e = this.options,
              i = t.pointers.length === e.pointers,
              a = t.distance < e.threshold,
              n = t.deltaTime < e.time;
            if ((this.reset(), t.eventType & V && 0 === this.count)) return this.failTimeout();
            if (a && n && i) {
              if (t.eventType != U) return this.failTimeout();
              var r = !this.pTime || t.timeStamp - this.pTime < e.interval,
                s = !this.pCenter || st(this.pCenter, t.center) < e.posThreshold;
              if (((this.pTime = t.timeStamp), (this.pCenter = t.center), s && r ? (this.count += 1) : (this.count = 1), (this._input = t), 0 === this.count % e.taps))
                return this.hasRequireFailures()
                  ? ((this._timer = m(
                      function () {
                        (this.state = Wt), this.tryEmit();
                      },
                      e.interval,
                      this
                    )),
                    qt)
                  : Wt;
            }
            return 32;
          },
          failTimeout: function () {
            return (
              (this._timer = m(
                function () {
                  this.state = 32;
                },
                this.options.interval,
                this
              )),
              32
            );
          },
          reset: function () {
            clearTimeout(this._timer);
          },
          emit: function () {
            this.state == Wt && ((this._input.tapCount = this.count), this.manager.emit(this.options.event, this._input));
          },
        }),
        (te.VERSION = "2.0.7"),
        (te.defaults = {
          domEvents: !1,
          touchAction: "compute",
          enable: !0,
          inputTarget: null,
          inputClass: null,
          preset: [[Xt, { enable: !1 }], [Yt, { enable: !1 }, ["rotate"]], [Zt, { direction: Y }], [Ht, { direction: Y }, ["swipe"]], [$t], [$t, { event: "doubletap", taps: 2 }, ["tap"]], [Qt]],
          cssProps: { userSelect: "none", touchSelect: "none", touchCallout: "none", contentZooming: "none", userDrag: "none", tapHighlightColor: "rgba(0,0,0,0)" },
        });
      function ee(t, e) {
        var i;
        (this.options = l({}, te.defaults, e || {})),
          (this.options.inputTarget = this.options.inputTarget || t),
          (this.handlers = {}),
          (this.session = {}),
          (this.recognizers = []),
          (this.oldCssProps = {}),
          (this.element = t),
          (this.input = new ((i = this).options.inputClass || (B ? gt : q ? St : O ? xt : ut))(i, et)),
          (this.touchAction = new Ot(this, this.options.touchAction)),
          ie(this, !0),
          y(
            this.options.recognizers,
            function (t) {
              var e = this.add(new t[0](t[1]));
              t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
            },
            this
          );
      }
      function ie(t, e) {
        var i,
          a = t.element;
        a.style &&
          (y(t.options.cssProps, function (n, r) {
            (i = L(a.style, r)), e ? ((t.oldCssProps[i] = a.style[i]), (a.style[i] = n)) : (a.style[i] = t.oldCssProps[i] || "");
          }),
          e || (t.oldCssProps = {}));
      }
      (ee.prototype = {
        set: function (t) {
          return l(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), (this.input.target = t.inputTarget), this.input.init()), this;
        },
        stop: function (t) {
          this.session.stopped = t ? 2 : 1;
        },
        recognize: function (t) {
          var e = this.session;
          if (!e.stopped) {
            var i;
            this.touchAction.preventDefaults(t);
            var a = this.recognizers,
              n = e.curRecognizer;
            (!n || (n && n.state & Wt)) && (n = e.curRecognizer = null);
            for (var r = 0; r < a.length; ) (i = a[r]), 2 === e.stopped || (n && i != n && !i.canRecognizeWith(n)) ? i.reset() : i.recognize(t), !n && i.state & (qt | Nt | Vt) && (n = e.curRecognizer = i), r++;
          }
        },
        get: function (t) {
          if (t instanceof Jt) return t;
          for (var e = this.recognizers, i = 0; i < e.length; i++) if (e[i].options.event == t) return e[i];
          return null;
        },
        add: function (t) {
          if (g(t, "add", this)) return this;
          var e = this.get(t.options.event);
          return e && this.remove(e), this.recognizers.push(t), (t.manager = this), this.touchAction.update(), t;
        },
        remove: function (t) {
          if (g(t, "remove", this)) return this;
          if ((t = this.get(t))) {
            var e = this.recognizers,
              i = P(e, t);
            -1 !== i && (e.splice(i, 1), this.touchAction.update());
          }
          return this;
        },
        on: function (t, e) {
          if (t !== o && e !== o) {
            var i = this.handlers;
            return (
              y(M(t), function (t) {
                (i[t] = i[t] || []), i[t].push(e);
              }),
              this
            );
          }
        },
        off: function (t, e) {
          if (t !== o) {
            var i = this.handlers;
            return (
              y(M(t), function (t) {
                e ? i[t] && i[t].splice(P(i[t], e), 1) : delete i[t];
              }),
              this
            );
          }
        },
        emit: function (t, e) {
          this.options.domEvents &&
            (function (t, e) {
              var i = r.createEvent("Event");
              i.initEvent(t, !0, !0), (i.gesture = e), e.target.dispatchEvent(i);
            })(t, e);
          var i = this.handlers[t] && this.handlers[t].slice();
          if (i && i.length) {
            (e.type = t),
              (e.preventDefault = function () {
                e.srcEvent.preventDefault();
              });
            for (var a = 0; a < i.length; ) i[a](e), a++;
          }
        },
        destroy: function () {
          this.element && ie(this, !1), (this.handlers = {}), (this.session = {}), this.input.destroy(), (this.element = null);
        },
      }),
        l(te, {
          INPUT_START: V,
          INPUT_MOVE: W,
          INPUT_END: U,
          INPUT_CANCEL: J,
          STATE_POSSIBLE: Bt,
          STATE_BEGAN: qt,
          STATE_CHANGED: Nt,
          STATE_ENDED: Vt,
          STATE_RECOGNIZED: Wt,
          STATE_CANCELLED: Ut,
          STATE_FAILED: 32,
          DIRECTION_NONE: z,
          DIRECTION_LEFT: K,
          DIRECTION_RIGHT: G,
          DIRECTION_UP: j,
          DIRECTION_DOWN: H,
          DIRECTION_HORIZONTAL: Y,
          DIRECTION_VERTICAL: Q,
          DIRECTION_ALL: X,
          Manager: ee,
          Input: tt,
          TouchAction: Ot,
          TouchInput: St,
          MouseInput: ut,
          PointerEventInput: gt,
          TouchMouseInput: xt,
          SingleTouchInput: bt,
          Recognizer: Jt,
          AttrRecognizer: jt,
          Tap: $t,
          Pan: Ht,
          Swipe: Zt,
          Pinch: Yt,
          Rotate: Xt,
          Press: Qt,
          on: E,
          off: x,
          each: y,
          merge: b,
          extend: A,
          assign: l,
          inherit: w,
          bindFn: C,
          prefixed: L,
        }),
        ((void 0 !== n ? n : "undefined" != typeof self ? self : {}).Hammer = te),
        (a = function () {
          return te;
        }.call(e, i, e, t)) === o || (t.exports = a);
    })(window, document);
  },
  ,
  ,
  ,
  function (t) {
    t.exports = JSON.parse(
      '["James","John","Robert","Michael","Mary","William","David","Joseph","Richard","Charles","Thomas","Christopher","Daniel","Elizabeth","Matthew","Patricia","George","Jennifer","Linda","Anthony","Barbara","Donald","Paul","Mark","Andrew","Edward","Steven","Kenneth","Margaret","Joshua","Kevin","Brian","Susan","Dorothy","Ronald","Sarah","Timothy","Jessica","Jason","Helen","Nancy","Betty","Karen","Jeffrey","Lisa","Ryan","Jacob","Frank","Gary","Nicholas","Anna","Eric","Sandra","Stephen","Emily","Ashley","Jonathan","Kimberly","Donna","Ruth","Carol","Michelle","Larry","Laura","Amanda","Justin","Raymond","Scott","Samuel","Brandon","Melissa","Benjamin","Rebecca","Deborah","Stephanie","Sharon","Kathleen","Cynthia","Gregory","Jack","Amy","Henry","Shirley","Patrick","Alexander","Emma","Angela","Catherine","Virginia","Katherine","Walter","Dennis","Jerry","Brenda","Pamela","Frances","Tyler","Nicole","Christine","Aaron","Peter","Samantha","Evelyn","Jose","Rachel","Alice","Douglas","Janet","Carolyn","Adam","Debra","Harold","Nathan","Martha","Maria","Marie","Zachary","Arthur","Heather","Diane","Julie","Joyce","Carl","Grace","Victoria","Albert","Rose","Joan","Kyle","Christina","Kelly","Ann","Lauren","Doris","Julia","Jean","Lawrence","Judith","Olivia","Kathryn","Joe","Mildred","Willie","Gerald","Lillian","Roger","Cheryl","Megan","Jeremy","Keith","Hannah","Andrea","Ethan","Sara","Terry","Jacqueline","Christian","Harry","Jesse","Sean","Teresa","Ralph","Austin","Gloria","Janice","Roy","Theresa","Louis","Noah","Bruce","Billy","Judy","Bryan","Madison","Eugene","Beverly","Jordan","Denise","Jane","Marilyn","Amber","Dylan","Danielle","Abigail","Charlotte","Diana","Brittany","Russell","Natalie","Wayne","Irene","Ruby","Annie","Sophia","Alan","Juan","Gabriel","Howard","Fred","Vincent","Lori","Philip","Kayla","Alexis","Tiffany","Florence","Isabella","Kathy","Louise","Logan","Lois","Tammy","Crystal","Randy","Bonnie","Phyllis","Anne","Taylor","Victor","Bobby","Erin","Johnny","Phillip","Martin","Josephine","Alyssa","Bradley","Ella","Shawn","Clarence","Travis","Ernest","Stanley","Allison","Craig","Shannon","Elijah","Edna","Peggy","Tina","Leonard","Robin","Dawn","Carlos","Earl","Eleanor","Jimmy","Francis","Cody","Caleb","Mason","Rita","Danny","Isaac","Audrey","Todd","Wanda","Clara","Ethel","Paula","Cameron","Norma","Dale","Ellen","Luis","Alex","Marjorie","Luke","Jamie","Nathaniel","Allen","Leslie","Joel","Evan","Edith","Connie","Eva","Gladys","Carrie","Ava","Frederick","Wendy","Hazel","Valerie","Curtis","Elaine","Courtney","Esther","Cindy","Vanessa","Brianna","Lucas","Norman","Marvin","Tracy","Tony","Monica","Antonio","Glenn","Melanie","Jasmine","Rodney","Theodore","Melvin","Alfred","Edwin","Steve","Chad","Sylvia","Jackson","April","Sheila","Adrian","Katie","Hunter","Alexandra","Angel","Lee","Marcus","Derek","Erica","Sherry","Jeffery","Mia","Caroline","Jesus","Herbert","Ian","Leah","Pauline","Alicia","Thelma","Lucille","Michele","Ricky","Suzanne","Veronica","Kristen","Wesley","Isaiah","Morgan","Anita","Liam","Julian","Troy","Joanne","Dolores","Geraldine","Connor","Chloe","Eddie","Jayden","Lorraine","Rhonda","Jill","Vivian","Bertha","Juanita","Dustin","Aiden","Leo","Mike","Darlene","Sally","Calvin","Lucy","Ray","Gail","Oscar","Holly","Jared","Leroy","Bernard","Randall","Jeremiah","June","Dana","Amelia","Beatrice","Brooke","Jay","Shane","Marion","Debbie","Madeline","Owen","Clifford","Claire","Eileen","Ida","Manuel","Renee","Lynn","Bernice","Corey","Ronnie","Barry","Kim","Kristin","Jo","Elsie","Regina","Gertrude","Miguel","Warren","Dean","Tommy","Gavin","Blake","Loretta","Stella","Rosa","Tara","Roberta","Cathy","Sydney","Bessie","Charlie","Savannah","Annette","Cassandra","Jessie","Dominic","Lydia","Don","Leon","Oliver","Jon","Laurie","Molly","Kaitlyn","Jeanne","Jeanette","Stacy","Chase","Colleen","Mitchell","Seth","Naomi","Hailey","Bill","Lloyd","Jerome","Chelsea","Alma","Beth","Alvin","Darrell","Minnie","Carter","Agnes","Landon","Brett","Trevor","Rosemary","Wyatt","Pearl","Joann","Lindsey","Lillie","Haley","Yvonne","Sebastian","Floyd","Micheal","Gordon","Vicki","Jim","Erik","Georgia","Gina","Edgar","Lewis","Devin","Max","Nora","Nellie","Carla","Levi","Lily","Stacey","Kelsey","Destiny","Terri","Vernon","Shelby","Mario","Jenna","Chris","Sue","Maureen","Heidi","Clyde","Derrick","Arlene","Violet","Daisy","Marian","Vera","Ricardo","Wilma","Paige","Tom","Marc","Constance","Brent","Lena","Carmen","Sabrina","Myrtle","Faith","Franklin","Cole","Kristina","Herman","Cora","Joy","Melinda","Mabel","Xavier","Maurice","Francisco","Gabrielle","Sofia","Deanna","Alejandro","Ivan","Marcia","Charlene","Katelyn","Viola","Mattie","Clayton","Jorge","Garrett","Tamara","Lester","Lindsay","Marlene","Gilbert","Elmer","Mackenzie","Kaylee","Nina","Zoe","Jennie","Claudia","Gene","Avery","Alexa","Cory","Colin","Glen","Sadie","Grant","Sam","Erika","Autumn","Jake","Andre","Colton","Addison","Eli","Harvey","Chester","Tonya","Jeff","Marissa","Priscilla","Patsy","Isabel","Angelina","Gwendolyn","Brayden","Delores","Spencer","Milton","Gabriella","Tanya","Maggie","Duane","Bryce","Sophie","Preston","Yolanda","Genevieve","Maxine","Tristan","Alison","Ruben","Jimmie","Aubrey","Caitlin","Miranda","Mae","Carole","Casey","Reginald","Vickie","Aidan","Kylie","Miriam","Glenda","Leona","Mariah","Roberto","Carson","Everett","Josiah","Riley","Diego","Brandy","Cecil","Dan","Margie","Jocelyn","Dora","Parker","Joanna","Marsha","Lance","Eduardo","Arnold","Neil","Hector","Makayla","Brooklyn","Darren","Ana","Johnnie","Brandi","Billie","Katrina","Ariana","Karl","Hattie","Nolan","Toni","Kara","Bailey","Alexandria","Hayden","Kay","Christy","Penny","Javier","Bethany","Roland","Cecilia","Omar","Clinton","Sierra","Fernando","Melody","Whitney","Ada","Natasha","Maya","Kendra","Dianne","Meghan","Allan","Lonnie","Johnathan","Marguerite","Briana","Micah","Maxwell","Isabelle","Bob","Tanner","Darryl","Marshall","Madelyn","Arianna","Claude","Abraham","Jenny","Felicia","Jackie","Angelica","Brendan","Guy","Bridget","Andy","Adriana","Hope","Pedro","Karla","Harriet","Brady","Lola","Bobbie","Geneva","Nicolas","Aaliyah","Blanche","Layla","Velma","Becky","Damian","Tracey","Dakota","Cooper","Kurt","Susie","Fannie","Raul","Candace","Jacquelyn","Lula","Misty","Shelly","Kristine","Andres","Sherri","Jade","Zoey","Sidney","Tim","Ben","Brad","Rachael","Desiree","Miles","Brittney","Iris","Wallace","Rick","Hugh","Jillian","Breanna","Dalton","Kate","Ross","Harper","Elias","Hilda","Byron","Rosie","Grayson","Nevaeh","Eunice","Jodi","Gabriela","Rafael","Jaxon","Sheryl","Monique","Tyrone","Angelo","Antoinette","Julius","Dwight","Summer","Lynda","Elena","Mamie","Trinity","Greg","Willard","Nelson","Harrison","Kaleb","Collin","Kristi","Sergio","Emmanuel","Dwayne","Mathew","Ramon","Perry","Ted","Gracie","Kelli","Drew","Janie","Krystal","Jaden","Meredith","Rebekah","Krista","Irma","Beulah","Ayden","Bianca","Armando","Freddie","Rosalie","Cesar","Shelley","Peyton","Belinda","Erick","Terrence","Virgil","Ashton","Kennedy","Marco","Devon","Morris","Kristy","Alberta","Felix","Camila","Ariel","Wade","Clifton","Shaun","Opal","Roman","Jeannette","Terrance","Verna","Giovanni","Sandy","Stuart","Kent","Faye","Brody","Ramona","Flora","Jaime","Genesis","Della","Candice","Cheyenne","Kirk","Inez","Leonardo","Gianna","Camille","Adrienne","Jace","Valeria","Skylar","Lila","Scarlett","Luther","Elise","Lorenzo","Natalia","Penelope","Jonah","Sonia","Guadalupe","Sonya","Marianne","Jada","Jonathon","Ellie","Damon","Dave","Marcella","Lincoln","Fredrick","Carly","Nichole","Yvette","Bryson","Dominick","Dillon","Cristian","Angie","Daryl","Patty","Maryann","Malcolm","Robyn","Bella","Lynne","Dallas","Kristopher","Santiago","Olga","Gayle","Rickey","Israel","Hudson","Homer","Kaden","Caden","Sheri","Myra","Donnie","Julio","Alberto","Simon","Daniela","Annabelle","Kendall","Kari","Adeline","Mckenzie","Josie","Karina","Callie","Abby","Otis","Earnest","Roxanne","Tabitha","Juliana","Gerard","Rex","Lyle","Gage","Celeste","Lilly","Hubert","Serenity","Enrique","Aurora","Kaitlin","Damien","Alana","Wilbur","Donovan","Cecelia","Trenton","Cassidy","Asher","Dianna","Jody","Salvatore","Emmett","Alisha","Liliana","Olive","Mateo","Mya","Erma","Muriel","Alfredo","Jan","Mallory","Neal","Celia","Geoffrey","Horace","Janelle","Eliza","Arturo","Bernadette","Aimee","Estelle","Leland","Ira","Gretchen","Mikayla","Vicky","Rudolph","Jordyn","Wendell","Mable","Conner","Abel","Kirsten","Eloise","Alec","Payton","Nadine","Bennie","Ezra","Traci","Reagan","Willis","Lana","Joey","Lora","Cara","Caitlyn","Gerardo","Johanna","Rylee","Aria","Allyson","Cristina","Darius","Lacey","Edmund","Easton","Kayden","Malachi","Braxton","Jaxson","Kiara","Ryder","Kylee","Sawyer","Camden","Ashlyn","Piper","Josue","Bentley","Michaela","Alejandra","Hayley","Malik","Braden","Chance","Alexia","Colby","Ezekiel","Adrianna","Giselle","Mila","Makenzie","Jayla","Axel","Weston","Khloe","Aubree","Aliyah","Julianna","Tucker","Zane","Jazmin","Tessa","Alondra","Kai","Eliana","Kaiden","Paisley","Selena","Griffin","Mckenna","Jalen","Delaney","Jasmin","London","Declan","Dawson","Silas","Skyler","Alaina","Greyson","Ivy","Raven","Esmeralda","Laila","Jazmine","Jaylen","Cayden","Myles","Kyla","Ty","Jude","Dante","Valentina","Marcos","Maddox","Brielle","Keegan","Reese","Hanna","Trey","Corbin","Nadia","Dominique","Mariana","Jameson","Luna","Eden","Anastasia","Bennett","Brooklynn","Delilah","Kameron","Lukas","Drake","Kyra","Graham","Diamond","Amaya","Quinn","Amir","Chandler","Trent","Willow","Kyler","Allie","Fabian","Hadley","Ciara","Jakob","Elliot","Madeleine","Makenna","Jaiden","Keira","Brock","Luca","Zion","Katelynn","Jayce","Savanna","Emilio","Emilia","Lane","Kayleigh","Tatiana","Kira","Alina","Carolina","Rylan","Alivia","Fatima","Macy","Tyson","Haylee","Brennan","Emanuel","Xander","Kingston","Asia","Leilani","Tori","Lyla","Kassandra","Beau","Mercedes","Alayna","Elliott","Zackary","Yesenia","Kinsley","Ashlee","Ximena","Camryn","Cade","Izabella","Serena","Maximus","Pablo","Paris","Sienna","Fiona","Gustavo","Ryker","Aniyah","Daniella","Lucia","Marisa","Ryleigh","Heaven","Athena","Maverick","Leila","Kailey","Gael","Britney","Harley","Marley","Landen","Saul","Cierra","Harmony","Noelle","Alissa","Nickolas","Jasper","Bryant","Imani","Sasha","Ismael","Ashlynn","Reid","Meagan","Desmond","Lexi","Zachery","Emiliano","Talia","Shayla","Brenden","Brantley","Holden","Quentin","Kiana","Emery","Clarissa","Rowan","Esteban","Presley","Brenna","Chelsey","Marina","Ali","Brynn","Lizbeth","Zander","Raquel","Kali","Deandre","Arielle","Tiana","Julissa","Teagan","Emerson","Ashleigh","Isla","Phoebe","Finn","Norah","Salvador","Malia","Jayson","Kamryn","Conor","King","Zachariah","Paola","Francesca","Adan","Joaquin","Moises","Emilee","Cadence","Jase","Nia","Ernesto","Juliet","Judah","Kaylie","Tristen","Adalyn","August","Adalynn","Maddison","Baylee","Jamal","Elaina","Hugo","Kasey","Ayla","Zayden","Tatum","Lauryn","Orlando","Marisol","Rodrigo","Waylon","Kody","Brooks","Keaton","Emely","Elisabeth","Jayda","Walker","Aden","Caiden","Nikolas","Alexus","Paxton","Reed","Kassidy","Kiera","Cash","Nayeli","Juliette","Quinton","Jaclyn","Rylie","Londyn","Viviana","Kyleigh","Davis","Kendrick","River","Noel","Amari","Anderson","Madalyn","Branden","Bryanna","Raegan","Mayra","Demetrius","Sage","Alessandra","Maci","Gunner","Skye","Madilyn","Kelvin","Alyson","Mikaela","Hallie","Cruz","Arabella","Tia","Tiara","Kaylin","Elisa","Karter","Everly","Kenzie","Khalil","Justice","Alanna","Mauricio","Cali","Katlyn","Yasmin","Kobe","Dane","Matteo","Itzel","Nyla","Sarai","Annika","Aniya","Latoya","Ebony","Cassie","Jermaine","Justine","Carissa","Terrell","Stefanie","Tasha","Johnathon","Shawna","Rene","Hillary","Kellie","Nikki","Taryn","Trisha","Marquis","Mandy","Christie","Mindy","Stacie","Tricia","Charity","Latasha","Kristie","Leticia","Cedric","Kelley","Kerry","Kerri","Christa","Keri","Kenny","Jana","Leigh","Kimberley","Roderick","Rochelle","Shelia","Teri","Ginger","Shari","Patti","Tami","Lynette"]'
    );
  },
  function (t) {
    t.exports = JSON.parse(
      '["Shoutout [NAME].","Respect to [NAME].","Props to [NAME].","Big up [NAME].","Give it up for [NAME]!","[NAME], you\'re on fire!","Run with it, [NAME]!","High five to [NAME]!","You’re a legend, [NAME]!","Let’s go [NAME]!","Get it, [NAME]!"]'
    );
  },
  function (t) {
    t.exports = JSON.parse(
      '[{"state":"Alabama","city":"Birmingham"},{"state":"Alabama","city":"Montgomery"},{"state":"Alabama","city":"Mobile"},{"state":"Alabama","city":"Huntsville"},{"state":"Alabama","city":"Tuscaloosa"},{"state":"Alabama","city":"Hoover"},{"state":"Alaska","city":"Anchorage"},{"state":"Alaska","city":"Juneau"},{"state":"Alaska","city":"Fairbanks"},{"state":"Alaska","city":"Wasilla"},{"state":"Alaska","city":"Sitka"},{"state":"Arizona","city":"Phoenix"},{"state":"Arizona","city":"Tucson"},{"state":"Arizona","city":"Mesa"},{"state":"Arizona","city":"Chandler"},{"state":"Arizona","city":"Glendale"},{"state":"Arizona","city":"Scottsdale"},{"state":"Arizona","city":"Gilbert"},{"state":"Arizona","city":"Tempe"},{"state":"Arizona","city":"Peoria"},{"state":"Arizona","city":"Surprise"},{"state":"Arizona","city":"Yuma"},{"state":"Arizona","city":"Avondale"},{"state":"Arkansas","city":"Little Rock"},{"state":"Arkansas","city":"Fort Smith"},{"state":"Arkansas","city":"Fayetteville"},{"state":"Arkansas","city":"Springdale"},{"state":"Arkansas","city":"Jonesboro"},{"state":"California","city":"Los Angeles"},{"state":"California","city":"San Diego"},{"state":"California","city":"San Jose"},{"state":"California","city":"San Francisco"},{"state":"California","city":"Fresno"},{"state":"California","city":"Sacramento"},{"state":"California","city":"Long Beach"},{"state":"California","city":"Oakland"},{"state":"California","city":"Bakersfield"},{"state":"California","city":"Anaheim"},{"state":"California","city":"Santa Ana"},{"state":"California","city":"Riverside"},{"state":"California","city":"Stockton"},{"state":"California","city":"Chula Vista"},{"state":"California","city":"Fremont"},{"state":"California","city":"Irvine"},{"state":"California","city":"San Bernardino"},{"state":"California","city":"Oxnard"},{"state":"California","city":"Fontana"},{"state":"California","city":"Moreno Valley"},{"state":"California","city":"Glendale"},{"state":"California","city":"Huntington Beach"},{"state":"California","city":"Santa Clarita"},{"state":"California","city":"Garden Grove"},{"state":"California","city":"Santa Rosa"},{"state":"California","city":"Oceanside"},{"state":"California","city":"Rancho Cucamonga"},{"state":"California","city":"Ontario"},{"state":"California","city":"Lancaster"},{"state":"California","city":"Elk Grove"},{"state":"California","city":"Palmdale"},{"state":"California","city":"Corona"},{"state":"California","city":"Salinas"},{"state":"California","city":"Pomona"},{"state":"California","city":"Torrance"},{"state":"California","city":"Hayward"},{"state":"California","city":"Escondido"},{"state":"California","city":"Sunnyvale"},{"state":"California","city":"Pasadena"},{"state":"California","city":"Orange"},{"state":"California","city":"Fullerton"},{"state":"California","city":"Thousand Oaks"},{"state":"California","city":"Visalia"},{"state":"California","city":"Simi Valley"},{"state":"California","city":"Concord"},{"state":"California","city":"Roseville"},{"state":"California","city":"Santa Clara"},{"state":"California","city":"Vallejo"},{"state":"California","city":"Victorville"},{"state":"California","city":"El Monte"},{"state":"California","city":"Berkeley"},{"state":"California","city":"Downey"},{"state":"California","city":"Costa Mesa"},{"state":"California","city":"Inglewood"},{"state":"California","city":"Ventura"},{"state":"California","city":"West Covina"},{"state":"California","city":"Norwalk"},{"state":"California","city":"Carlsbad"},{"state":"California","city":"Fairfield"},{"state":"California","city":"Richmond"},{"state":"California","city":"Murrieta"},{"state":"California","city":"Burbank"},{"state":"California","city":"Antioch"},{"state":"California","city":"Daly City"},{"state":"California","city":"Temecula"},{"state":"California","city":"Santa Maria"},{"state":"California","city":"El Cajon"},{"state":"California","city":"Rialto"},{"state":"California","city":"San Mateo"},{"state":"California","city":"Compton"},{"state":"California","city":"Clovis"},{"state":"California","city":"South Gate"},{"state":"California","city":"Vista"},{"state":"California","city":"Mission Viejo"},{"state":"California","city":"Vacaville"},{"state":"California","city":"Carson"},{"state":"California","city":"Hesperia"},{"state":"California","city":"Redding"},{"state":"California","city":"Santa Monica"},{"state":"California","city":"Westminster"},{"state":"California","city":"Santa Barbara"},{"state":"California","city":"Chico"},{"state":"California","city":"Whittier"},{"state":"California","city":"Newport Beach"},{"state":"California","city":"San Leandro"},{"state":"California","city":"Hawthorne"},{"state":"California","city":"San Marcos"},{"state":"California","city":"Citrus Heights"},{"state":"California","city":"Alhambra"},{"state":"California","city":"Tracy"},{"state":"California","city":"Livermore"},{"state":"California","city":"Buena Park"},{"state":"California","city":"Lakewood"},{"state":"California","city":"Merced"},{"state":"California","city":"Hemet"},{"state":"California","city":"Chino"},{"state":"California","city":"Menifee"},{"state":"California","city":"Lake Forest"},{"state":"California","city":"Napa"},{"state":"California","city":"Redwood City"},{"state":"California","city":"Bellflower"},{"state":"California","city":"Indio"},{"state":"California","city":"Tustin"},{"state":"California","city":"Baldwin Park"},{"state":"California","city":"Chino Hills"},{"state":"California","city":"Mountain View"},{"state":"California","city":"Alameda"},{"state":"California","city":"Upland"},{"state":"California","city":"Folsom"},{"state":"California","city":"San Ramon"},{"state":"California","city":"Pleasanton"},{"state":"California","city":"Lynwood"},{"state":"California","city":"Union City"},{"state":"California","city":"Apple Valley"},{"state":"California","city":"Redlands"},{"state":"California","city":"Turlock"},{"state":"California","city":"Perris"},{"state":"California","city":"Manteca"},{"state":"California","city":"Milpitas"},{"state":"California","city":"Redondo Beach"},{"state":"Colorado","city":"Denver"},{"state":"Colorado","city":"Colorado Springs"},{"state":"Colorado","city":"Aurora"},{"state":"Colorado","city":"Fort Collins"},{"state":"Colorado","city":"Lakewood"},{"state":"Colorado","city":"Thornton"},{"state":"Colorado","city":"Pueblo"},{"state":"Colorado","city":"Arvada"},{"state":"Colorado","city":"Westminster"},{"state":"Colorado","city":"Centennial"},{"state":"Colorado","city":"Boulder"},{"state":"Colorado","city":"Greeley"},{"state":"Colorado","city":"Longmont"},{"state":"Colorado","city":"Loveland"},{"state":"Connecticut","city":"Bridgeport"},{"state":"Connecticut","city":"New Haven"},{"state":"Connecticut","city":"Hartford"},{"state":"Connecticut","city":"Stamford"},{"state":"Connecticut","city":"Waterbury"},{"state":"Connecticut","city":"Norwalk"},{"state":"Connecticut","city":"Danbury"},{"state":"Connecticut","city":"New Britain"},{"state":"Delaware","city":"Wilmington"},{"state":"Delaware","city":"Dover"},{"state":"Delaware","city":"Newark"},{"state":"Delaware","city":"Middletown"},{"state":"Delaware","city":"Smyrna"},{"state":"DC","city":"Washington"},{"state":"DC","city":"Arlington"},{"state":"DC","city":"Alexandria"},{"state":"DC","city":"Bethesda"},{"state":"DC","city":"Silver Spring"},{"state":"Florida","city":"Jacksonville"},{"state":"Florida","city":"Miami"},{"state":"Florida","city":"Tampa"},{"state":"Florida","city":"St. Petersburg"},{"state":"Florida","city":"Orlando"},{"state":"Florida","city":"Hialeah"},{"state":"Florida","city":"Tallahassee"},{"state":"Florida","city":"Fort Lauderdale"},{"state":"Florida","city":"Port St. Lucie"},{"state":"Florida","city":"Pembroke Pines"},{"state":"Florida","city":"Cape Coral"},{"state":"Florida","city":"Hollywood"},{"state":"Florida","city":"Gainesville"},{"state":"Florida","city":"Miramar"},{"state":"Florida","city":"Coral Springs"},{"state":"Florida","city":"Clearwater"},{"state":"Florida","city":"Miami Gardens"},{"state":"Florida","city":"Palm Bay"},{"state":"Florida","city":"West Palm Beach"},{"state":"Florida","city":"Pompano Beach"},{"state":"Florida","city":"Lakeland"},{"state":"Florida","city":"Davie"},{"state":"Florida","city":"Miami Beach"},{"state":"Florida","city":"Deltona"},{"state":"Florida","city":"Plantation"},{"state":"Florida","city":"Sunrise"},{"state":"Florida","city":"Boca Raton"},{"state":"Florida","city":"Largo"},{"state":"Florida","city":"Melbourne"},{"state":"Florida","city":"Palm Coast"},{"state":"Florida","city":"Deerfield Beach"},{"state":"Florida","city":"Boynton Beach"},{"state":"Florida","city":"Lauderhill"},{"state":"Georgia","city":"Atlanta"},{"state":"Georgia","city":"Augusta-Richmond County"},{"state":"Georgia","city":"Columbus"},{"state":"Georgia","city":"Savannah"},{"state":"Georgia","city":"Athens-Clarke County"},{"state":"Georgia","city":"Sandy Springs"},{"state":"Georgia","city":"Macon"},{"state":"Georgia","city":"Roswell"},{"state":"Georgia","city":"Albany"},{"state":"Georgia","city":"Johns Creek"},{"state":"Georgia","city":"Warner Robins"},{"state":"Hawaii","city":"Honolulu"},{"state":"Hawaii","city":"East Honolulu"},{"state":"Hawaii","city":"Pearl City"},{"state":"Hawaii","city":"Hilo"},{"state":"Hawaii","city":"Kailua"},{"state":"Idaho","city":"Boise City"},{"state":"Idaho","city":"Nampa"},{"state":"Idaho","city":"Meridian"},{"state":"Idaho","city":"Idaho Falls"},{"state":"Idaho","city":"Caldwell"},{"state":"Illinois","city":"Chicago"},{"state":"Illinois","city":"Aurora"},{"state":"Illinois","city":"Rockford"},{"state":"Illinois","city":"Joliet"},{"state":"Illinois","city":"Naperville"},{"state":"Illinois","city":"Springfield"},{"state":"Illinois","city":"Peoria"},{"state":"Illinois","city":"Elgin"},{"state":"Illinois","city":"Waukegan"},{"state":"Illinois","city":"Cicero"},{"state":"Illinois","city":"Champaign"},{"state":"Illinois","city":"Bloomington"},{"state":"Illinois","city":"Decatur"},{"state":"Illinois","city":"Arlington Heights"},{"state":"Illinois","city":"Evanston"},{"state":"Illinois","city":"Schaumburg"},{"state":"Illinois","city":"Bolingbrook"},{"state":"Illinois","city":"Palatine"},{"state":"Indiana","city":"Indianapolis"},{"state":"Indiana","city":"Fort Wayne"},{"state":"Indiana","city":"Evansville"},{"state":"Indiana","city":"South Bend"},{"state":"Indiana","city":"Hammond"},{"state":"Indiana","city":"Bloomington"},{"state":"Indiana","city":"Gary"},{"state":"Indiana","city":"Carmel"},{"state":"Indiana","city":"Fishers"},{"state":"Indiana","city":"Muncie"},{"state":"Indiana","city":"Lafayette"},{"state":"Iowa","city":"Des Moines"},{"state":"Iowa","city":"Cedar Rapids"},{"state":"Iowa","city":"Davenport"},{"state":"Iowa","city":"Sioux City"},{"state":"Iowa","city":"Waterloo"},{"state":"Iowa","city":"Iowa City"},{"state":"Kansas","city":"Wichita"},{"state":"Kansas","city":"Overland Park"},{"state":"Kansas","city":"Kansas City"},{"state":"Kansas","city":"Topeka"},{"state":"Kansas","city":"Olathe"},{"state":"Kansas","city":"Lawrence"},{"state":"Kentucky","city":"Louisville"},{"state":"Kentucky","city":"Lexington"},{"state":"Kentucky","city":"Bowling Green"},{"state":"Kentucky","city":"Owensboro"},{"state":"Kentucky","city":"Covington"},{"state":"Kentucky","city":"Frankfort"},{"state":"Louisiana","city":"New Orleans"},{"state":"Louisiana","city":"Baton Rouge"},{"state":"Louisiana","city":"Shreveport"},{"state":"Louisiana","city":"Lafayette"},{"state":"Louisiana","city":"Lake Charles"},{"state":"Louisiana","city":"Kenner"},{"state":"Maine","city":"Portland"},{"state":"Maine","city":"Lewiston"},{"state":"Maine","city":"Bangor"},{"state":"Maine","city":"South Portland"},{"state":"Maine","city":"Auburn"},{"state":"Maine","city":"Augusta"},{"state":"Maryland","city":"Baltimore"},{"state":"Maryland","city":"Columbia"},{"state":"Maryland","city":"Germantown"},{"state":"Maryland","city":"Silver Spring"},{"state":"Maryland","city":"Frederick"},{"state":"Maryland","city":"Annapolis"},{"state":"Massachusetts","city":"Boston"},{"state":"Massachusetts","city":"Worcester"},{"state":"Massachusetts","city":"Springfield"},{"state":"Massachusetts","city":"Lowell"},{"state":"Massachusetts","city":"Cambridge"},{"state":"Massachusetts","city":"New Bedford"},{"state":"Massachusetts","city":"Brockton"},{"state":"Massachusetts","city":"Quincy"},{"state":"Massachusetts","city":"Lynn"},{"state":"Massachusetts","city":"Fall River"},{"state":"Massachusetts","city":"Newton"},{"state":"Massachusetts","city":"Lawrence"},{"state":"Massachusetts","city":"Somerville"},{"state":"Michigan","city":"Detroit"},{"state":"Michigan","city":"Grand Rapids"},{"state":"Michigan","city":"Warren"},{"state":"Michigan","city":"Sterling Heights"},{"state":"Michigan","city":"Lansing"},{"state":"Michigan","city":"Ann Arbor"},{"state":"Michigan","city":"Flint"},{"state":"Michigan","city":"Dearborn"},{"state":"Michigan","city":"Livonia"},{"state":"Michigan","city":"Westland"},{"state":"Michigan","city":"Troy"},{"state":"Michigan","city":"Farmington Hills"},{"state":"Michigan","city":"Kalamazoo"},{"state":"Michigan","city":"Wyoming"},{"state":"Michigan","city":"Southfield"},{"state":"Michigan","city":"Rochester Hills"},{"state":"Minnesota","city":"Minneapolis"},{"state":"Minnesota","city":"St. Paul"},{"state":"Minnesota","city":"Rochester"},{"state":"Minnesota","city":"Duluth"},{"state":"Minnesota","city":"Bloomington"},{"state":"Minnesota","city":"Brooklyn Park"},{"state":"Minnesota","city":"Plymouth"},{"state":"Mississippi","city":"Jackson"},{"state":"Mississippi","city":"Gulfport"},{"state":"Mississippi","city":"Southaven"},{"state":"Mississippi","city":"Biloxi"},{"state":"Mississippi","city":"Hattiesburg"},{"state":"Missouri","city":"Kansas City"},{"state":"Missouri","city":"St. Louis"},{"state":"Missouri","city":"Springfield"},{"state":"Missouri","city":"Independence"},{"state":"Missouri","city":"Columbia"},{"state":"Missouri","city":"Lee\'s Summit"},{"state":"Missouri","city":"O\'Fallon"},{"state":"Missouri","city":"St. Joseph"},{"state":"Montana","city":"Billings"},{"state":"Montana","city":"Missoula"},{"state":"Montana","city":"Great Falls"},{"state":"Montana","city":"Bozeman"},{"state":"Montana","city":"Butte"},{"state":"Montana","city":"Helena"},{"state":"Nebraska","city":"Omaha"},{"state":"Nebraska","city":"Lincoln"},{"state":"Nebraska","city":"Bellevue"},{"state":"Nebraska","city":"Grand Island"},{"state":"Nebraska","city":"Kearney"},{"state":"Nevada","city":"Las Vegas"},{"state":"Nevada","city":"Henderson"},{"state":"Nevada","city":"Reno"},{"state":"Nevada","city":"North Las Vegas"},{"state":"Nevada","city":"Sparks"},{"state":"Nevada","city":"Paradise"},{"state":"Nevada","city":"Carson City"},{"state":"New Hampshire","city":"Manchester"},{"state":"New Hampshire","city":"Nashua"},{"state":"New Hampshire","city":"Concord"},{"state":"New Hampshire","city":"Dover"},{"state":"New Hampshire","city":"Rochester"},{"state":"New Jersey","city":"Newark"},{"state":"New Jersey","city":"Jersey City"},{"state":"New Jersey","city":"Paterson"},{"state":"New Jersey","city":"Elizabeth"},{"state":"New Jersey","city":"Trenton"},{"state":"New Jersey","city":"Clifton"},{"state":"New Jersey","city":"Camden"},{"state":"New Jersey","city":"Passaic"},{"state":"New Jersey","city":"Union City"},{"state":"New Mexico","city":"Albuquerque"},{"state":"New Mexico","city":"Las Cruces"},{"state":"New Mexico","city":"Rio Rancho"},{"state":"New Mexico","city":"Santa Fe"},{"state":"New Mexico","city":"Roswell"},{"state":"New York","city":"New York"},{"state":"New York","city":"Buffalo"},{"state":"New York","city":"Rochester"},{"state":"New York","city":"Yonkers"},{"state":"New York","city":"Syracuse"},{"state":"New York","city":"Albany"},{"state":"New York","city":"New Rochelle"},{"state":"New York","city":"Mount Vernon"},{"state":"New York","city":"Schenectady"},{"state":"North Carolina","city":"Charlotte"},{"state":"North Carolina","city":"Raleigh"},{"state":"North Carolina","city":"Greensboro"},{"state":"North Carolina","city":"Winston-Salem"},{"state":"North Carolina","city":"Durham"},{"state":"North Carolina","city":"Fayetteville"},{"state":"North Carolina","city":"Cary"},{"state":"North Carolina","city":"Wilmington"},{"state":"North Carolina","city":"High Point"},{"state":"North Carolina","city":"Greenville"},{"state":"North Carolina","city":"Asheville"},{"state":"North Carolina","city":"Concord"},{"state":"North Carolina","city":"Gastonia"},{"state":"North Carolina","city":"Jacksonville"},{"state":"North Dakota","city":"Fargo"},{"state":"North Dakota","city":"Bismarck"},{"state":"North Dakota","city":"Grand Forks"},{"state":"North Dakota","city":"Minot"},{"state":"North Dakota","city":"West Fargo"},{"state":"Ohio","city":"Columbus"},{"state":"Ohio","city":"Cleveland"},{"state":"Ohio","city":"Cincinnati"},{"state":"Ohio","city":"Toledo"},{"state":"Ohio","city":"Akron"},{"state":"Ohio","city":"Dayton"},{"state":"Ohio","city":"Parma"},{"state":"Ohio","city":"Canton"},{"state":"Ohio","city":"Youngstown"},{"state":"Oklahoma","city":"Oklahoma City"},{"state":"Oklahoma","city":"Tulsa"},{"state":"Oklahoma","city":"Norman"},{"state":"Oklahoma","city":"Broken Arrow"},{"state":"Oklahoma","city":"Lawton"},{"state":"Oklahoma","city":"Edmond"},{"state":"Oregon","city":"Portland"},{"state":"Oregon","city":"Eugene"},{"state":"Oregon","city":"Salem"},{"state":"Oregon","city":"Gresham"},{"state":"Oregon","city":"Hillsboro"},{"state":"Oregon","city":"Beaverton"},{"state":"Oregon","city":"Bend"},{"state":"Oregon","city":"Medford"},{"state":"Pennsylvania","city":"Philadelphia"},{"state":"Pennsylvania","city":"Pittsburgh"},{"state":"Pennsylvania","city":"Allentown"},{"state":"Pennsylvania","city":"Erie"},{"state":"Pennsylvania","city":"Reading"},{"state":"Pennsylvania","city":"Scranton"},{"state":"Pennsylvania","city":"Bethlehem"},{"state":"Rhode Island","city":"Providence"},{"state":"Rhode Island","city":"Warwick"},{"state":"Rhode Island","city":"Cranston"},{"state":"Rhode Island","city":"Pawtucket"},{"state":"Rhode Island","city":"East Providence"},{"state":"South Carolina","city":"Columbia"},{"state":"South Carolina","city":"Charleston"},{"state":"South Carolina","city":"North Charleston"},{"state":"South Carolina","city":"Mount Pleasant"},{"state":"South Carolina","city":"Rock Hill"},{"state":"South Dakota","city":"Sioux Falls"},{"state":"South Dakota","city":"Rapid City"},{"state":"South Dakota","city":"Aberdeen"},{"state":"South Dakota","city":"Brookings"},{"state":"South Dakota","city":"Watertown"},{"state":"South Dakota","city":"Pierre"},{"state":"Tennessee","city":"Memphis"},{"state":"Tennessee","city":"Nashville"},{"state":"Tennessee","city":"Knoxville"},{"state":"Tennessee","city":"Chattanooga"},{"state":"Tennessee","city":"Clarksville"},{"state":"Tennessee","city":"Murfreesboro"},{"state":"Texas","city":"Houston"},{"state":"Texas","city":"San Antonio"},{"state":"Texas","city":"Dallas"},{"state":"Texas","city":"Austin"},{"state":"Texas","city":"Fort Worth"},{"state":"Texas","city":"El Paso"},{"state":"Texas","city":"Arlington"},{"state":"Texas","city":"Corpus Christi"},{"state":"Texas","city":"Plano"},{"state":"Texas","city":"Laredo"},{"state":"Texas","city":"Lubbock"},{"state":"Texas","city":"Garland"},{"state":"Texas","city":"Irving"},{"state":"Texas","city":"Amarillo"},{"state":"Texas","city":"Grand Prairie"},{"state":"Texas","city":"Brownsville"},{"state":"Texas","city":"Pasadena"},{"state":"Texas","city":"Mesquite"},{"state":"Texas","city":"McKinney"},{"state":"Texas","city":"McAllen"},{"state":"Texas","city":"Killeen"},{"state":"Texas","city":"Waco"},{"state":"Texas","city":"Carrollton"},{"state":"Texas","city":"Beaumont"},{"state":"Texas","city":"Abilene"},{"state":"Texas","city":"Frisco"},{"state":"Texas","city":"Denton"},{"state":"Texas","city":"Midland"},{"state":"Texas","city":"Wichita Falls"},{"state":"Texas","city":"Odessa"},{"state":"Texas","city":"Round Rock"},{"state":"Texas","city":"Richardson"},{"state":"Texas","city":"Tyler"},{"state":"Texas","city":"Lewisville"},{"state":"Texas","city":"College Station"},{"state":"Texas","city":"San Angelo"},{"state":"Texas","city":"Pearland"},{"state":"Texas","city":"Allen"},{"state":"Texas","city":"League City"},{"state":"Texas","city":"Longview"},{"state":"Texas","city":"Sugar Land"},{"state":"Texas","city":"Edinburg"},{"state":"Texas","city":"Mission"},{"state":"Texas","city":"Bryan"},{"state":"Texas","city":"Baytown"},{"state":"Texas","city":"Pharr"},{"state":"Texas","city":"Missouri City"},{"state":"Utah","city":"Salt Lake City"},{"state":"Utah","city":"West Valley City"},{"state":"Utah","city":"Provo"},{"state":"Utah","city":"West Jordan"},{"state":"Utah","city":"Orem"},{"state":"Utah","city":"Sandy"},{"state":"Utah","city":"Ogden"},{"state":"Utah","city":"St. George"},{"state":"Utah","city":"Layton"},{"state":"Vermont","city":"Burlington"},{"state":"Vermont","city":"South Burlington"},{"state":"Vermont","city":"Rutland"},{"state":"Vermont","city":"Barre"},{"state":"Vermont","city":"Montpelier"},{"state":"Virginia","city":"Virginia Beach"},{"state":"Virginia","city":"Norfolk"},{"state":"Virginia","city":"Chesapeake"},{"state":"Virginia","city":"Richmond"},{"state":"Virginia","city":"Newport News"},{"state":"Virginia","city":"Alexandria"},{"state":"Virginia","city":"Hampton"},{"state":"Virginia","city":"Roanoke"},{"state":"Virginia","city":"Portsmouth"},{"state":"Virginia","city":"Suffolk"},{"state":"Virginia","city":"Lynchburg"},{"state":"Washington","city":"Seattle"},{"state":"Washington","city":"Spokane"},{"state":"Washington","city":"Tacoma"},{"state":"Washington","city":"Vancouver"},{"state":"Washington","city":"Bellevue"},{"state":"Washington","city":"Everett"},{"state":"Washington","city":"Kent"},{"state":"Washington","city":"Yakima"},{"state":"Washington","city":"Renton"},{"state":"Washington","city":"Spokane Valley"},{"state":"Washington","city":"Federal Way"},{"state":"Washington","city":"Bellingham"},{"state":"Washington","city":"Kennewick"},{"state":"Washington","city":"Auburn"},{"state":"West Virginia","city":"Charleston"},{"state":"West Virginia","city":"Huntington"},{"state":"West Virginia","city":"Morgantown"},{"state":"West Virginia","city":"Parkersburg"},{"state":"West Virginia","city":"Wheeling"},{"state":"Wisconsin","city":"Milwaukee"},{"state":"Wisconsin","city":"Madison"},{"state":"Wisconsin","city":"Green Bay"},{"state":"Wisconsin","city":"Kenosha"},{"state":"Wisconsin","city":"Racine"},{"state":"Wisconsin","city":"Appleton"},{"state":"Wisconsin","city":"Waukesha"},{"state":"Wyoming","city":"Cheyenne"},{"state":"Wyoming","city":"Casper"},{"state":"Wyoming","city":"Laramie"},{"state":"Wyoming","city":"Gillette"},{"state":"Wyoming","city":"Rock Springs"}]'
    );
  },
  function (t) {
    t.exports = JSON.parse(
      '[{"state":"Alabama","bordering":["Florida","Georgia","Mississippi","Tennessee"]},{"state":"Alaska","bordering":["Washington"]},{"state":"Arizona","bordering":["California","Colorado","Nevada","New Mexico","Utah"]},{"state":"Arkansas","bordering":["Louisiana","Mississippi","Missouri","Oklahoma","Tennessee","Texas"]},{"state":"California","bordering":["Arizona","Nevada","Oregon"]},{"state":"Colorado","bordering":["Arizona","Kansas","Nebraska","New Mexico","Oklahoma","Utah","Wyoming"]},{"state":"Connecticut","bordering":["Massachusetts","New York","Rhode Island"]},{"state":"Delaware","bordering":["Maryland","New Jersey","Pennsylvania"]},{"state":"DC","bordering":["Maryland","Virginia"]},{"state":"Florida","bordering":["Alabama","Georgia"]},{"state":"Georgia","bordering":["Alabama, Florida, North Carolina, South Carolina, Tennessee"]},{"state":"Hawaii","bordering":["California"]},{"state":"Idaho","bordering":["Montana","Nevada","Oregon","Utah","Washington","Wyoming"]},{"state":"Illinois","bordering":["Indiana","Iowa","Michigan","Kentucky","Missouri","Wisconsin"]},{"state":"Indiana","bordering":["Illinois","Kentucky","Michigan","Ohio"]},{"state":"Iowa","bordering":["Illinois","Minnesota","Missouri","Nebraska","South Dakota","Wisconsin"]},{"state":"Kansas","bordering":["Colorado","Missouri","Nebraska","Oklahoma"]},{"state":"Kentucky","bordering":["Illinois","Indiana","Missouri","Ohio","Tennessee","Virginia","West Virginia"]},{"state":"Louisiana","bordering":["Arkansas","Mississippi","Texas"]},{"state":"Maine","bordering":["Massachusetts","New Hampshire","Vermont"]},{"state":"Maryland","bordering":["DC","Delaware","Pennsylvania","Virginia","West Virginia"]},{"state":"Massachusetts","bordering":["Connecticut","New Hampshire","New York","Rhode Island","Vermont"]},{"state":"Michigan","bordering":["Illinois","Indiana","Minnesota","Ohio","Wisconsin"]},{"state":"Minnesota","bordering":["Iowa","Michigan","North Dakota","South Dakota","Wisconsin"]},{"state":"Mississippi","bordering":["Alabama","Arkanssas","Louisiana","Tennessee"]},{"state":"Missouri","bordering":["Arkansas","Illinois","Iowa","Kansas","Kentucky","Nebraska","Oklahoma","Tennessee"]},{"state":"Montana","bordering":["Idaho","North Dakota","South Dakota","Wyoming"]},{"state":"Nebraska","bordering":["Colorado","Iowa","Kansas","Missouri","South Dakota","Wyoming"]},{"state":"Nevada","bordering":["Arizona","California","Idaho","Oregon","Utah"]},{"state":"New Hampshire","bordering":["Maine","Massachusetts","Vermont"]},{"state":"New Jersey","bordering":["Delaware","New York","Pennsylvania"]},{"state":"New Mexico","bordering":["Arizona","Colorado","Oklahoma","Texas","Utah"]},{"state":"New York","bordering":["Connecticut","Massachusetts","New Jersey","Pennsylvania","Rhode Island","Vermont"]},{"state":"North Carolina","bordering":["Georgia","South Carolina","Tennessee","Virginia"]},{"state":"North Dakota","bordering":["Minnesota","Montana","South Dakota"]},{"state":"Ohio","bordering":["Indiana","Kentucky","Michigan","Pennsylvania","West Virginia"]},{"state":"Oklahoma","bordering":["Arkansas","Colorado","Kansas","Missouri","New Mexico","Texas"]},{"state":"Oregon","bordering":["California","Idaho","Nevada","Washington"]},{"state":"Pennsylvania","bordering":["Delaware","Maryland","New Jersey","New York","Ohio","West Virginia"]},{"state":"Rhode Island","bordering":["Connecticut","Massachusetts","New York"]},{"state":"South Carolina","bordering":["Georgia","North Carolina"]},{"state":"South Dakota","bordering":["Iowa","Minnesota","Montana","Nebraska","North Dakota","Wyoming"]},{"state":"Tennessee","bordering":["Alabama","Arkansas","Georgia","Kentucky","Mississippi","Missouri","North Carolina","Virginia"]},{"state":"Texas","bordering":["Arkansas","Louisiana","New Mexico","Oklahoma"]},{"state":"Utah","bordering":["Arizona","Colorado","Idaho","Nevada","New Mexico","Wyoming"]},{"state":"Vermont","bordering":["Massachusetts","New Hampshire","New York"]},{"state":"Virginia","bordering":["DC","Kentucky","Maryland","North Carolina","Tennessee","West Virginia"]},{"state":"Washington","bordering":["Idaho","Oregon"]},{"state":"West Virginia","bordering":["Kentucky","Maryland","Ohio","Pennsylvania","Virginia"]},{"state":"Wisconsin","bordering":["Illinois","Iowa","Michigan","Minnesota"]},{"state":"Wyoming","bordering":["Colorado","Idaho","Montana","Nebraska","South Dakota","Utah"]}]'
    );
  },
  function (t, e, i) {
    t.exports = i(35);
  },
  function (t, e) {
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector),
      Element.prototype.closest ||
        (Element.prototype.closest = function (t) {
          var e = this;
          do {
            if (Element.prototype.matches.call(e, t)) return e;
            e = e.parentElement || e.parentNode;
          } while (null !== e && 1 === e.nodeType);
          return null;
        });
  },
  function (t, e, i) {
    t.exports = i(20)();
  },
  function (t, e, i) {
    "use strict";
    var a = i(21);
    function n() {}
    function r() {}
    (r.resetWarningCache = n),
      (t.exports = function () {
        function t(t, e, i, n, r, s) {
          if (s !== a) {
            var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw ((o.name = "Invariant Violation"), o);
          }
        }
        function e() {
          return t;
        }
        t.isRequired = t;
        var i = {
          array: t,
          bool: t,
          func: t,
          number: t,
          object: t,
          string: t,
          symbol: t,
          any: t,
          arrayOf: e,
          element: t,
          elementType: t,
          instanceOf: e,
          node: t,
          objectOf: e,
          oneOf: e,
          oneOfType: e,
          shape: e,
          exact: e,
          checkPropTypes: r,
          resetWarningCache: n,
        };
        return (i.PropTypes = i), i;
      });
  },
  function (t, e, i) {
    "use strict";
    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  },
  function (t, e) {
    function i(e, a) {
      return (
        (t.exports = i =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        (t.exports.default = t.exports),
        (t.exports.__esModule = !0),
        i(e, a)
      );
    }
    (t.exports = i), (t.exports.default = t.exports), (t.exports.__esModule = !0);
  },
  function (t, e) {
    (t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }),
      (t.exports.default = t.exports),
      (t.exports.__esModule = !0);
  },
  function (t, e, i) {
    var a, n, r, s, o, l, c, h, u, d, p, f, m, g, y, v, A, b, w, C, S, k;
    /**
     * isMobile.js v0.4.1
     *
     * A simple library to detect Apple phones and tablets,
     * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
     * and any kind of seven inch device, via user agent sniffing.
     *
     * @author: Kai Mallea (kmallea@gmail.com)
     *
     * @license: http://creativecommons.org/publicdomain/zero/1.0/
     */
    /**
     * isMobile.js v0.4.1
     *
     * A simple library to detect Apple phones and tablets,
     * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
     * and any kind of seven inch device, via user agent sniffing.
     *
     * @author: Kai Mallea (kmallea@gmail.com)
     *
     * @license: http://creativecommons.org/publicdomain/zero/1.0/
     */
    (s = this),
      (o = /iPhone/i),
      (l = /iPod/i),
      (c = /iPad/i),
      (h = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i),
      (u = /Android/i),
      (d = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i),
      (p = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i),
      (f = /Windows Phone/i),
      (m = /(?=.*\bWindows\b)(?=.*\bARM\b)/i),
      (g = /BlackBerry/i),
      (y = /BB10/i),
      (v = /Opera Mini/i),
      (A = /(CriOS|Chrome)(?=.*\bMobile\b)/i),
      (b = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i),
      (w = new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i")),
      (C = function (t, e) {
        return t.test(e);
      }),
      (S = function (t) {
        var e = t || navigator.userAgent,
          i = e.split("[FBAN");
        if (
          (void 0 !== i[1] && (e = i[0]),
          void 0 !== (i = e.split("Twitter"))[1] && (e = i[0]),
          (this.apple = { phone: C(o, e), ipod: C(l, e), tablet: !C(o, e) && C(c, e), device: C(o, e) || C(l, e) || C(c, e) }),
          (this.amazon = { phone: C(d, e), tablet: !C(d, e) && C(p, e), device: C(d, e) || C(p, e) }),
          (this.android = { phone: C(d, e) || C(h, e), tablet: !C(d, e) && !C(h, e) && (C(p, e) || C(u, e)), device: C(d, e) || C(p, e) || C(h, e) || C(u, e) }),
          (this.windows = { phone: C(f, e), tablet: C(m, e), device: C(f, e) || C(m, e) }),
          (this.other = { blackberry: C(g, e), blackberry10: C(y, e), opera: C(v, e), firefox: C(b, e), chrome: C(A, e), device: C(g, e) || C(y, e) || C(v, e) || C(b, e) || C(A, e) }),
          (this.seven_inch = C(w, e)),
          (this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch),
          (this.phone = this.apple.phone || this.android.phone || this.windows.phone),
          (this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet),
          "undefined" == typeof window)
        )
          return this;
      }),
      (k = function () {
        var t = new S();
        return (t.Class = S), t;
      }),
      t.exports && "undefined" == typeof window
        ? (t.exports = S)
        : t.exports && "undefined" != typeof window
        ? (t.exports = k())
        : ((n = []), (a = s.isMobile = k()), void 0 === (r = "function" == typeof a ? a.apply(e, n) : a) || (t.exports = r));
  },
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  function (t, e, i) {
    "use strict";
    i.r(e);
    i(18);
    const a = (t, e = {}, i = null) => {
        let a = void 0 === e.method ? "get" : e.method,
          n = void 0 === e.type ? "json" : e.type.toLowerCase(),
          r = void 0 === e.headers ? [] : e.headers,
          s = void 0 === e.data ? null : e.data,
          o = new XMLHttpRequest();
        o.open(a, t, !0),
          "json" === n && (o.setRequestHeader("Accept", "application/json"), o.setRequestHeader("Content-Type", "application/json")),
          Array.prototype.slice.call(r).forEach((t) => {
            o.setRequestHeader(t[0], t[1]);
          }),
          o.send(s),
          (o.onreadystatechange = () => {
            4 === o.readyState && 200 === o.status && i("text" === n ? o.responseText : o.response);
          });
      },
      n = function () {
        let t = window,
          e = "inner";
        return "innerWidth" in window || ((e = "client"), (t = document.documentElement || document.body)), { width: t[e + "Width"], height: t[e + "Height"] };
      },
      r = (t, e) => (" " + t.className + " ").indexOf(" " + e + " ") > -1,
      s = () => {
        if (window.location.search && "" != window.location.search) return JSON.parse('{"' + decodeURI(window.location.search.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      },
      o = (t, e) => t.filter((t) => t !== e);
    function l() {}
    l.prototype = {
      on: function (t, e, i) {
        var a = this.e || (this.e = {});
        return (a[t] || (a[t] = [])).push({ fn: e, ctx: i }), this;
      },
      once: function (t, e, i) {
        var a = this;
        function n() {
          a.off(t, n), e.apply(i, arguments);
        }
        return (n._ = e), this.on(t, n, i);
      },
      emit: function (t) {
        for (var e = [].slice.call(arguments, 1), i = ((this.e || (this.e = {}))[t] || []).slice(), a = 0, n = i.length; a < n; a++) i[a].fn.apply(i[a].ctx, e);
        return this;
      },
      off: function (t, e) {
        var i = this.e || (this.e = {}),
          a = i[t],
          n = [];
        if (a && e) for (var r = 0, s = a.length; r < s; r++) a[r].fn !== e && a[r].fn._ !== e && n.push(a[r]);
        return n.length ? (i[t] = n) : delete i[t], this;
      },
    };
    var c = l;
    c.TinyEmitter = l;
    var h = function (t) {
      (this.wrap = document.querySelector("[data-router-wrapper]")), (this.properties = t), (this.Transition = t.transition ? new t.transition.class(this.wrap, t.transition.name) : null);
    };
    (h.prototype.setup = function () {
      this.onEnter && this.onEnter(), this.onEnterCompleted && this.onEnterCompleted();
    }),
      (h.prototype.add = function () {
        this.wrap.insertAdjacentHTML("beforeend", this.properties.view.outerHTML);
      }),
      (h.prototype.update = function () {
        document.title = this.properties.page.title;
      }),
      (h.prototype.show = function (t) {
        var e = this;
        return new Promise(function (i) {
          try {
            function a(t) {
              e.onEnterCompleted && e.onEnterCompleted(), i();
            }
            return e.update(), e.onEnter && e.onEnter(), Promise.resolve(e.Transition ? Promise.resolve(e.Transition.show(t)).then(a) : a());
          } catch (t) {
            return Promise.reject(t);
          }
        });
      }),
      (h.prototype.hide = function (t) {
        var e = this;
        return new Promise(function (i) {
          try {
            function a(t) {
              e.onLeaveCompleted && e.onLeaveCompleted(), i();
            }
            return e.onLeave && e.onLeave(), Promise.resolve(e.Transition ? Promise.resolve(e.Transition.hide(t)).then(a) : a());
          } catch (t) {
            return Promise.reject(t);
          }
        });
      });
    var u = new window.DOMParser(),
      d = function (t, e) {
        (this.renderers = t), (this.transitions = e);
      };
    (d.prototype.getOrigin = function (t) {
      var e = t.match(/(https?:\/\/[\w\-.]+)/);
      return e ? e[1].replace(/https?:\/\//, "") : null;
    }),
      (d.prototype.getPathname = function (t) {
        var e = t.match(/https?:\/\/.*?(\/[\w_\-./]+)/);
        return e ? e[1] : "/";
      }),
      (d.prototype.getAnchor = function (t) {
        var e = t.match(/(#.*)$/);
        return e ? e[1] : null;
      }),
      (d.prototype.getParams = function (t) {
        var e = t.match(/\?([\w_\-.=&]+)/);
        if (!e) return null;
        for (var i = e[1].split("&"), a = {}, n = 0; n < i.length; n++) {
          var r = i[n].split("=");
          a[r[0]] = r[1];
        }
        return a;
      }),
      (d.prototype.getDOM = function (t) {
        return "string" == typeof t ? u.parseFromString(t, "text/html") : t;
      }),
      (d.prototype.getView = function (t) {
        return t.querySelector("[data-router-view]");
      }),
      (d.prototype.getSlug = function (t) {
        return t.getAttribute("data-router-view");
      }),
      (d.prototype.getRenderer = function (t) {
        if (!this.renderers) return Promise.resolve(h);
        if (t in this.renderers) {
          var e = this.renderers[t];
          return "function" != typeof e || h.isPrototypeOf(e)
            ? "function" == typeof e.then
              ? Promise.resolve(e).then(function (t) {
                  return t.default;
                })
              : Promise.resolve(e)
            : Promise.resolve(e()).then(function (t) {
                return t.default;
              });
        }
        return Promise.resolve(h);
      }),
      (d.prototype.getTransition = function (t) {
        return this.transitions ? (t in this.transitions ? { class: this.transitions[t], name: t } : "default" in this.transitions ? { class: this.transitions.default, name: "default" } : null) : null;
      }),
      (d.prototype.getProperties = function (t) {
        var e = this.getDOM(t),
          i = this.getView(e),
          a = this.getSlug(i);
        return { page: e, view: i, slug: a, renderer: this.getRenderer(a, this.renderers), transition: this.getTransition(a, this.transitions) };
      }),
      (d.prototype.getLocation = function (t) {
        return { href: t, anchor: this.getAnchor(t), origin: this.getOrigin(t), params: this.getParams(t), pathname: this.getPathname(t) };
      });
    var p = (function (t) {
        function e(e) {
          var i = this;
          void 0 === e && (e = {});
          var a = e.renderers,
            n = e.transitions;
          t.call(this),
            (this.Helpers = new d(a, n)),
            (this.Transitions = n),
            (this.Contextual = !1),
            (this.location = this.Helpers.getLocation(window.location.href)),
            (this.properties = this.Helpers.getProperties(document.cloneNode(!0))),
            (this.popping = !1),
            (this.running = !1),
            (this.trigger = null),
            (this.cache = new Map()),
            this.cache.set(this.location.href, this.properties),
            this.properties.renderer.then(function (t) {
              (i.From = new t(i.properties)), i.From.setup();
            }),
            (this._navigate = this.navigate.bind(this)),
            window.addEventListener("popstate", this.popState.bind(this)),
            (this.links = document.querySelectorAll("a:not([target]):not([data-router-disabled])")),
            this.attach(this.links);
        }
        return (
          t && (e.__proto__ = t),
          ((e.prototype = Object.create(t && t.prototype)).constructor = e),
          (e.prototype.attach = function (t) {
            for (var e = 0, i = t; e < i.length; e += 1) i[e].addEventListener("click", this._navigate);
          }),
          (e.prototype.detach = function (t) {
            for (var e = 0, i = t; e < i.length; e += 1) i[e].removeEventListener("click", this._navigate);
          }),
          (e.prototype.navigate = function (t) {
            if (!t.metaKey && !t.ctrlKey) {
              t.preventDefault();
              var e = !!t.currentTarget.hasAttribute("data-transition") && t.currentTarget.dataset.transition;
              this.redirect(t.currentTarget.href, e, t.currentTarget);
            }
          }),
          (e.prototype.redirect = function (t, e, i) {
            if ((void 0 === e && (e = !1), void 0 === i && (i = "script"), (this.trigger = i), !this.running && t !== this.location.href)) {
              var a = this.Helpers.getLocation(t);
              (this.Contextual = !1),
                e && ((this.Contextual = this.Transitions.contextual[e].prototype), (this.Contextual.name = e)),
                a.origin !== this.location.origin || (a.anchor && a.pathname === this.location.pathname) ? (window.location.href = t) : ((this.location = a), this.beforeFetch());
            }
          }),
          (e.prototype.popState = function () {
            (this.trigger = "popstate"), (this.Contextual = !1);
            var t = this.Helpers.getLocation(window.location.href);
            this.location.pathname !== t.pathname || (!this.location.anchor && !t.anchor) ? ((this.popping = !0), (this.location = t), this.beforeFetch()) : (this.location = t);
          }),
          (e.prototype.pushState = function () {
            this.popping || window.history.pushState(this.location, "", this.location.href);
          }),
          (e.prototype.fetch = function () {
            try {
              var t = this;
              return Promise.resolve(fetch(t.location.href, { mode: "same-origin", method: "GET", headers: { "X-Requested-With": "Highway" }, credentials: "same-origin" })).then(function (e) {
                if (e.status >= 200 && e.status < 300) return e.text();
                window.location.href = t.location.href;
              });
            } catch (t) {
              return Promise.reject(t);
            }
          }),
          (e.prototype.beforeFetch = function () {
            try {
              var t = this;
              function e() {
                t.afterFetch();
              }
              t.pushState(), (t.running = !0), t.emit("NAVIGATE_OUT", { from: { page: t.From.properties.page, view: t.From.properties.view }, trigger: t.trigger, location: t.location });
              var i = { trigger: t.trigger, contextual: t.Contextual },
                a = t.cache.has(t.location.href)
                  ? Promise.resolve(t.From.hide(i)).then(function () {
                      t.properties = t.cache.get(t.location.href);
                    })
                  : Promise.resolve(Promise.all([t.fetch(), t.From.hide(i)])).then(function (e) {
                      (t.properties = t.Helpers.getProperties(e[0])), t.cache.set(t.location.href, t.properties);
                    });
              return Promise.resolve(a && a.then ? a.then(e) : e());
            } catch (t) {
              return Promise.reject(t);
            }
          }),
          (e.prototype.afterFetch = function () {
            try {
              var t = this;
              return Promise.resolve(t.properties.renderer).then(function (e) {
                return (
                  (t.To = new e(t.properties)),
                  t.To.add(),
                  t.emit("NAVIGATE_IN", { to: { page: t.To.properties.page, view: t.To.wrap.lastElementChild }, trigger: t.trigger, location: t.location }),
                  Promise.resolve(t.To.show({ trigger: t.trigger, contextual: t.Contextual })).then(function () {
                    (t.popping = !1),
                      (t.running = !1),
                      t.detach(t.links),
                      (t.links = document.querySelectorAll("a:not([target]):not([data-router-disabled])")),
                      t.attach(t.links),
                      t.emit("NAVIGATE_END", { to: { page: t.To.properties.page, view: t.To.wrap.lastElementChild }, from: { page: t.From.properties.page, view: t.From.properties.view }, trigger: t.trigger, location: t.location }),
                      (t.From = t.To),
                      (t.trigger = null);
                  })
                );
              });
            } catch (t) {
              return Promise.reject(t);
            }
          }),
          e
        );
      })(c),
      f = function (t, e) {
        (this.wrap = t), (this.name = e);
      };
    (f.prototype.show = function (t) {
      var e = this,
        i = t.trigger,
        a = t.contextual,
        n = this.wrap.lastElementChild,
        r = this.wrap.firstElementChild;
      return new Promise(function (t) {
        a
          ? (n.setAttribute("data-transition-in", a.name), n.removeAttribute("data-transition-out", a.name), a.in && a.in({ to: n, from: r, trigger: i, done: t }))
          : (n.setAttribute("data-transition-in", e.name), n.removeAttribute("data-transition-out", e.name), e.in && e.in({ to: n, from: r, trigger: i, done: t }));
      });
    }),
      (f.prototype.hide = function (t) {
        var e = this,
          i = t.trigger,
          a = t.contextual,
          n = this.wrap.firstElementChild;
        return new Promise(function (t) {
          a
            ? (n.setAttribute("data-transition-out", a.name), n.removeAttribute("data-transition-in", a.name), a.out && a.out({ from: n, trigger: i, done: t }))
            : (n.setAttribute("data-transition-out", e.name), n.removeAttribute("data-transition-in", e.name), e.out && e.out({ from: n, trigger: i, done: t }));
        });
      }),
      console.log("Highway v2.2.0");
    var m = { Core: p, Helpers: d, Renderer: h, Transition: f },
      g = i(5),
      y = i.n(g),
      v = i(6),
      A = i.n(v);
    function b() {
      return (b =
        Object.assign ||
        function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = arguments[e];
            for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
          }
          return t;
        }).apply(this, arguments);
    }
    function w(t, e) {
      var i = {
        start: function () {
          return 0;
        },
        center: function (t) {
          return a(t) / 2;
        },
        end: a,
      };
      function a(t) {
        return e - t;
      }
      return {
        measure: function (a) {
          return "number" == typeof t ? e * Number(t) : i[t](a);
        },
      };
    }
    function C(t, e) {
      var i = Math.abs(t - e);
      function a(e) {
        return e < t;
      }
      function n(t) {
        return t > e;
      }
      function r(t) {
        return a(t) || n(t);
      }
      return {
        constrain: function (i) {
          return r(i) ? (a(i) ? t : e) : i;
        },
        length: i,
        max: e,
        min: t,
        reachedAny: r,
        reachedMax: n,
        reachedMin: a,
        removeOffset: function (t) {
          return i ? t - i * Math.ceil((t - e) / i) : t;
        },
      };
    }
    function S() {
      var t = [];
      var e = {
        add: function (i, a, n, r) {
          return (
            void 0 === r && (r = !1),
            i.addEventListener(a, n, r),
            t.push(function () {
              return i.removeEventListener(a, n, r);
            }),
            e
          );
        },
        removeAll: function () {
          return (
            (t = t.filter(function (t) {
              return t();
            })),
            e
          );
        },
      };
      return e;
    }
    function k(t) {
      var e = t;
      function i(t) {
        return (e /= t), n;
      }
      function a(t) {
        return "number" == typeof t ? t : t.get();
      }
      var n = {
        add: function (t) {
          return (e += a(t)), n;
        },
        divide: i,
        get: function () {
          return e;
        },
        multiply: function (t) {
          return (e *= t), n;
        },
        normalize: function () {
          return 0 !== e && i(e), n;
        },
        set: function (t) {
          return (e = a(t)), n;
        },
        subtract: function (t) {
          return (e -= a(t)), n;
        },
      };
      return n;
    }
    function E(t) {
      return t ? t / Math.abs(t) : 0;
    }
    function x(t, e) {
      return Math.abs(t - e);
    }
    function _(t, e) {
      for (var i = [], a = 0; a < t.length; a += e) i.push(t.slice(a, a + e));
      return i;
    }
    function T(t) {
      return Object.keys(t).map(Number);
    }
    function M(t) {
      return t[P(t)];
    }
    function P(t) {
      return Math.max(0, t.length - 1);
    }
    function D(t, e) {
      var i = t.classList;
      e && i.contains(e) && i.remove(e);
    }
    function I(t, e) {
      var i = t.classList;
      e && !i.contains(e) && i.add(e);
    }
    function L(t, e, i, a, n, r, s, o, l, c, h, u, d, p, f) {
      var m = t.scroll,
        g = t.cross,
        y = ["INPUT", "SELECT", "TEXTAREA"],
        v = k(0),
        A = k(0),
        b = k(0),
        w = S(),
        C = S(),
        _ = { mouse: 2.5, touch: 3.5 },
        T = { mouse: 5, touch: 7 },
        M = n ? 5 : 16,
        P = 1,
        D = 20,
        I = !1,
        L = !1,
        R = !1,
        F = !1;
      function O(t) {
        if (!(F = "mousedown" === t.type) || 0 === t.button) {
          var e,
            n,
            o = x(a.get(), s.get()) >= 2,
            l = F || !o,
            h = ((e = t.target), (n = e.nodeName || ""), !(y.indexOf(n) > -1)),
            u = o || (F && h);
          (I = !0),
            r.pointerDown(t),
            b.set(a),
            a.set(s),
            c.useBaseMass().useSpeed(80),
            (function () {
              var t = F ? document : i;
              C.add(t, "touchmove", B).add(t, "touchend", q).add(t, "mousemove", B).add(t, "mouseup", q);
            })(),
            v.set(r.readPoint(t, m)),
            A.set(r.readPoint(t, g)),
            d.emit("pointerDown"),
            l && (R = !1),
            u && t.preventDefault();
        }
      }
      function B(t) {
        if (!L && !F) {
          if (!t.cancelable) return q();
          var i = r.readPoint(t, m).get(),
            n = r.readPoint(t, g).get(),
            s = x(i, v.get()),
            l = x(n, A.get());
          if (!(L = s > l) && !R) return q();
        }
        var c = r.pointerMove(t);
        !R && c && (R = !0), o.start(), a.add(e.applyTo(c)), t.preventDefault();
      }
      function q() {
        var t = h.byDistance(0, !1).index !== u.get(),
          i = r.pointerUp() * (n ? T : _)[F ? "mouse" : "touch"],
          s = (function (t, e) {
            var i = u.clone().add(-1 * E(t)),
              a = i.get() === u.min || i.get() === u.max,
              r = h.byDistance(t, !n).distance;
            return n || Math.abs(t) < D ? r : !p && a ? 0.6 * r : f && e ? 0.5 * r : h.byIndex(i.get(), 0).distance;
          })(e.applyTo(i), t),
          o = (function (t, e) {
            if (0 === t || 0 === e) return 0;
            if (Math.abs(t) <= Math.abs(e)) return 0;
            var i = x(Math.abs(t), Math.abs(e));
            return Math.abs(i / t);
          })(i, s),
          m = x(a.get(), b.get()) >= 0.5,
          g = t && o > 0.75,
          y = Math.abs(i) < D,
          v = g ? 10 : M,
          A = g ? P + 2.5 * o : P;
        m && !F && (R = !0), (L = !1), (I = !1), C.removeAll(), c.useSpeed(y ? 9 : v).useMass(A), l.distance(s, !n), (F = !1), d.emit("pointerUp");
      }
      function N(t) {
        R && t.preventDefault();
      }
      return {
        addActivationEvents: function () {
          var t = i;
          w.add(t, "touchmove", function () {})
            .add(t, "touchend", function () {})
            .add(t, "touchstart", O)
            .add(t, "mousedown", O)
            .add(t, "touchcancel", q)
            .add(t, "contextmenu", q)
            .add(t, "click", N);
        },
        clickAllowed: function () {
          return !R;
        },
        pointerDown: function () {
          return I;
        },
        removeAllEvents: function () {
          w.removeAll(), C.removeAll();
        },
      };
    }
    function R(t, e, i) {
      var a,
        n,
        r =
          ((a = 2),
          (n = Math.pow(10, a)),
          function (t) {
            return Math.round(t * n) / n;
          }),
        s = k(0),
        o = k(0),
        l = k(0),
        c = 0,
        h = e,
        u = i;
      function d(t) {
        return (h = t), f;
      }
      function p(t) {
        return (u = t), f;
      }
      var f = {
        direction: function () {
          return c;
        },
        seek: function (e) {
          l.set(e).subtract(t);
          var i,
            a,
            n,
            r = ((i = l.get()), (n = 0) + ((i - (a = 0)) / (100 - a)) * (h - n));
          return (
            (c = E(l.get())),
            l.normalize().multiply(r).subtract(s),
            (function (t) {
              t.divide(u), o.add(t);
            })(l),
            f
          );
        },
        settle: function (e) {
          var i = e.get() - t.get(),
            a = !r(i);
          return a && t.set(e), a;
        },
        update: function () {
          s.add(o), t.add(s), o.multiply(0);
        },
        useBaseMass: function () {
          return p(i);
        },
        useBaseSpeed: function () {
          return d(e);
        },
        useMass: p,
        useSpeed: d,
      };
      return f;
    }
    function F(t, e, i, a) {
      var n = 10,
        r = !1;
      return {
        constrain: function (s) {
          if (!r && t.reachedAny(i.get()) && t.reachedAny(e.get())) {
            var o = s ? 0.7 : 0.45,
              l = i.get() - e.get();
            i.subtract(l * o), !s && Math.abs(l) < n && (i.set(t.constrain(i.get())), a.useSpeed(10).useMass(3));
          }
        },
        toggleActive: function (t) {
          r = !t;
        },
      };
    }
    function O(t, e, i, a, n) {
      var r = C(-e + t, i[0]),
        s = a.map(r.constrain);
      return {
        snapsContained: (function () {
          if (e <= t) return [r.max];
          if ("keepSnaps" === n) return s;
          var i = (function () {
              var t = s[0],
                e = M(s),
                i = s.lastIndexOf(t),
                a = s.indexOf(e) + 1;
              return C(i, a);
            })(),
            a = i.min,
            o = i.max;
          return s.slice(a, o);
        })(),
      };
    }
    function B(t, e, i, a, n) {
      var r = C(i.min + e.measure(0.1), i.max + e.measure(0.1)),
        s = r.reachedMin,
        o = r.reachedMax;
      return {
        loop: function (e) {
          if (
            (function (t) {
              return 1 === t ? o(a.get()) : -1 === t && s(a.get());
            })(e)
          ) {
            var i = t * (-1 * e);
            n.forEach(function (t) {
              return t.add(i);
            });
          }
        },
      };
    }
    function q(t, e, i, a, n, r) {
      var s,
        o,
        l = t.startEdge,
        c = t.endEdge,
        h = n
          .map(function (t) {
            return a[l] - t[l];
          })
          .map(i.measure)
          .map(function (t) {
            return -Math.abs(t);
          }),
        u =
          ((s = _(h, r).map(function (t) {
            return t[0];
          })),
          (o = _(n, r)
            .map(function (t) {
              return M(t)[c] - t[0][l];
            })
            .map(i.measure)
            .map(Math.abs)
            .map(e.measure)),
          s.map(function (t, e) {
            return t + o[e];
          }));
      return { snaps: h, snapsAligned: u };
    }
    function N(t, e, i, a, n) {
      var r = a.reachedAny,
        s = a.removeOffset,
        o = a.constrain;
      function l(t, e) {
        return Math.abs(t) < Math.abs(e) ? t : e;
      }
      function c(e, a) {
        var n = e,
          r = e + i,
          s = e - i;
        if (!t) return n;
        if (!a) return l(l(n, r), s);
        var o = l(n, 1 === a ? r : s);
        return Math.abs(o) * a;
      }
      return {
        byDistance: function (i, a) {
          var l = n.get() + i,
            h = (function (i) {
              var a = t ? s(i) : o(i);
              return {
                index: e
                  .map(function (t) {
                    return t - a;
                  })
                  .map(function (t) {
                    return c(t, 0);
                  })
                  .map(function (t, e) {
                    return { diff: t, index: e };
                  })
                  .sort(function (t, e) {
                    return Math.abs(t.diff) - Math.abs(e.diff);
                  })[0].index,
                distance: a,
              };
            })(l),
            u = h.index,
            d = h.distance,
            p = !t && r(l);
          return !a || p ? { index: u, distance: i } : { index: u, distance: i + c(e[u] - d, 0) };
        },
        byIndex: function (t, i) {
          return { index: t, distance: c(e[t] - n.get(), i) };
        },
        shortcut: c,
      };
    }
    function V(t, e, i, a, n) {
      var r,
        s,
        o = a.align,
        l = a.axis,
        c = a.direction,
        h = a.startIndex,
        u = a.inViewThreshold,
        d = a.loop,
        p = a.speed,
        f = a.dragFree,
        m = a.slidesToScroll,
        g = a.skipSnaps,
        y = a.containScroll,
        v = e.getBoundingClientRect(),
        A = i.map(function (t) {
          return t.getBoundingClientRect();
        }),
        b = (function (t) {
          var e = "rtl" === t ? -1 : 1;
          return {
            applyTo: function (t) {
              return t * e;
            },
          };
        })(c),
        E = (function (t, e) {
          var i = "y" === t ? "y" : "x";
          return {
            scroll: i,
            cross: "y" === t ? "x" : "y",
            startEdge: "y" === i ? "top" : "rtl" === e ? "right" : "left",
            endEdge: "y" === i ? "bottom" : "rtl" === e ? "left" : "right",
            measureSize: function (t) {
              var e = t.width,
                a = t.height;
              return "x" === i ? e : a;
            },
          };
        })(l, c),
        x =
          ((r = E.measureSize(v)),
          {
            measure: function (t) {
              return 0 === r ? 0 : (t / r) * s;
            },
            totalPercent: (s = 100),
          }),
        _ = x.totalPercent,
        D = w(o, _),
        I = (function (t, e, i, a, n) {
          var r = t.measureSize,
            s = t.startEdge,
            o = t.endEdge,
            l = a.map(r);
          return {
            slideSizes: l.map(e.measure),
            slideSizesWithGaps: a
              .map(function (t, e, a) {
                var r = e === P(a),
                  c = window.getComputedStyle(M(i)),
                  h = parseFloat(c.getPropertyValue("margin-" + o));
                return r ? l[e] + (n ? h : 0) : a[e + 1][s] - t[s];
              })
              .map(e.measure)
              .map(Math.abs),
          };
        })(E, x, i, A, d),
        V = I.slideSizes,
        W = I.slideSizesWithGaps,
        U = q(E, D, x, v, A, m),
        J = U.snaps,
        z = U.snapsAligned,
        K = -M(J) + M(W),
        G = O(_, K, J, z, y).snapsContained,
        j = !d && "" !== y ? G : z,
        H = (function (t, e, i) {
          var a, n;
          return { limit: ((a = e[0]), (n = M(e)), C(i ? a - t : n, a)) };
        })(K, j, d).limit,
        Y = (function t(e, i, a) {
          var n = C(0, e),
            r = n.min,
            s = n.constrain,
            o = e + 1,
            l = c(i);
          function c(t) {
            return a ? Math.abs((o + t) % o) : s(t);
          }
          function h() {
            return l;
          }
          function u(t) {
            return (l = c(t)), d;
          }
          var d = {
            add: function (t) {
              return u(h() + t);
            },
            clone: function () {
              return t(e, h(), a);
            },
            get: h,
            set: u,
            min: r,
            max: e,
          };
          return d;
        })(P(j), h, d),
        Q = Y.clone(),
        X = T(i),
        Z = (function (t) {
          var e = 0;
          function i(t, i) {
            return function () {
              t === !!e && i();
            };
          }
          function a() {
            e = window.requestAnimationFrame(t);
          }
          return {
            proceed: i(!0, a),
            start: i(!1, a),
            stop: i(!0, function () {
              window.cancelAnimationFrame(e), (e = 0);
            }),
          };
        })(function () {
          d || st.scrollBounds.constrain(st.dragHandler.pointerDown()), st.scrollBody.seek(et).update();
          var t = st.scrollBody.settle(et);
          t && !st.dragHandler.pointerDown() && (st.animation.stop(), n.emit("settle")), t || n.emit("scroll"), d && (st.scrollLooper.loop(st.scrollBody.direction()), st.slideLooper.loop()), st.translate.to(tt), st.animation.proceed();
        }),
        $ = j[Y.get()],
        tt = k($),
        et = k($),
        it = R(tt, p, 1),
        at = N(d, j, K, H, et),
        nt = (function (t, e, i, a, n, r) {
          function s(a) {
            var s = a.distance,
              o = a.index !== e.get();
            s && (t.start(), n.add(s)), o && (i.set(e.get()), e.set(a.index), r.emit("select"));
          }
          return {
            distance: function (t, e) {
              s(a.byDistance(t, e));
            },
            index: function (t, i) {
              var n = e.clone().set(t);
              s(a.byIndex(n.get(), i));
            },
          };
        })(Z, Y, Q, at, et, n),
        rt = (function (t, e, i, a, n, r) {
          var s = Math.min(Math.max(r, 0.01), 0.99),
            o = (n ? [0, e, -e] : [0]).reduce(function (t, e) {
              return t.concat(l(e, s));
            }, []);
          function l(e, n) {
            var r = i.map(function (t) {
              return t * (n || 0);
            });
            return a.map(function (a, n) {
              return { start: a - i[n] + r[n] + e, end: a + t - r[n] + e, index: n };
            });
          }
          return {
            check: function (t) {
              return o.reduce(function (e, i) {
                var a = i.index,
                  n = i.start,
                  r = i.end;
                return -1 === e.indexOf(a) && n < t && r > t ? e.concat([a]) : e;
              }, []);
            },
            findSlideBounds: l,
          };
        })(_, K, V, J, d, u),
        st = {
          animation: Z,
          axis: E,
          direction: b,
          dragHandler: L(
            E,
            b,
            t,
            et,
            f,
            (function (t, e) {
              var i = t.scroll,
                a = { x: "clientX", y: "clientY" },
                n = k(0),
                r = k(0),
                s = k(0),
                o = k(0),
                l = 10,
                c = 5,
                h = 100,
                u = [],
                d = new Date().getTime(),
                p = !1;
              function f(t, e) {
                p = !t.touches;
                var i = a[e],
                  n = p ? t[i] : t.touches[0][i];
                return o.set(n);
              }
              return {
                pointerDown: function (t) {
                  var a = f(t, i);
                  return n.set(a), s.set(a), e.measure(n.get());
                },
                pointerMove: function (t) {
                  var a = f(t, i),
                    n = new Date().getTime(),
                    o = n - d;
                  return o >= l && (o >= h && (u = []), u.push(a.get()), (d = n)), r.set(a).subtract(s), s.set(a), e.measure(r.get());
                },
                pointerUp: function () {
                  var t = new Date().getTime() - d,
                    i = s.get(),
                    a = u
                      .slice(-c)
                      .map(function (t) {
                        return i - t;
                      })
                      .sort(function (t, e) {
                        return Math.abs(t) < Math.abs(e) ? 1 : -1;
                      })[0];
                  return s.set(t > h || !a ? 0 : a), (u = []), e.measure(s.get());
                },
                readPoint: f,
              };
            })(E, x),
            tt,
            Z,
            nt,
            it,
            at,
            Y,
            n,
            d,
            g
          ),
          pxToPercent: x,
          index: Y,
          indexPrevious: Q,
          limit: H,
          location: tt,
          options: a,
          scrollBody: it,
          scrollBounds: F(H, tt, et, it),
          scrollLooper: B(K, x, H, tt, [tt, et]),
          scrollProgress: (function (t) {
            var e = t.max,
              i = t.length;
            return {
              get: function (t) {
                return (t - e) / -i;
              },
            };
          })(H),
          scrollSnaps: j,
          scrollTarget: at,
          scrollTo: nt,
          slideFocus: (function (t, e, i) {
            var a = S(),
              n = 0;
            function r(t) {
              9 === t.keyCode && (n = new Date().getTime());
            }
            function s(r, s) {
              a.add(
                r,
                "focus",
                function () {
                  if (!(new Date().getTime() - n > 10)) {
                    t.scrollLeft = 0;
                    var a = Math.floor(s / i);
                    e.index(a, 0);
                  }
                },
                !0
              );
            }
            return {
              addActivationEvents: function (t) {
                a.add(document, "keydown", r, !1), t.forEach(s);
              },
              removeAllEvents: a.removeAll,
            };
          })(t, nt, m),
          slideLooper: (function (t, e, i, a, n, r, s, o) {
            var l,
              c = T(a),
              h = T(a).reverse(),
              u = ((l = n[0] - 1), f(p(h, l), "end")).concat(
                (function () {
                  var t = e - n[0] - 1;
                  return f(p(c, t), "start");
                })()
              );
            function d(t, e) {
              return t.reduce(function (t, e) {
                return t - a[e];
              }, e);
            }
            function p(t, e) {
              return t.reduce(function (t, i) {
                return d(t, e) > 0 ? t.concat([i]) : t;
              }, []);
            }
            function f(t, e) {
              var a = "start" === e,
                n = a ? -i : i,
                o = r.findSlideBounds(n);
              return t.map(function (t) {
                var e = a ? 0 : -i,
                  n = a ? i : 0,
                  r = o.filter(function (e) {
                    return e.index === t;
                  })[0][a ? "end" : "start"];
                return {
                  point: r,
                  getTarget: function () {
                    return s.get() > r ? e : n;
                  },
                  index: t,
                  location: -1,
                };
              });
            }
            return {
              canLoop: function () {
                return u.every(function (t) {
                  var i = t.index;
                  return (
                    d(
                      c.filter(function (t) {
                        return t !== i;
                      }),
                      e
                    ) <= 0
                  );
                });
              },
              clear: function () {
                u.forEach(function (e) {
                  var i = e.index;
                  o[i].style[t.startEdge] = "";
                });
              },
              loop: function () {
                u.forEach(function (e) {
                  var i = e.getTarget,
                    a = e.location,
                    n = e.index,
                    r = i();
                  r !== a && ((o[n].style[t.startEdge] = r + "%"), (e.location = r));
                });
              },
              loopPoints: u,
            };
          })(E, _, K, W, j, rt, tt, i),
          slidesInView: rt,
          slideIndexes: X,
          target: et,
          translate: (function (t, e, i) {
            var a = i.style,
              n =
                "x" === t.scroll
                  ? function (t) {
                      return "translate3d(" + t + "%,0px,0px)";
                    }
                  : function (t) {
                      return "translate3d(0px," + t + "%,0px)";
                    },
              r = !1;
            return {
              clear: function () {
                a.transform = "";
              },
              to: function (t) {
                r || (a.transform = n(e.applyTo(t.get())));
              },
              toggleActive: function (t) {
                r = !t;
              },
            };
          })(E, b, e),
        };
      return st;
    }
    var W = {
      align: "center",
      axis: "x",
      containScroll: "",
      direction: "ltr",
      dragFree: !1,
      draggable: !0,
      draggableClass: "is-draggable",
      draggingClass: "is-dragging",
      inViewThreshold: 0,
      loop: !1,
      skipSnaps: !0,
      selectedClass: "is-selected",
      slidesToScroll: 1,
      speed: 10,
      startIndex: 0,
    };
    var U = function (t, e) {
        var i,
          a,
          n,
          r,
          s,
          o,
          l,
          c = (function () {
            var t = {};
            function e(e) {
              return t[e] || [];
            }
            var i = {
              emit: function (t) {
                return (
                  e(t).forEach(function (e) {
                    return e(t);
                  }),
                  i
                );
              },
              off: function (a, n) {
                return (
                  (t[a] = e(a).filter(function (t) {
                    return t !== n;
                  })),
                  i
                );
              },
              on: function (a, n) {
                return (t[a] = e(a).concat([n])), i;
              },
            };
            return i;
          })(),
          h = S(),
          u =
            ((i = function () {
              if (m) {
                var e = r.axis.measureSize(t.getBoundingClientRect());
                v !== e && x(), c.emit("resize");
              }
            }),
            (a = 500),
            (n = 0),
            function () {
              window.clearTimeout(n), (n = window.setTimeout(i, a) || 0);
            }),
          d = x,
          p = c.on,
          f = c.off,
          m = !1,
          g = b({}, W),
          y = b({}, g),
          v = 0;
        function A() {
          if (!t) throw new Error("Missing root node 😢");
          var e,
            i = t.querySelector("*");
          if (!i) throw new Error("Missing container node 😢");
          (o = i),
            (l = Array.prototype.slice.call(o.children)),
            (e = getComputedStyle(t, ":before").content),
            (s = {
              get: function () {
                try {
                  return JSON.parse(e.slice(1, -1).replace(/\\/g, ""));
                } catch (t) {}
                return {};
              },
            });
        }
        function w(e) {
          if ((A(), (g = b({}, g, e)), (y = b({}, g, s.get())), (r = V(t, o, l, y, c)), h.add(window, "resize", u), r.translate.to(r.location), (v = r.axis.measureSize(t.getBoundingClientRect())), y.loop)) {
            if (!r.slideLooper.canLoop()) return E(), w({ loop: !1 });
            r.slideLooper.loop();
          }
          y.draggable && o.offsetParent && l.length && (r.dragHandler.addActivationEvents(), y.draggableClass && I(t, y.draggableClass), y.draggingClass && c.on("pointerDown", C).on("pointerUp", C)),
            l.length && r.slideFocus.addActivationEvents(l),
            y.selectedClass && (k(), c.on("select", k).on("pointerUp", k)),
            m ||
              (setTimeout(function () {
                return c.emit("init");
              }, 0),
              (m = !0));
        }
        function C(e) {
          var i = y.draggingClass;
          "pointerDown" === e ? I(t, i) : D(t, i);
        }
        function k() {
          var t = y.selectedClass,
            e = _(!0);
          T(!0).forEach(function (e) {
            return D(l[e], t);
          }),
            e.forEach(function (e) {
              return I(l[e], t);
            });
        }
        function E() {
          r.dragHandler.removeAllEvents(),
            r.slideFocus.removeAllEvents(),
            r.animation.stop(),
            h.removeAll(),
            r.translate.clear(),
            r.slideLooper.clear(),
            D(t, y.draggableClass),
            l.forEach(function (t) {
              return D(t, y.selectedClass);
            }),
            c.off("select", k).off("pointerUp", k).off("pointerDown", C).off("pointerUp", C);
        }
        function x(t) {
          if (m) {
            var e = b({ startIndex: P() }, t);
            E(), w(e), c.emit("reInit");
          }
        }
        function _(t) {
          var e = r[t ? "target" : "location"].get(),
            i = y.loop ? "removeOffset" : "constrain";
          return r.slidesInView.check(r.limit[i](e));
        }
        function T(t) {
          var e = _(t);
          return r.slideIndexes.filter(function (t) {
            return -1 === e.indexOf(t);
          });
        }
        function M(t, e, i) {
          r.scrollBody.useBaseMass().useSpeed(e ? 100 : y.speed), m && r.scrollTo.index(t, i || 0);
        }
        function P() {
          return r.index.get();
        }
        return (
          w(e),
          {
            canScrollNext: function () {
              return r.index.clone().add(1).get() !== P();
            },
            canScrollPrev: function () {
              return r.index.clone().add(-1).get() !== P();
            },
            clickAllowed: function () {
              return r.dragHandler.clickAllowed();
            },
            containerNode: function () {
              return o;
            },
            dangerouslyGetEngine: function () {
              return r;
            },
            destroy: function () {
              m && (E(), (m = !1), c.emit("destroy"));
            },
            off: f,
            on: p,
            previousScrollSnap: function () {
              return r.indexPrevious.get();
            },
            reInit: d,
            rootNode: function () {
              return t;
            },
            scrollNext: function (t) {
              M(r.index.clone().add(1).get(), !0 === t, -1);
            },
            scrollPrev: function (t) {
              M(r.index.clone().add(-1).get(), !0 === t, 1);
            },
            scrollProgress: function () {
              return r.scrollProgress.get(r.location.get());
            },
            scrollSnapList: function () {
              return r.scrollSnaps.map(r.scrollProgress.get);
            },
            scrollTo: M,
            selectedScrollSnap: P,
            slideNodes: function () {
              return l;
            },
            slidesInView: _,
            slidesNotInView: T,
          }
        );
      },
      J = i(7),
      z = {
        assetPath: document.getElementById("site-data") && window.location.host.indexOf("localhost") < 0 ? document.getElementById("site-data").getAttribute("data-asset-path") : "/assets/code/",
        firstLoad: !0,
        isMobile: !1,
        isSafari: navigator.userAgent.indexOf("Safari") > -1 && -1 === navigator.userAgent.indexOf("Chrome"),
        isChrome: navigator.userAgent.indexOf("Chrome") > -1,
        isFirefox: navigator.userAgent.indexOf("Firefox") > -1,
        windowHeight: "",
        windowWidth: "",
        domain: location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : ""),
        transitionFinished: !1,
        queryParams: {},
        referrer: "",
        reducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        headerShowing: !0,
        preloadedSlugs: [],
        keyToggle: !1,
        productsInCart: !1,
        isGreaterThan767: !1,
        currentRewardTier: 0,
        currentFocus: null,
        currentSliders: [],
        loadASPImages: !1,
      },
      K = {
        header: document.getElementById("header"),
        globalFooter: document.getElementById("footer"),
        mainNav: document.getElementById("main-navigation"),
        mainEl: document.getElementById("main"),
        containerEl: document.getElementById("container"),
        globalMask: document.getElementById("global-mask"),
        openMobileMenu: function () {},
        closeMobileMenu: function () {},
        resetMobileMenu: function () {},
      },
      G = { cartTotal: 0, currentReward: 0, totalDiscount: 0, currentRewardTier: 0 },
      j = function (t) {
        for (var e, i = t.length; 0 !== i; ) {
          (e = Math.floor(Math.random() * i)), i--;
          var a = [t[e], t[i]];
          (t[i] = a[0]), (t[e] = a[1]);
        }
        return t;
      },
      H = function (t, e) {
        return Math.random() * (e - t) + t;
      },
      Y = function (t, e, i, a, n) {
        return ((t - e) * (n - a)) / (i - e) + a;
      },
      Q = function (t, e) {
        return Number(Math.round(t + "e" + e) + "e-" + e);
      },
      X = function (t) {
        var e = t.previousElementSibling;
        (e && void 0 !== e) || (e = t.nextElementSibling);
        var i = t.getAttribute("placeholder");
        "label" == e.tagName.toLowerCase() && ((e.textContent = i), e.classList.remove("error")), t.classList.remove("error");
      },
      Z = function (t, e) {
        var i = t.previousElementSibling;
        (i && void 0 !== i) || (i = t.nextElementSibling), "label" == i.tagName.toLowerCase() && ((i.textContent = e), (i.className += " error")), (t.className += " error");
      },
      $ = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          r = i || t.action,
          s = t.method,
          o = J(t, { hash: !0 });
        "get" === s && (o = J(t));
        var l = !0;
        !0 === e &&
          (l = (function (t) {
            var e = !0,
              i = t.getElementsByClassName("validate");
            return (
              Array.prototype.slice.call(i).forEach(function (i) {
                X(i);
                var a = i.getAttribute("type"),
                  n = i.tagName,
                  r = i.getAttribute("name"),
                  s = i.value;
                switch (("textarea" == n.toLowerCase() && (a = "textarea"), a)) {
                  case "password":
                    "customer[password_confirmation]" == r && t.querySelectorAll("input[type='password']")[0].value !== s && (Z(i, "Passwords Do Not Match"), (e = !1)),
                      s.length < 5 && (Z(i, "Your Password Must Be At Least 5 Characters"), (e = !1));
                    break;
                  case "text":
                  case "textarea":
                    "" === s && (Z(i, i.placeholder + " Can Not Be Blank"), (e = !1));
                    break;
                  case "email":
                    ("" !== s && s.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/)) || (Z(i, "Please enter a valid email"), (e = !1));
                }
              }),
              e
            );
          })(t)),
          !0 === l &&
            ("get" === s
              ? a(r + "?" + o, { method: s, type: "json" }, function (t) {
                  n(JSON.parse(t));
                })
              : a(r, { method: s, type: "json", data: JSON.stringify(o) }, function (t) {
                  n(JSON.parse(t));
                }));
      },
      tt = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        r(t, "bound") ||
          ((t.className += " bound"),
          t.addEventListener("submit", function (n) {
            n.preventDefault(),
              $(t, e, i, function (t) {
                a(t);
              });
          }));
      },
      et = function (t) {
        var e = t;
        if (!e) return e;
        if (
          ((e = e.replace("sunniva.myshopify.com", "shop.drinksupercoffee.com")),
          z.queryParams && Object.keys(z.queryParams).length > 0
            ? (Object.keys(z.queryParams).forEach(function (t, i) {
                e = e.indexOf("?") >= 0 ? e + "&" + t + "=" + z.queryParams[t] : e + "?" + t + "=" + z.queryParams[t];
              }),
              "" !== z.referrer && (e = e + "&dr=" + z.referrer))
            : "" !== z.referrer && (e = e.indexOf("?") >= 0 ? e + "&dr=" + encodeURIComponent(z.referrer) : e + "?dr=" + encodeURIComponent(z.referrer)),
          v.get("_ga"))
        ) {
          var i = z.linker ? z.linker : "_ga=" + v.get("_ga").replace("GA", "");
          e = e.indexOf("?") >= 0 ? e + "&" + i : e + "?" + i;
        }
        return e;
      },
      it = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
          r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null;
        switch (t) {
          case "facebook":
            "undefined" == typeof fbq ? console.log("FB not initialized") : a ? fbq(e, i, a) : n ? fbq(e, i, a, n) : fbq(e, i);
            break;
          case "segment":
            if ("undefined" == typeof analytics) console.log("Segment not initialized");
            else
              switch (e) {
                case "track":
                  n ? analytics.track(i, a, n) : analytics.track(i, a);
                  break;
                case "page":
                default:
                  analytics.page();
              }
            break;
          case "klaviyo":
            var s = setInterval(function () {
              "undefined" != typeof _learnq && (a ? _learnq.push([e, i, a]) : _learnq.push([e, i]), clearInterval(s));
            }, 10);
            break;
          case "google":
          default:
            "undefined" == typeof ga ? console.log("GA not initialized") : r ? ga(e, i, a, n, r) : n ? ga(e, i, a, n) : a ? ga(e, i, a) : ga(e, i);
        }
      };
    function at(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }
    function nt(t, e) {
      (t.prototype = Object.create(e.prototype)), (t.prototype.constructor = t), (t.__proto__ = e);
    }
    /*!
     * GSAP 3.6.1
     * https://greensock.com
     *
     * @license Copyright 2008-2021, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */ var rt,
      st,
      ot,
      lt,
      ct,
      ht,
      ut,
      dt,
      pt,
      ft,
      mt,
      gt,
      yt,
      vt = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } },
      At = { duration: 0.5, overwrite: !1, delay: 0 },
      bt = 1e-8,
      wt = 2 * Math.PI,
      Ct = wt / 4,
      St = 0,
      kt = Math.sqrt,
      Et = Math.cos,
      xt = Math.sin,
      _t = function (t) {
        return "string" == typeof t;
      },
      Tt = function (t) {
        return "function" == typeof t;
      },
      Mt = function (t) {
        return "number" == typeof t;
      },
      Pt = function (t) {
        return void 0 === t;
      },
      Dt = function (t) {
        return "object" == typeof t;
      },
      It = function (t) {
        return !1 !== t;
      },
      Lt = function () {
        return "undefined" != typeof window;
      },
      Rt = function (t) {
        return Tt(t) || _t(t);
      },
      Ft = ("function" == typeof ArrayBuffer && ArrayBuffer.isView) || function () {},
      Ot = Array.isArray,
      Bt = /(?:-?\.?\d|\.)+/gi,
      qt = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
      Nt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      Vt = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
      Wt = /[+-]=-?[.\d]+/,
      Ut = /[#\-+.]*\b[a-z\d-=+%.]+/gi,
      Jt = /[\d.+\-=]+(?:e[-+]\d*)*/i,
      zt = {},
      Kt = {},
      Gt = function (t) {
        return (Kt = ve(t, zt)) && Zi;
      },
      jt = function (t, e) {
        return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
      },
      Ht = function (t, e) {
        return !e && console.warn(t);
      },
      Yt = function (t, e) {
        return (t && (zt[t] = e) && Kt && (Kt[t] = e)) || zt;
      },
      Qt = function () {
        return 0;
      },
      Xt = {},
      Zt = [],
      $t = {},
      te = {},
      ee = {},
      ie = 30,
      ae = [],
      ne = "",
      re = function (t) {
        var e,
          i,
          a = t[0];
        if ((Dt(a) || Tt(a) || (t = [t]), !(e = (a._gsap || {}).harness))) {
          for (i = ae.length; i-- && !ae[i].targetTest(a); );
          e = ae[i];
        }
        for (i = t.length; i--; ) (t[i] && (t[i]._gsap || (t[i]._gsap = new ki(t[i], e)))) || t.splice(i, 1);
        return t;
      },
      se = function (t) {
        return t._gsap || re(Ke(t))[0]._gsap;
      },
      oe = function (t, e, i) {
        return (i = t[e]) && Tt(i) ? t[e]() : (Pt(i) && t.getAttribute && t.getAttribute(e)) || i;
      },
      le = function (t, e) {
        return (t = t.split(",")).forEach(e) || t;
      },
      ce = function (t) {
        return Math.round(1e5 * t) / 1e5 || 0;
      },
      he = function (t, e) {
        for (var i = e.length, a = 0; t.indexOf(e[a]) < 0 && ++a < i; );
        return a < i;
      },
      ue = function (t, e, i) {
        var a,
          n = Mt(t[1]),
          r = (n ? 2 : 1) + (e < 2 ? 0 : 1),
          s = t[r];
        if ((n && (s.duration = t[1]), (s.parent = i), e)) {
          for (a = s; i && !("immediateRender" in a); ) (a = i.vars.defaults || {}), (i = It(i.vars.inherit) && i.parent);
          (s.immediateRender = It(a.immediateRender)), e < 2 ? (s.runBackwards = 1) : (s.startAt = t[r - 1]);
        }
        return s;
      },
      de = function () {
        var t,
          e,
          i = Zt.length,
          a = Zt.slice(0);
        for ($t = {}, Zt.length = 0, t = 0; t < i; t++) (e = a[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
      },
      pe = function (t, e, i, a) {
        Zt.length && de(), t.render(e, i, a), Zt.length && de();
      },
      fe = function (t) {
        var e = parseFloat(t);
        return (e || 0 === e) && (t + "").match(Ut).length < 2 ? e : _t(t) ? t.trim() : t;
      },
      me = function (t) {
        return t;
      },
      ge = function (t, e) {
        for (var i in e) i in t || (t[i] = e[i]);
        return t;
      },
      ye = function (t, e) {
        for (var i in e) i in t || "duration" === i || "ease" === i || (t[i] = e[i]);
      },
      ve = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      },
      Ae = function t(e, i) {
        for (var a in i) "__proto__" !== a && "constructor" !== a && "prototype" !== a && (e[a] = Dt(i[a]) ? t(e[a] || (e[a] = {}), i[a]) : i[a]);
        return e;
      },
      be = function (t, e) {
        var i,
          a = {};
        for (i in t) i in e || (a[i] = t[i]);
        return a;
      },
      we = function (t) {
        var e = t.parent || st,
          i = t.keyframes ? ye : ge;
        if (It(t.inherit)) for (; e; ) i(t, e.vars.defaults), (e = e.parent || e._dp);
        return t;
      },
      Ce = function (t, e, i, a) {
        void 0 === i && (i = "_first"), void 0 === a && (a = "_last");
        var n = e._prev,
          r = e._next;
        n ? (n._next = r) : t[i] === e && (t[i] = r), r ? (r._prev = n) : t[a] === e && (t[a] = n), (e._next = e._prev = e.parent = null);
      },
      Se = function (t, e) {
        t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t), (t._act = 0);
      },
      ke = function (t, e) {
        if (t && (!e || e._end > t._dur || e._start < 0)) for (var i = t; i; ) (i._dirty = 1), (i = i.parent);
        return t;
      },
      Ee = function t(e) {
        return !e || (e._ts && t(e.parent));
      },
      xe = function (t) {
        return t._repeat ? _e(t._tTime, (t = t.duration() + t._rDelay)) * t : 0;
      },
      _e = function (t, e) {
        var i = Math.floor((t /= e));
        return t && i === t ? i - 1 : i;
      },
      Te = function (t, e) {
        return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
      },
      Me = function (t) {
        return (t._end = ce(t._start + (t._tDur / Math.abs(t._ts || t._rts || bt) || 0)));
      },
      Pe = function (t, e) {
        var i = t._dp;
        return i && i.smoothChildTiming && t._ts && ((t._start = ce(i._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts))), Me(t), i._dirty || ke(i, t)), t;
      },
      De = function (t, e) {
        var i;
        if (((e._time || (e._initted && !e._dur)) && ((i = Te(t.rawTime(), e)), (!e._dur || Ve(0, e.totalDuration(), i) - e._tTime > bt) && e.render(i, !0)), ke(t, e)._dp && t._initted && t._time >= t._dur && t._ts)) {
          if (t._dur < t.duration()) for (i = t; i._dp; ) i.rawTime() >= 0 && i.totalTime(i._tTime), (i = i._dp);
          t._zTime = -bt;
        }
      },
      Ie = function (t, e, i, a) {
        return (
          e.parent && Se(e),
          (e._start = ce(i + e._delay)),
          (e._end = ce(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0))),
          (function (t, e, i, a, n) {
            void 0 === i && (i = "_first"), void 0 === a && (a = "_last");
            var r,
              s = t[a];
            if (n) for (r = e[n]; s && s[n] > r; ) s = s._prev;
            s ? ((e._next = s._next), (s._next = e)) : ((e._next = t[i]), (t[i] = e)), e._next ? (e._next._prev = e) : (t[a] = e), (e._prev = s), (e.parent = e._dp = t);
          })(t, e, "_first", "_last", t._sort ? "_start" : 0),
          (t._recent = e),
          a || De(t, e),
          t
        );
      },
      Le = function (t, e) {
        return (zt.ScrollTrigger || jt("scrollTrigger", e)) && zt.ScrollTrigger.create(e, t);
      },
      Re = function (t, e, i, a) {
        return Pi(t, e), t._initted ? (!i && t._pt && ((t._dur && !1 !== t.vars.lazy) || (!t._dur && t.vars.lazy)) && ut !== ui.frame ? (Zt.push(t), (t._lazy = [e, a]), 1) : void 0) : 1;
      },
      Fe = function (t, e, i, a) {
        var n = t._repeat,
          r = ce(e) || 0,
          s = t._tTime / t._tDur;
        return s && !a && (t._time *= r / t._dur), (t._dur = r), (t._tDur = n ? (n < 0 ? 1e10 : ce(r * (n + 1) + t._rDelay * n)) : r), s && !a ? Pe(t, (t._tTime = t._tDur * s)) : t.parent && Me(t), i || ke(t.parent, t), t;
      },
      Oe = function (t) {
        return t instanceof xi ? ke(t) : Fe(t, t._dur);
      },
      Be = { _start: 0, endTime: Qt },
      qe = function t(e, i) {
        var a,
          n,
          r = e.labels,
          s = e._recent || Be,
          o = e.duration() >= 1e8 ? s.endTime(!1) : e._dur;
        return _t(i) && (isNaN(i) || i in r)
          ? "<" === (a = i.charAt(0)) || ">" === a
            ? ("<" === a ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(i.substr(1)) || 0)
            : (a = i.indexOf("=")) < 0
            ? (i in r || (r[i] = o), r[i])
            : ((n = +(i.charAt(a - 1) + i.substr(a + 1))), a > 1 ? t(e, i.substr(0, a - 1)) + n : o + n)
          : null == i
          ? o
          : +i;
      },
      Ne = function (t, e) {
        return t || 0 === t ? e(t) : e;
      },
      Ve = function (t, e, i) {
        return i < t ? t : i > e ? e : i;
      },
      We = function (t) {
        if ("string" != typeof t) return "";
        var e = Jt.exec(t);
        return e ? t.substr(e.index + e[0].length) : "";
      },
      Ue = [].slice,
      Je = function (t, e) {
        return t && Dt(t) && "length" in t && ((!e && !t.length) || (t.length - 1 in t && Dt(t[0]))) && !t.nodeType && t !== ot;
      },
      ze = function (t, e, i) {
        return (
          void 0 === i && (i = []),
          t.forEach(function (t) {
            var a;
            return (_t(t) && !e) || Je(t, 1) ? (a = i).push.apply(a, Ke(t)) : i.push(t);
          }) || i
        );
      },
      Ke = function (t, e) {
        return !_t(t) || e || (!lt && di()) ? (Ot(t) ? ze(t, e) : Je(t) ? Ue.call(t, 0) : t ? [t] : []) : Ue.call(ct.querySelectorAll(t), 0);
      },
      Ge = function (t) {
        return t.sort(function () {
          return 0.5 - Math.random();
        });
      },
      je = function (t) {
        if (Tt(t)) return t;
        var e = Dt(t) ? t : { each: t },
          i = Ai(e.ease),
          a = e.from || 0,
          n = parseFloat(e.base) || 0,
          r = {},
          s = a > 0 && a < 1,
          o = isNaN(a) || s,
          l = e.axis,
          c = a,
          h = a;
        return (
          _t(a) ? (c = h = { center: 0.5, edges: 0.5, end: 1 }[a] || 0) : !s && o && ((c = a[0]), (h = a[1])),
          function (t, s, u) {
            var d,
              p,
              f,
              m,
              g,
              y,
              v,
              A,
              b,
              w = (u || e).length,
              C = r[w];
            if (!C) {
              if (!(b = "auto" === e.grid ? 0 : (e.grid || [1, 1e8])[1])) {
                for (v = -1e8; v < (v = u[b++].getBoundingClientRect().left) && b < w; );
                b--;
              }
              for (C = r[w] = [], d = o ? Math.min(b, w) * c - 0.5 : a % b, p = o ? (w * h) / b - 0.5 : (a / b) | 0, v = 0, A = 1e8, y = 0; y < w; y++)
                (f = (y % b) - d), (m = p - ((y / b) | 0)), (C[y] = g = l ? Math.abs("y" === l ? m : f) : kt(f * f + m * m)), g > v && (v = g), g < A && (A = g);
              "random" === a && Ge(C),
                (C.max = v - A),
                (C.min = A),
                (C.v = w = (parseFloat(e.amount) || parseFloat(e.each) * (b > w ? w - 1 : l ? ("y" === l ? w / b : b) : Math.max(b, w / b)) || 0) * ("edges" === a ? -1 : 1)),
                (C.b = w < 0 ? n - w : n),
                (C.u = We(e.amount || e.each) || 0),
                (i = i && w < 0 ? yi(i) : i);
            }
            return (w = (C[t] - C.min) / C.max || 0), ce(C.b + (i ? i(w) : w) * C.v) + C.u;
          }
        );
      },
      He = function (t) {
        var e = t < 1 ? Math.pow(10, (t + "").length - 2) : 1;
        return function (i) {
          var a = Math.round(parseFloat(i) / t) * t * e;
          return (a - (a % 1)) / e + (Mt(i) ? 0 : We(i));
        };
      },
      Ye = function (t, e) {
        var i,
          a,
          n = Ot(t);
        return (
          !n && Dt(t) && ((i = n = t.radius || 1e8), t.values ? ((t = Ke(t.values)), (a = !Mt(t[0])) && (i *= i)) : (t = He(t.increment))),
          Ne(
            e,
            n
              ? Tt(t)
                ? function (e) {
                    return (a = t(e)), Math.abs(a - e) <= i ? a : e;
                  }
                : function (e) {
                    for (var n, r, s = parseFloat(a ? e.x : e), o = parseFloat(a ? e.y : 0), l = 1e8, c = 0, h = t.length; h--; ) (n = a ? (n = t[h].x - s) * n + (r = t[h].y - o) * r : Math.abs(t[h] - s)) < l && ((l = n), (c = h));
                    return (c = !i || l <= i ? t[c] : e), a || c === e || Mt(e) ? c : c + We(e);
                  }
              : He(t)
          )
        );
      },
      Qe = function (t, e, i, a) {
        return Ne(Ot(t) ? !e : !0 === i ? !!(i = 0) : !a, function () {
          return Ot(t) ? t[~~(Math.random() * t.length)] : (i = i || 1e-5) && (a = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((t - i / 2 + Math.random() * (e - t + 0.99 * i)) / i) * i * a) / a;
        });
      },
      Xe = function (t, e, i) {
        return Ne(i, function (i) {
          return t[~~e(i)];
        });
      },
      Ze = function (t) {
        for (var e, i, a, n, r = 0, s = ""; ~(e = t.indexOf("random(", r)); )
          (a = t.indexOf(")", e)), (n = "[" === t.charAt(e + 7)), (i = t.substr(e + 7, a - e - 7).match(n ? Ut : Bt)), (s += t.substr(r, e - r) + Qe(n ? i : +i[0], n ? 0 : +i[1], +i[2] || 1e-5)), (r = a + 1);
        return s + t.substr(r, t.length - r);
      },
      $e = function (t, e, i, a, n) {
        var r = e - t,
          s = a - i;
        return Ne(n, function (e) {
          return i + (((e - t) / r) * s || 0);
        });
      },
      ti = function (t, e, i) {
        var a,
          n,
          r,
          s = t.labels,
          o = 1e8;
        for (a in s) (n = s[a] - e) < 0 == !!i && n && o > (n = Math.abs(n)) && ((r = a), (o = n));
        return r;
      },
      ei = function (t, e, i) {
        var a,
          n,
          r = t.vars,
          s = r[e];
        if (s) return (a = r[e + "Params"]), (n = r.callbackScope || t), i && Zt.length && de(), a ? s.apply(n, a) : s.call(n);
      },
      ii = function (t) {
        return Se(t), t.scrollTrigger && t.scrollTrigger.kill(!1), t.progress() < 1 && ei(t, "onInterrupt"), t;
      },
      ai = {
        aqua: [0, 255, 255],
        lime: [0, 255, 0],
        silver: [192, 192, 192],
        black: [0, 0, 0],
        maroon: [128, 0, 0],
        teal: [0, 128, 128],
        blue: [0, 0, 255],
        navy: [0, 0, 128],
        white: [255, 255, 255],
        olive: [128, 128, 0],
        yellow: [255, 255, 0],
        orange: [255, 165, 0],
        gray: [128, 128, 128],
        purple: [128, 0, 128],
        green: [0, 128, 0],
        red: [255, 0, 0],
        pink: [255, 192, 203],
        cyan: [0, 255, 255],
        transparent: [255, 255, 255, 0],
      },
      ni = function (t, e, i) {
        return (255 * (6 * (t = t < 0 ? t + 1 : t > 1 ? t - 1 : t) < 1 ? e + (i - e) * t * 6 : t < 0.5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) + 0.5) | 0;
      },
      ri = function (t, e, i) {
        var a,
          n,
          r,
          s,
          o,
          l,
          c,
          h,
          u,
          d,
          p = t ? (Mt(t) ? [t >> 16, (t >> 8) & 255, 255 & t] : 0) : ai.black;
        if (!p) {
          if (("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), ai[t])) p = ai[t];
          else if ("#" === t.charAt(0)) {
            if ((t.length < 6 && (t = "#" + (a = t.charAt(1)) + a + (n = t.charAt(2)) + n + (r = t.charAt(3)) + r + (5 === t.length ? t.charAt(4) + t.charAt(4) : "")), 9 === t.length))
              return [(p = parseInt(t.substr(1, 6), 16)) >> 16, (p >> 8) & 255, 255 & p, parseInt(t.substr(7), 16) / 255];
            p = [(t = parseInt(t.substr(1), 16)) >> 16, (t >> 8) & 255, 255 & t];
          } else if ("hsl" === t.substr(0, 3))
            if (((p = d = t.match(Bt)), e)) {
              if (~t.indexOf("=")) return (p = t.match(qt)), i && p.length < 4 && (p[3] = 1), p;
            } else
              (s = (+p[0] % 360) / 360),
                (o = +p[1] / 100),
                (a = 2 * (l = +p[2] / 100) - (n = l <= 0.5 ? l * (o + 1) : l + o - l * o)),
                p.length > 3 && (p[3] *= 1),
                (p[0] = ni(s + 1 / 3, a, n)),
                (p[1] = ni(s, a, n)),
                (p[2] = ni(s - 1 / 3, a, n));
          else p = t.match(Bt) || ai.transparent;
          p = p.map(Number);
        }
        return (
          e &&
            !d &&
            ((a = p[0] / 255),
            (n = p[1] / 255),
            (r = p[2] / 255),
            (l = ((c = Math.max(a, n, r)) + (h = Math.min(a, n, r))) / 2),
            c === h ? (s = o = 0) : ((u = c - h), (o = l > 0.5 ? u / (2 - c - h) : u / (c + h)), (s = c === a ? (n - r) / u + (n < r ? 6 : 0) : c === n ? (r - a) / u + 2 : (a - n) / u + 4), (s *= 60)),
            (p[0] = ~~(s + 0.5)),
            (p[1] = ~~(100 * o + 0.5)),
            (p[2] = ~~(100 * l + 0.5))),
          i && p.length < 4 && (p[3] = 1),
          p
        );
      },
      si = function (t) {
        var e = [],
          i = [],
          a = -1;
        return (
          t.split(li).forEach(function (t) {
            var n = t.match(Nt) || [];
            e.push.apply(e, n), i.push((a += n.length + 1));
          }),
          (e.c = i),
          e
        );
      },
      oi = function (t, e, i) {
        var a,
          n,
          r,
          s,
          o = "",
          l = (t + o).match(li),
          c = e ? "hsla(" : "rgba(",
          h = 0;
        if (!l) return t;
        if (
          ((l = l.map(function (t) {
            return (t = ri(t, e, 1)) && c + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")";
          })),
          i && ((r = si(t)), (a = i.c).join(o) !== r.c.join(o)))
        )
          for (s = (n = t.replace(li, "1").split(Nt)).length - 1; h < s; h++) o += n[h] + (~a.indexOf(h) ? l.shift() || c + "0,0,0,0)" : (r.length ? r : l.length ? l : i).shift());
        if (!n) for (s = (n = t.split(li)).length - 1; h < s; h++) o += n[h] + l[h];
        return o + n[s];
      },
      li = (function () {
        var t,
          e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
        for (t in ai) e += "|" + t + "\\b";
        return new RegExp(e + ")", "gi");
      })(),
      ci = /hsl[a]?\(/,
      hi = function (t) {
        var e,
          i = t.join(" ");
        if (((li.lastIndex = 0), li.test(i))) return (e = ci.test(i)), (t[1] = oi(t[1], e)), (t[0] = oi(t[0], e, si(t[1]))), !0;
      },
      ui = (function () {
        var t,
          e,
          i,
          a,
          n,
          r,
          s = Date.now,
          o = 500,
          l = 33,
          c = s(),
          h = c,
          u = 1e3 / 240,
          d = u,
          p = [],
          f = function i(f) {
            var m,
              g,
              y,
              v,
              A = s() - h,
              b = !0 === f;
            if ((A > o && (c += A - l), ((m = (y = (h += A) - c) - d) > 0 || b) && ((v = ++a.frame), (n = y - 1e3 * a.time), (a.time = y /= 1e3), (d += m + (m >= u ? 4 : u - m)), (g = 1)), b || (t = e(i)), g))
              for (r = 0; r < p.length; r++) p[r](y, n, v, f);
          };
        return (a = {
          time: 0,
          frame: 0,
          tick: function () {
            f(!0);
          },
          deltaRatio: function (t) {
            return n / (1e3 / (t || 60));
          },
          wake: function () {
            ht &&
              (!lt &&
                Lt() &&
                ((ot = lt = window), (ct = ot.document || {}), (zt.gsap = Zi), (ot.gsapVersions || (ot.gsapVersions = [])).push(Zi.version), Gt(Kt || ot.GreenSockGlobals || (!ot.gsap && ot) || {}), (i = ot.requestAnimationFrame)),
              t && a.sleep(),
              (e =
                i ||
                function (t) {
                  return setTimeout(t, (d - 1e3 * a.time + 1) | 0);
                }),
              (pt = 1),
              f(2));
          },
          sleep: function () {
            (i ? ot.cancelAnimationFrame : clearTimeout)(t), (pt = 0), (e = Qt);
          },
          lagSmoothing: function (t, e) {
            (o = t || 1 / bt), (l = Math.min(e, o, 0));
          },
          fps: function (t) {
            (u = 1e3 / (t || 240)), (d = 1e3 * a.time + u);
          },
          add: function (t) {
            p.indexOf(t) < 0 && p.push(t), di();
          },
          remove: function (t) {
            var e;
            ~(e = p.indexOf(t)) && p.splice(e, 1) && r >= e && r--;
          },
          _listeners: p,
        });
      })(),
      di = function () {
        return !pt && ui.wake();
      },
      pi = {},
      fi = /^[\d.\-M][\d.\-,\s]/,
      mi = /["']/g,
      gi = function (t) {
        var e,
          i,
          a,
          n,
          r = (t + "").split("("),
          s = pi[r[0]];
        return s && r.length > 1 && s.config
          ? s.config.apply(
              null,
              ~t.indexOf("{")
                ? [
                    (function (t) {
                      for (var e, i, a, n = {}, r = t.substr(1, t.length - 3).split(":"), s = r[0], o = 1, l = r.length; o < l; o++)
                        (i = r[o]), (e = o !== l - 1 ? i.lastIndexOf(",") : i.length), (a = i.substr(0, e)), (n[s] = isNaN(a) ? a.replace(mi, "").trim() : +a), (s = i.substr(e + 1).trim());
                      return n;
                    })(r[1]),
                  ]
                : ((e = t), (i = e.indexOf("(") + 1), (a = e.indexOf(")")), (n = e.indexOf("(", i)), e.substring(i, ~n && n < a ? e.indexOf(")", a + 1) : a)).split(",").map(fe)
            )
          : pi._CE && fi.test(t)
          ? pi._CE("", t)
          : s;
      },
      yi = function (t) {
        return function (e) {
          return 1 - t(1 - e);
        };
      },
      vi = function t(e, i) {
        for (var a, n = e._first; n; )
          n instanceof xi ? t(n, i) : !n.vars.yoyoEase || (n._yoyo && n._repeat) || n._yoyo === i || (n.timeline ? t(n.timeline, i) : ((a = n._ease), (n._ease = n._yEase), (n._yEase = a), (n._yoyo = i))), (n = n._next);
      },
      Ai = function (t, e) {
        return (t && (Tt(t) ? t : pi[t] || gi(t))) || e;
      },
      bi = function (t, e, i, a) {
        void 0 === i &&
          (i = function (t) {
            return 1 - e(1 - t);
          }),
          void 0 === a &&
            (a = function (t) {
              return t < 0.5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
            });
        var n,
          r = { easeIn: e, easeOut: i, easeInOut: a };
        return (
          le(t, function (t) {
            for (var e in ((pi[t] = zt[t] = r), (pi[(n = t.toLowerCase())] = i), r)) pi[n + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = pi[t + "." + e] = r[e];
          }),
          r
        );
      },
      wi = function (t) {
        return function (e) {
          return e < 0.5 ? (1 - t(1 - 2 * e)) / 2 : 0.5 + t(2 * (e - 0.5)) / 2;
        };
      },
      Ci = function t(e, i, a) {
        var n = i >= 1 ? i : 1,
          r = (a || (e ? 0.3 : 0.45)) / (i < 1 ? i : 1),
          s = (r / wt) * (Math.asin(1 / n) || 0),
          o = function (t) {
            return 1 === t ? 1 : n * Math.pow(2, -10 * t) * xt((t - s) * r) + 1;
          },
          l =
            "out" === e
              ? o
              : "in" === e
              ? function (t) {
                  return 1 - o(1 - t);
                }
              : wi(o);
        return (
          (r = wt / r),
          (l.config = function (i, a) {
            return t(e, i, a);
          }),
          l
        );
      },
      Si = function t(e, i) {
        void 0 === i && (i = 1.70158);
        var a = function (t) {
            return t ? --t * t * ((i + 1) * t + i) + 1 : 0;
          },
          n =
            "out" === e
              ? a
              : "in" === e
              ? function (t) {
                  return 1 - a(1 - t);
                }
              : wi(a);
        return (
          (n.config = function (i) {
            return t(e, i);
          }),
          n
        );
      };
    le("Linear,Quad,Cubic,Quart,Quint,Strong", function (t, e) {
      var i = e < 5 ? e + 1 : e;
      bi(
        t + ",Power" + (i - 1),
        e
          ? function (t) {
              return Math.pow(t, i);
            }
          : function (t) {
              return t;
            },
        function (t) {
          return 1 - Math.pow(1 - t, i);
        },
        function (t) {
          return t < 0.5 ? Math.pow(2 * t, i) / 2 : 1 - Math.pow(2 * (1 - t), i) / 2;
        }
      );
    }),
      (pi.Linear.easeNone = pi.none = pi.Linear.easeIn),
      bi("Elastic", Ci("in"), Ci("out"), Ci()),
      (ft = 7.5625),
      (gt = 1 / (mt = 2.75)),
      bi(
        "Bounce",
        function (t) {
          return 1 - yt(1 - t);
        },
        (yt = function (t) {
          return t < gt ? ft * t * t : t < 0.7272727272727273 ? ft * Math.pow(t - 1.5 / mt, 2) + 0.75 : t < 0.9090909090909092 ? ft * (t -= 2.25 / mt) * t + 0.9375 : ft * Math.pow(t - 2.625 / mt, 2) + 0.984375;
        })
      ),
      bi("Expo", function (t) {
        return t ? Math.pow(2, 10 * (t - 1)) : 0;
      }),
      bi("Circ", function (t) {
        return -(kt(1 - t * t) - 1);
      }),
      bi("Sine", function (t) {
        return 1 === t ? 1 : 1 - Et(t * Ct);
      }),
      bi("Back", Si("in"), Si("out"), Si()),
      (pi.SteppedEase = pi.steps = zt.SteppedEase = {
        config: function (t, e) {
          void 0 === t && (t = 1);
          var i = 1 / t,
            a = t + (e ? 0 : 1),
            n = e ? 1 : 0,
            r = 1 - bt;
          return function (t) {
            return (((a * Ve(0, r, t)) | 0) + n) * i;
          };
        },
      }),
      (At.ease = pi["quad.out"]),
      le("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (t) {
        return (ne += t + "," + t + "Params,");
      });
    var ki = function (t, e) {
        (this.id = St++), (t._gsap = this), (this.target = t), (this.harness = e), (this.get = e ? e.get : oe), (this.set = e ? e.getSetter : Ni);
      },
      Ei = (function () {
        function t(t, e) {
          var i = t.parent || st;
          (this.vars = t),
            (this._delay = +t.delay || 0),
            (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && ((this._rDelay = t.repeatDelay || 0), (this._yoyo = !!t.yoyo || !!t.yoyoEase)),
            (this._ts = 1),
            Fe(this, +t.duration, 1, 1),
            (this.data = t.data),
            pt || ui.wake(),
            i && Ie(i, this, e || 0 === e ? e : i._time, 1),
            t.reversed && this.reverse(),
            t.paused && this.paused(!0);
        }
        var e = t.prototype;
        return (
          (e.delay = function (t) {
            return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay), (this._delay = t), this) : this._delay;
          }),
          (e.duration = function (t) {
            return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur;
          }),
          (e.totalDuration = function (t) {
            return arguments.length ? ((this._dirty = 0), Fe(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
          }),
          (e.totalTime = function (t, e) {
            if ((di(), !arguments.length)) return this._tTime;
            var i = this._dp;
            if (i && i.smoothChildTiming && this._ts) {
              for (Pe(this, t), !i._dp || i.parent || De(i, this); i.parent; ) i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), (i = i.parent);
              !this.parent && this._dp.autoRemoveChildren && ((this._ts > 0 && t < this._tDur) || (this._ts < 0 && t > 0) || (!this._tDur && !t)) && Ie(this._dp, this, this._start - this._delay);
            }
            return (this._tTime !== t || (!this._dur && !e) || (this._initted && Math.abs(this._zTime) === bt) || (!t && !this._initted && (this.add || this._ptLookup))) && (this._ts || (this._pTime = t), pe(this, t, e)), this;
          }),
          (e.time = function (t, e) {
            return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + xe(this)) % this._dur || (t ? this._dur : 0), e) : this._time;
          }),
          (e.totalProgress = function (t, e) {
            return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
          }),
          (e.progress = function (t, e) {
            return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + xe(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
          }),
          (e.iteration = function (t, e) {
            var i = this.duration() + this._rDelay;
            return arguments.length ? this.totalTime(this._time + (t - 1) * i, e) : this._repeat ? _e(this._tTime, i) + 1 : 1;
          }),
          (e.timeScale = function (t) {
            if (!arguments.length) return this._rts === -bt ? 0 : this._rts;
            if (this._rts === t) return this;
            var e = this.parent && this._ts ? Te(this.parent._time, this) : this._tTime;
            return (
              (this._rts = +t || 0),
              (this._ts = this._ps || t === -bt ? 0 : this._rts),
              (function (t) {
                for (var e = t.parent; e && e.parent; ) (e._dirty = 1), e.totalDuration(), (e = e.parent);
                return t;
              })(this.totalTime(Ve(-this._delay, this._tDur, e), !0))
            );
          }),
          (e.paused = function (t) {
            return arguments.length
              ? (this._ps !== t &&
                  ((this._ps = t),
                  t
                    ? ((this._pTime = this._tTime || Math.max(-this._delay, this.rawTime())), (this._ts = this._act = 0))
                    : (di(),
                      (this._ts = this._rts),
                      this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && (this._tTime -= bt) && Math.abs(this._zTime) !== bt))),
                this)
              : this._ps;
          }),
          (e.startTime = function (t) {
            if (arguments.length) {
              this._start = t;
              var e = this.parent || this._dp;
              return e && (e._sort || !this.parent) && Ie(e, this, t - this._delay), this;
            }
            return this._start;
          }),
          (e.endTime = function (t) {
            return this._start + (It(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
          }),
          (e.rawTime = function (t) {
            var e = this.parent || this._dp;
            return e ? (t && (!this._ts || (this._repeat && this._time && this.totalProgress() < 1)) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Te(e.rawTime(t), this) : this._tTime) : this._tTime;
          }),
          (e.globalTime = function (t) {
            for (var e = this, i = arguments.length ? t : e.rawTime(); e; ) (i = e._start + i / (e._ts || 1)), (e = e._dp);
            return i;
          }),
          (e.repeat = function (t) {
            return arguments.length ? ((this._repeat = t === 1 / 0 ? -2 : t), Oe(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
          }),
          (e.repeatDelay = function (t) {
            return arguments.length ? ((this._rDelay = t), Oe(this)) : this._rDelay;
          }),
          (e.yoyo = function (t) {
            return arguments.length ? ((this._yoyo = t), this) : this._yoyo;
          }),
          (e.seek = function (t, e) {
            return this.totalTime(qe(this, t), It(e));
          }),
          (e.restart = function (t, e) {
            return this.play().totalTime(t ? -this._delay : 0, It(e));
          }),
          (e.play = function (t, e) {
            return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
          }),
          (e.reverse = function (t, e) {
            return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
          }),
          (e.pause = function (t, e) {
            return null != t && this.seek(t, e), this.paused(!0);
          }),
          (e.resume = function () {
            return this.paused(!1);
          }),
          (e.reversed = function (t) {
            return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -bt : 0)), this) : this._rts < 0;
          }),
          (e.invalidate = function () {
            return (this._initted = this._act = 0), (this._zTime = -bt), this;
          }),
          (e.isActive = function () {
            var t,
              e = this.parent || this._dp,
              i = this._start;
            return !(e && !(this._ts && this._initted && e.isActive() && (t = e.rawTime(!0)) >= i && t < this.endTime(!0) - bt));
          }),
          (e.eventCallback = function (t, e, i) {
            var a = this.vars;
            return arguments.length > 1 ? (e ? ((a[t] = e), i && (a[t + "Params"] = i), "onUpdate" === t && (this._onUpdate = e)) : delete a[t], this) : a[t];
          }),
          (e.then = function (t) {
            var e = this;
            return new Promise(function (i) {
              var a = Tt(t) ? t : me,
                n = function () {
                  var t = e.then;
                  (e.then = null), Tt(a) && (a = a(e)) && (a.then || a === e) && (e.then = t), i(a), (e.then = t);
                };
              (e._initted && 1 === e.totalProgress() && e._ts >= 0) || (!e._tTime && e._ts < 0) ? n() : (e._prom = n);
            });
          }),
          (e.kill = function () {
            ii(this);
          }),
          t
        );
      })();
    ge(Ei.prototype, { _time: 0, _start: 0, _end: 0, _tTime: 0, _tDur: 0, _dirty: 0, _repeat: 0, _yoyo: !1, parent: null, _initted: !1, _rDelay: 0, _ts: 1, _dp: 0, ratio: 0, _zTime: -bt, _prom: 0, _ps: !1, _rts: 1 });
    var xi = (function (t) {
      function e(e, i) {
        var a;
        return (
          void 0 === e && (e = {}),
          ((a = t.call(this, e, i) || this).labels = {}),
          (a.smoothChildTiming = !!e.smoothChildTiming),
          (a.autoRemoveChildren = !!e.autoRemoveChildren),
          (a._sort = It(e.sortChildren)),
          a.parent && De(a.parent, at(a)),
          e.scrollTrigger && Le(at(a), e.scrollTrigger),
          a
        );
      }
      nt(e, t);
      var i = e.prototype;
      return (
        (i.to = function (t, e, i) {
          return new Ri(t, ue(arguments, 0, this), qe(this, Mt(e) ? arguments[3] : i)), this;
        }),
        (i.from = function (t, e, i) {
          return new Ri(t, ue(arguments, 1, this), qe(this, Mt(e) ? arguments[3] : i)), this;
        }),
        (i.fromTo = function (t, e, i, a) {
          return new Ri(t, ue(arguments, 2, this), qe(this, Mt(e) ? arguments[4] : a)), this;
        }),
        (i.set = function (t, e, i) {
          return (e.duration = 0), (e.parent = this), we(e).repeatDelay || (e.repeat = 0), (e.immediateRender = !!e.immediateRender), new Ri(t, e, qe(this, i), 1), this;
        }),
        (i.call = function (t, e, i) {
          return Ie(this, Ri.delayedCall(0, t, e), qe(this, i));
        }),
        (i.staggerTo = function (t, e, i, a, n, r, s) {
          return (i.duration = e), (i.stagger = i.stagger || a), (i.onComplete = r), (i.onCompleteParams = s), (i.parent = this), new Ri(t, i, qe(this, n)), this;
        }),
        (i.staggerFrom = function (t, e, i, a, n, r, s) {
          return (i.runBackwards = 1), (we(i).immediateRender = It(i.immediateRender)), this.staggerTo(t, e, i, a, n, r, s);
        }),
        (i.staggerFromTo = function (t, e, i, a, n, r, s, o) {
          return (a.startAt = i), (we(a).immediateRender = It(a.immediateRender)), this.staggerTo(t, e, a, n, r, s, o);
        }),
        (i.render = function (t, e, i) {
          var a,
            n,
            r,
            s,
            o,
            l,
            c,
            h,
            u,
            d,
            p,
            f,
            m = this._time,
            g = this._dirty ? this.totalDuration() : this._tDur,
            y = this._dur,
            v = this !== st && t > g - bt && t >= 0 ? g : t < bt ? 0 : t,
            A = this._zTime < 0 != t < 0 && (this._initted || !y);
          if (v !== this._tTime || i || A) {
            if ((m !== this._time && y && ((v += this._time - m), (t += this._time - m)), (a = v), (u = this._start), (l = !(h = this._ts)), A && (y || (m = this._zTime), (t || !e) && (this._zTime = t)), this._repeat)) {
              if (((p = this._yoyo), (o = y + this._rDelay), this._repeat < -1 && t < 0)) return this.totalTime(100 * o + t, e, i);
              if (
                ((a = ce(v % o)),
                v === g ? ((s = this._repeat), (a = y)) : ((s = ~~(v / o)) && s === v / o && ((a = y), s--), a > y && (a = y)),
                (d = _e(this._tTime, o)),
                !m && this._tTime && d !== s && (d = s),
                p && 1 & s && ((a = y - a), (f = 1)),
                s !== d && !this._lock)
              ) {
                var b = p && 1 & d,
                  w = b === (p && 1 & s);
                if (
                  (s < d && (b = !b),
                  (m = b ? 0 : y),
                  (this._lock = 1),
                  (this.render(m || (f ? 0 : ce(s * o)), e, !y)._lock = 0),
                  !e && this.parent && ei(this, "onRepeat"),
                  this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1),
                  (m && m !== this._time) || l !== !this._ts || (this.vars.onRepeat && !this.parent && !this._act))
                )
                  return this;
                if (((y = this._dur), (g = this._tDur), w && ((this._lock = 2), (m = b ? y : -1e-4), this.render(m, !0)), (this._lock = 0), !this._ts && !l)) return this;
                vi(this, f);
              }
            }
            if (
              (this._hasPause &&
                !this._forcing &&
                this._lock < 2 &&
                (c = (function (t, e, i) {
                  var a;
                  if (i > e)
                    for (a = t._first; a && a._start <= i; ) {
                      if (!a._dur && "isPause" === a.data && a._start > e) return a;
                      a = a._next;
                    }
                  else
                    for (a = t._last; a && a._start >= i; ) {
                      if (!a._dur && "isPause" === a.data && a._start < e) return a;
                      a = a._prev;
                    }
                })(this, ce(m), ce(a))) &&
                (v -= a - (a = c._start)),
              (this._tTime = v),
              (this._time = a),
              (this._act = !h),
              this._initted || ((this._onUpdate = this.vars.onUpdate), (this._initted = 1), (this._zTime = t), (m = 0)),
              !m && a && !e && ei(this, "onStart"),
              a >= m && t >= 0)
            )
              for (n = this._first; n; ) {
                if (((r = n._next), (n._act || a >= n._start) && n._ts && c !== n)) {
                  if (n.parent !== this) return this.render(t, e, i);
                  if ((n.render(n._ts > 0 ? (a - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (a - n._start) * n._ts, e, i), a !== this._time || (!this._ts && !l))) {
                    (c = 0), r && (v += this._zTime = -bt);
                    break;
                  }
                }
                n = r;
              }
            else {
              n = this._last;
              for (var C = t < 0 ? t : a; n; ) {
                if (((r = n._prev), (n._act || C <= n._end) && n._ts && c !== n)) {
                  if (n.parent !== this) return this.render(t, e, i);
                  if ((n.render(n._ts > 0 ? (C - n._start) * n._ts : (n._dirty ? n.totalDuration() : n._tDur) + (C - n._start) * n._ts, e, i), a !== this._time || (!this._ts && !l))) {
                    (c = 0), r && (v += this._zTime = C ? -bt : bt);
                    break;
                  }
                }
                n = r;
              }
            }
            if (c && !e && (this.pause(), (c.render(a >= m ? 0 : -bt)._zTime = a >= m ? 1 : -1), this._ts)) return (this._start = u), Me(this), this.render(t, e, i);
            this._onUpdate && !e && ei(this, "onUpdate", !0),
              ((v === g && g >= this.totalDuration()) || (!v && m)) &&
                ((u !== this._start && Math.abs(h) === Math.abs(this._ts)) ||
                  this._lock ||
                  ((t || !y) && ((v === g && this._ts > 0) || (!v && this._ts < 0)) && Se(this, 1),
                  e || (t < 0 && !m) || (!v && !m) || (ei(this, v === g ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < g && this.timeScale() > 0) && this._prom())));
          }
          return this;
        }),
        (i.add = function (t, e) {
          var i = this;
          if ((Mt(e) || (e = qe(this, e)), !(t instanceof Ei))) {
            if (Ot(t))
              return (
                t.forEach(function (t) {
                  return i.add(t, e);
                }),
                this
              );
            if (_t(t)) return this.addLabel(t, e);
            if (!Tt(t)) return this;
            t = Ri.delayedCall(0, t);
          }
          return this !== t ? Ie(this, t, e) : this;
        }),
        (i.getChildren = function (t, e, i, a) {
          void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === a && (a = -1e8);
          for (var n = [], r = this._first; r; ) r._start >= a && (r instanceof Ri ? e && n.push(r) : (i && n.push(r), t && n.push.apply(n, r.getChildren(!0, e, i)))), (r = r._next);
          return n;
        }),
        (i.getById = function (t) {
          for (var e = this.getChildren(1, 1, 1), i = e.length; i--; ) if (e[i].vars.id === t) return e[i];
        }),
        (i.remove = function (t) {
          return _t(t) ? this.removeLabel(t) : Tt(t) ? this.killTweensOf(t) : (Ce(this, t), t === this._recent && (this._recent = this._last), ke(this));
        }),
        (i.totalTime = function (e, i) {
          return arguments.length
            ? ((this._forcing = 1), !this._dp && this._ts && (this._start = ce(ui.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t.prototype.totalTime.call(this, e, i), (this._forcing = 0), this)
            : this._tTime;
        }),
        (i.addLabel = function (t, e) {
          return (this.labels[t] = qe(this, e)), this;
        }),
        (i.removeLabel = function (t) {
          return delete this.labels[t], this;
        }),
        (i.addPause = function (t, e, i) {
          var a = Ri.delayedCall(0, e || Qt, i);
          return (a.data = "isPause"), (this._hasPause = 1), Ie(this, a, qe(this, t));
        }),
        (i.removePause = function (t) {
          var e = this._first;
          for (t = qe(this, t); e; ) e._start === t && "isPause" === e.data && Se(e), (e = e._next);
        }),
        (i.killTweensOf = function (t, e, i) {
          for (var a = this.getTweensOf(t, i), n = a.length; n--; ) _i !== a[n] && a[n].kill(t, e);
          return this;
        }),
        (i.getTweensOf = function (t, e) {
          for (var i, a = [], n = Ke(t), r = this._first, s = Mt(e); r; )
            r instanceof Ri
              ? he(r._targets, n) && (s ? (!_i || (r._initted && r._ts)) && r.globalTime(0) <= e && r.globalTime(r.totalDuration()) > e : !e || r.isActive()) && a.push(r)
              : (i = r.getTweensOf(n, e)).length && a.push.apply(a, i),
              (r = r._next);
          return a;
        }),
        (i.tweenTo = function (t, e) {
          e = e || {};
          var i = this,
            a = qe(i, t),
            n = e,
            r = n.startAt,
            s = n.onStart,
            o = n.onStartParams,
            l = n.immediateRender,
            c = Ri.to(
              i,
              ge(
                {
                  ease: e.ease || "none",
                  lazy: !1,
                  immediateRender: !1,
                  time: a,
                  overwrite: "auto",
                  duration: e.duration || Math.abs((a - (r && "time" in r ? r.time : i._time)) / i.timeScale()) || bt,
                  onStart: function () {
                    i.pause();
                    var t = e.duration || Math.abs((a - i._time) / i.timeScale());
                    c._dur !== t && Fe(c, t, 0, 1).render(c._time, !0, !0), s && s.apply(c, o || []);
                  },
                },
                e
              )
            );
          return l ? c.render(0) : c;
        }),
        (i.tweenFromTo = function (t, e, i) {
          return this.tweenTo(e, ge({ startAt: { time: qe(this, t) } }, i));
        }),
        (i.recent = function () {
          return this._recent;
        }),
        (i.nextLabel = function (t) {
          return void 0 === t && (t = this._time), ti(this, qe(this, t));
        }),
        (i.previousLabel = function (t) {
          return void 0 === t && (t = this._time), ti(this, qe(this, t), 1);
        }),
        (i.currentLabel = function (t) {
          return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + bt);
        }),
        (i.shiftChildren = function (t, e, i) {
          void 0 === i && (i = 0);
          for (var a, n = this._first, r = this.labels; n; ) n._start >= i && ((n._start += t), (n._end += t)), (n = n._next);
          if (e) for (a in r) r[a] >= i && (r[a] += t);
          return ke(this);
        }),
        (i.invalidate = function () {
          var e = this._first;
          for (this._lock = 0; e; ) e.invalidate(), (e = e._next);
          return t.prototype.invalidate.call(this);
        }),
        (i.clear = function (t) {
          void 0 === t && (t = !0);
          for (var e, i = this._first; i; ) (e = i._next), this.remove(i), (i = e);
          return this._dp && (this._time = this._tTime = this._pTime = 0), t && (this.labels = {}), ke(this);
        }),
        (i.totalDuration = function (t) {
          var e,
            i,
            a,
            n = 0,
            r = this._last,
            s = 1e8;
          if (arguments.length) return this.timeScale((this._repeat < 0 ? this.duration() : this.totalDuration()) / (this.reversed() ? -t : t));
          if (this._dirty) {
            for (a = this.parent; r; )
              (e = r._prev),
                r._dirty && r.totalDuration(),
                (i = r._start) > s && this._sort && r._ts && !this._lock ? ((this._lock = 1), (Ie(this, r, i - r._delay, 1)._lock = 0)) : (s = i),
                i < 0 && r._ts && ((n -= i), ((!a && !this._dp) || (a && a.smoothChildTiming)) && ((this._start += i / this._ts), (this._time -= i), (this._tTime -= i)), this.shiftChildren(-i, !1, -Infinity), (s = 0)),
                r._end > n && r._ts && (n = r._end),
                (r = e);
            Fe(this, this === st && this._time > n ? this._time : n, 1, 1), (this._dirty = 0);
          }
          return this._tDur;
        }),
        (e.updateRoot = function (t) {
          if ((st._ts && (pe(st, Te(t, st)), (ut = ui.frame)), ui.frame >= ie)) {
            ie += vt.autoSleep || 120;
            var e = st._first;
            if ((!e || !e._ts) && vt.autoSleep && ui._listeners.length < 2) {
              for (; e && !e._ts; ) e = e._next;
              e || ui.sleep();
            }
          }
        }),
        e
      );
    })(Ei);
    ge(xi.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
    var _i,
      Ti = function (t, e, i, a, n, r, s, o, l) {
        Tt(a) && (a = a(n || 0, t, r));
        var c,
          h = t[e],
          u = "get" !== i ? i : Tt(h) ? (l ? t[e.indexOf("set") || !Tt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]()) : h,
          d = Tt(h) ? (l ? Bi : Oi) : Fi;
        if ((_t(a) && (~a.indexOf("random(") && (a = Ze(a)), "=" === a.charAt(1) && (a = parseFloat(u) + parseFloat(a.substr(2)) * ("-" === a.charAt(0) ? -1 : 1) + (We(u) || 0))), u !== a))
          return isNaN(u * a)
            ? (!h && !(e in t) && jt(e, a),
              function (t, e, i, a, n, r, s) {
                var o,
                  l,
                  c,
                  h,
                  u,
                  d,
                  p,
                  f,
                  m = new Hi(this._pt, t, e, 0, 1, Ui, null, n),
                  g = 0,
                  y = 0;
                for (m.b = i, m.e = a, i += "", (p = ~(a += "").indexOf("random(")) && (a = Ze(a)), r && (r((f = [i, a]), t, e), (i = f[0]), (a = f[1])), l = i.match(Vt) || []; (o = Vt.exec(a)); )
                  (h = o[0]),
                    (u = a.substring(g, o.index)),
                    c ? (c = (c + 1) % 5) : "rgba(" === u.substr(-5) && (c = 1),
                    h !== l[y++] &&
                      ((d = parseFloat(l[y - 1]) || 0),
                      (m._pt = { _next: m._pt, p: u || 1 === y ? u : ",", s: d, c: "=" === h.charAt(1) ? parseFloat(h.substr(2)) * ("-" === h.charAt(0) ? -1 : 1) : parseFloat(h) - d, m: c && c < 4 ? Math.round : 0 }),
                      (g = Vt.lastIndex));
                return (m.c = g < a.length ? a.substring(g, a.length) : ""), (m.fp = s), (Wt.test(a) || p) && (m.e = 0), (this._pt = m), m;
              }.call(this, t, e, u, a, d, o || vt.stringFilter, l))
            : ((c = new Hi(this._pt, t, e, +u || 0, a - (u || 0), "boolean" == typeof h ? Wi : Vi, 0, d)), l && (c.fp = l), s && c.modifier(s, this, t), (this._pt = c));
      },
      Mi = function (t, e, i, a, n, r) {
        var s, o, l, c;
        if (
          te[t] &&
          !1 !==
            (s = new te[t]()).init(
              n,
              s.rawVars
                ? e[t]
                : (function (t, e, i, a, n) {
                    if ((Tt(t) && (t = Di(t, n, e, i, a)), !Dt(t) || (t.style && t.nodeType) || Ot(t) || Ft(t))) return _t(t) ? Di(t, n, e, i, a) : t;
                    var r,
                      s = {};
                    for (r in t) s[r] = Di(t[r], n, e, i, a);
                    return s;
                  })(e[t], a, n, r, i),
              i,
              a,
              r
            ) &&
          ((i._pt = o = new Hi(i._pt, n, t, 0, 1, s.render, s, 0, s.priority)), i !== dt)
        )
          for (l = i._ptLookup[i._targets.indexOf(n)], c = s._props.length; c--; ) l[s._props[c]] = o;
        return s;
      },
      Pi = function t(e, i) {
        var a,
          n,
          r,
          s,
          o,
          l,
          c,
          h,
          u,
          d,
          p,
          f,
          m,
          g = e.vars,
          y = g.ease,
          v = g.startAt,
          A = g.immediateRender,
          b = g.lazy,
          w = g.onUpdate,
          C = g.onUpdateParams,
          S = g.callbackScope,
          k = g.runBackwards,
          E = g.yoyoEase,
          x = g.keyframes,
          _ = g.autoRevert,
          T = e._dur,
          M = e._startAt,
          P = e._targets,
          D = e.parent,
          I = D && "nested" === D.data ? D.parent._targets : P,
          L = "auto" === e._overwrite && !rt,
          R = e.timeline;
        if ((R && (!x || !y) && (y = "none"), (e._ease = Ai(y, At.ease)), (e._yEase = E ? yi(Ai(!0 === E ? y : E, At.ease)) : 0), E && e._yoyo && !e._repeat && ((E = e._yEase), (e._yEase = e._ease), (e._ease = E)), !R)) {
          if (((f = (h = P[0] ? se(P[0]).harness : 0) && g[h.prop]), (a = be(g, Xt)), M && M.render(-1, !0).kill(), v))
            if ((Se((e._startAt = Ri.set(P, ge({ data: "isStart", overwrite: !1, parent: D, immediateRender: !0, lazy: It(b), startAt: null, delay: 0, onUpdate: w, onUpdateParams: C, callbackScope: S, stagger: 0 }, v)))), A)) {
              if (i > 0) _ || (e._startAt = 0);
              else if (T && !(i < 0 && M)) return void (i && (e._zTime = i));
            } else !1 === _ && (e._startAt = 0);
          else if (k && T)
            if (M) !_ && (e._startAt = 0);
            else if ((i && (A = !1), (r = ge({ overwrite: !1, data: "isFromStart", lazy: A && It(b), immediateRender: A, stagger: 0, parent: D }, a)), f && (r[h.prop] = f), Se((e._startAt = Ri.set(P, r))), A)) {
              if (!i) return;
            } else t(e._startAt, bt);
          for (e._pt = 0, b = (T && It(b)) || (b && !T), n = 0; n < P.length; n++) {
            if (
              ((c = (o = P[n])._gsap || re(P)[n]._gsap),
              (e._ptLookup[n] = d = {}),
              $t[c.id] && Zt.length && de(),
              (p = I === P ? n : I.indexOf(o)),
              h &&
                !1 !== (u = new h()).init(o, f || a, e, p, I) &&
                ((e._pt = s = new Hi(e._pt, o, u.name, 0, 1, u.render, u, 0, u.priority)),
                u._props.forEach(function (t) {
                  d[t] = s;
                }),
                u.priority && (l = 1)),
              !h || f)
            )
              for (r in a) te[r] && (u = Mi(r, a, e, p, o, I)) ? u.priority && (l = 1) : (d[r] = s = Ti.call(e, o, r, "get", a[r], p, I, 0, g.stringFilter));
            e._op && e._op[n] && e.kill(o, e._op[n]), L && e._pt && ((_i = e), st.killTweensOf(o, d, e.globalTime(0)), (m = !e.parent), (_i = 0)), e._pt && b && ($t[c.id] = 1);
          }
          l && ji(e), e._onInit && e._onInit(e);
        }
        (e._from = !R && !!g.runBackwards), (e._onUpdate = w), (e._initted = (!e._op || e._pt) && !m);
      },
      Di = function (t, e, i, a, n) {
        return Tt(t) ? t.call(e, i, a, n) : _t(t) && ~t.indexOf("random(") ? Ze(t) : t;
      },
      Ii = ne + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
      Li = (Ii + ",id,stagger,delay,duration,paused,scrollTrigger").split(","),
      Ri = (function (t) {
        function e(e, i, a, n) {
          var r;
          "number" == typeof i && ((a.duration = i), (i = a), (a = null));
          var s,
            o,
            l,
            c,
            h,
            u,
            d,
            p,
            f = (r = t.call(this, n ? i : we(i), a) || this).vars,
            m = f.duration,
            g = f.delay,
            y = f.immediateRender,
            v = f.stagger,
            A = f.overwrite,
            b = f.keyframes,
            w = f.defaults,
            C = f.scrollTrigger,
            S = f.yoyoEase,
            k = r.parent,
            E = (Ot(e) || Ft(e) ? Mt(e[0]) : "length" in i) ? [e] : Ke(e);
          if (((r._targets = E.length ? re(E) : Ht("GSAP target " + e + " not found. https://greensock.com", !vt.nullTargetWarn) || []), (r._ptLookup = []), (r._overwrite = A), b || v || Rt(m) || Rt(g))) {
            if (((i = r.vars), (s = r.timeline = new xi({ data: "nested", defaults: w || {} })).kill(), (s.parent = s._dp = at(r)), (s._start = 0), b))
              ge(s.vars.defaults, { ease: "none" }),
                b.forEach(function (t) {
                  return s.to(E, t, ">");
                });
            else {
              if (((c = E.length), (d = v ? je(v) : Qt), Dt(v))) for (h in v) ~Ii.indexOf(h) && (p || (p = {}), (p[h] = v[h]));
              for (o = 0; o < c; o++) {
                for (h in ((l = {}), i)) Li.indexOf(h) < 0 && (l[h] = i[h]);
                (l.stagger = 0),
                  S && (l.yoyoEase = S),
                  p && ve(l, p),
                  (u = E[o]),
                  (l.duration = +Di(m, at(r), o, u, E)),
                  (l.delay = (+Di(g, at(r), o, u, E) || 0) - r._delay),
                  !v && 1 === c && l.delay && ((r._delay = g = l.delay), (r._start += g), (l.delay = 0)),
                  s.to(u, l, d(o, u, E));
              }
              s.duration() ? (m = g = 0) : (r.timeline = 0);
            }
            m || r.duration((m = s.duration()));
          } else r.timeline = 0;
          return (
            !0 !== A || rt || ((_i = at(r)), st.killTweensOf(E), (_i = 0)),
            k && De(k, at(r)),
            (y || (!m && !b && r._start === ce(k._time) && It(y) && Ee(at(r)) && "nested" !== k.data)) && ((r._tTime = -bt), r.render(Math.max(0, -g))),
            C && Le(at(r), C),
            r
          );
        }
        nt(e, t);
        var i = e.prototype;
        return (
          (i.render = function (t, e, i) {
            var a,
              n,
              r,
              s,
              o,
              l,
              c,
              h,
              u,
              d = this._time,
              p = this._tDur,
              f = this._dur,
              m = t > p - bt && t >= 0 ? p : t < bt ? 0 : t;
            if (f) {
              if (m !== this._tTime || !t || i || (!this._initted && this._tTime) || (this._startAt && this._zTime < 0 != t < 0)) {
                if (((a = m), (h = this.timeline), this._repeat)) {
                  if (((s = f + this._rDelay), this._repeat < -1 && t < 0)) return this.totalTime(100 * s + t, e, i);
                  if (
                    ((a = ce(m % s)),
                    m === p ? ((r = this._repeat), (a = f)) : ((r = ~~(m / s)) && r === m / s && ((a = f), r--), a > f && (a = f)),
                    (l = this._yoyo && 1 & r) && ((u = this._yEase), (a = f - a)),
                    (o = _e(this._tTime, s)),
                    a === d && !i && this._initted)
                  )
                    return this;
                  r !== o && (h && this._yEase && vi(h, l), !this.vars.repeatRefresh || l || this._lock || ((this._lock = i = 1), (this.render(ce(s * r), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (Re(this, t < 0 ? t : a, i, e)) return (this._tTime = 0), this;
                  if (f !== this._dur) return this.render(t, e, i);
                }
                for (
                  this._tTime = m,
                    this._time = a,
                    !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                    this.ratio = c = (u || this._ease)(a / f),
                    this._from && (this.ratio = c = 1 - c),
                    a && !d && !e && ei(this, "onStart"),
                    n = this._pt;
                  n;

                )
                  n.r(c, n.d), (n = n._next);
                (h && h.render(t < 0 ? t : !a && l ? -bt : h._dur * c, e, i)) || (this._startAt && (this._zTime = t)),
                  this._onUpdate && !e && (t < 0 && this._startAt && this._startAt.render(t, !0, i), ei(this, "onUpdate")),
                  this._repeat && r !== o && this.vars.onRepeat && !e && this.parent && ei(this, "onRepeat"),
                  (m !== this._tDur && m) ||
                    this._tTime !== m ||
                    (t < 0 && this._startAt && !this._onUpdate && this._startAt.render(t, !0, !0),
                    (t || !f) && ((m === this._tDur && this._ts > 0) || (!m && this._ts < 0)) && Se(this, 1),
                    e || (t < 0 && !d) || (!m && !d) || (ei(this, m === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < p && this.timeScale() > 0) && this._prom()));
              }
            } else
              !(function (t, e, i, a) {
                var n,
                  r,
                  s,
                  o = t.ratio,
                  l =
                    e < 0 ||
                    (!e &&
                      ((!t._start &&
                        (function t(e) {
                          var i = e.parent;
                          return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t(i));
                        })(t)) ||
                        ((t._ts < 0 || t._dp._ts < 0) && "isFromStart" !== t.data && "isStart" !== t.data)))
                      ? 0
                      : 1,
                  c = t._rDelay,
                  h = 0;
                if (
                  (c && t._repeat && ((h = Ve(0, t._tDur, e)), (r = _e(h, c)), (s = _e(t._tTime, c)), t._yoyo && 1 & r && (l = 1 - l), r !== s && ((o = 1 - l), t.vars.repeatRefresh && t._initted && t.invalidate())),
                  l !== o || a || t._zTime === bt || (!e && t._zTime))
                ) {
                  if (!t._initted && Re(t, e, a, i)) return;
                  for (s = t._zTime, t._zTime = e || (i ? bt : 0), i || (i = e && !s), t.ratio = l, t._from && (l = 1 - l), t._time = 0, t._tTime = h, n = t._pt; n; ) n.r(l, n.d), (n = n._next);
                  t._startAt && e < 0 && t._startAt.render(e, !0, !0),
                    t._onUpdate && !i && ei(t, "onUpdate"),
                    h && t._repeat && !i && t.parent && ei(t, "onRepeat"),
                    (e >= t._tDur || e < 0) && t.ratio === l && (l && Se(t, 1), i || (ei(t, l ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
                } else t._zTime || (t._zTime = e);
              })(this, t, e, i);
            return this;
          }),
          (i.targets = function () {
            return this._targets;
          }),
          (i.invalidate = function () {
            return (this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0), (this._ptLookup = []), this.timeline && this.timeline.invalidate(), t.prototype.invalidate.call(this);
          }),
          (i.kill = function (t, e) {
            if ((void 0 === e && (e = "all"), !(t || (e && "all" !== e)))) return (this._lazy = this._pt = 0), this.parent ? ii(this) : this;
            if (this.timeline) {
              var i = this.timeline.totalDuration();
              return this.timeline.killTweensOf(t, e, _i && !0 !== _i.vars.overwrite)._first || ii(this), this.parent && i !== this.timeline.totalDuration() && Fe(this, (this._dur * this.timeline._tDur) / i, 0, 1), this;
            }
            var a,
              n,
              r,
              s,
              o,
              l,
              c,
              h = this._targets,
              u = t ? Ke(t) : h,
              d = this._ptLookup,
              p = this._pt;
            if (
              (!e || "all" === e) &&
              (function (t, e) {
                for (var i = t.length, a = i === e.length; a && i-- && t[i] === e[i]; );
                return i < 0;
              })(h, u)
            )
              return "all" === e && (this._pt = 0), ii(this);
            for (
              a = this._op = this._op || [],
                "all" !== e &&
                  (_t(e) &&
                    ((o = {}),
                    le(e, function (t) {
                      return (o[t] = 1);
                    }),
                    (e = o)),
                  (e = (function (t, e) {
                    var i,
                      a,
                      n,
                      r,
                      s = t[0] ? se(t[0]).harness : 0,
                      o = s && s.aliases;
                    if (!o) return e;
                    for (a in ((i = ve({}, e)), o)) if ((a in i)) for (n = (r = o[a].split(",")).length; n--; ) i[r[n]] = i[a];
                    return i;
                  })(h, e))),
                c = h.length;
              c--;

            )
              if (~u.indexOf(h[c]))
                for (o in ((n = d[c]), "all" === e ? ((a[c] = e), (s = n), (r = {})) : ((r = a[c] = a[c] || {}), (s = e)), s))
                  (l = n && n[o]) && (("kill" in l.d && !0 !== l.d.kill(o)) || Ce(this, l, "_pt"), delete n[o]), "all" !== r && (r[o] = 1);
            return this._initted && !this._pt && p && ii(this), this;
          }),
          (e.to = function (t, i) {
            return new e(t, i, arguments[2]);
          }),
          (e.from = function (t, i) {
            return new e(t, ue(arguments, 1));
          }),
          (e.delayedCall = function (t, i, a, n) {
            return new e(i, 0, { immediateRender: !1, lazy: !1, overwrite: !1, delay: t, onComplete: i, onReverseComplete: i, onCompleteParams: a, onReverseCompleteParams: a, callbackScope: n });
          }),
          (e.fromTo = function (t, i, a) {
            return new e(t, ue(arguments, 2));
          }),
          (e.set = function (t, i) {
            return (i.duration = 0), i.repeatDelay || (i.repeat = 0), new e(t, i);
          }),
          (e.killTweensOf = function (t, e, i) {
            return st.killTweensOf(t, e, i);
          }),
          e
        );
      })(Ei);
    ge(Ri.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }),
      le("staggerTo,staggerFrom,staggerFromTo", function (t) {
        Ri[t] = function () {
          var e = new xi(),
            i = Ue.call(arguments, 0);
          return i.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, i);
        };
      });
    var Fi = function (t, e, i) {
        return (t[e] = i);
      },
      Oi = function (t, e, i) {
        return t[e](i);
      },
      Bi = function (t, e, i, a) {
        return t[e](a.fp, i);
      },
      qi = function (t, e, i) {
        return t.setAttribute(e, i);
      },
      Ni = function (t, e) {
        return Tt(t[e]) ? Oi : Pt(t[e]) && t.setAttribute ? qi : Fi;
      },
      Vi = function (t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4, e);
      },
      Wi = function (t, e) {
        return e.set(e.t, e.p, !!(e.s + e.c * t), e);
      },
      Ui = function (t, e) {
        var i = e._pt,
          a = "";
        if (!t && e.b) a = e.b;
        else if (1 === t && e.e) a = e.e;
        else {
          for (; i; ) (a = i.p + (i.m ? i.m(i.s + i.c * t) : Math.round(1e4 * (i.s + i.c * t)) / 1e4) + a), (i = i._next);
          a += e.c;
        }
        e.set(e.t, e.p, a, e);
      },
      Ji = function (t, e) {
        for (var i = e._pt; i; ) i.r(t, i.d), (i = i._next);
      },
      zi = function (t, e, i, a) {
        for (var n, r = this._pt; r; ) (n = r._next), r.p === a && r.modifier(t, e, i), (r = n);
      },
      Ki = function (t) {
        for (var e, i, a = this._pt; a; ) (i = a._next), (a.p === t && !a.op) || a.op === t ? Ce(this, a, "_pt") : a.dep || (e = 1), (a = i);
        return !e;
      },
      Gi = function (t, e, i, a) {
        a.mSet(t, e, a.m.call(a.tween, i, a.mt), a);
      },
      ji = function (t) {
        for (var e, i, a, n, r = t._pt; r; ) {
          for (e = r._next, i = a; i && i.pr > r.pr; ) i = i._next;
          (r._prev = i ? i._prev : n) ? (r._prev._next = r) : (a = r), (r._next = i) ? (i._prev = r) : (n = r), (r = e);
        }
        t._pt = a;
      },
      Hi = (function () {
        function t(t, e, i, a, n, r, s, o, l) {
          (this.t = e), (this.s = a), (this.c = n), (this.p = i), (this.r = r || Vi), (this.d = s || this), (this.set = o || Fi), (this.pr = l || 0), (this._next = t), t && (t._prev = this);
        }
        return (
          (t.prototype.modifier = function (t, e, i) {
            (this.mSet = this.mSet || this.set), (this.set = Gi), (this.m = t), (this.mt = i), (this.tween = e);
          }),
          t
        );
      })();
    le(
      ne +
        "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
      function (t) {
        return (Xt[t] = 1);
      }
    ),
      (zt.TweenMax = zt.TweenLite = Ri),
      (zt.TimelineLite = zt.TimelineMax = xi),
      (st = new xi({ sortChildren: !1, defaults: At, autoRemoveChildren: !0, id: "root", smoothChildTiming: !0 })),
      (vt.stringFilter = hi);
    var Yi = {
      registerPlugin: function () {
        for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
        e.forEach(function (t) {
          return (function (t) {
            var e = (t = (!t.name && t.default) || t).name,
              i = Tt(t),
              a =
                e && !i && t.init
                  ? function () {
                      this._props = [];
                    }
                  : t,
              n = { init: Qt, render: Ji, add: Ti, kill: Ki, modifier: zi, rawVars: 0 },
              r = { targetTest: 0, get: 0, getSetter: Ni, aliases: {}, register: 0 };
            if ((di(), t !== a)) {
              if (te[e]) return;
              ge(a, ge(be(t, n), r)), ve(a.prototype, ve(n, be(t, r))), (te[(a.prop = e)] = a), t.targetTest && (ae.push(a), (Xt[e] = 1)), (e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin");
            }
            Yt(e, a), t.register && t.register(Zi, a, Hi);
          })(t);
        });
      },
      timeline: function (t) {
        return new xi(t);
      },
      getTweensOf: function (t, e) {
        return st.getTweensOf(t, e);
      },
      getProperty: function (t, e, i, a) {
        _t(t) && (t = Ke(t)[0]);
        var n = se(t || {}).get,
          r = i ? me : fe;
        return (
          "native" === i && (i = ""),
          t
            ? e
              ? r(((te[e] && te[e].get) || n)(t, e, i, a))
              : function (e, i, a) {
                  return r(((te[e] && te[e].get) || n)(t, e, i, a));
                }
            : t
        );
      },
      quickSetter: function (t, e, i) {
        if ((t = Ke(t)).length > 1) {
          var a = t.map(function (t) {
              return Zi.quickSetter(t, e, i);
            }),
            n = a.length;
          return function (t) {
            for (var e = n; e--; ) a[e](t);
          };
        }
        t = t[0] || {};
        var r = te[e],
          s = se(t),
          o = (s.harness && (s.harness.aliases || {})[e]) || e,
          l = r
            ? function (e) {
                var a = new r();
                (dt._pt = 0), a.init(t, i ? e + i : e, dt, 0, [t]), a.render(1, a), dt._pt && Ji(1, dt);
              }
            : s.set(t, o);
        return r
          ? l
          : function (e) {
              return l(t, o, i ? e + i : e, s, 1);
            };
      },
      isTweening: function (t) {
        return st.getTweensOf(t, !0).length > 0;
      },
      defaults: function (t) {
        return t && t.ease && (t.ease = Ai(t.ease, At.ease)), Ae(At, t || {});
      },
      config: function (t) {
        return Ae(vt, t || {});
      },
      registerEffect: function (t) {
        var e = t.name,
          i = t.effect,
          a = t.plugins,
          n = t.defaults,
          r = t.extendTimeline;
        (a || "").split(",").forEach(function (t) {
          return t && !te[t] && !zt[t] && Ht(e + " effect requires " + t + " plugin.");
        }),
          (ee[e] = function (t, e, a) {
            return i(Ke(t), ge(e || {}, n), a);
          }),
          r &&
            (xi.prototype[e] = function (t, i, a) {
              return this.add(ee[e](t, Dt(i) ? i : (a = i) && {}, this), a);
            });
      },
      registerEase: function (t, e) {
        pi[t] = Ai(e);
      },
      parseEase: function (t, e) {
        return arguments.length ? Ai(t, e) : pi;
      },
      getById: function (t) {
        return st.getById(t);
      },
      exportRoot: function (t, e) {
        void 0 === t && (t = {});
        var i,
          a,
          n = new xi(t);
        for (n.smoothChildTiming = It(t.smoothChildTiming), st.remove(n), n._dp = 0, n._time = n._tTime = st._time, i = st._first; i; )
          (a = i._next), (!e && !i._dur && i instanceof Ri && i.vars.onComplete === i._targets[0]) || Ie(n, i, i._start - i._delay), (i = a);
        return Ie(st, n, 0), n;
      },
      utils: {
        wrap: function t(e, i, a) {
          var n = i - e;
          return Ot(e)
            ? Xe(e, t(0, e.length), i)
            : Ne(a, function (t) {
                return ((n + ((t - e) % n)) % n) + e;
              });
        },
        wrapYoyo: function t(e, i, a) {
          var n = i - e,
            r = 2 * n;
          return Ot(e)
            ? Xe(e, t(0, e.length - 1), i)
            : Ne(a, function (t) {
                return e + ((t = (r + ((t - e) % r)) % r || 0) > n ? r - t : t);
              });
        },
        distribute: je,
        random: Qe,
        snap: Ye,
        normalize: function (t, e, i) {
          return $e(t, e, 0, 1, i);
        },
        getUnit: We,
        clamp: function (t, e, i) {
          return Ne(i, function (i) {
            return Ve(t, e, i);
          });
        },
        splitColor: ri,
        toArray: Ke,
        mapRange: $e,
        pipe: function () {
          for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
          return function (t) {
            return e.reduce(function (t, e) {
              return e(t);
            }, t);
          };
        },
        unitize: function (t, e) {
          return function (i) {
            return t(parseFloat(i)) + (e || We(i));
          };
        },
        interpolate: function t(e, i, a, n) {
          var r = isNaN(e + i)
            ? 0
            : function (t) {
                return (1 - t) * e + t * i;
              };
          if (!r) {
            var s,
              o,
              l,
              c,
              h,
              u = _t(e),
              d = {};
            if ((!0 === a && (n = 1) && (a = null), u)) (e = { p: e }), (i = { p: i });
            else if (Ot(e) && !Ot(i)) {
              for (l = [], c = e.length, h = c - 2, o = 1; o < c; o++) l.push(t(e[o - 1], e[o]));
              c--,
                (r = function (t) {
                  t *= c;
                  var e = Math.min(h, ~~t);
                  return l[e](t - e);
                }),
                (a = i);
            } else n || (e = ve(Ot(e) ? [] : {}, e));
            if (!l) {
              for (s in i) Ti.call(d, e, s, "get", i[s]);
              r = function (t) {
                return Ji(t, d) || (u ? e.p : e);
              };
            }
          }
          return Ne(a, r);
        },
        shuffle: Ge,
      },
      install: Gt,
      effects: ee,
      ticker: ui,
      updateRoot: xi.updateRoot,
      plugins: te,
      globalTimeline: st,
      core: {
        PropTween: Hi,
        globals: Yt,
        Tween: Ri,
        Timeline: xi,
        Animation: Ei,
        getCache: se,
        _removeLinkedListItem: Ce,
        suppressOverwrites: function (t) {
          return (rt = t);
        },
      },
    };
    le("to,from,fromTo,delayedCall,set,killTweensOf", function (t) {
      return (Yi[t] = Ri[t]);
    }),
      ui.add(xi.updateRoot),
      (dt = Yi.to({}, { duration: 0 }));
    var Qi = function (t, e) {
        for (var i = t._pt; i && i.p !== e && i.op !== e && i.fp !== e; ) i = i._next;
        return i;
      },
      Xi = function (t, e) {
        return {
          name: t,
          rawVars: 1,
          init: function (t, i, a) {
            a._onInit = function (t) {
              var a, n;
              if (
                (_t(i) &&
                  ((a = {}),
                  le(i, function (t) {
                    return (a[t] = 1);
                  }),
                  (i = a)),
                e)
              ) {
                for (n in ((a = {}), i)) a[n] = e(i[n]);
                i = a;
              }
              !(function (t, e) {
                var i,
                  a,
                  n,
                  r = t._targets;
                for (i in e) for (a = r.length; a--; ) (n = t._ptLookup[a][i]) && (n = n.d) && (n._pt && (n = Qi(n, i)), n && n.modifier && n.modifier(e[i], t, r[a], i));
              })(t, i);
            };
          },
        };
      },
      Zi =
        Yi.registerPlugin(
          {
            name: "attr",
            init: function (t, e, i, a, n) {
              var r, s;
              for (r in e) (s = this.add(t, "setAttribute", (t.getAttribute(r) || 0) + "", e[r], a, n, 0, 0, r)) && (s.op = r), this._props.push(r);
            },
          },
          {
            name: "endArray",
            init: function (t, e) {
              for (var i = e.length; i--; ) this.add(t, i, t[i] || 0, e[i]);
            },
          },
          Xi("roundProps", He),
          Xi("modifiers"),
          Xi("snap", Ye)
        ) || Yi;
    (Ri.version = xi.version = Zi.version = "3.6.1"), (ht = 1), Lt() && di();
    pi.Power0, pi.Power1, pi.Power2;
    /*!
     * CSSPlugin 3.6.1
     * https://greensock.com
     *
     * Copyright 2008-2021, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */ var $i,
      ta,
      ea,
      ia,
      aa,
      na,
      ra,
      sa = pi.Power3,
      oa = (pi.Power4, pi.Linear),
      la = (pi.Quad, pi.Cubic, pi.Quart, pi.Quint, pi.Strong, pi.Elastic, pi.Back, pi.SteppedEase, pi.Bounce, pi.Sine),
      ca = (pi.Expo, pi.Circ, {}),
      ha = 180 / Math.PI,
      ua = Math.PI / 180,
      da = Math.atan2,
      pa = /([A-Z])/g,
      fa = /(?:left|right|width|margin|padding|x)/i,
      ma = /[\s,\(]\S/,
      ya = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" },
      va = function (t, e) {
        return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
      },
      Aa = function (t, e) {
        return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
      },
      ba = function (t, e) {
        return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e);
      },
      wa = function (t, e) {
        var i = e.s + e.c * t;
        e.set(e.t, e.p, ~~(i + (i < 0 ? -0.5 : 0.5)) + e.u, e);
      },
      Ca = function (t, e) {
        return e.set(e.t, e.p, t ? e.e : e.b, e);
      },
      Sa = function (t, e) {
        return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
      },
      ka = function (t, e, i) {
        return (t.style[e] = i);
      },
      Ea = function (t, e, i) {
        return t.style.setProperty(e, i);
      },
      xa = function (t, e, i) {
        return (t._gsap[e] = i);
      },
      _a = function (t, e, i) {
        return (t._gsap.scaleX = t._gsap.scaleY = i);
      },
      Ta = function (t, e, i, a, n) {
        var r = t._gsap;
        (r.scaleX = r.scaleY = i), r.renderTransform(n, r);
      },
      Ma = function (t, e, i, a, n) {
        var r = t._gsap;
        (r[e] = i), r.renderTransform(n, r);
      },
      Pa = "transform",
      Da = Pa + "Origin",
      Ia = function (t, e) {
        var i = ta.createElementNS ? ta.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : ta.createElement(t);
        return i.style ? i : ta.createElement(t);
      },
      La = function t(e, i, a) {
        var n = getComputedStyle(e);
        return n[i] || n.getPropertyValue(i.replace(pa, "-$1").toLowerCase()) || n.getPropertyValue(i) || (!a && t(e, Fa(i) || i, 1)) || "";
      },
      Ra = "O,Moz,ms,Ms,Webkit".split(","),
      Fa = function (t, e, i) {
        var a = (e || aa).style,
          n = 5;
        if (t in a && !i) return t;
        for (t = t.charAt(0).toUpperCase() + t.substr(1); n-- && !(Ra[n] + t in a); );
        return n < 0 ? null : (3 === n ? "ms" : n >= 0 ? Ra[n] : "") + t;
      },
      Oa = function () {
        "undefined" != typeof window &&
          window.document &&
          (($i = window),
          (ta = $i.document),
          (ea = ta.documentElement),
          (aa = Ia("div") || { style: {} }),
          Ia("div"),
          (Pa = Fa(Pa)),
          (Da = Pa + "Origin"),
          (aa.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"),
          (ra = !!Fa("perspective")),
          (ia = 1));
      },
      Ba = function t(e) {
        var i,
          a = Ia("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
          n = this.parentNode,
          r = this.nextSibling,
          s = this.style.cssText;
        if ((ea.appendChild(a), a.appendChild(this), (this.style.display = "block"), e))
          try {
            (i = this.getBBox()), (this._gsapBBox = this.getBBox), (this.getBBox = t);
          } catch (t) {}
        else this._gsapBBox && (i = this._gsapBBox());
        return n && (r ? n.insertBefore(this, r) : n.appendChild(this)), ea.removeChild(a), (this.style.cssText = s), i;
      },
      qa = function (t, e) {
        for (var i = e.length; i--; ) if (t.hasAttribute(e[i])) return t.getAttribute(e[i]);
      },
      Na = function (t) {
        var e;
        try {
          e = t.getBBox();
        } catch (i) {
          e = Ba.call(t, !0);
        }
        return (e && (e.width || e.height)) || t.getBBox === Ba || (e = Ba.call(t, !0)), !e || e.width || e.x || e.y ? e : { x: +qa(t, ["x", "cx", "x1"]) || 0, y: +qa(t, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
      },
      Va = function (t) {
        return !(!t.getCTM || (t.parentNode && !t.ownerSVGElement) || !Na(t));
      },
      Wa = function (t, e) {
        if (e) {
          var i = t.style;
          e in ca && e !== Da && (e = Pa), i.removeProperty ? (("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6)) || (e = "-" + e), i.removeProperty(e.replace(pa, "-$1").toLowerCase())) : i.removeAttribute(e);
        }
      },
      Ua = function (t, e, i, a, n, r) {
        var s = new Hi(t._pt, e, i, 0, 1, r ? Sa : Ca);
        return (t._pt = s), (s.b = a), (s.e = n), t._props.push(i), s;
      },
      Ja = { deg: 1, rad: 1, turn: 1 },
      za = function t(e, i, a, n) {
        var r,
          s,
          o,
          l,
          c = parseFloat(a) || 0,
          h = (a + "").trim().substr((c + "").length) || "px",
          u = aa.style,
          d = fa.test(i),
          p = "svg" === e.tagName.toLowerCase(),
          f = (p ? "client" : "offset") + (d ? "Width" : "Height"),
          m = "px" === n,
          g = "%" === n;
        return n === h || !c || Ja[n] || Ja[h]
          ? c
          : ("px" !== h && !m && (c = t(e, i, a, "px")),
            (l = e.getCTM && Va(e)),
            (!g && "%" !== h) || (!ca[i] && !~i.indexOf("adius"))
              ? ((u[d ? "width" : "height"] = 100 + (m ? h : n)),
                (s = ~i.indexOf("adius") || ("em" === n && e.appendChild && !p) ? e : e.parentNode),
                l && (s = (e.ownerSVGElement || {}).parentNode),
                (s && s !== ta && s.appendChild) || (s = ta.body),
                (o = s._gsap) && g && o.width && d && o.time === ui.time
                  ? ce((c / o.width) * 100)
                  : ((g || "%" === h) && (u.position = La(e, "position")),
                    s === e && (u.position = "static"),
                    s.appendChild(aa),
                    (r = aa[f]),
                    s.removeChild(aa),
                    (u.position = "absolute"),
                    d && g && (((o = se(s)).time = ui.time), (o.width = s[f])),
                    ce(m ? (r * c) / 100 : r && c ? (100 / r) * c : 0)))
              : ((r = l ? e.getBBox()[d ? "width" : "height"] : e[f]), ce(g ? (c / r) * 100 : (c / 100) * r)));
      },
      Ka = function (t, e, i, a) {
        var n;
        return (
          ia || Oa(),
          e in ya && "transform" !== e && ~(e = ya[e]).indexOf(",") && (e = e.split(",")[0]),
          ca[e] && "transform" !== e
            ? ((n = an(t, a)), (n = "transformOrigin" !== e ? n[e] : nn(La(t, Da)) + " " + n.zOrigin + "px"))
            : (!(n = t.style[e]) || "auto" === n || a || ~(n + "").indexOf("calc(")) && (n = (Ya[e] && Ya[e](t, e, i)) || La(t, e) || oe(t, e) || ("opacity" === e ? 1 : 0)),
          i && !~(n + "").trim().indexOf(" ") ? za(t, e, n, i) + i : n
        );
      },
      Ga = function (t, e, i, a) {
        if (!i || "none" === i) {
          var n = Fa(e, t, 1),
            r = n && La(t, n, 1);
          r && r !== i ? ((e = n), (i = r)) : "borderColor" === e && (i = La(t, "borderTopColor"));
        }
        var s,
          o,
          l,
          c,
          h,
          u,
          d,
          p,
          f,
          m,
          g,
          y,
          v = new Hi(this._pt, t.style, e, 0, 1, Ui),
          A = 0,
          b = 0;
        if (((v.b = i), (v.e = a), (i += ""), "auto" === (a += "") && ((t.style[e] = a), (a = La(t, e) || a), (t.style[e] = i)), hi((s = [i, a])), (a = s[1]), (l = (i = s[0]).match(Nt) || []), (a.match(Nt) || []).length)) {
          for (; (o = Nt.exec(a)); )
            (d = o[0]),
              (f = a.substring(A, o.index)),
              h ? (h = (h + 1) % 5) : ("rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5)) || (h = 1),
              d !== (u = l[b++] || "") &&
                ((c = parseFloat(u) || 0),
                (g = u.substr((c + "").length)),
                (y = "=" === d.charAt(1) ? +(d.charAt(0) + "1") : 0) && (d = d.substr(2)),
                (p = parseFloat(d)),
                (m = d.substr((p + "").length)),
                (A = Nt.lastIndex - m.length),
                m || ((m = m || vt.units[e] || g), A === a.length && ((a += m), (v.e += m))),
                g !== m && (c = za(t, e, u, m) || 0),
                (v._pt = { _next: v._pt, p: f || 1 === b ? f : ",", s: c, c: y ? y * p : p - c, m: (h && h < 4) || "zIndex" === e ? Math.round : 0 }));
          v.c = A < a.length ? a.substring(A, a.length) : "";
        } else v.r = "display" === e && "none" === a ? Sa : Ca;
        return Wt.test(a) && (v.e = 0), (this._pt = v), v;
      },
      ja = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" },
      Ha = function (t, e) {
        if (e.tween && e.tween._time === e.tween._dur) {
          var i,
            a,
            n,
            r = e.t,
            s = r.style,
            o = e.u,
            l = r._gsap;
          if ("all" === o || !0 === o) (s.cssText = ""), (a = 1);
          else for (n = (o = o.split(",")).length; --n > -1; ) (i = o[n]), ca[i] && ((a = 1), (i = "transformOrigin" === i ? Da : Pa)), Wa(r, i);
          a && (Wa(r, Pa), l && (l.svg && r.removeAttribute("transform"), an(r, 1), (l.uncache = 1)));
        }
      },
      Ya = {
        clearProps: function (t, e, i, a, n) {
          if ("isFromStart" !== n.data) {
            var r = (t._pt = new Hi(t._pt, e, i, 0, 0, Ha));
            return (r.u = a), (r.pr = -10), (r.tween = n), t._props.push(i), 1;
          }
        },
      },
      Qa = [1, 0, 0, 1, 0, 0],
      Xa = {},
      Za = function (t) {
        return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t;
      },
      $a = function (t) {
        var e = La(t, Pa);
        return Za(e) ? Qa : e.substr(7).match(qt).map(ce);
      },
      tn = function (t, e) {
        var i,
          a,
          n,
          r,
          s = t._gsap || se(t),
          o = t.style,
          l = $a(t);
        return s.svg && t.getAttribute("transform")
          ? "1,0,0,1,0,0" === (l = [(n = t.transform.baseVal.consolidate().matrix).a, n.b, n.c, n.d, n.e, n.f]).join(",")
            ? Qa
            : l
          : (l !== Qa ||
              t.offsetParent ||
              t === ea ||
              s.svg ||
              ((n = o.display),
              (o.display = "block"),
              ((i = t.parentNode) && t.offsetParent) || ((r = 1), (a = t.nextSibling), ea.appendChild(t)),
              (l = $a(t)),
              n ? (o.display = n) : Wa(t, "display"),
              r && (a ? i.insertBefore(t, a) : i ? i.appendChild(t) : ea.removeChild(t))),
            e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
      },
      en = function (t, e, i, a, n, r) {
        var s,
          o,
          l,
          c = t._gsap,
          h = n || tn(t, !0),
          u = c.xOrigin || 0,
          d = c.yOrigin || 0,
          p = c.xOffset || 0,
          f = c.yOffset || 0,
          m = h[0],
          g = h[1],
          y = h[2],
          v = h[3],
          A = h[4],
          b = h[5],
          w = e.split(" "),
          C = parseFloat(w[0]) || 0,
          S = parseFloat(w[1]) || 0;
        i
          ? h !== Qa && (o = m * v - g * y) && ((l = C * (-g / o) + S * (m / o) - (m * b - g * A) / o), (C = C * (v / o) + S * (-y / o) + (y * b - v * A) / o), (S = l))
          : ((C = (s = Na(t)).x + (~w[0].indexOf("%") ? (C / 100) * s.width : C)), (S = s.y + (~(w[1] || w[0]).indexOf("%") ? (S / 100) * s.height : S))),
          a || (!1 !== a && c.smooth) ? ((A = C - u), (b = S - d), (c.xOffset = p + (A * m + b * y) - A), (c.yOffset = f + (A * g + b * v) - b)) : (c.xOffset = c.yOffset = 0),
          (c.xOrigin = C),
          (c.yOrigin = S),
          (c.smooth = !!a),
          (c.origin = e),
          (c.originIsAbsolute = !!i),
          (t.style[Da] = "0px 0px"),
          r && (Ua(r, c, "xOrigin", u, C), Ua(r, c, "yOrigin", d, S), Ua(r, c, "xOffset", p, c.xOffset), Ua(r, c, "yOffset", f, c.yOffset)),
          t.setAttribute("data-svg-origin", C + " " + S);
      },
      an = function (t, e) {
        var i = t._gsap || new ki(t);
        if ("x" in i && !e && !i.uncache) return i;
        var a,
          n,
          r,
          s,
          o,
          l,
          c,
          h,
          u,
          d,
          p,
          f,
          m,
          g,
          y,
          v,
          A,
          b,
          w,
          C,
          S,
          k,
          E,
          x,
          _,
          T,
          M,
          P,
          D,
          I,
          L,
          R,
          F = t.style,
          O = i.scaleX < 0,
          B = La(t, Da) || "0";
        return (
          (a = n = r = l = c = h = u = d = p = 0),
          (s = o = 1),
          (i.svg = !(!t.getCTM || !Va(t))),
          (g = tn(t, i.svg)),
          i.svg && ((x = !i.uncache && !e && t.getAttribute("data-svg-origin")), en(t, x || B, !!x || i.originIsAbsolute, !1 !== i.smooth, g)),
          (f = i.xOrigin || 0),
          (m = i.yOrigin || 0),
          g !== Qa &&
            ((b = g[0]),
            (w = g[1]),
            (C = g[2]),
            (S = g[3]),
            (a = k = g[4]),
            (n = E = g[5]),
            6 === g.length
              ? ((s = Math.sqrt(b * b + w * w)),
                (o = Math.sqrt(S * S + C * C)),
                (l = b || w ? da(w, b) * ha : 0),
                (u = C || S ? da(C, S) * ha + l : 0) && (o *= Math.abs(Math.cos(u * ua))),
                i.svg && ((a -= f - (f * b + m * C)), (n -= m - (f * w + m * S))))
              : ((R = g[6]),
                (I = g[7]),
                (M = g[8]),
                (P = g[9]),
                (D = g[10]),
                (L = g[11]),
                (a = g[12]),
                (n = g[13]),
                (r = g[14]),
                (c = (y = da(R, D)) * ha),
                y && ((x = k * (v = Math.cos(-y)) + M * (A = Math.sin(-y))), (_ = E * v + P * A), (T = R * v + D * A), (M = k * -A + M * v), (P = E * -A + P * v), (D = R * -A + D * v), (L = I * -A + L * v), (k = x), (E = _), (R = T)),
                (h = (y = da(-C, D)) * ha),
                y && ((v = Math.cos(-y)), (L = S * (A = Math.sin(-y)) + L * v), (b = x = b * v - M * A), (w = _ = w * v - P * A), (C = T = C * v - D * A)),
                (l = (y = da(w, b)) * ha),
                y && ((x = b * (v = Math.cos(y)) + w * (A = Math.sin(y))), (_ = k * v + E * A), (w = w * v - b * A), (E = E * v - k * A), (b = x), (k = _)),
                c && Math.abs(c) + Math.abs(l) > 359.9 && ((c = l = 0), (h = 180 - h)),
                (s = ce(Math.sqrt(b * b + w * w + C * C))),
                (o = ce(Math.sqrt(E * E + R * R))),
                (y = da(k, E)),
                (u = Math.abs(y) > 2e-4 ? y * ha : 0),
                (p = L ? 1 / (L < 0 ? -L : L) : 0)),
            i.svg && ((x = t.getAttribute("transform")), (i.forceCSS = t.setAttribute("transform", "") || !Za(La(t, Pa))), x && t.setAttribute("transform", x))),
          Math.abs(u) > 90 && Math.abs(u) < 270 && (O ? ((s *= -1), (u += l <= 0 ? 180 : -180), (l += l <= 0 ? 180 : -180)) : ((o *= -1), (u += u <= 0 ? 180 : -180))),
          (i.x = a - ((i.xPercent = a && (i.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-a) ? -50 : 0))) ? (t.offsetWidth * i.xPercent) / 100 : 0) + "px"),
          (i.y = n - ((i.yPercent = n && (i.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-n) ? -50 : 0))) ? (t.offsetHeight * i.yPercent) / 100 : 0) + "px"),
          (i.z = r + "px"),
          (i.scaleX = ce(s)),
          (i.scaleY = ce(o)),
          (i.rotation = ce(l) + "deg"),
          (i.rotationX = ce(c) + "deg"),
          (i.rotationY = ce(h) + "deg"),
          (i.skewX = u + "deg"),
          (i.skewY = d + "deg"),
          (i.transformPerspective = p + "px"),
          (i.zOrigin = parseFloat(B.split(" ")[2]) || 0) && (F[Da] = nn(B)),
          (i.xOffset = i.yOffset = 0),
          (i.force3D = vt.force3D),
          (i.renderTransform = i.svg ? ln : ra ? on : sn),
          (i.uncache = 0),
          i
        );
      },
      nn = function (t) {
        return (t = t.split(" "))[0] + " " + t[1];
      },
      rn = function (t, e, i) {
        var a = We(e);
        return ce(parseFloat(e) + parseFloat(za(t, "x", i + "px", a))) + a;
      },
      sn = function (t, e) {
        (e.z = "0px"), (e.rotationY = e.rotationX = "0deg"), (e.force3D = 0), on(t, e);
      },
      on = function (t, e) {
        var i = e || this,
          a = i.xPercent,
          n = i.yPercent,
          r = i.x,
          s = i.y,
          o = i.z,
          l = i.rotation,
          c = i.rotationY,
          h = i.rotationX,
          u = i.skewX,
          d = i.skewY,
          p = i.scaleX,
          f = i.scaleY,
          m = i.transformPerspective,
          g = i.force3D,
          y = i.target,
          v = i.zOrigin,
          A = "",
          b = ("auto" === g && t && 1 !== t) || !0 === g;
        if (v && ("0deg" !== h || "0deg" !== c)) {
          var w,
            C = parseFloat(c) * ua,
            S = Math.sin(C),
            k = Math.cos(C);
          (C = parseFloat(h) * ua), (w = Math.cos(C)), (r = rn(y, r, S * w * -v)), (s = rn(y, s, -Math.sin(C) * -v)), (o = rn(y, o, k * w * -v + v));
        }
        "0px" !== m && (A += "perspective(" + m + ") "),
          (a || n) && (A += "translate(" + a + "%, " + n + "%) "),
          (b || "0px" !== r || "0px" !== s || "0px" !== o) && (A += "0px" !== o || b ? "translate3d(" + r + ", " + s + ", " + o + ") " : "translate(" + r + ", " + s + ") "),
          "0deg" !== l && (A += "rotate(" + l + ") "),
          "0deg" !== c && (A += "rotateY(" + c + ") "),
          "0deg" !== h && (A += "rotateX(" + h + ") "),
          ("0deg" === u && "0deg" === d) || (A += "skew(" + u + ", " + d + ") "),
          (1 === p && 1 === f) || (A += "scale(" + p + ", " + f + ") "),
          (y.style[Pa] = A || "translate(0, 0)");
      },
      ln = function (t, e) {
        var i,
          a,
          n,
          r,
          s,
          o = e || this,
          l = o.xPercent,
          c = o.yPercent,
          h = o.x,
          u = o.y,
          d = o.rotation,
          p = o.skewX,
          f = o.skewY,
          m = o.scaleX,
          g = o.scaleY,
          y = o.target,
          v = o.xOrigin,
          A = o.yOrigin,
          b = o.xOffset,
          w = o.yOffset,
          C = o.forceCSS,
          S = parseFloat(h),
          k = parseFloat(u);
        (d = parseFloat(d)),
          (p = parseFloat(p)),
          (f = parseFloat(f)) && ((p += f = parseFloat(f)), (d += f)),
          d || p
            ? ((d *= ua),
              (p *= ua),
              (i = Math.cos(d) * m),
              (a = Math.sin(d) * m),
              (n = Math.sin(d - p) * -g),
              (r = Math.cos(d - p) * g),
              p && ((f *= ua), (s = Math.tan(p - f)), (n *= s = Math.sqrt(1 + s * s)), (r *= s), f && ((s = Math.tan(f)), (i *= s = Math.sqrt(1 + s * s)), (a *= s))),
              (i = ce(i)),
              (a = ce(a)),
              (n = ce(n)),
              (r = ce(r)))
            : ((i = m), (r = g), (a = n = 0)),
          ((S && !~(h + "").indexOf("px")) || (k && !~(u + "").indexOf("px"))) && ((S = za(y, "x", h, "px")), (k = za(y, "y", u, "px"))),
          (v || A || b || w) && ((S = ce(S + v - (v * i + A * n) + b)), (k = ce(k + A - (v * a + A * r) + w))),
          (l || c) && ((s = y.getBBox()), (S = ce(S + (l / 100) * s.width)), (k = ce(k + (c / 100) * s.height))),
          (s = "matrix(" + i + "," + a + "," + n + "," + r + "," + S + "," + k + ")"),
          y.setAttribute("transform", s),
          C && (y.style[Pa] = s);
      },
      cn = function (t, e, i, a, n, r) {
        var s,
          o,
          l = _t(n),
          c = parseFloat(n) * (l && ~n.indexOf("rad") ? ha : 1),
          h = r ? c * r : c - a,
          u = a + h + "deg";
        return (
          l &&
            ("short" === (s = n.split("_")[1]) && (h %= 360) !== h % 180 && (h += h < 0 ? 360 : -360),
            "cw" === s && h < 0 ? (h = ((h + 36e9) % 360) - 360 * ~~(h / 360)) : "ccw" === s && h > 0 && (h = ((h - 36e9) % 360) - 360 * ~~(h / 360))),
          (t._pt = o = new Hi(t._pt, e, i, a, h, Aa)),
          (o.e = u),
          (o.u = "deg"),
          t._props.push(i),
          o
        );
      },
      hn = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      },
      un = function (t, e, i) {
        var a,
          n,
          r,
          s,
          o,
          l,
          c,
          h = hn({}, i._gsap),
          u = i.style;
        for (n in (h.svg
          ? ((r = i.getAttribute("transform")), i.setAttribute("transform", ""), (u[Pa] = e), (a = an(i, 1)), Wa(i, Pa), i.setAttribute("transform", r))
          : ((r = getComputedStyle(i)[Pa]), (u[Pa] = e), (a = an(i, 1)), (u[Pa] = r)),
        ca))
          (r = h[n]) !== (s = a[n]) &&
            "perspective,force3D,transformOrigin,svgOrigin".indexOf(n) < 0 &&
            ((o = We(r) !== (c = We(s)) ? za(i, n, r, c) : parseFloat(r)), (l = parseFloat(s)), (t._pt = new Hi(t._pt, a, n, o, l - o, va)), (t._pt.u = c || 0), t._props.push(n));
        hn(a, h);
      };
    le("padding,margin,Width,Radius", function (t, e) {
      var i = "Top",
        a = "Right",
        n = "Bottom",
        r = "Left",
        s = (e < 3 ? [i, a, n, r] : [i + r, i + a, n + a, n + r]).map(function (i) {
          return e < 2 ? t + i : "border" + i + t;
        });
      Ya[e > 1 ? "border" + t : t] = function (t, e, i, a, n) {
        var r, o;
        if (arguments.length < 4)
          return (
            (r = s.map(function (e) {
              return Ka(t, e, i);
            })),
            5 === (o = r.join(" ")).split(r[0]).length ? r[0] : o
          );
        (r = (a + "").split(" ")),
          (o = {}),
          s.forEach(function (t, e) {
            return (o[t] = r[e] = r[e] || r[((e - 1) / 2) | 0]);
          }),
          t.init(e, o, n);
      };
    });
    var dn,
      pn,
      fn = {
        name: "css",
        register: Oa,
        targetTest: function (t) {
          return t.style && t.nodeType;
        },
        init: function (t, e, i, a, n) {
          var r,
            s,
            o,
            l,
            c,
            h,
            u,
            d,
            p,
            f,
            m,
            g,
            y,
            v,
            A,
            b,
            w,
            C,
            S,
            k = this._props,
            E = t.style,
            x = i.vars.startAt;
          for (u in (ia || Oa(), e))
            if ("autoRound" !== u && ((s = e[u]), !te[u] || !Mi(u, e, i, a, t, n)))
              if (((c = typeof s), (h = Ya[u]), "function" === c && (c = typeof (s = s.call(i, a, t, n))), "string" === c && ~s.indexOf("random(") && (s = Ze(s)), h)) h(this, t, u, s, i) && (A = 1);
              else if ("--" === u.substr(0, 2))
                (r = (getComputedStyle(t).getPropertyValue(u) + "").trim()),
                  (s += ""),
                  (li.lastIndex = 0),
                  li.test(r) || ((d = We(r)), (p = We(s))),
                  p ? d !== p && (r = za(t, u, r, p) + p) : d && (s += d),
                  this.add(E, "setProperty", r, s, a, n, 0, 0, u);
              else if ("undefined" !== c) {
                if (
                  (x && u in x ? ((r = "function" == typeof x[u] ? x[u].call(i, a, t, n) : x[u]), u in vt.units && !We(r) && (r += vt.units[u]), "=" === (r + "").charAt(1) && (r = Ka(t, u))) : (r = Ka(t, u)),
                  (l = parseFloat(r)),
                  (f = "string" === c && "=" === s.charAt(1) ? +(s.charAt(0) + "1") : 0) && (s = s.substr(2)),
                  (o = parseFloat(s)),
                  u in ya &&
                    ("autoAlpha" === u && (1 === l && "hidden" === Ka(t, "visibility") && o && (l = 0), Ua(this, E, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)),
                    "scale" !== u && "transform" !== u && ~(u = ya[u]).indexOf(",") && (u = u.split(",")[0])),
                  (m = u in ca))
                )
                  if (
                    (g || (((y = t._gsap).renderTransform && !e.parseTransform) || an(t, e.parseTransform), (v = !1 !== e.smoothOrigin && y.smooth), ((g = this._pt = new Hi(this._pt, E, Pa, 0, 1, y.renderTransform, y, 0, -1)).dep = 1)),
                    "scale" === u)
                  )
                    (this._pt = new Hi(this._pt, y, "scaleY", y.scaleY, f ? f * o : o - y.scaleY)), k.push("scaleY", u), (u += "X");
                  else {
                    if ("transformOrigin" === u) {
                      (w = void 0),
                        (C = void 0),
                        (S = void 0),
                        (w = (b = s).split(" ")),
                        (C = w[0]),
                        (S = w[1] || "50%"),
                        ("top" !== C && "bottom" !== C && "left" !== S && "right" !== S) || ((b = C), (C = S), (S = b)),
                        (w[0] = ja[C] || C),
                        (w[1] = ja[S] || S),
                        (s = w.join(" ")),
                        y.svg ? en(t, s, 0, v, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== y.zOrigin && Ua(this, y, "zOrigin", y.zOrigin, p), Ua(this, E, u, nn(r), nn(s)));
                      continue;
                    }
                    if ("svgOrigin" === u) {
                      en(t, s, 1, v, 0, this);
                      continue;
                    }
                    if (u in Xa) {
                      cn(this, y, u, l, s, f);
                      continue;
                    }
                    if ("smoothOrigin" === u) {
                      Ua(this, y, "smooth", y.smooth, s);
                      continue;
                    }
                    if ("force3D" === u) {
                      y[u] = s;
                      continue;
                    }
                    if ("transform" === u) {
                      un(this, s, t);
                      continue;
                    }
                  }
                else u in E || (u = Fa(u) || u);
                if (m || ((o || 0 === o) && (l || 0 === l) && !ma.test(s) && u in E))
                  (d = (r + "").substr((l + "").length)),
                    o || (o = 0),
                    d !== (p = We(s) || (u in vt.units ? vt.units[u] : d)) && (l = za(t, u, r, p)),
                    (this._pt = new Hi(this._pt, m ? y : E, u, l, f ? f * o : o - l, m || ("px" !== p && "zIndex" !== u) || !1 === e.autoRound ? va : wa)),
                    (this._pt.u = p || 0),
                    d !== p && ((this._pt.b = r), (this._pt.r = ba));
                else if (u in E) Ga.call(this, t, u, r, s);
                else {
                  if (!(u in t)) {
                    jt(u, s);
                    continue;
                  }
                  this.add(t, u, t[u], s, a, n);
                }
                k.push(u);
              }
          A && ji(this);
        },
        get: Ka,
        aliases: ya,
        getSetter: function (t, e, i) {
          var a = ya[e];
          return (
            a && a.indexOf(",") < 0 && (e = a),
            e in ca && e !== Da && (t._gsap.x || Ka(t, "x")) ? (i && na === i ? ("scale" === e ? _a : xa) : (na = i || {}) && ("scale" === e ? Ta : Ma)) : t.style && !Pt(t.style[e]) ? ka : ~e.indexOf("-") ? Ea : Ni(t, e)
          );
        },
        core: { _removeProperty: Wa, _getMatrix: tn },
      };
    (Zi.utils.checkPrefix = Fa),
      (pn = le("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (dn = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function (t) {
        ca[t] = 1;
      })),
      le(dn, function (t) {
        (vt.units[t] = "deg"), (Xa[t] = 1);
      }),
      (ya[pn[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + dn),
      le("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function (t) {
        var e = t.split(":");
        ya[e[1]] = pn[e[0]];
      }),
      le("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (t) {
        vt.units[t] = "px";
      }),
      Zi.registerPlugin(fn);
    var mn,
      gn,
      yn,
      vn,
      An,
      bn,
      wn,
      Cn,
      Sn,
      kn,
      En,
      xn,
      _n,
      Tn,
      Mn,
      Pn,
      Dn,
      In,
      Ln,
      Rn,
      Fn,
      On,
      Bn,
      qn,
      Nn,
      Vn,
      Wn,
      Un = Zi.registerPlugin(fn) || Zi,
      Jn = (Un.core.Tween, i(0)),
      zn = i.n(Jn),
      Kn = i(1),
      Gn = i.n(Kn),
      jn = (function () {
        function t(e) {
          var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          zn()(this, t),
            (this.worker = new Worker("/assets/code/image-load.js")),
            (this.array = []),
            (this.domElements = !1),
            (this.count = 0),
            (this.sent = 0),
            (this.total = 0),
            (this.callbackCap = void 0 === i.callbackCap ? 1e6 : parseInt(i.callbackCap)),
            (this.dataAttr = void 0 === i.dataAttr ? "preload" : i.dataAttr),
            (this.forceNoWorker = void 0 !== i.forceNoWorker && i.forceNoWorker),
            (this.size = void 0 === i.size ? "mobile" : i.size),
            (this.tagExclusions = void 0 === i.tagExclusions ? ["audio", "iframe", "video"] : i.tagExclusions),
            (this.workerCap = void 0 === i.workerCap ? 1e6 : parseInt(i.workerCap)),
            (this.delay = void 0 !== i.delay && parseInt(i.delay)),
            this.bindEvents();
        }
        return (
          Gn()(t, [
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                this.worker.addEventListener("message", function (e) {
                  var i = e.data,
                    a = URL.createObjectURL(i.blob);
                  if (((t.array[i.url] = a), t.domElements)) {
                    i.url.indexOf("localhost") && (i.url = i.url.replace(z.domain, ""));
                    for (var n = document.querySelectorAll("[data-".concat(t.dataAttr, "-").concat(t.size, '="').concat(i.url, '"]')), r = 0; r < n.length; r++) t.preload(n[r], a);
                  } else t.returnedUrls.push(a), t.count++;
                });
              },
            },
            {
              key: "remove",
              value: function (t, e) {
                return t.filter(function (t) {
                  return t !== e;
                });
              },
            },
            {
              key: "loadImage",
              value: function (t) {
                var e = t.getAttribute("data-".concat(this.dataAttr, "-").concat(this.size));
                void 0 !== this.array[e] && "" !== this.array[e] && this.preload(t, this.array[e]);
              },
            },
            {
              key: "loadImages",
              value: function () {
                var t = this,
                  e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                  i = arguments.length > 1 ? arguments[1] : void 0,
                  a = arguments.length > 2 ? arguments[2] : void 0;
                "string" === i && ((e = document.querySelectorAll(e)), (this.domElements = !0)), "nodeList" === i && (this.domElements = !0), "array" === i && ((this.domElements = !1), (this.returnedUrls = []));
                window.location.protocol;
                (this.count = 0), (this.total = e.length);
                for (var n = 0; n < e.length; n++) {
                  var r = void 0,
                    s = void 0;
                  this.domElements ? ((r = e[n].getAttribute("data-".concat(this.dataAttr, "-").concat(this.size))), (s = e[n].tagName.toLowerCase())) : (r = e[n]),
                    r && "" !== r
                      ? (r.indexOf("http") < 0 && (r = z.domain + r),
                        (void 0 !== this.array[r] && "" === this.array[r]) ||
                          (void 0 === this.array[r] || "" === this.array[r]
                            ? (this.domElements && (!0 === this.forceNoWorker || this.tagExclusions.indexOf(s) >= 0 || this.sent >= this.workerCap)) || r.indexOf("gif") > 0
                              ? this.preload(e[n], r)
                              : ((this.array[r] = ""), this.sent++, this.message(r))
                            : (this.domElements ? this.preload(e[n], this.array[r]) : this.returnedUrls.push(this.array[r]), this.total--)))
                      : (this.clearElement(e[n]), this.total--);
                }
                setTimeout(function () {});
                var o = setInterval(function () {
                  (t.count >= t.total || t.count >= t.callbackCap) &&
                    (clearInterval(o), t.domElements ? a(t.count + " elements loaded, " + (t.count - t.total) + " duplicate elements, " + (e.length - t.total) + " deferred elements") : a(t.returnedUrls));
                }, 10);
                this.delay &&
                  !1 !== this.delay &&
                  setTimeout(function () {
                    clearInterval(o), a(t.count + " elements loaded, forced after " + t.delay + " milleseconds");
                  }, this.delay);
              },
            },
            {
              key: "preload",
              value: function (t, e) {
                switch (t.tagName.toLowerCase()) {
                  case "audio":
                  case "video":
                    this.loadSource(t, e);
                    break;
                  case "image":
                    this.loadSVGImage(t, e);
                    break;
                  case "iframe":
                  case "img":
                    this.loadSrc(t, e);
                    break;
                  default:
                    this.loadBackgroundImage(t, e);
                }
                this.clearElement(t);
              },
            },
            {
              key: "loadSource",
              value: function (t, e) {
                var i = this,
                  a = document.createElement("source");
                a.setAttribute("src", e), t.appendChild(a), t.load(), t.classList.contains("tiktok-video") || t.play();
                var n = setInterval(function () {
                  t.readyState > 3 && (i.count++, clearInterval(n));
                }, 10);
              },
            },
            {
              key: "loadSrc",
              value: function (t, e) {
                var i = this;
                (t.onload = function () {
                  i.count++;
                }),
                  (t.onerror = function () {
                    i.count++;
                  }),
                  t.setAttribute("src", e);
              },
            },
            {
              key: "loadSVGImage",
              value: function (t, e) {
                var i = this;
                (t.onload = function () {
                  i.count++;
                }),
                  (t.onerror = function () {
                    i.count++;
                  }),
                  t.setAttribute("href", e);
              },
            },
            {
              key: "loadBackgroundImage",
              value: function (t, e) {
                var i = this,
                  a = new Image();
                (a.onload = function () {
                  (t.style.backgroundImage = "url(" + e + ")"), i.count++;
                }),
                  (a.onerror = function () {
                    i.count++;
                  }),
                  (a.src = e);
              },
            },
            {
              key: "clearElement",
              value: function (t) {
                t && (t.classList.remove("preload"), t.classList.remove("preload-critical"), t.classList.remove("preload-fixed"), t.removeAttribute("data-preload-desktop"), t.removeAttribute("data-preload-mobile"));
              },
            },
            {
              key: "clearBlob",
              value: function (t) {
                this.array[t] && (URL.revokeObjectURL(this.array[t]), this.remove(this.array, t));
              },
            },
            {
              key: "clearAllBlobs",
              value: function () {
                for (var t = 0; t < this.array.length; t++) URL.revokeObjectURL(this.array[t]);
                this.array = [];
              },
            },
            {
              key: "message",
              value: function (t) {
                this.worker.postMessage(t);
              },
            },
          ]),
          t
        );
      })(),
      Hn = i(8),
      Yn = i.n(Hn),
      Qn = function (t) {
        if (9 == t.keyCode) {
          if ("INPUT" == t.target.nodeName || "TEXTAREA" == t.target.nodeName) return;
          if (1 == z.keyToggle) return;
          z.keyToggle = !0;
          var e = document.querySelectorAll("a, button, input, textarea, option, select");
          (i = e),
            Array.prototype.slice.call(i).forEach(function (t) {
              t.classList.contains("js-key-focus") || t.classList.contains("hidden") || t.classList.add("js-key-focus");
            }),
            (function (t) {
              Array.prototype.slice.call(t).forEach(function (t) {
                t.classList.contains("tab-active") || t.classList.add("tab-active");
              });
            })(document.querySelectorAll(".js-tabshow"));
        }
        var i;
      },
      Xn = function (t) {
        var e = t.querySelectorAll("a, button, input, select, option, textarea");
        Array.prototype.slice.call(e).forEach(function (t) {
          t.setAttribute("tabindex", "-1");
        });
      },
      Zn = function () {
        var t;
        t = z.isGreaterThan767 ? document.querySelectorAll(".drawer:not(.mobile-only):not(.bound)") : document.querySelectorAll(".drawer:not(.bound)");
        for (
          var e = document.getElementById("cat-filter-jack"),
            i = function (i) {
              var a = t[i],
                n = a.classList.contains("cat-filter") || a.classList.contains("flavor-filter"),
                r = a.querySelectorAll("a, button, input, select, option, textarea"),
                s = r[r.length - 1],
                o = a.classList.contains("absolute"),
                l = a.classList.contains("animate"),
                c = a.classList.contains("propagate");
              a.classList.add("bound");
              var h = a.querySelector(".drawer-content"),
                u = h.getBoundingClientRect().height;
              Xn(h),
                a.addEventListener("click", function (t) {
                  if ((c || t.stopPropagation(), a.classList.contains("open")))
                    a.classList.remove("open"), Xn(h), l ? Un.to(h, 0.4, { height: 0, ease: "expo.inOut", force3D: !0, clearProps: "transform" }) : Un.set(h, { height: 0 }), n && Un.set(e, { height: 0 });
                  else {
                    for (var i = document.querySelectorAll(".drawer.open"), r = 0; r < i.length; r++)
                      i[r].classList.remove("open"),
                        l ? Un.to(i[r].querySelector(".drawer-content"), 0.3, { height: 0, ease: "expo.inOut", force3D: !0, clearProps: "transform" }) : Un.set(i[r].querySelector(".drawer-content"), { height: 0 });
                    a.classList.add("open"),
                      (s = h.querySelectorAll("a, button, input, select, option, textarea")),
                      Array.prototype.slice.call(s).forEach(function (t) {
                        t.setAttribute("tabindex", "0");
                      }),
                      l ? Un.to(h, 0.4, { height: u, ease: "expo.inOut", force3D: !0 }) : Un.set(h, { height: u }),
                      n && Un.set(e, { height: u });
                  }
                  var s;
                  "object" != y()(_o) || o || _o.resize();
                }),
                s &&
                  s.addEventListener("blur", function (t) {
                    a.contains(t.relatedTarget) ||
                      (a.classList.remove("open"),
                      Xn(h),
                      l ? Un.to(h, 0.4, { height: 0, ease: "expo.inOut", force3D: !0 }) : Un.set(h, { height: 0 }),
                      Un.set(h, { height: 0 }),
                      n && Un.set(e, { height: 0 }),
                      "object" != y()(_o) || o || _o.resize());
                  }),
                Un.set(h, { height: 0 }),
                h.addEventListener("click", function (t) {
                  c || t.stopPropagation();
                });
            },
            a = 0;
          a < t.length;
          a++
        )
          i(a);
      },
      $n = (function () {
        function t(e) {
          zn()(this, t),
            (this.trigger = e),
            (this.triggerBtn = e.querySelector(".trigger-btn")),
            (this.megaNav = e.querySelector(".mega-nav")),
            (this.ddArrow = e.querySelector(".dd-arrow")),
            (this.linkColumns = this.megaNav.querySelectorAll(".column")),
            (this.otherFadeEls = this.megaNav.querySelector(".tiles")),
            (this.interactiveEls = this.megaNav.querySelectorAll("a, button")),
            (this.interactiveLast = this.interactiveEls[this.interactiveEls.length - 1]),
            (this.shop = this.megaNav.classList.contains("shop")),
            this.shop && (this.megaNavBackdrop = document.querySelector(".meganav-backdrop")),
            this.init();
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                (this.isOpen = !1),
                  (this.allStaggerEls = [this.otherFadeEls]),
                  (this.timeline = new Un.timeline({ paused: !0 })),
                  Un.set(this.megaNav, { x: -z.windowWidth }),
                  this.timeline.set(this.megaNav, { x: 0 }),
                  this.shop && this.timeline.fromTo(this.megaNavBackdrop, 0.37, { autoAlpha: 0 }, { autoAlpha: 1, ease: "sine.inOut", force3D: !0 }),
                  this.timeline
                    .fromTo(this.megaNav, 0.4, { pointerEvents: "none", opacity: 0 }, { pointerEvents: "all", opacity: 1, ease: "sine.inOut", force3D: !0 }, 0)
                    .fromTo(this.ddArrow, 0.35, { rotation: 0 }, { rotation: 180, ease: "sine.inOut" }, 0);
                for (var t = 0; t < this.linkColumns.length; t++) {
                  var e = this.linkColumns[t].querySelectorAll("h3, li");
                  this.timeline.fromTo(e, 0.5, { opacity: 0, y: 19 }, { stagger: 0.032, opacity: 1, y: 0, ease: "expo.inOut", force3D: !0 }, 0), this.allStaggerEls.push(e);
                }
                this.otherFadeEls && this.timeline.fromTo(this.otherFadeEls, 0.5, { opacity: 0, y: 20 }, { opacity: 1, y: 0, ease: "expo.inOut", force3D: !0 }, 0), this.bindEvents();
              },
            },
            {
              key: "handleBlur",
              value: function (t) {
                !this.trigger.contains(t.relatedTarget) && this.isOpen && this.close();
              },
            },
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                this.trigger.addEventListener("mouseenter", function () {
                  t.isOpen || t.open();
                }),
                  this.trigger.addEventListener("mouseleave", function () {
                    t.isOpen && t.close();
                  }),
                  this.triggerBtn.addEventListener("focus", function () {
                    t.isOpen || t.open();
                  }),
                  this.triggerBtn.addEventListener("blur", function (e) {
                    t.handleBlur(e);
                  }),
                  this.interactiveLast.addEventListener("blur", function (e) {
                    t.handleBlur(e);
                  });
              },
            },
            {
              key: "open",
              value: function () {
                (this.isOpen = !0), this.timeline.timeScale(1).play();
              },
            },
            {
              key: "close",
              value: function () {
                (this.isOpen = !1), this.timeline.timeScale(1.1).reverse();
              },
            },
            {
              key: "reset",
              value: function () {
                (this.isOpen = !1), this.timeline.progress(0);
              },
            },
          ]),
          t
        );
      })(),
      tr = (function () {
        function t(e, i) {
          zn()(this, t),
            (this.trigger = e),
            (this.closeTrigger = document.getElementById("mobile-menu--close")),
            (this.mobileNavWrapper = document.getElementById("mobile-menu--wrapper")),
            (this.overlay = document.getElementById("mobile-menu--background")),
            (this.mobileNav = document.getElementById("mobile-menu")),
            (this.subnav = i),
            this.init();
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                this.isOpen = !1;
                var t = this.mobileNav.querySelectorAll(".mobile-logo, .close"),
                  e = this.subnav.querySelectorAll(".stagger-el");
                (this.timeline = new Un.timeline({ paused: !0 })),
                  Un.set(this.mobileNavWrapper, { xPercent: 100 }),
                  Un.set(this.mobileNav, { xPercent: 60 }),
                  this.timeline
                    .set(this.mobileNavWrapper, { xPercent: 0 })
                    .set(this.subnav, { className: "+=show" })
                    .to(this.overlay, 0.35, { opacity: 1, ease: "sine.inOut" })
                    .to(this.mobileNav, 0.35, { xPercent: 0, opacity: 1, ease: "sine.inOut" }, "-=0.2")
                    .to(t, 0.25, { opacity: 1, ease: "sine.inOut", stagger: 0.04 }, "-=0.2")
                    .to(e, 0.25, { opacity: 1, ease: "sine.inOut", stagger: 0.04 }, "-=0.2"),
                  this.bindEvents();
              },
            },
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                this.trigger.addEventListener("click", function () {
                  t.isOpen || t.open();
                }),
                  this.closeTrigger.addEventListener("click", function () {
                    t.isOpen && t.close();
                  }),
                  this.overlay.addEventListener("click", function () {
                    t.isOpen && t.close();
                  });
              },
            },
            {
              key: "open",
              value: function () {
                (this.isOpen = !0), this.timeline.timeScale(1).play();
              },
            },
            {
              key: "close",
              value: function () {
                (this.isOpen = !1), this.timeline.timeScale(5).reverse();
              },
            },
            {
              key: "reset",
              value: function () {
                (this.isOpen = !1), this.timeline.progress(0);
              },
            },
          ]),
          t
        );
      })(),
      er = [],
      ir = function () {
        er = [];
        for (
          var t = document.querySelectorAll(".reviews-grid .review .upvote"),
            e = function (e) {
              if (r(t[e], "lock")) return "continue";
              var i = t[e].querySelector(".icon");
              t[e].classList.add("lock");
              var a = Yn.a.loadAnimation({ container: i, renderer: "svg", loop: !1, autoplay: !1, path: "https://super-coffee.cdn.prismic.io/super-coffee/6bfb4d8b-3389-4708-820c-c2e123d9ee06_07_HighFive_sized.json" });
              er.push(a),
                i.addEventListener("click", function () {
                  a.goToAndPlay(0);
                });
            },
            i = 0;
          i < t.length;
          i++
        )
          e(i);
      },
      ar = 1,
      nr = [],
      rr = [],
      sr = Date.now,
      or = sr(),
      lr = 0,
      cr = 1,
      hr = function (t) {
        return t;
      },
      ur = function (t) {
        return Math.round(1e5 * t) / 1e5 || 0;
      },
      dr = function () {
        return "undefined" != typeof window;
      },
      pr = function () {
        return mn || (dr() && (mn = window.gsap) && mn.registerPlugin && mn);
      },
      fr = function (t) {
        return !!~wn.indexOf(t);
      },
      mr = function (t, e) {
        return ~nr.indexOf(t) && nr[nr.indexOf(t) + 1][e];
      },
      gr = function (t, e) {
        var i = e.s,
          a = e.sc,
          n = rr.indexOf(t),
          r = a === Pr.sc ? 1 : 2;
        return (
          !~n && (n = rr.push(t) - 1),
          rr[n + r] ||
            (rr[n + r] =
              mr(t, i) ||
              (fr(t)
                ? a
                : function (e) {
                    return arguments.length ? (t[i] = e) : t[i];
                  }))
        );
      },
      yr = function (t) {
        return (
          mr(t, "getBoundingClientRect") ||
          (fr(t)
            ? function () {
                return (ms.width = yn.innerWidth), (ms.height = yn.innerHeight), ms;
              }
            : function () {
                return Lr(t);
              })
        );
      },
      vr = function (t, e) {
        var i = e.s,
          a = e.d2,
          n = e.d,
          r = e.a;
        return (i = "scroll" + a) && (r = mr(t, i)) ? r() - yr(t)()[n] : fr(t) ? Math.max(An[i], bn[i]) - (yn["inner" + a] || An["client" + a] || bn["client" + a]) : t[i] - t["offset" + a];
      },
      Ar = function (t, e) {
        for (var i = 0; i < Fn.length; i += 3) (!e || ~e.indexOf(Fn[i + 1])) && t(Fn[i], Fn[i + 1], Fn[i + 2]);
      },
      br = function (t) {
        return "string" == typeof t;
      },
      wr = function (t) {
        return "function" == typeof t;
      },
      Cr = function (t) {
        return "number" == typeof t;
      },
      Sr = function (t) {
        return "object" == typeof t;
      },
      kr = function (t) {
        return wr(t) && t();
      },
      Er = function (t, e) {
        return function () {
          var i = kr(t),
            a = kr(e);
          return function () {
            kr(i), kr(a);
          };
        };
      },
      xr = Math.abs,
      _r = "padding",
      Tr = "px",
      Mr = {
        s: "scrollLeft",
        p: "left",
        p2: "Left",
        os: "right",
        os2: "Right",
        d: "width",
        d2: "Width",
        a: "x",
        sc: function (t) {
          return arguments.length ? yn.scrollTo(t, Pr.sc()) : yn.pageXOffset || vn.scrollLeft || An.scrollLeft || bn.scrollLeft || 0;
        },
      },
      Pr = {
        s: "scrollTop",
        p: "top",
        p2: "Top",
        os: "bottom",
        os2: "Bottom",
        d: "height",
        d2: "Height",
        a: "y",
        op: Mr,
        sc: function (t) {
          return arguments.length ? yn.scrollTo(Mr.sc(), t) : yn.pageYOffset || vn.scrollTop || An.scrollTop || bn.scrollTop || 0;
        },
      },
      Dr = function (t) {
        return yn.getComputedStyle(t);
      },
      Ir = function (t, e) {
        for (var i in e) i in t || (t[i] = e[i]);
        return t;
      },
      Lr = function (t, e) {
        var i = e && "matrix(1, 0, 0, 1, 0, 0)" !== Dr(t)[Dn] && mn.to(t, { x: 0, y: 0, xPercent: 0, yPercent: 0, rotation: 0, rotationX: 0, rotationY: 0, scale: 1, skewX: 0, skewY: 0 }).progress(1),
          a = t.getBoundingClientRect();
        return i && i.progress(0).kill(), a;
      },
      Rr = function (t, e) {
        var i = e.d2;
        return t["offset" + i] || t["client" + i] || 0;
      },
      Fr = function (t) {
        var e,
          i = [],
          a = t.labels,
          n = t.duration();
        for (e in a) i.push(a[e] / n);
        return i;
      },
      Or = function (t, e, i, a) {
        return i.split(",").forEach(function (i) {
          return t(e, i, a);
        });
      },
      Br = function (t, e, i) {
        return t.addEventListener(e, i, { passive: !0 });
      },
      qr = function (t, e, i) {
        return t.removeEventListener(e, i);
      },
      Nr = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" },
      Vr = { toggleActions: "play", anticipatePin: 0 },
      Wr = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 },
      Ur = function (t, e) {
        if (br(t)) {
          var i = t.indexOf("="),
            a = ~i ? +(t.charAt(i - 1) + 1) * parseFloat(t.substr(i + 1)) : 0;
          ~i && (t.indexOf("%") > i && (a *= e / 100), (t = t.substr(0, i - 1))), (t = a + (t in Wr ? Wr[t] * e : ~t.indexOf("%") ? (parseFloat(t) * e) / 100 : parseFloat(t) || 0));
        }
        return t;
      },
      Jr = function (t, e, i, a, n, r, s) {
        var o = n.startColor,
          l = n.endColor,
          c = n.fontSize,
          h = n.indent,
          u = n.fontWeight,
          d = vn.createElement("div"),
          p = fr(i) || "fixed" === mr(i, "pinType"),
          f = -1 !== t.indexOf("scroller"),
          m = p ? bn : i,
          g = -1 !== t.indexOf("start"),
          y = g ? o : l,
          v = "border-color:" + y + ";font-size:" + c + ";color:" + y + ";font-weight:" + u + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
        return (
          (v += "position:" + (f && p ? "fixed;" : "absolute;")),
          (f || !p) && (v += (a === Pr ? "right" : "bottom") + ":" + (r + parseFloat(h)) + "px;"),
          s && (v += "box-sizing:border-box;text-align:left;width:" + s.offsetWidth + "px;"),
          (d._isStart = g),
          d.setAttribute("class", "gsap-marker-" + t),
          (d.style.cssText = v),
          (d.innerText = e || 0 === e ? t + "-" + e : t),
          m.children[0] ? m.insertBefore(d, m.children[0]) : m.appendChild(d),
          (d._offset = d["offset" + a.op.d2]),
          zr(d, 0, a, g),
          d
        );
      },
      zr = function (t, e, i, a) {
        var n = { display: "block" },
          r = i[a ? "os2" : "p2"],
          s = i[a ? "p2" : "os2"];
        (t._isFlipped = a), (n[i.a + "Percent"] = a ? -100 : 0), (n[i.a] = a ? "1px" : 0), (n["border" + r + "Width"] = 1), (n["border" + s + "Width"] = 0), (n[i.p] = e + "px"), mn.set(t, n);
      },
      Kr = [],
      Gr = {},
      jr = function () {
        return kn || (kn = Sn(ls));
      },
      Hr = function () {
        kn || ((kn = Sn(ls)), lr || es("scrollStart"), (lr = sr()));
      },
      Yr = function () {
        return !Mn && !qn && !vn.fullscreenElement && Cn.restart(!0);
      },
      Qr = {},
      Xr = [],
      Zr = [],
      $r = function (t) {
        var e,
          i = mn.ticker.frame,
          a = [],
          n = 0;
        if (Wn !== i || ar) {
          for (ns(); n < Zr.length; n += 4) (e = yn.matchMedia(Zr[n]).matches) !== Zr[n + 3] && ((Zr[n + 3] = e), e ? a.push(n) : ns(1, Zr[n]) || (wr(Zr[n + 2]) && Zr[n + 2]()));
          for (as(), n = 0; n < a.length; n++) (e = a[n]), (Vn = Zr[e]), (Zr[e + 2] = Zr[e + 1](t));
          (Vn = 0), gn && rs(0, 1), (Wn = i), es("matchMedia");
        }
      },
      ts = function t() {
        return qr(bs, "scrollEnd", t) || rs(!0);
      },
      es = function (t) {
        return (
          (Qr[t] &&
            Qr[t].map(function (t) {
              return t();
            })) ||
          Xr
        );
      },
      is = [],
      as = function (t) {
        for (var e = 0; e < is.length; e += 4) (t && is[e + 3] !== t) || ((is[e].style.cssText = is[e + 1]), (is[e + 2].uncache = 1));
      },
      ns = function (t, e) {
        var i;
        for (In = 0; In < Kr.length; In++) (i = Kr[In]), (e && i.media !== e) || (t ? i.kill(1) : (i.scroll.rec || (i.scroll.rec = i.scroll()), i.revert()));
        as(e), e || es("revert");
      },
      rs = function (t, e) {
        if (!lr || t) {
          var i = es("refreshInit");
          for (On && bs.sort(), e || ns(), In = 0; In < Kr.length; In++) Kr[In].refresh();
          for (
            i.forEach(function (t) {
              return t && t.render && t.render(-1);
            }),
              In = Kr.length;
            In--;

          )
            Kr[In].scroll.rec = 0;
          Cn.pause(), es("refresh");
        } else Br(bs, "scrollEnd", ts);
      },
      ss = 0,
      os = 1,
      ls = function () {
        var t = Kr.length,
          e = sr(),
          i = e - or >= 50,
          a = t && Kr[0].scroll();
        if (((os = ss > a ? -1 : 1), (ss = a), i && (lr && !Pn && e - lr > 200 && ((lr = 0), es("scrollEnd")), (_n = or), (or = e)), os < 0)) {
          for (In = t; In-- > 0; ) Kr[In] && Kr[In].update(0, i);
          os = 1;
        } else for (In = 0; In < t; In++) Kr[In] && Kr[In].update(0, i);
        kn = 0;
      },
      cs = ["left", "top", "bottom", "right", "marginBottom", "marginRight", "marginTop", "marginLeft", "display", "flexShrink", "float", "zIndex"],
      hs = cs.concat(["width", "height", "boxSizing", "maxWidth", "maxHeight", "position", "margin", _r, "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"]),
      us = function (t, e, i, a) {
        if (t.parentNode !== e) {
          for (var n, r = cs.length, s = e.style, o = t.style; r--; ) s[(n = cs[r])] = i[n];
          (s.position = "absolute" === i.position ? "absolute" : "relative"),
            "inline" === i.display && (s.display = "inline-block"),
            (o.bottom = o.right = "auto"),
            (s.overflow = "visible"),
            (s.boxSizing = "border-box"),
            (s.width = Rr(t, Mr) + Tr),
            (s.height = Rr(t, Pr) + Tr),
            (s.padding = o.margin = o.top = o.left = "0"),
            ps(a),
            (o.width = o.maxWidth = i.width),
            (o.height = o.maxHeight = i.height),
            (o.padding = i.padding),
            t.parentNode.insertBefore(e, t),
            e.appendChild(t);
        }
      },
      ds = /([A-Z])/g,
      ps = function (t) {
        if (t) {
          var e,
            i,
            a = t.t.style,
            n = t.length,
            r = 0;
          for ((t.t._gsap || mn.core.getCache(t.t)).uncache = 1; r < n; r += 2) (i = t[r + 1]), (e = t[r]), i ? (a[e] = i) : a[e] && a.removeProperty(e.replace(ds, "-$1").toLowerCase());
        }
      },
      fs = function (t) {
        for (var e = hs.length, i = t.style, a = [], n = 0; n < e; n++) a.push(hs[n], i[hs[n]]);
        return (a.t = t), a;
      },
      ms = { left: 0, top: 0 },
      gs = function (t, e, i, a, n, r, s, o, l, c, h, u) {
        if ((wr(t) && (t = t(o)), br(t) && "max" === t.substr(0, 3) && (t = u + ("=" === t.charAt(4) ? Ur("0" + t.substr(3), i) : 0)), Cr(t))) s && zr(s, i, a, !0);
        else {
          wr(e) && (e = e(o));
          var d,
            p,
            f,
            m = En(e)[0] || bn,
            g = Lr(m) || {},
            y = t.split(" ");
          (g && (g.left || g.top)) || "none" !== Dr(m).display || ((f = m.style.display), (m.style.display = "block"), (g = Lr(m)), f ? (m.style.display = f) : m.style.removeProperty("display")),
            (d = Ur(y[0], g[a.d])),
            (p = Ur(y[1] || "0", i)),
            (t = g[a.p] - l[a.p] - c + d + n - p),
            s && zr(s, p, a, i - p < 20 || (s._isStart && p > 20)),
            (i -= i - p);
        }
        if (r) {
          var v = t + i,
            A = r._isStart;
          (u = "scroll" + a.d2), zr(r, v, a, (A && v > 20) || (!A && (h ? Math.max(bn[u], An[u]) : r.parentNode[u]) <= v + 1)), h && ((l = Lr(s)), h && (r.style[a.op.p] = l[a.op.p] - a.op.m - r._offset + Tr));
        }
        return Math.round(t);
      },
      ys = /(?:webkit|moz|length|cssText|inset)/i,
      vs = function (t, e, i, a) {
        if (t.parentNode !== e) {
          var n,
            r,
            s = t.style;
          if (e === bn) {
            for (n in ((t._stOrig = s.cssText), (r = Dr(t)))) +n || ys.test(n) || !r[n] || "string" != typeof s[n] || "0" === n || (s[n] = r[n]);
            (s.top = i), (s.left = a);
          } else s.cssText = t._stOrig;
          (mn.core.getCache(t).uncache = 1), e.appendChild(t);
        }
      },
      As = function (t, e) {
        var i,
          a,
          n = gr(t, e),
          r = "_scroll" + e.p2,
          s = function e(s, o, l, c, h) {
            var u = e.tween,
              d = o.onComplete,
              p = {};
            return (
              u && u.kill(),
              (i = Math.round(l)),
              (o[r] = s),
              (o.modifiers = p),
              (p[r] = function (t) {
                return (t = ur(n())) !== i && t !== a && Math.abs(t - i) > 2 ? (u.kill(), (e.tween = 0)) : (t = l + c * u.ratio + h * u.ratio * u.ratio), (a = i), (i = ur(t));
              }),
              (o.onComplete = function () {
                (e.tween = 0), d && d.call(u);
              }),
              (u = e.tween = mn.to(t, o))
            );
          };
        return (
          (t[r] = n),
          t.addEventListener("wheel", function () {
            return s.tween && s.tween.kill() && (s.tween = 0);
          }),
          s
        );
      };
    Mr.op = Pr;
    var bs = (function () {
      function t(e, i) {
        gn || t.register(mn) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), this.init(e, i);
      }
      return (
        (t.prototype.init = function (e, i) {
          if (((this.progress = this.start = 0), this.vars && this.kill(1), cr)) {
            var a,
              n,
              r,
              s,
              o,
              l,
              c,
              h,
              u,
              d,
              p,
              f,
              m,
              g,
              y,
              v,
              A,
              b,
              w,
              C,
              S,
              k,
              E,
              x,
              _,
              T,
              M,
              P,
              D,
              I,
              L,
              R,
              F,
              O,
              B,
              q,
              N,
              V,
              W,
              U = (e = Ir(br(e) || Cr(e) || e.nodeType ? { trigger: e } : e, Vr)).horizontal ? Mr : Pr,
              J = e,
              z = J.onUpdate,
              K = J.toggleClass,
              G = J.id,
              j = J.onToggle,
              H = J.onRefresh,
              Y = J.scrub,
              Q = J.trigger,
              X = J.pin,
              Z = J.pinSpacing,
              $ = J.invalidateOnRefresh,
              tt = J.anticipatePin,
              et = J.onScrubComplete,
              it = J.onSnapComplete,
              at = J.once,
              nt = J.snap,
              rt = J.pinReparent,
              st = !Y && 0 !== Y,
              ot = En(e.scroller || yn)[0],
              lt = mn.core.getCache(ot),
              ct = fr(ot),
              ht = "pinType" in e ? "fixed" === e.pinType : ct || "fixed" === mr(ot, "pinType"),
              ut = [e.onEnter, e.onLeave, e.onEnterBack, e.onLeaveBack],
              dt = st && e.toggleActions.split(" "),
              pt = "markers" in e ? e.markers : Vr.markers,
              ft = ct ? 0 : parseFloat(Dr(ot)["border" + U.p2 + "Width"]) || 0,
              mt = this,
              gt =
                e.onRefreshInit &&
                function () {
                  return e.onRefreshInit(mt);
                },
              yt = (function (t, e, i) {
                var a = i.d,
                  n = i.d2,
                  r = i.a;
                return (r = mr(t, "getBoundingClientRect"))
                  ? function () {
                      return r()[a];
                    }
                  : function () {
                      return (e ? yn["inner" + n] : t["client" + n]) || 0;
                    };
              })(ot, ct, U),
              vt = (function (t, e) {
                return !e || ~nr.indexOf(t)
                  ? yr(t)
                  : function () {
                      return ms;
                    };
              })(ot, ct);
            (mt.media = Vn),
              (tt *= 45),
              Kr.push(mt),
              (mt.scroller = ot),
              (mt.scroll = gr(ot, U)),
              (o = mt.scroll()),
              (mt.vars = e),
              (i = i || e.animation),
              "refreshPriority" in e && (On = 1),
              (lt.tweenScroll = lt.tweenScroll || { top: As(ot, Pr), left: As(ot, Mr) }),
              (mt.tweenTo = a = lt.tweenScroll[U.p]),
              i &&
                ((i.vars.lazy = !1),
                i._initted || (!1 !== i.vars.immediateRender && !1 !== e.immediateRender && i.render(0, !0, !0)),
                (mt.animation = i.pause()),
                (i.scrollTrigger = mt),
                (R = Cr(Y) && Y) &&
                  (L = mn.to(i, {
                    ease: "power3",
                    duration: R,
                    onComplete: function () {
                      return et && et(mt);
                    },
                  })),
                (D = 0),
                G || (G = i.vars.id)),
              nt &&
                (Sr(nt) || (nt = { snapTo: nt }),
                "scrollBehavior" in bn.style && mn.set(ct ? [bn, An] : ot, { scrollBehavior: "auto" }),
                (r = wr(nt.snapTo)
                  ? nt.snapTo
                  : "labels" === nt.snapTo
                  ? (function (t) {
                      return function (e) {
                        return mn.utils.snap(Fr(t), e);
                      };
                    })(i)
                  : "labelsDirectional" === nt.snapTo
                  ? ((V = i),
                    function (t, e) {
                      var i,
                        a = Fr(V);
                      if (
                        (a.sort(function (t, e) {
                          return t - e;
                        }),
                        e.direction > 0)
                      ) {
                        for (t -= 1e-4, i = 0; i < a.length; i++) if (a[i] >= t) return a[i];
                        return a.pop();
                      }
                      for (i = a.length, t += 1e-4; i--; ) if (a[i] <= t) return a[i];
                      return a[0];
                    })
                  : mn.utils.snap(nt.snapTo)),
                (F = nt.duration || { min: 0.1, max: 2 }),
                (F = Sr(F) ? xn(F.min, F.max) : xn(F, F)),
                (O = mn
                  .delayedCall(nt.delay || R / 2 || 0.1, function () {
                    if (Math.abs(mt.getVelocity()) < 10 && !Pn) {
                      var t = i && !st ? i.totalProgress() : mt.progress,
                        e = ((t - I) / (sr() - _n)) * 1e3 || 0,
                        n = (xr(e / 2) * e) / 0.185,
                        s = t + (!1 === nt.inertia ? 0 : n),
                        o = xn(0, 1, r(s, mt)),
                        l = mt.scroll(),
                        u = Math.round(c + o * g),
                        d = nt,
                        p = d.onStart,
                        f = d.onInterrupt,
                        m = d.onComplete,
                        y = a.tween;
                      if (l <= h && l >= c && u !== l) {
                        if (y && !y._initted && y.data <= Math.abs(u - l)) return;
                        a(
                          u,
                          {
                            duration: F(xr((0.185 * Math.max(xr(s - t), xr(o - t))) / e / 0.05 || 0)),
                            ease: nt.ease || "power3",
                            data: Math.abs(u - l),
                            onInterrupt: function () {
                              return O.restart(!0) && f && f(mt);
                            },
                            onComplete: function () {
                              (D = I = i && !st ? i.totalProgress() : mt.progress), it && it(mt), m && m(mt);
                            },
                          },
                          l,
                          n * g,
                          u - l - n * g
                        ),
                          p && p(mt, a.tween);
                      }
                    } else mt.isActive && O.restart(!0);
                  })
                  .pause())),
              G && (Gr[G] = mt),
              (Q = mt.trigger = En(Q || X)[0]),
              (X = !0 === X ? Q : En(X)[0]),
              br(K) && (K = { targets: Q, className: K }),
              X &&
                (!1 === Z || "margin" === Z || (Z = !(!Z && "flex" === Dr(X.parentNode).display) && _r),
                (mt.pin = X),
                !1 !== e.force3D && mn.set(X, { force3D: !0 }),
                (n = mn.core.getCache(X)).spacer ? (y = n.pinState) : ((n.spacer = b = vn.createElement("div")), b.setAttribute("class", "pin-spacer" + (G ? " pin-spacer-" + G : "")), (n.pinState = y = fs(X))),
                (mt.spacer = b = n.spacer),
                (P = Dr(X)),
                (x = P[Z + U.os2]),
                (C = mn.getProperty(X)),
                (S = mn.quickSetter(X, U.a, Tr)),
                us(X, b, P),
                (A = fs(X))),
              pt &&
                ((m = Sr(pt) ? Ir(pt, Nr) : Nr),
                (p = Jr("scroller-start", G, ot, U, m, 0)),
                (f = Jr("scroller-end", G, ot, U, m, 0, p)),
                (w = p["offset" + U.op.d2]),
                (u = Jr("start", G, ot, U, m, w)),
                (d = Jr("end", G, ot, U, m, w)),
                ht || (((W = ct ? bn : ot).style.position = "absolute" === Dr(W).position ? "absolute" : "relative"), mn.set([p, f], { force3D: !0 }), (T = mn.quickSetter(p, U.a, Tr)), (M = mn.quickSetter(f, U.a, Tr)))),
              (mt.revert = function (t) {
                var e = !1 !== t || !mt.enabled,
                  a = Mn;
                e !== s &&
                  (e && ((q = Math.max(mt.scroll(), mt.scroll.rec || 0)), (B = mt.progress), (N = i && i.progress())),
                  u &&
                    [u, d, p, f].forEach(function (t) {
                      return (t.style.display = e ? "none" : "block");
                    }),
                  e && (Mn = 1),
                  mt.update(e),
                  (Mn = a),
                  X &&
                    (e
                      ? (function (t, e, i) {
                          if ((ps(i), t.parentNode === e)) {
                            var a = e.parentNode;
                            a && (a.insertBefore(t, e), a.removeChild(e));
                          }
                        })(X, b, y)
                      : (!rt || !mt.isActive) && us(X, b, Dr(X), _)),
                  (s = e));
              }),
              (mt.refresh = function (a, n) {
                if ((!Mn && mt.enabled) || n)
                  if (X && a && lr) Br(t, "scrollEnd", ts);
                  else {
                    (Mn = 1), L && L.pause(), $ && i && i.progress(0).invalidate(), s || mt.revert();
                    for (
                      var r,
                        m,
                        w,
                        S,
                        x,
                        T,
                        M,
                        P,
                        D,
                        I = yt(),
                        R = vt(),
                        F = vr(ot, U),
                        O = 0,
                        V = 0,
                        W = e.end,
                        J = e.endTrigger || Q,
                        z = e.start || (0 !== e.start && Q ? (X ? "0 0" : "0 100%") : 0),
                        K = (Q && Math.max(0, Kr.indexOf(mt))) || 0,
                        G = K;
                      G--;

                    )
                      (T = Kr[G]).end || T.refresh(0, 1) || (Mn = 1), (M = T.pin) && (M === Q || M === X) && T.revert();
                    for (
                      c = gs(z, Q, I, U, mt.scroll(), u, p, mt, R, ft, ht, F) || (X ? -0.001 : 0),
                        wr(W) && (W = W(mt)),
                        br(W) && !W.indexOf("+=") && (~W.indexOf(" ") ? (W = (br(z) ? z.split(" ")[0] : "") + W) : ((O = Ur(W.substr(2), I)), (W = br(z) ? z : c + O), (J = Q))),
                        h = Math.max(c, gs(W || (J ? "100% 0" : F), J, I, U, mt.scroll() + O, d, f, mt, R, ft, ht, F)) || -0.001,
                        g = h - c || ((c -= 0.01) && 0.001),
                        O = 0,
                        G = K;
                      G--;

                    )
                      (M = (T = Kr[G]).pin) && T.start - T._pinPush < c && ((r = T.end - T.start), M === Q && (O += r), M === X && (V += r));
                    if (((c += O), (h += O), (mt._pinPush = V), u && O && (((r = {})[U.a] = "+=" + O), mn.set([u, d], r)), X))
                      (r = Dr(X)),
                        (S = U === Pr),
                        (w = mt.scroll()),
                        (k = parseFloat(C(U.a)) + V),
                        !F && h > 1 && ((ct ? bn : ot).style["overflow-" + U.a] = "scroll"),
                        us(X, b, r),
                        (A = fs(X)),
                        (m = Lr(X, !0)),
                        (P = ht && gr(ot, S ? Mr : Pr)()),
                        Z && (((_ = [Z + U.os2, g + V + Tr]).t = b), (G = Z === _r ? Rr(X, U) + g + V : 0) && _.push(U.d, G + Tr), ps(_), ht && mt.scroll(q)),
                        ht &&
                          (((x = { top: m.top + (S ? w - c : P) + Tr, left: m.left + (S ? P : w - c) + Tr, boxSizing: "border-box", position: "fixed" }).width = x.maxWidth = Math.ceil(m.width) + Tr),
                          (x.height = x.maxHeight = Math.ceil(m.height) + Tr),
                          (x.margin = x.marginTop = x.marginRight = x.marginBottom = x.marginLeft = "0"),
                          (x.padding = r.padding),
                          (x.paddingTop = r.paddingTop),
                          (x.paddingRight = r.paddingRight),
                          (x.paddingBottom = r.paddingBottom),
                          (x.paddingLeft = r.paddingLeft),
                          (v = (function (t, e, i) {
                            for (var a, n = [], r = t.length, s = i ? 8 : 0; s < r; s += 2) (a = t[s]), n.push(a, a in e ? e[a] : t[s + 1]);
                            return (n.t = t.t), n;
                          })(y, x, rt))),
                        i ? ((D = i._initted), Bn(1), i.progress(1, !0), (E = C(U.a) - k + g + V), g !== E && v.splice(v.length - 2, 2), i.progress(0, !0), D || i.invalidate(), Bn(0)) : (E = g);
                    else if (Q && mt.scroll()) for (m = Q.parentNode; m && m !== bn; ) m._pinOffset && ((c -= m._pinOffset), (h -= m._pinOffset)), (m = m.parentNode);
                    for (G = 0; G < K; G++) (T = Kr[G].pin) && (T === Q || T === X) && Kr[G].revert(!1);
                    (mt.start = c),
                      (mt.end = h),
                      (o = l = mt.scroll()) < q && mt.scroll(q),
                      mt.revert(!1),
                      (Mn = 0),
                      i && st && i._initted && i.progress(N, !0).render(i.time(), !0, !0),
                      B !== mt.progress && (L && i.totalProgress(B, !0), (mt.progress = B), mt.update()),
                      X && Z && (b._pinOffset = Math.round(mt.progress * E)),
                      H && H(mt);
                  }
              }),
              (mt.getVelocity = function () {
                return ((mt.scroll() - l) / (sr() - _n)) * 1e3 || 0;
              }),
              (mt.update = function (t, e) {
                var n,
                  r,
                  s,
                  u,
                  d,
                  f = mt.scroll(),
                  m = t ? 0 : (f - c) / g,
                  y = m < 0 ? 0 : m > 1 ? 1 : m || 0,
                  w = mt.progress;
                if ((e && ((l = o), (o = f), nt && ((I = D), (D = i && !st ? i.totalProgress() : y))), tt && !y && X && !Mn && !ar && lr && c < f + ((f - l) / (sr() - _n)) * tt && (y = 1e-4), y !== w && mt.enabled)) {
                  if (
                    ((u = (d = (n = mt.isActive = !!y && y < 1) !== (!!w && w < 1)) || !!y != !!w),
                    (mt.direction = y > w ? 1 : -1),
                    (mt.progress = y),
                    st || (!L || Mn || ar ? i && i.totalProgress(y, !!Mn) : ((L.vars.totalProgress = y), L.invalidate().restart())),
                    X)
                  )
                    if ((t && Z && (b.style[Z + U.os2] = x), ht)) {
                      if (u) {
                        if (((s = !t && y > w && h + 1 > f && f + 1 >= vr(ot, U)), rt))
                          if (t || (!n && !s)) vs(X, b);
                          else {
                            var C = Lr(X, !0),
                              _ = f - c;
                            vs(X, bn, C.top + (U === Pr ? _ : 0) + Tr, C.left + (U === Pr ? 0 : _) + Tr);
                          }
                        ps(n || s ? v : A), (E !== g && y < 1 && n) || S(k + (1 !== y || s ? 0 : E));
                      }
                    } else S(k + E * y);
                  nt && !a.tween && !Mn && !ar && O.restart(!0),
                    K &&
                      (d || (at && y && (y < 1 || !Nn))) &&
                      En(K.targets).forEach(function (t) {
                        return t.classList[n || at ? "add" : "remove"](K.className);
                      }),
                    z && !st && !t && z(mt),
                    u && !Mn
                      ? ((r = y && !w ? 0 : 1 === y ? 1 : 1 === w ? 2 : 3),
                        st &&
                          ((s = (!d && "none" !== dt[r + 1] && dt[r + 1]) || dt[r]),
                          i && ("complete" === s || "reset" === s || s in i) && ("complete" === s ? i.pause().totalProgress(1) : "reset" === s ? i.restart(!0).pause() : i[s]()),
                          z && z(mt)),
                        (!d && Nn) || (j && d && j(mt), ut[r] && ut[r](mt), at && (1 === y ? mt.kill(!1, 1) : (ut[r] = 0)), d || (ut[(r = 1 === y ? 1 : 3)] && ut[r](mt))))
                      : st && z && !Mn && z(mt);
                }
                M && (T(f + (p._isFlipped ? 1 : 0)), M(f));
              }),
              (mt.enable = function () {
                mt.enabled ||
                  ((mt.enabled = !0),
                  Br(ot, "resize", Yr),
                  Br(ot, "scroll", Hr),
                  gt && Br(t, "refreshInit", gt),
                  i && i.add
                    ? mn.delayedCall(0.01, function () {
                        return c || h || mt.refresh();
                      }) &&
                      (g = 0.01) &&
                      (c = h = 0)
                    : mt.refresh());
              }),
              (mt.disable = function (e, i) {
                if (
                  mt.enabled &&
                  (!1 !== e && mt.revert(), (mt.enabled = mt.isActive = !1), i || (L && L.pause()), (q = 0), n && (n.uncache = 1), gt && qr(t, "refreshInit", gt), O && (O.pause(), a.tween && a.tween.kill() && (a.tween = 0)), !ct)
                ) {
                  for (var r = Kr.length; r--; ) if (Kr[r].scroller === ot && Kr[r] !== mt) return;
                  qr(ot, "resize", Yr), qr(ot, "scroll", Hr);
                }
              }),
              (mt.kill = function (t, e) {
                mt.disable(t, e), G && delete Gr[G];
                var a = Kr.indexOf(mt);
                Kr.splice(a, 1),
                  a === In && os > 0 && In--,
                  i && ((i.scrollTrigger = null), t && i.render(-1), e || i.kill()),
                  u &&
                    [u, d, p, f].forEach(function (t) {
                      return t.parentNode.removeChild(t);
                    }),
                  X &&
                    (n && (n.uncache = 1),
                    (a = 0),
                    Kr.forEach(function (t) {
                      return t.pin === X && a++;
                    }),
                    a || (n.spacer = 0));
              }),
              mt.enable();
          } else this.update = this.refresh = this.kill = hr;
        }),
        (t.register = function (e) {
          if (
            !gn &&
            ((mn = e || pr()),
            dr() && window.document && ((yn = window), (vn = document), (An = vn.documentElement), (bn = vn.body)),
            mn && ((En = mn.utils.toArray), (xn = mn.utils.clamp), (Bn = mn.core.suppressOverwrites || hr), mn.core.globals("ScrollTrigger", t), bn))
          ) {
            (Sn =
              yn.requestAnimationFrame ||
              function (t) {
                return setTimeout(t, 16);
              }),
              Br(yn, "wheel", Hr),
              (wn = [yn, vn, An, bn]),
              Br(vn, "scroll", Hr);
            var i,
              a = bn.style,
              n = a.borderTop;
            (a.borderTop = "1px solid #000"),
              (i = Lr(bn)),
              (Pr.m = Math.round(i.top + Pr.sc()) || 0),
              (Mr.m = Math.round(i.left + Mr.sc()) || 0),
              n ? (a.borderTop = n) : a.removeProperty("border-top"),
              (Tn = setInterval(jr, 200)),
              mn.delayedCall(0.5, function () {
                return (ar = 0);
              }),
              Br(vn, "touchcancel", hr),
              Br(bn, "touchstart", hr),
              Or(Br, vn, "pointerdown,touchstart,mousedown", function () {
                return (Pn = 1);
              }),
              Or(Br, vn, "pointerup,touchend,mouseup", function () {
                return (Pn = 0);
              }),
              (Dn = mn.utils.checkPrefix("transform")),
              hs.push(Dn),
              (gn = sr()),
              (Cn = mn.delayedCall(0.2, rs).pause()),
              (Fn = [
                vn,
                "visibilitychange",
                function () {
                  var t = yn.innerWidth,
                    e = yn.innerHeight;
                  vn.hidden ? ((Ln = t), (Rn = e)) : (Ln === t && Rn === e) || Yr();
                },
                vn,
                "DOMContentLoaded",
                rs,
                yn,
                "load",
                function () {
                  return lr || rs();
                },
                yn,
                "resize",
                Yr,
              ]),
              Ar(Br);
          }
          return gn;
        }),
        (t.defaults = function (t) {
          for (var e in t) Vr[e] = t[e];
        }),
        (t.kill = function () {
          (cr = 0),
            Kr.slice(0).forEach(function (t) {
              return t.kill(1);
            });
        }),
        (t.config = function (t) {
          "limitCallbacks" in t && (Nn = !!t.limitCallbacks);
          var e = t.syncInterval;
          (e && clearInterval(Tn)) || ((Tn = e) && setInterval(jr, e)), "autoRefreshEvents" in t && (Ar(qr) || Ar(Br, t.autoRefreshEvents || "none"), (qn = -1 === (t.autoRefreshEvents + "").indexOf("resize")));
        }),
        (t.scrollerProxy = function (t, e) {
          var i = En(t)[0],
            a = rr.indexOf(i),
            n = fr(i);
          ~a && rr.splice(a, n ? 6 : 2), n ? nr.unshift(yn, e, bn, e, An, e) : nr.unshift(i, e);
        }),
        (t.matchMedia = function (t) {
          var e, i, a, n, r;
          for (i in t)
            (a = Zr.indexOf(i)),
              (n = t[i]),
              (Vn = i),
              "all" === i
                ? n()
                : (e = yn.matchMedia(i)) &&
                  (e.matches && (r = n()),
                  ~a ? ((Zr[a + 1] = Er(Zr[a + 1], n)), (Zr[a + 2] = Er(Zr[a + 2], r))) : ((a = Zr.length), Zr.push(i, n, r), e.addListener ? e.addListener($r) : e.addEventListener("change", $r)),
                  (Zr[a + 3] = e.matches)),
              (Vn = 0);
          return Zr;
        }),
        (t.clearMatchMedia = function (t) {
          t || (Zr.length = 0), (t = Zr.indexOf(t)) >= 0 && Zr.splice(t, 4);
        }),
        t
      );
    })();
    (bs.version = "3.6.1"),
      (bs.saveStyles = function (t) {
        return t
          ? En(t).forEach(function (t) {
              if (t && t.style) {
                var e = is.indexOf(t);
                e >= 0 && is.splice(e, 4), is.push(t, t.style.cssText, mn.core.getCache(t), Vn);
              }
            })
          : is;
      }),
      (bs.revert = function (t, e) {
        return ns(!t, e);
      }),
      (bs.create = function (t, e) {
        return new bs(t, e);
      }),
      (bs.refresh = function (t) {
        return t ? Yr() : rs(!0);
      }),
      (bs.update = ls),
      (bs.maxScroll = function (t, e) {
        return vr(t, e ? Mr : Pr);
      }),
      (bs.getScrollFunc = function (t, e) {
        return gr(En(t)[0], e ? Mr : Pr);
      }),
      (bs.getById = function (t) {
        return Gr[t];
      }),
      (bs.getAll = function () {
        return Kr.slice(0);
      }),
      (bs.isScrolling = function () {
        return !!lr;
      }),
      (bs.addEventListener = function (t, e) {
        var i = Qr[t] || (Qr[t] = []);
        ~i.indexOf(e) || i.push(e);
      }),
      (bs.removeEventListener = function (t, e) {
        var i = Qr[t],
          a = i && i.indexOf(e);
        a >= 0 && i.splice(a, 1);
      }),
      (bs.batch = function (t, e) {
        var i,
          a = [],
          n = {},
          r = e.interval || 0.016,
          s = e.batchMax || 1e9,
          o = function (t, e) {
            var i = [],
              a = [],
              n = mn
                .delayedCall(r, function () {
                  e(i, a), (i = []), (a = []);
                })
                .pause();
            return function (t) {
              i.length || n.restart(!0), i.push(t.trigger), a.push(t), s <= i.length && n.progress(1);
            };
          };
        for (i in e) n[i] = "on" === i.substr(0, 2) && wr(e[i]) && "onRefreshInit" !== i ? o(0, e[i]) : e[i];
        return (
          wr(s) &&
            ((s = s()),
            Br(bs, "refresh", function () {
              return (s = e.batchMax());
            })),
          En(t).forEach(function (t) {
            var e = {};
            for (i in n) e[i] = n[i];
            (e.trigger = t), a.push(bs.create(e));
          }),
          a
        );
      }),
      (bs.sort = function (t) {
        return Kr.sort(
          t ||
            function (t, e) {
              return -1e6 * (t.vars.refreshPriority || 0) + t.start - (e.start + -1e6 * (e.vars.refreshPriority || 0));
            }
        );
      }),
      pr() && mn.registerPlugin(bs);
    var ws = i(9),
      Cs = (function () {
        function t(e, i) {
          zn()(this, t),
            (this.selector = e),
            (this.options = i || {}),
            (this.breakpoint = this.options.breakpoint || 797),
            (this.swipeThreshold = this.options.swipeThreshold || 10),
            (this.xOffset = this.options.xOffset || 60),
            (this.addCSS = void 0 === this.options.addCSS || this.options.addCSS),
            (this.calcHeight = this.options.calcHeight || !1),
            (this.addAnimations = this.options.addAnimations || !0),
            (this.hitPoints = void 0 === this.options.hitPoints || this.options.hitPoints),
            (this.slideSelector = this.options.slideSelector || ".js-slider-cell"),
            (this.arrows = this.options.arrows || !1),
            (this.dots = this.options.dots || !1),
            (this.infinite = void 0 === this.options.infinite || this.options.infinite),
            (this.autoPlay = this.options.autoPlay || !1),
            (this.slider = "object" === y()(this.selector) ? this.selector : document.querySelector(this.selector)),
            (this.slideEls = this.slider.querySelectorAll(this.slideSelector)),
            (this.slides = []),
            (this.index = 0),
            (this.count = null),
            (this.current = null),
            (this.next = null),
            (this.previous = null),
            (this.direction = null),
            (this.target = null),
            (this.mobile = !1),
            (this.touch = !1),
            (this.hammerInstance = null),
            (this.animating = !1),
            (this.mouseover = !1),
            (this.prevTrigger = []),
            (this.nextTrigger = []),
            (this.dotsArr = []),
            (this.events = { slideChangeStart: null, slideChangeEnd: null, slideChangeData: {} });
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                z.windowWidth < this.breakpoint && (this.mobile = !0),
                  z.isMobile && (this.touch = !0),
                  this.initSlides(),
                  this.initEvents(),
                  this.calculateHeight(),
                  this.createHitPoints(),
                  this.activateHitPoints(),
                  this.createArrows(),
                  this.createDots(),
                  this.activateArrows(),
                  this.mouseListener(),
                  this.activateAutoplay();
              },
            },
            {
              key: "initSlides",
              value: function () {
                if ((this.createSlideObjects(), this.addCSS)) {
                  for (var t = 0; t < this.count; t++) this.slides[t].el.setAttribute("style", "position: absolute; top: 0; left: 0; bottom: 0; right: 0;");
                  for (var e = 0; e < this.count; e++) this.slides[e] !== this.current && (this.slides[e].el.style.opacity = 0);
                }
                this.count > 2 ? ((this.next = this.slides[1]), (this.previous = this.slides[this.count - 1])) : ((this.next = this.slides[1]), (this.previous = this.slides[1])),
                  this.current.el.classList.add("is-selected"),
                  this.previous.el.classList.add("is-previous"),
                  this.next.el.classList.add("is-next");
              },
            },
            {
              key: "createSlideObjects",
              value: function () {
                for (var t, e = 0; e < this.slideEls.length; e++) (t = { el: this.slideEls[e], index: e }), this.slides.push(t);
                (this.count = this.slides.length), (this.current = this.slides[this.index]);
              },
            },
            {
              key: "initEvents",
              value: function () {
                (this.events.slideChangeStart = new CustomEvent("slideChangeStart")), (this.events.slideChangeEnd = new CustomEvent("slideChangeEnd"));
              },
            },
            {
              key: "updateSlideChangeData",
              value: function () {
                this.events.slideChangeData = { direction: this.direction, index: this.index, current: this.current, previous: this.previous, next: this.next, target: this.target };
              },
            },
            {
              key: "slideChangeStart",
              value: function () {
                (this.animating = !0), this.updateSlideChangeData(), (this.events.slideChangeStart.data = this.events.slideChangeData), this.slider.dispatchEvent(this.events.slideChangeStart);
              },
            },
            {
              key: "slideChangeEnd",
              value: function (t) {
                this.updateSlideChangeData(), (this.events.slideChangeEnd.data = this.events.slideChangeData), this.slider.dispatchEvent(this.events.slideChangeEnd), (this.animating = !1);
              },
            },
            {
              key: "createDots",
              value: function () {
                var t = this;
                if (this.dots)
                  switch (this.dots) {
                    case "auto":
                      var e = document.createElement("div");
                      e.classList.add("js-dot-wrapper"), this.addCSS && e.setAttribute("style", "position:absolute; height:30px; bottom:0; right:50%; z-index:1; display:flex; justify-content:center;");
                      for (var i = 0; i < this.count; i++) {
                        var a = document.createElement("div");
                        a.classList.add("js-dot"), 0 == i && a.classList.add("is-selected"), this.addCSS && a.setAttribute("style", "height:30px; width: 30px; padding: 7px;");
                      }
                      break;
                    default:
                      var n = this.slider.parentElement.querySelectorAll(this.dots);
                      Array.prototype.slice.call(n).forEach(function (e) {
                        t.dotsArr.push(e);
                      });
                  }
              },
            },
            {
              key: "createArrows",
              value: function () {
                if (this.arrows) {
                  var t = this.slider.parentElement.querySelectorAll(this.arrows);
                  this.prevTrigger.push(t[0]), this.nextTrigger.push(t[1]);
                }
              },
            },
            {
              key: "activateArrows",
              value: function () {
                var t,
                  e = this;
                this.arrows &&
                  ((t = this.hitPoints ? 1 : 0),
                  this.prevTrigger[t].addEventListener("click", function () {
                    0 != e.animating || e.prevTrigger[t].classList.contains("disabled") || e.slideBackward(e);
                  }),
                  this.nextTrigger[t].addEventListener("click", function () {
                    0 != e.animating || e.nextTrigger[t].classList.contains("disabled") || e.slideForward(e);
                  }));
              },
            },
            {
              key: "calculateHeight",
              value: function () {
                if (this.calcHeight) {
                  var t,
                    e = 0;
                  Array.prototype.slice.call(this.slides).forEach(function (i) {
                    (t = i.el.getBoundingClientRect().height) > e && (e = t);
                  }),
                    Array.prototype.slice.call(this.slides).forEach(function (t) {
                      Un.set(t.el, { height: e });
                    }),
                    Un.set(this.slider, { height: e });
                }
              },
            },
            {
              key: "createHitPoints",
              value: function () {
                if (this.hitPoints)
                  if (this.mobile || this.touch) {
                    var t = document.createElement("div");
                    t.classList.add("js-prev-next-trigger"),
                      this.addCSS && t.setAttribute("style", "position:absolute; width:100%; top:0; right:0; bottom: 0; z-index: 2;"),
                      this.slider.appendChild(t),
                      this.nextTrigger.push(t),
                      this.prevTrigger.push(t);
                  } else {
                    var e = document.createElement("div");
                    e.classList.add("js-prev-trigger"), this.addCSS && e.setAttribute("style", "position:absolute; width:50%; top:0; left:0; bottom: 0; z-index: 2;"), this.slider.appendChild(e), this.prevTrigger.push(e);
                    var i = document.createElement("div");
                    i.classList.add("js-next-trigger"), this.addCSS && i.setAttribute("style", "position:absolute; width:50%; top:0; right:0; bottom: 0; z-index: 2;"), this.slider.appendChild(i), this.nextTrigger.push(i);
                  }
              },
            },
            {
              key: "panStart",
              value: function (t, e) {
                t.deltaX > this.swipeThreshold && this.slideBackward(this), t.deltaX < -1 * this.swipeThreshold && this.slideForward(this);
              },
            },
            {
              key: "activateHitPoints",
              value: function () {
                var t = this;
                if (this.hitPoints)
                  this.mobile || this.touch
                    ? ((this.hammerInstance = new ws(this.nextTrigger[0], { touchAction: "auto" })),
                      this.hammerInstance.get("pan").set({ direction: ws.DIRECTION_ALL }),
                      this.hammerInstance.on("panstart", function (e) {
                        t.panStart(e, t);
                      }))
                    : (this.prevTrigger[0].addEventListener("click", function () {
                        t.slideBackward(t);
                      }),
                      this.nextTrigger[0].addEventListener("click", function () {
                        t.slideForward(t);
                      }));
                else if (this.mobile || this.touch) {
                  this.hammerInstance = [];
                  for (var e = 0; e < this.count; e++) {
                    var i = new ws(this.slides[e].el, { touchAction: "auto" });
                    i.get("pan").set({ direction: ws.DIRECTION_ALL }),
                      i.on("panstart", function (e) {
                        t.panStart(e, t);
                      }),
                      this.hammerInstance.push(i);
                  }
                }
              },
            },
            {
              key: "mouseListener",
              value: function () {
                var t = this;
                this.slider.addEventListener("mouseenter", function () {
                  t.mouseover = !0;
                }),
                  this.slider.addEventListener("mouseleave", function () {
                    t.mouseover = !1;
                  });
              },
            },
            {
              key: "autoPlayForward",
              value: function () {
                0 == this.animating && this.slideForward(this);
              },
            },
            {
              key: "activateAutoplay",
              value: function () {
                var t = this;
                this.autoPlay &&
                  setInterval(function () {
                    0 == t.animating && 0 == t.mouseover && t.slideForward(t);
                  }, this.autoPlay);
              },
            },
            {
              key: "slideForward",
              value: function (t) {
                (this.infinite || this.index != this.count - 1) && ((this.direction = "forward"), this.animating || t.updateCurrent(this.direction));
              },
            },
            {
              key: "slideBackward",
              value: function (t) {
                (this.infinite || 0 != this.index) && ((this.direction = "backward"), this.animating || t.updateCurrent(this.direction));
              },
            },
            {
              key: "updateCurrent",
              value: function (t) {
                var e, i, a;
                switch (((this.target = "forward" === t ? this.next.index : this.previous.index), this.slideChangeStart(), t)) {
                  case "forward":
                    (e = -1 * this.xOffset),
                      this.addAnimations && this.tweenSlides(this.current, e, this.next),
                      this.count > 2
                        ? this.index == this.count - 1
                          ? ((i = this.index), (this.index = 0), (a = this.index + 1))
                          : this.index == this.count - 2
                          ? ((i = this.index), (this.index = this.index + 1), (a = 0))
                          : ((i = this.index), (this.index = this.index + 1), (a = this.index + 1))
                        : 0 == this.index
                        ? ((this.index = 1), (i = 0), (a = 0))
                        : ((this.index = 0), (i = 1), (a = 1));
                    break;
                  case "backward":
                    (e = this.xOffset),
                      this.addAnimations && this.tweenSlides(this.current, e, this.previous),
                      this.count > 2
                        ? 0 == this.index
                          ? ((a = this.index), (this.index = this.count - 1), (i = this.index - 1))
                          : 1 == this.index
                          ? ((a = this.index), (this.index = this.index - 1), (i = this.count - 1))
                          : ((a = this.index), (this.index = this.index - 1), (i = this.index - 1))
                        : 0 == this.index
                        ? ((this.index = 1), (i = 0), (a = 0))
                        : ((this.index = 0), (i = 1), (a = 1));
                }
                (this.next = this.slides[a]), (this.previous = this.slides[i]), (this.current = this.slides[this.index]), this.updateSlideClasses(), this.updateSlideChangeData();
              },
            },
            {
              key: "slideToTarget",
              value: function (t) {
                if (!0 !== this.animating && ((t = parseInt(t, 10)), (this.target = t), this.slideChangeStart(), t != this.index)) {
                  var e,
                    i,
                    a = this.xOffset;
                  t > this.index && (a = -1 * this.xOffset),
                    this.addAnimations && this.tweenSlides(this.current, a, this.slides[t]),
                    this.count > 2
                      ? 0 == t
                        ? ((i = 1), (this.index = t), (e = this.count - 1))
                        : t == this.count - 1
                        ? ((i = 0), (this.index = t), (e = t - 1))
                        : ((i = t + 1), (this.index = t), (e = t - 1))
                      : 1 == t
                      ? ((this.index = 1), (e = 0), (i = 0))
                      : ((this.index = 0), (e = 1), (i = 1)),
                    (this.next = this.slides[i]),
                    (this.previous = this.slides[e]),
                    (this.current = this.slides[this.index]),
                    this.updateSlideClasses(),
                    this.updateSlideChangeData();
                }
              },
            },
            {
              key: "tweenSlides",
              value: function (t, e, i) {
                var a = this;
                (this.animating = !0), this.dots && this.updateDots(t, i);
                var n = t.el,
                  r = i.el;
                Un.to(n, 0.35, { x: e, autoAlpha: 0, ease: la.easeOut }),
                  Un.to(r, 0.55, { autoAlpha: 1, ease: la.easeIn, delay: 0.35 }),
                  Un.to(n, 0.01, {
                    x: 0,
                    delay: 0.7,
                    onComplete: function () {
                      (a.animating = !1), a.slideChangeEnd(a);
                    },
                  });
              },
            },
            {
              key: "updateDots",
              value: function (t, e) {
                var i = t.index,
                  a = e.index;
                this.dotsArr[i].classList.remove("is-selected"), this.dotsArr[a].classList.add("is-selected");
              },
            },
            {
              key: "updateSlideClasses",
              value: function () {
                for (var t = 0; t < this.count; t++) this.slides[t].el.classList.remove("is-selected"), this.slides[t].el.classList.remove("is-previous"), this.slides[t].el.classList.remove("is-next");
                this.current.el.classList.add("is-selected"), this.previous.el.classList.add("is-previous"), this.next.el.classList.add("is-next");
              },
            },
            { key: "destroy", value: function () {} },
          ]),
          t
        );
      })(),
      Ss = function (t) {
        var e = t.dataset.number;
        e = parseInt(e, 10);
        var i = 0;
        function a(t) {
          return t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        t.innerHTML = i;
        var n = function () {
            (i += 1), (t.innerHTML = a(i));
          },
          r = window.setInterval(function () {
            (i += i < 10 ? 1 : i < 100 ? 11 : i < 1e3 ? 121 : i < 1e4 ? 1311 : i < 1e5 ? 11277 : 71127) >= e ? ((i = e), (t.innerHTML = a(i)), window.clearInterval(r), window.setInterval(n, 1200)) : (t.innerHTML = a(i));
          }, 32);
      },
      ks =
        (i(19),
        (function () {
          function t() {
            zn()(this, t), (this.checkout = v.get("cart") ? v.get("cart") : void 0), (this.cart = void 0), (this.lock = !1), (this.build = !0), (this.miniCartOpen = !1), (this.miniCartTlProducts = null), (this.miniCartTlEmpty = null);
          }
          return (
            Gn()(t, [
              {
                key: "init",
                value: function () {
                  var t = this;
                  if (this.checkout) {
                    var e = [],
                      i = new Promise(function (e, i) {
                        var n = { url: "carts/" + t.checkout };
                        a("/v1/cache/get/", { method: "POST", type: "json", data: JSON.stringify(n) }, function (i) {
                          var a = JSON.parse(i);
                          e(t.normalizeCart(a));
                        });
                      });
                    if ((e.push(i), "object" === y()(Rl))) {
                      var n = new Promise(function (t, e) {
                        var i = { url: "carts/" + Rl.checkout };
                        a("/v1/cache/get/", { method: "POST", type: "json", data: JSON.stringify(i) }, function (e) {
                          var i = JSON.parse(e);
                          t(Rl.normalizeCart(i));
                        });
                      });
                      e.push(n);
                    }
                    Promise.allSettled(e).then(function (e) {
                      var i = Rl.checkForSubscription(e[1].value);
                      i && Rl.updateCart(e[1].value),
                        (t.cart = i ? e[1].value : e[0].value),
                        (t.checkout = e[0].value.id),
                        (t.url = et(t.cart.webUrl)),
                        (t.baseline = t.getBaseline(t.cart.lineItems)),
                        t.buildMiniCart({ open: !1 }),
                        t.displayBaseline();
                    });
                  } else this.buildMiniCart({ open: !1 }), (this.baseline = this.getBaseline([])), this.displayBaseline();
                  this.buildCartTl(), this.bindCartTrigger();
                },
              },
              {
                key: "captureScroll",
                value: function (t) {
                  document.createElement("div");
                },
              },
              {
                key: "splitForSup",
                value: function (t) {
                  var e = t.toString().split(".");
                  return (t = "".concat(e[0], ".<sup>").concat(e[1], "</sup>"));
                },
              },
              {
                key: "getBaseline",
                value: function (t) {
                  var e = 0,
                    i = 0,
                    a = 0,
                    n = 0;
                  Array.prototype.slice.call(t).forEach(function (t) {
                    if (((e += t.quantity), (i += t.quantity * parseFloat(t.price)), t.discount_type && "percentage" == t.discount_type && t.attributes._order_interval_frequency && "null" !== t.attributes._order_interval_frequency)) {
                      var r = t.discount ? t.discount : 15;
                      a += t.quantity * ((parseFloat(t.price) / (100 - r)) * 100);
                    } else t.original_price && t.original_price > t.price ? (a += t.quantity * parseFloat(t.original_price)) : (a += t.quantity * parseFloat(t.price));
                    n = a - i;
                  }),
                    (G.cartTotal = i),
                    (G.cart = t),
                    (G.totalDiscount = Q(n, 2));
                  var r = this.checkForSubscriptionInShopifyCart(t);
                  return z.firstLoad ? Fl.updateProgress(i, !0, r) : Fl.updateProgress(i, !1, r), { total: i - G.currentReward, quantity: e, subtotal: a, discounts: G.totalDiscount };
                },
              },
              {
                key: "checkForSubscriptionInShopifyCart",
                value: function (t) {
                  if (!t || t.length <= 0) return !1;
                  var e = !1;
                  return (
                    Array.prototype.slice.call(t).forEach(function (t) {
                      t.attributes && t.attributes._order_interval_frequency && "null" !== t.attributes._order_interval_frequency && (e = !0);
                    }),
                    e
                  );
                },
              },
              {
                key: "displayBaseline",
                value: function () {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    i = void 0 === e.numberElemClass ? document.getElementsByClassName("cart-quantity") : document.getElementsByClassName(e.numberElemClass),
                    a = void 0 === e.subtotalElemClass ? document.getElementsByClassName("cart-subtotal") : document.getElementsByClassName(e.subtotalElemClass),
                    n = void 0 === e.subtotalElemClass ? document.getElementsByClassName("cart-discounts") : document.getElementsByClassName(e.discountsElemClass),
                    r = void 0 === e.totalElemClass ? document.getElementsByClassName("cart-total") : document.getElementsByClassName(e.totalElemClass),
                    s = void 0 === e.checkoutElemClass ? document.getElementsByClassName("cart-checkout") : document.getElementsByClassName(e.checkoutElemClass);
                  Array.prototype.slice.call(i).forEach(function (e) {
                    e.classList.remove("empty"), t.baseline.quantity <= 0 && e.classList.add("empty"), (e.textContent = t.baseline.quantity);
                  }),
                    Array.prototype.slice.call(r).forEach(function (e) {
                      e.innerHTML = "$" + t.splitForSup(t.baseline.total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    }),
                    Array.prototype.slice.call(a).forEach(function (e) {
                      e.innerHTML = "$" + t.splitForSup(t.baseline.subtotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    }),
                    Array.prototype.slice.call(n).forEach(function (e) {
                      0 == t.baseline.discounts ? e.classList.remove("discount") : e.classList.add("discount"),
                        (e.innerHTML = "$" + t.splitForSup(t.baseline.discounts.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })));
                    }),
                    Array.prototype.slice.call(s).forEach(function (e) {
                      e.href = t.url ? t.url : "javascript:void(0);";
                    });
                },
              },
              {
                key: "buildMiniCart",
                value: function () {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    i = void 0 === e.elem ? document.getElementById("mini-cart") : e.elem,
                    a = void 0 === e.open;
                  if (i) {
                    var n = document.getElementById("mini-cart-products"),
                      r = this.cart && this.cart.lineItems ? this.cart.lineItems : [],
                      s = this.returnMiniCartHTML(r);
                    this.returnProductAddOns(r);
                    Un.to(n, 0.3, {
                      opacity: 0,
                      onComplete: function () {
                        (n.innerHTML = s), r.length > 0 && t.toggleNoResults(!0), r.length <= 0 && t.toggleNoResults(), t.bindCartEvents(), Un.to(n, 0.3, { opacity: 1 }), a && t.openMiniCart();
                      },
                    });
                  }
                },
              },
              {
                key: "toggleNoResults",
                value: function () {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    i = document.getElementById("mini-cart--full"),
                    a = document.getElementById("mini-cart--empty");
                  if (!1 !== e) (z.productsInCart = !0), Un.to(a, 0.25, { autoAlpha: 0 }), Un.to(i, 0.25, { autoAlpha: 1, delay: 0.25 });
                  else if (((z.productsInCart = !1), Un.to(i, 0.25, { autoAlpha: 0 }), Un.to(a, 0.25, { autoAlpha: 1, delay: 0.25 }), z.mcLottieAnim && z.mcLottieAnim.play(), this.miniCartOpen))
                    if (z.windowWidth > 1023) {
                      var n = document.getElementById("mini-cart--upsells-desktop");
                      Un.to(n, 0.25, { x: 400, autoAlpha: 0, ease: sa.easeIn }),
                        Un.set(n, {
                          x: 957,
                          delay: 0.25,
                          onComplete: function () {
                            t.miniCartTlProducts.pause(0), t.miniCartTlEmpty.pause(1);
                          },
                        });
                    } else this.miniCartTlProducts.pause(0), this.miniCartTlEmpty.pause(1);
                },
              },
              {
                key: "bindCartTrigger",
                value: function () {
                  var t = this,
                    e = document.getElementsByClassName("mini-cart-trigger");
                  Array.prototype.slice.call(e).forEach(function (e) {
                    e.addEventListener("click", function (e) {
                      e.preventDefault(), t.miniCartOpen ? t.closeMiniCart() : t.openMiniCart();
                    });
                  });
                },
              },
              {
                key: "buildCartTl",
                value: function () {
                  (this.miniCartTlProducts = new Un.timeline({ paused: !0 })), (this.miniCartTlEmpty = new Un.timeline({ paused: !0 }));
                  var t = document.getElementById("mini-cart"),
                    e = document.getElementById("mini-cart--bg"),
                    i = document.getElementById("mini-cart--shadow"),
                    a = document.getElementById("mini-cart--upsells-desktop");
                  this.miniCartTlProducts.to(t, 0.5, { x: "0%", autoAlpha: 1, ease: sa.easeOut }, 0),
                    z.windowWidth > 767 && this.miniCartTlProducts.to(e, 0.01, { x: "0%" }, 0).to(e, 0.35, { opacity: 1, ease: sa.easeOut }, 0).to(i, 0.01, { opacity: 1 }, 0).to(i, 0.5, { x: "0%", ease: sa.easeOut }, 0),
                    z.windowWidth > 1023 && this.miniCartTlProducts.to(a, 0.01, { x: 400 }, 0.36).to(a, 0.4, { x: 0, autoAlpha: 1, ease: sa.easeOut }, 0.36),
                    this.miniCartTlEmpty.to(t, 0.5, { x: "0%", autoAlpha: 1, ease: sa.easeOut }, 0),
                    z.windowWidth > 767 && this.miniCartTlEmpty.to(e, 0.01, { x: "0%" }, 0).to(e, 0.35, { opacity: 1, ease: sa.easeOut }, 0).to(i, 0.01, { opacity: 1 }, 0).to(i, 0.5, { x: "0%", ease: sa.easeOut }, 0);
                },
              },
              {
                key: "openMiniCart",
                value: function () {
                  if (!this.miniCartOpen) {
                    if ((this.captureScroll(!0), z.productsInCart)) {
                      this.miniCartTlProducts.timeScale(1).play();
                      var t = document.querySelectorAll("#mini-cart-products .line-item");
                      Array.prototype.slice.call(t).forEach(function (t, e) {
                        var i = t.querySelector("[name='data']"),
                          a = JSON.parse(i.value);
                        it("google", "ec:addImpression", { id: a.sku, name: a.name, brand: a.brand, category: a.category, variant: a.variant, price: parseFloat(a.price), position: e + 1 });
                      }),
                        it("google", "send", "event", "cart", "Viewed Cart", "Mini Cart");
                    } else z.mcLottieAnim && z.mcLottieAnim.play(), this.miniCartTlEmpty.timeScale(1).play();
                    if (((this.miniCartOpen = !0), z.keyToggle)) {
                      var e = document.activeElement;
                      z.currentFocus = e;
                      var i = document.getElementById("cart-heading"),
                        a = document.querySelectorAll("#mini-cart a, #mini-cart button"),
                        n = a[a.length - 1];
                      n &&
                        !n.classList.contains("blur-handle") &&
                        n.addEventListener("blur", function () {
                          i.focus();
                        }),
                        i.focus();
                    }
                  }
                },
              },
              {
                key: "bindCartEvents",
                value: function () {
                  var t = this,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    i = void 0 === e.cartFormClass ? document.getElementsByClassName("cart-form") : document.getElementsByClassName(e.cartFormClass),
                    a = void 0 === e.removeButtonClass ? document.getElementsByClassName("cart-remove") : document.getElementsByClassName(e.removeButtonClass);
                  Array.prototype.slice.call(i).forEach(function (t) {
                    r(t, "bound") ||
                      (t.classList.add("bound"),
                      t.addEventListener("submit", function (t) {
                        t.preventDefault();
                      }));
                  }),
                    Array.prototype.slice.call(a).forEach(function (e) {
                      r(e, "bound") ||
                        (e.classList.add("bound"),
                        e.addEventListener("click", function (i) {
                          if (!t.lock) {
                            var a = e.closest(".line-item"),
                              n = a.querySelector("[type='number'"),
                              r = a.querySelector("[name='data']"),
                              s = JSON.parse(r.value);
                            it("google", "ec:addProduct", { id: s.sku, name: s.name, brand: s.brand, category: s.category, variant: s.variant, quantity: n.value, price: parseFloat(s.price) }),
                              it("google", "ec:setAction", "remove"),
                              it("google", "send", "event", "ecommerce", "Removed Product", s.category),
                              a.remove(),
                              t.updateCart(!1, function (t) {});
                          }
                        }));
                    }),
                    this.bindIncrements();
                },
              },
              {
                key: "bindIncrements",
                value: function () {
                  var t = this,
                    e = document.getElementsByClassName("cart-form");
                  Array.prototype.slice.call(e).forEach(function (e) {
                    if (!r(e, "bound-increment")) {
                      var i = e.getElementsByClassName("line-item");
                      Array.prototype.slice.call(i).forEach(function (e, i) {
                        var a = e.querySelector("[name='[cart][".concat(i, "][quantity]']")),
                          n = e.querySelector("[data-type='plus']"),
                          s = e.querySelector("[data-type='minus']"),
                          o = e.querySelector(".count"),
                          l = !1;
                        n.addEventListener("click", function (i) {
                          if ((i.preventDefault(), !l && !r(n, "disabled"))) {
                            r(s, "disabled") && s.classList.remove("disabled"), (l = !0);
                            var c = parseInt(a.value) + 1;
                            (a.value = c), (o.textContent = c), e.setAttribute("data-quantity", c);
                            var h = e.querySelector("[name='data']"),
                              u = JSON.parse(h.value);
                            it("google", "ec:addProduct", { id: u.sku, name: u.name, brand: u.brand, category: u.category, variant: u.variant, quantity: 1, price: parseFloat(u.price) }),
                              it("google", "ec:setAction", "add"),
                              it("google", "send", "event", "ecommerce", "Added Product", u.category),
                              t.updateCart(!1, function (t) {
                                l = !1;
                              });
                          }
                        }),
                          s.addEventListener("click", function (i) {
                            if ((i.preventDefault(), !l && !r(s, "disabled"))) {
                              r(n, "disabled") && s.classList.remove("disabled"), (l = !0);
                              var c = parseInt(a.value) - 1;
                              0 === c && e.remove(), (a.value = c), (o.textContent = c), e.setAttribute("data-quantity", c);
                              var h = e.querySelector("[name='data']"),
                                u = JSON.parse(h.value);
                              it("google", "ec:addProduct", { id: u.sku, name: u.name, brand: u.brand, category: u.category, variant: u.variant, quantity: 1, price: parseFloat(u.price) }),
                                it("google", "ec:setAction", "remove"),
                                it("google", "send", "event", "ecommerce", "Removed Product", u.category),
                                t.updateCart(!1, function (t) {
                                  l = !1;
                                });
                            }
                          });
                      }),
                        e.classList.add("bound-increment");
                    }
                  });
                },
              },
              {
                key: "submitData",
                value: function (t, e) {
                  var i = this,
                    n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                  this.lock = !0;
                  var r = [],
                    s = new Promise(function (n, r) {
                      a(t.action, { method: t.method, type: "json", data: JSON.stringify(e) }, function (t) {
                        var e = JSON.parse(t);
                        e.error ? r(e.error) : ((e.request.checkout.type = "one-time"), n(i.normalizeCart(e.request.checkout)));
                      });
                    });
                  if ((r.push(s), "object" === y()(Rl))) {
                    var o = new Promise(function (t, i) {
                      var n = Rl.checkout ? "/v1/app/subscription/update/" : "/v1/app/subscription/create/";
                      (e.subscription_checkout = Rl.checkout),
                        a(n, { method: "POST", type: "json", data: JSON.stringify(e) }, function (e) {
                          var a = JSON.parse(e);
                          a.error ? i(a.error) : ((a.checkout.type = "subscription"), Rl.updateCheckout(a.checkout.token), t(Rl.normalizeCart(a.checkout)));
                        });
                    });
                    r.push(o);
                  }
                  Promise.allSettled(r).then(function (t) {
                    var e = Rl.checkForSubscription(t[1].value);
                    e && Rl.updateCart(t[1].value),
                      (i.cart = e ? t[1].value : t[0].value),
                      (i.checkout = t[0].value.id),
                      (i.url = et(i.cart.webUrl)),
                      (i.baseline = i.getBaseline(i.cart.lineItems)),
                      i.displayBaseline(),
                      i.build && i.buildMiniCart(),
                      (i.lock = !1),
                      (i.build = !0),
                      "function" == typeof n && n("Update Successful");
                  });
                },
              },
              {
                key: "updateCart",
                value: function () {
                  var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                    e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                  if (!this.lock) {
                    this.build = t;
                    var i = document.getElementById("cart-form"),
                      a = i || document.getElementById("mini-cart-form"),
                      n = J(a, { hash: !0, isJSON: !0 });
                    n.checkout = { id: this.checkout };
                    var r = [];
                    n.cart &&
                      Array.prototype.slice.call(n.cart).forEach(function (t) {
                        if (t.properties) {
                          var e = [];
                          Object.keys(t.properties).forEach(function (i, a) {
                            var n = { key: i, value: t.properties[i] };
                            e.push(n);
                          }),
                            r.push({ quantity: parseInt(t.quantity), variantId: t.variantId, customAttributes: e });
                        } else r.push({ quantity: parseInt(t.quantity), variantId: t.variantId });
                      }),
                      (n.cart = r),
                      n.cart.length < 1 && this.toggleNoResults(),
                      this.submitData(a, n, function (t) {
                        "function" == typeof e && e(t);
                      });
                  }
                },
              },
              {
                key: "normalizeCart",
                value: function (t) {
                  var e = { id: t.id, lineItems: [], webUrl: t.webUrl };
                  return (
                    t.lineItems &&
                      t.lineItems.edges &&
                      Array.prototype.slice.call(t.lineItems.edges).forEach(function (t) {
                        var i = {
                          product_id: t.node.variant.product.id,
                          variant_id: t.node.variant.id,
                          quantity: t.node.quantity,
                          note: "",
                          image: t.node.variant.image.src,
                          price: parseFloat(t.node.variant.priceV2.amount),
                          original_price: null !== t.node.variant.compareAtPriceV2 ? parseFloat(t.node.variant.compareAtPriceV2.amount) : null,
                          variant_title: t.node.variant.title,
                          product_title: t.node.title,
                          url: "/products/" + t.node.variant.product.productType.toLowerCase().replace(/ /g, "-") + "/" + t.node.variant.product.handle + "/",
                          sku: t.node.variant.sku,
                          product_type: t.node.variant.product.productType,
                          vendor: t.node.variant.product.vendor,
                          attributes: {},
                        };
                        t.node.customAttributes.length > 0 &&
                          Array.prototype.slice.call(t.node.customAttributes).forEach(function (t) {
                            i.attributes[t.key] = t.value;
                          }),
                          e.lineItems.push(i);
                      }),
                    e
                  );
                },
              },
            ]),
            t
          );
        })()),
      Es = (function () {
        function t(e) {
          var i = this,
            a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          zn()(this, t),
            (this.form = e),
            (this.id = this.form.getAttribute("data-product-id")),
            (this.options = this.form.getElementsByClassName("option")),
            (this.select = this.form.querySelector(".product-select")),
            (this.btn = this.form.querySelector(".add-to-cart")),
            (this.variants = this.select.getElementsByTagName("option")),
            (this.quantityCap = 500);
          var n = s(),
            r = n && n.variant ? "one-time" : "subscription",
            o = void 0 === a.default ? r : a.default;
          this.setupFakeSelects(), this.bindEvents(), this.bindQuantityIncrement();
          var l = s();
          l && l.variant && this.setupLinkedVariant(l.variant), (this.selected = this.getCurrentSelection()), this.checkSoldOut(this.form, this.variants, this.selected);
          var c = this.returnAvailableVariants(this.variants, this.selected, this.currentOptions);
          this.hideVariants(c);
          var h = this.form.getElementsByClassName("fake-select-item");
          Array.prototype.slice.call(h).forEach(function (t) {
            i.bindSelects(i.variants, t);
          }),
            "object" === y()(Rl) && Rl.loadSubscription(this.id, this.form, { default: o });
        }
        return (
          Gn()(t, [
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                if (!r(this.form, "bound")) {
                  this.form.classList.add("bound"),
                    this.form.addEventListener("submit", function (e) {
                      e.preventDefault(), t.addToCart(t.form);
                    });
                  var e = this.form.closest(".product-card");
                  if (e) {
                    var i = e.querySelector(".trigger-quick-shop"),
                      a = e.querySelector(".quick-shop"),
                      n = e.querySelector(".quick-shop-inner"),
                      s = e.querySelector(".quick-shop-close"),
                      o = e.querySelector(".add-to-cart");
                    i.addEventListener("click", function (t) {
                      if ((t.preventDefault(), !r(a, "active") && (a.classList.add("active"), z.keyToggle))) {
                        var e = document.activeElement;
                        (z.currentFocus = e), n.querySelector("button, a").focus();
                      }
                    }),
                      a.addEventListener("click", function (t) {
                        var e = t.target || t.srcElement;
                        n.contains(e) || a.classList.remove("active");
                      }),
                      s.addEventListener("click", function (t) {
                        a.classList.remove("active");
                      }),
                      o &&
                        o.addEventListener("click", function (t) {
                          a.classList.remove("active");
                        });
                  }
                }
              },
            },
            {
              key: "bindQuantityIncrement",
              value: function () {
                var t = this,
                  e = this.form.querySelector(".increment-wrapper");
                if (!r(e, "bound")) {
                  e.classList.add("bound");
                  var i = e.querySelector("[data-type='plus']"),
                    a = e.querySelector("[data-type='minus']"),
                    n = this.form.querySelector("[name='quantity']"),
                    s = e.querySelector(".count");
                  i.addEventListener("click", function (e) {
                    if ((e.preventDefault(), !r(i, "disabled"))) {
                      r(a, "disabled") && a.classList.remove("disabled"), n.value + 1 === t.quantityCap && i.classList.add("disabled");
                      var o = parseInt(n.value) + 1;
                      (n.value = o), (s.textContent = o);
                    }
                  }),
                    a.addEventListener("click", function (t) {
                      if ((t.preventDefault(), !r(a, "disabled"))) {
                        r(i, "disabled") && a.classList.remove("disabled"), n.value - 1 == 1 && a.classList.add("disabled");
                        var e = parseInt(n.value) - 1;
                        (n.value = e), (s.textContent = e);
                      }
                    });
                }
              },
            },
            {
              key: "bindSelects",
              value: function (t, e) {
                var i = this,
                  a = e.getElementsByTagName("li");
                Array.prototype.slice.call(a).forEach(function (t) {
                  var e = t.getAttribute("data-name"),
                    n = t.parentElement,
                    s = n.getAttribute("data-type"),
                    o = n.parentElement.querySelector(".fake-selected");
                  t.addEventListener("click", function () {
                    if (!r(t, "selected")) {
                      Array.prototype.slice.call(a).forEach(function (e) {
                        e == t ? (e.classList.add("selected"), (o.textContent = e.textContent)) : e.classList.remove("selected");
                      });
                      var n = i.getCurrentSelection();
                      i.checkSoldOut(i.form, i.variants, n);
                      var l = i.returnAvailableVariants(i.variants, e);
                      i.hideVariants(l, s);
                      var c = 0;
                      Array.prototype.slice.call(i.variants).forEach(function (t, e) {
                        t.textContent.split("||")[0].toLowerCase() == n.replace(/-/g, " ") && (c = e);
                      }),
                        (i.select.selectedIndex = c);
                    }
                  });
                });
              },
            },
            {
              key: "setupFakeSelects",
              value: function () {
                var t = this;
                if (!r(this.select, "bound") && !r(this.select, "hidden")) {
                  var e = [],
                    i = [],
                    a = {};
                  Array.prototype.slice.call(this.options).forEach(function (t) {
                    var i = t.textContent.toLowerCase();
                    e.push(i), (a[i] = []);
                  }),
                    (this.currentOptions = e),
                    (this.currentColor = void 0),
                    Array.prototype.slice.call(this.variants).forEach(function (n) {
                      var r = n.textContent.split("||"),
                        s = r[0].split(" / ");
                      Array.prototype.slice.call(e).forEach(function (e, a) {
                        "color" == e && (t.currentColor !== s[a] && i.push({ desktop: r[2], mobile: r[3] }), (t.currentColor = s[a]));
                      }),
                        Array.prototype.slice.call(s).forEach(function (t, i) {
                          -1 === a[e[i]].indexOf(t) && a[e[i]].push(t);
                        });
                    });
                  var n = this.form.querySelector(".fake-selects-wrapper");
                  Object.keys(a).forEach(function (t, e) {
                    var r = t.replace(/\s+/g, "-").toLowerCase();
                    0 === e && t;
                    var s = "",
                      o = document.createElement("div");
                    (o.className = "fake-select-item fake-select-item-" + r),
                      "color" !== t && ((s += "<p class='label'>(" + t + ")</p>"), (s += "<p class='fake-selected'>" + a[t][0] + "</p>")),
                      (s += "<ul class='fake-select fake-select-" + r + "' data-type='" + r + "'>"),
                      Array.prototype.slice.call(a[t]).forEach(function (t, e) {
                        var a = t.replace(/\s+/g, "-").toLowerCase(),
                          n = "";
                        0 === e && (n = " selected"), (s += "<li data-name='" + a + "' class='" + r + "-" + a + n + "' data-variant-img='" + i[e] + "'>" + t + "</li>");
                      }),
                      (s += "</ul>"),
                      "color" == t && ((s += "<p class='label'>(" + t + ")</p>"), (s += "<p class='fake-selected'>" + a[t][0] + "</p>")),
                      (o.innerHTML = s),
                      n.appendChild(o);
                  });
                }
              },
            },
            {
              key: "setupLinkedVariant",
              value: function (t) {
                var e,
                  i = this,
                  a = this.select.getElementsByTagName("option"),
                  n = 0;
                if (
                  (Array.prototype.slice.call(a).forEach(function (i, a) {
                    i.getAttribute("data-raw-id") == t && ((e = i), (n = a));
                  }),
                  (this.select.selectedIndex = n),
                  e)
                ) {
                  var s = e.textContent.split("||")[0].split(" / "),
                    o = this.form.getElementsByClassName("fake-select-item");
                  Array.prototype.slice.call(o).forEach(function (t, e) {
                    var a = t.querySelector(".fake-select").getAttribute("data-type"),
                      n = t.getElementsByTagName("li"),
                      o = i.options[e].textContent.toLowerCase();
                    n.length > 1 &&
                      Array.prototype.slice.call(n).forEach(function (t, i) {
                        var n = t.getAttribute("data-name").replace(/-/g, " "),
                          l = s[e].toLowerCase();
                        a != o || n != l || r(t, "selected") ? n !== l && t.classList.remove("selected") : t.classList.add("selected");
                      }),
                      (t.querySelector(".fake-selected").textContent = s[e]);
                  });
                }
              },
            },
            {
              key: "returnAvailableVariants",
              value: function (t, e, i) {
                var a = [],
                  n = e;
                return (
                  e.indexOf(" / ") > -1 && (n = (n = n.split(" / "))[0]),
                  Array.prototype.slice.call(t).forEach(function (t) {
                    var e = t.textContent.toLowerCase().split("||");
                    if ((e = e[0].split(" / ")).indexOf(n) > -1) {
                      var i = o(e, n);
                      a = a.concat(i);
                    }
                  }),
                  a
                );
              },
            },
            {
              key: "checkSoldOut",
              value: function (t, e, i) {
                var a = !0,
                  n = document.getElementsByClassName("product-price"),
                  r = t.querySelector("[name='quantity']").value;
                Array.prototype.slice.call(e).forEach(function (t) {
                  var e = t.textContent.toLowerCase().split("||"),
                    s = e[1];
                  e = e[0];
                  var o = parseInt(t.getAttribute("data-inventory"));
                  e.replace(/-/g, " ").indexOf(i.replace(/-/g, " ")) > -1 &&
                    (Array.prototype.slice.call(n).forEach(function (t) {
                      t.setAttribute("data-usd", s), (t.textContent = "$" + s.toLocaleString("en-US", { minimumFractionDigits: 2 }) * r);
                    }),
                    o > 0 && (a = !1));
                }),
                  this.btn && (a ? (this.btn.classList.add("disabled"), (this.btn.textContent = "Sold Out")) : (this.btn.classList.remove("disabled"), (this.btn.textContent = "Add To Cart")));
              },
            },
            {
              key: "getCurrentSelection",
              value: function () {
                var t = "",
                  e = this.form.querySelectorAll(".fake-select .selected");
                return (
                  Array.prototype.slice.call(e).forEach(function (e, i) {
                    t += 0 === i ? e.getAttribute("data-name") : " / " + e.getAttribute("data-name");
                  }),
                  t
                );
              },
            },
            {
              key: "hideVariants",
              value: function (t, e) {
                var i = this.form.getElementsByClassName("fake-select");
                Array.prototype.slice.call(i).forEach(function (i) {
                  if (i.getAttribute("data-type") !== e) {
                    var a = i.getElementsByTagName("li");
                    Array.prototype.slice.call(a).forEach(function (e) {
                      t.indexOf(e.textContent.toLowerCase()) > -1 ? e.classList.remove("disabled") : e.classList.add("disabled");
                    });
                  }
                });
              },
            },
            {
              key: "addToCart",
              value: function () {
                var t,
                  e = J(this.form, { hash: !0, isJSON: !0 });
                if ((Ll.checkout && (e.checkout = { id: Ll.checkout }), Ll.cart && Ll.cart.lineItems.length > 0)) t = this.addItem(Ll.cart.lineItems, e);
                else if (e.properties) {
                  var i = [];
                  Object.keys(e.properties).forEach(function (t, a) {
                    var n = { key: t, value: e.properties[t] };
                    i.push(n);
                  }),
                    (t = [{ quantity: parseInt(e.quantity), variantId: e.id, customAttributes: i }]);
                } else t = [{ quantity: parseInt(e.quantity), variantId: e.id }];
                (e.cart = t),
                  Ll.submitData(this.form, e, function (t) {
                    var i = JSON.parse(e.data);
                    it("google", "ec:addProduct", { id: i.sku, name: i.name, brand: i.brand, category: i.category, variant: i.variant, quantity: parseInt(e.quantity), price: parseFloat(i.price) }),
                      it("google", "ec:setAction", "add"),
                      it("google", "send", "event", "ecommerce", "Added Product", i.category),
                      it("facebook", "track", "AddToCart", {
                        content_name: i.name,
                        content_category: i.category,
                        content_ids: ["shopify_" + i.product_id + "_" + i.variant_id],
                        content_type: "product",
                        value: parseFloat(i.price),
                        currency: "USD",
                      });
                  }),
                  Mo && Mo.celebrate();
              },
            },
            {
              key: "addItem",
              value: function (t, e) {
                var i = this,
                  a = !1,
                  n = e.id,
                  r = [];
                if (
                  (Array.prototype.slice.call(t).forEach(function (t, s) {
                    var o,
                      l = t.variant_id,
                      c = t.quantity;
                    if ((l == n && !0 === i.compareObjects(e.properties, t.attributes) && ((c += parseInt(e.quantity)), (a = !0)), Object.keys(t.attributes).length > 0)) {
                      var h = [];
                      Object.keys(t.attributes).forEach(function (e, i) {
                        var a = { key: e, value: t.attributes[e] };
                        h.push(a);
                      }),
                        (o = { quantity: parseInt(c), variantId: l, customAttributes: h });
                    } else o = { quantity: parseInt(c), variantId: l };
                    r.push(o);
                  }),
                  !1 === a)
                ) {
                  var s;
                  if (e.properties) {
                    var o = [];
                    Object.keys(e.properties).forEach(function (t, i) {
                      var a = { key: t, value: e.properties[t] };
                      o.push(a);
                    }),
                      (s = { quantity: parseInt(e.quantity), variantId: e.id, customAttributes: o });
                  } else s = { quantity: parseInt(e.quantity), variantId: e.id };
                  r.push(s);
                }
                return r;
              },
            },
            {
              key: "compareObjects",
              value: function (t, e) {
                var i = Object.keys(t),
                  a = Object.keys(e);
                if (i.length !== a.length) return !1;
                for (var n = 0, r = i; n < r.length; n++) {
                  var s = r[n];
                  if (t[s] !== e[s]) return !1;
                }
                return !0;
              },
            },
          ]),
          t
        );
      })(),
      xs = i(3),
      _s = i.n(xs),
      Ts = i(4),
      Ms = i.n(Ts),
      Ps = i(2),
      Ds = i.n(Ps),
      Is = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
      Ls = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi,
      Rs = Math.PI / 180,
      Fs = (Math.PI, Math.sin),
      Os = Math.cos,
      Bs = Math.abs,
      qs = Math.sqrt,
      Ns =
        (Math.atan2,
        function (t) {
          return "number" == typeof t;
        }),
      Vs = function (t) {
        return Math.round(1e5 * t) / 1e5 || 0;
      };
    function Ws(t, e, i, a, n, r, s, o, l) {
      if (t !== o || e !== l) {
        (i = Bs(i)), (a = Bs(a));
        var c = (n % 360) * Rs,
          h = Os(c),
          u = Fs(c),
          d = Math.PI,
          p = 2 * d,
          f = (t - o) / 2,
          m = (e - l) / 2,
          g = h * f + u * m,
          y = -u * f + h * m,
          v = g * g,
          A = y * y,
          b = v / (i * i) + A / (a * a);
        b > 1 && ((i = qs(b) * i), (a = qs(b) * a));
        var w = i * i,
          C = a * a,
          S = (w * C - w * A - C * v) / (w * A + C * v);
        S < 0 && (S = 0);
        var k = (r === s ? -1 : 1) * qs(S),
          E = k * ((i * y) / a),
          x = k * ((-a * g) / i),
          _ = (t + o) / 2 + (h * E - u * x),
          T = (e + l) / 2 + (u * E + h * x),
          M = (g - E) / i,
          P = (y - x) / a,
          D = (-g - E) / i,
          I = (-y - x) / a,
          L = M * M + P * P,
          R = (P < 0 ? -1 : 1) * Math.acos(M / qs(L)),
          F = (M * I - P * D < 0 ? -1 : 1) * Math.acos((M * D + P * I) / qs(L * (D * D + I * I)));
        isNaN(F) && (F = d), !s && F > 0 ? (F -= p) : s && F < 0 && (F += p), (R %= p), (F %= p);
        var O,
          B = Math.ceil(Bs(F) / (p / 4)),
          q = [],
          N = F / B,
          V = ((4 / 3) * Fs(N / 2)) / (1 + Os(N / 2)),
          W = h * i,
          U = u * i,
          J = u * -a,
          z = h * a;
        for (O = 0; O < B; O++) (g = Os((n = R + O * N))), (y = Fs(n)), (M = Os((n += N))), (P = Fs(n)), q.push(g - V * y, y + V * g, M + V * P, P - V * M, M, P);
        for (O = 0; O < q.length; O += 2) (g = q[O]), (y = q[O + 1]), (q[O] = g * W + y * J + _), (q[O + 1] = g * U + y * z + T);
        return (q[O - 2] = o), (q[O - 1] = l), q;
      }
    }
    function Us(t) {
      var e,
        i,
        a,
        n,
        r,
        s,
        o,
        l,
        c,
        h,
        u,
        d,
        p,
        f,
        m,
        g =
          (t + "")
            .replace(Ls, function (t) {
              var e = +t;
              return e < 1e-4 && e > -1e-4 ? 0 : e;
            })
            .match(Is) || [],
        y = [],
        v = 0,
        A = 0,
        b = g.length,
        w = 0,
        C = "ERROR: malformed path: " + t,
        S = function (t, e, i, a) {
          (h = (i - t) / 3), (u = (a - e) / 3), o.push(t + h, e + u, i - h, a - u, i, a);
        };
      if (!t || !isNaN(g[0]) || isNaN(g[1])) return console.log(C), y;
      for (e = 0; e < b; e++)
        if (((p = r), isNaN(g[e]) ? (s = (r = g[e].toUpperCase()) !== g[e]) : e--, (a = +g[e + 1]), (n = +g[e + 2]), s && ((a += v), (n += A)), e || ((l = a), (c = n)), "M" === r))
          o && (o.length < 8 ? (y.length -= 1) : (w += o.length)), (v = l = a), (A = c = n), (o = [a, n]), y.push(o), (e += 2), (r = "L");
        else if ("C" === r) o || (o = [0, 0]), s || (v = A = 0), o.push(a, n, v + 1 * g[e + 3], A + 1 * g[e + 4], (v += 1 * g[e + 5]), (A += 1 * g[e + 6])), (e += 6);
        else if ("S" === r) (h = v), (u = A), ("C" !== p && "S" !== p) || ((h += v - o[o.length - 4]), (u += A - o[o.length - 3])), s || (v = A = 0), o.push(h, u, a, n, (v += 1 * g[e + 3]), (A += 1 * g[e + 4])), (e += 4);
        else if ("Q" === r) (h = v + (2 / 3) * (a - v)), (u = A + (2 / 3) * (n - A)), s || (v = A = 0), (v += 1 * g[e + 3]), (A += 1 * g[e + 4]), o.push(h, u, v + (2 / 3) * (a - v), A + (2 / 3) * (n - A), v, A), (e += 4);
        else if ("T" === r) (h = v - o[o.length - 4]), (u = A - o[o.length - 3]), o.push(v + h, A + u, a + (2 / 3) * (v + 1.5 * h - a), n + (2 / 3) * (A + 1.5 * u - n), (v = a), (A = n)), (e += 2);
        else if ("H" === r) S(v, A, (v = a), A), (e += 1);
        else if ("V" === r) S(v, A, v, (A = a + (s ? A - v : 0))), (e += 1);
        else if ("L" === r || "Z" === r) "Z" === r && ((a = l), (n = c), (o.closed = !0)), ("L" === r || Bs(v - a) > 0.5 || Bs(A - n) > 0.5) && (S(v, A, a, n), "L" === r && (e += 2)), (v = a), (A = n);
        else if ("A" === r) {
          if (
            ((f = g[e + 4]),
            (m = g[e + 5]),
            (h = g[e + 6]),
            (u = g[e + 7]),
            (i = 7),
            f.length > 1 && (f.length < 3 ? ((u = h), (h = m), i--) : ((u = m), (h = f.substr(2)), (i -= 2)), (m = f.charAt(1)), (f = f.charAt(0))),
            (d = Ws(v, A, +g[e + 1], +g[e + 2], +g[e + 3], +f, +m, (s ? v : 0) + 1 * h, (s ? A : 0) + 1 * u)),
            (e += i),
            d)
          )
            for (i = 0; i < d.length; i++) o.push(d[i]);
          (v = o[o.length - 2]), (A = o[o.length - 1]);
        } else console.log(C);
      return (e = o.length) < 6 ? (y.pop(), (e = 0)) : o[0] === o[e - 2] && o[1] === o[e - 1] && (o.closed = !0), (y.totalPoints = w + e), y;
    }
    function Js(t) {
      Ns(t[0]) && (t = [t]);
      var e,
        i,
        a,
        n,
        r = "",
        s = t.length;
      for (i = 0; i < s; i++) {
        for (n = t[i], r += "M" + Vs(n[0]) + "," + Vs(n[1]) + " C", e = n.length, a = 2; a < e; a++) r += Vs(n[a++]) + "," + Vs(n[a++]) + " " + Vs(n[a++]) + "," + Vs(n[a++]) + " " + Vs(n[a++]) + "," + Vs(n[a]) + " ";
        n.closed && (r += "z");
      }
      return r;
    }
    /*!
     * CustomEase 3.6.0
     * https://greensock.com
     *
     * @license Copyright 2008-2021, GreenSock. All rights reserved.
     * Subject to the terms at https://greensock.com/standard-license or for
     * Club GreenSock members, the agreement issued with that membership.
     * @author: Jack Doyle, jack@greensock.com
     */ var zs,
      Ks,
      Gs = function () {
        return zs || ("undefined" != typeof window && (zs = window.gsap) && zs.registerPlugin && zs);
      },
      js = function () {
        (zs = Gs()) ? (zs.registerEase("_CE", $s.create), (Ks = 1)) : console.warn("Please gsap.registerPlugin(CustomEase)");
      },
      Hs = function (t) {
        return ~~(1e3 * t + (t < 0 ? -0.5 : 0.5)) / 1e3;
      },
      Ys = 1,
      Qs = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi,
      Xs = /[cLlsSaAhHvVtTqQ]/g,
      Zs = function t(e, i, a, n, r, s, o, l, c, h, u) {
        var d,
          p = (e + a) / 2,
          f = (i + n) / 2,
          m = (a + r) / 2,
          g = (n + s) / 2,
          y = (r + o) / 2,
          v = (s + l) / 2,
          A = (p + m) / 2,
          b = (f + g) / 2,
          w = (m + y) / 2,
          C = (g + v) / 2,
          S = (A + w) / 2,
          k = (b + C) / 2,
          E = o - e,
          x = l - i,
          _ = Math.abs((a - o) * x - (n - l) * E),
          T = Math.abs((r - o) * x - (s - l) * E);
        return (
          h ||
            ((h = [
              { x: e, y: i },
              { x: o, y: l },
            ]),
            (u = 1)),
          h.splice(u || h.length - 1, 0, { x: S, y: k }),
          (_ + T) * (_ + T) > c * (E * E + x * x) && ((d = h.length), t(e, i, p, f, A, b, S, k, c, h, u), t(S, k, w, C, y, v, o, l, c, h, u + 1 + (h.length - d))),
          h
        );
      },
      $s = (function () {
        function t(t, e, i) {
          Ks || js(), (this.id = t), Ys && this.setData(e, i);
        }
        var e = t.prototype;
        return (
          (e.setData = function (t, e) {
            e = e || {};
            var i,
              a,
              n,
              r,
              s,
              o,
              l,
              c,
              h,
              u = (t = t || "0,0,1,1").match(Qs),
              d = 1,
              p = [],
              f = [],
              m = e.precision || 1,
              g = m <= 1;
            if (((this.data = t), (Xs.test(t) || (~t.indexOf("M") && t.indexOf("C") < 0)) && (u = Us(t)[0]), 4 === (i = u.length))) u.unshift(0, 0), u.push(1, 1), (i = 8);
            else if ((i - 2) % 6) throw "Invalid CustomEase";
            for (
              (0 == +u[0] && 1 == +u[i - 2]) ||
                (function (t, e, i) {
                  i || 0 === i || (i = Math.max(+t[t.length - 1], +t[1]));
                  var a,
                    n = -1 * +t[0],
                    r = -i,
                    s = t.length,
                    o = 1 / (+t[s - 2] + n),
                    l =
                      -e ||
                      (Math.abs(+t[s - 1] - +t[1]) < 0.01 * (+t[s - 2] - +t[0])
                        ? (function (t) {
                            var e,
                              i = t.length,
                              a = 1e20;
                            for (e = 1; e < i; e += 6) +t[e] < a && (a = +t[e]);
                            return a;
                          })(t) + r
                        : +t[s - 1] + r);
                  for (l = l ? 1 / l : -o, a = 0; a < s; a += 2) (t[a] = (+t[a] + n) * o), (t[a + 1] = (+t[a + 1] + r) * l);
                })(u, e.height, e.originY),
                this.segment = u,
                r = 2;
              r < i;
              r += 6
            )
              (a = { x: +u[r - 2], y: +u[r - 1] }), (n = { x: +u[r + 4], y: +u[r + 5] }), p.push(a, n), Zs(a.x, a.y, +u[r], +u[r + 1], +u[r + 2], +u[r + 3], n.x, n.y, 1 / (2e5 * m), p, p.length - 1);
            for (i = p.length, r = 0; r < i; r++)
              (l = p[r]),
                (c = p[r - 1] || l),
                (l.x > c.x || (c.y !== l.y && c.x === l.x) || l === c) && l.x <= 1
                  ? ((c.cx = l.x - c.x),
                    (c.cy = l.y - c.y),
                    (c.n = l),
                    (c.nx = l.x),
                    g && r > 1 && Math.abs(c.cy / c.cx - p[r - 2].cy / p[r - 2].cx) > 2 && (g = 0),
                    c.cx < d && (c.cx ? (d = c.cx) : ((c.cx = 0.001), r === i - 1 && ((c.x -= 0.001), (d = Math.min(d, 0.001)), (g = 0)))))
                  : (p.splice(r--, 1), i--);
            if (((s = 1 / (i = (1 / d + 1) | 0)), (o = 0), (l = p[0]), g)) {
              for (r = 0; r < i; r++) (h = r * s), l.nx < h && (l = p[++o]), (a = l.y + ((h - l.x) / l.cx) * l.cy), (f[r] = { x: h, cx: s, y: a, cy: 0, nx: 9 }), r && (f[r - 1].cy = a - f[r - 1].y);
              f[i - 1].cy = p[p.length - 1].y - a;
            } else {
              for (r = 0; r < i; r++) l.nx < r * s && (l = p[++o]), (f[r] = l);
              o < p.length - 1 && (f[r - 1] = p[p.length - 2]);
            }
            return (
              (this.ease = function (t) {
                var e = f[(t * i) | 0] || f[i - 1];
                return e.nx < t && (e = e.n), e.y + ((t - e.x) / e.cx) * e.cy;
              }),
              (this.ease.custom = this),
              this.id && zs.registerEase(this.id, this.ease),
              this
            );
          }),
          (e.getSVGData = function (e) {
            return t.getSVGData(this, e);
          }),
          (t.create = function (e, i, a) {
            return new t(e, i, a).ease;
          }),
          (t.register = function (t) {
            (zs = t), js();
          }),
          (t.get = function (t) {
            return zs.parseEase(t);
          }),
          (t.getSVGData = function (e, i) {
            var a,
              n,
              r,
              s,
              o,
              l,
              c,
              h,
              u,
              d,
              p = (i = i || {}).width || 100,
              f = i.height || 100,
              m = i.x || 0,
              g = (i.y || 0) + f,
              y = zs.utils.toArray(i.path)[0];
            if ((i.invert && ((f = -f), (g = 0)), "string" == typeof e && (e = zs.parseEase(e)), e.custom && (e = e.custom), e instanceof t))
              a = Js(
                (function (t, e, i, a, n, r, s) {
                  for (var o, l, c, h, u, d = t.length; --d > -1; ) for (l = (o = t[d]).length, c = 0; c < l; c += 2) (h = o[c]), (u = o[c + 1]), (o[c] = h * e + u * a + r), (o[c + 1] = h * i + u * n + s);
                  return (t._dirty = 1), t;
                })([e.segment], p, 0, 0, -f, m, g)
              );
            else {
              for (a = [m, g], s = 1 / (c = Math.max(5, 200 * (i.precision || 1))), h = 5 / (c += 2), u = Hs(m + s * p), n = ((d = Hs(g + e(s) * -f)) - g) / (u - m), r = 2; r < c; r++)
                (o = Hs(m + r * s * p)), (l = Hs(g + e(r * s) * -f)), (Math.abs((l - d) / (o - u) - n) > h || r === c - 1) && (a.push(u, d), (n = (l - d) / (o - u))), (u = o), (d = l);
              a = "M" + a.join(",");
            }
            return y && y.setAttribute("d", a), a;
          }),
          t
        );
      })();
    Gs() && zs.registerPlugin($s), ($s.version = "3.6.0");
    var to,
      eo,
      io = (function () {
        function t() {
          zn()(this, t), (this.worker = new Worker("/assets/code/scene-image-load.js")), (this.count = 0), (this.loadCount = 0);
          var e = navigator.connection,
            i = !(!e || !e.effectiveType.includes("2g")),
            a = !(!e || !e.saveData),
            n = document.getElementById("scene-images"),
            r = z.isEarlyAccess && !z.accessCode;
          (this.windowSize = z.windowWidth > 768 ? "desktopUrls" : "mobileUrls"),
            (this.sceneImages = n.dataset[this.windowSize].split(" ||| ")),
            n.parentElement.removeChild(n),
            (this.size = z.windowWidth > 1440 ? 1920 : z.windowWidth > 1200 ? 1680 : z.windowWidth > 768 ? 1e3 : 400),
            (this.total = i || a || r ? 1 : 60),
            this.bindEvents();
        }
        return (
          Gn()(t, [
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                this.worker.addEventListener("message", function (e) {
                  var i = URL.createObjectURL(e.data.blob),
                    a = e.data.currCount,
                    n = new Image();
                  (n.onload = function () {
                    to.images.push({ currCount: a, image: n }),
                      t.loadCount++,
                      t.loadCount === t.total &&
                        (to.images.sort(function (t, e) {
                          return t.currCount - e.currCount;
                        }),
                        to.images.reverse(),
                        Un.delayedCall(0.5, function () {
                          to.drawFirstFrame();
                        }));
                  }),
                    (n.src = i);
                });
              },
            },
            {
              key: "loadImages",
              value: function () {
                for (var t = 0; t < this.total; t++) {
                  this.imageFormat = z.isSafari ? "jpg" : "webp";
                  var e = "".concat(this.sceneImages[t], "&w=").concat(this.size, "&fm=").concat(this.imageFormat, "&q=90");
                  this.message(e + " ||| " + this.count), this.count++;
                }
              },
            },
            {
              key: "message",
              value: function (t) {
                this.worker.postMessage(t);
              },
            },
          ]),
          t
        );
      })(),
      ao = (function () {
        function t() {
          zn()(this, t), (this.images = []), (this.readyToDraw = !1), (this.length = 60), (this.prevIdx = 1), new io("image-load").loadImages(), this.setup();
        }
        return (
          Gn()(t, [
            {
              key: "drawFirstFrame",
              value: function () {
                var t, e;
                (this.readyToDraw = !0),
                  (this.topImg = this.images[0].image),
                  z.windowWidth,
                  z.windowHeight,
                  (t = z.windowWidth),
                  (e = z.windowHeight),
                  this.setSize(t, e),
                  (this.ctx.webkitImageSmoothingEnabled = !1),
                  (this.ctx.msImageSmoothingEnabled = !1),
                  (this.ctx.imageSmoothingEnabled = !1),
                  this.drawImage(1);
              },
            },
            {
              key: "setup",
              value: function () {
                (this.div = document.querySelector("#fixed-scene")),
                  (this.canvas = document.createElement("canvas")),
                  (this.canvas.id = "scene"),
                  this.div.appendChild(this.canvas),
                  (this.ctx = this.canvas.getContext("2d", { antialias: !1 }));
              },
            },
            {
              key: "drawImage",
              value: function (t) {
                if (!(t - 1 > this.length - 1 || t - 1 < 0)) {
                  this.prevIdx = t;
                  var e = this.images[t - 1];
                  e && ((e = e.image), this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.ctx.drawImage(e, this.drawX, this.drawY, e.width * this.scale, e.height * this.scale));
                }
              },
            },
            {
              key: "setSize",
              value: function (t, e) {
                (this.canvas.width = t * window.devicePixelRatio),
                  (this.canvas.height = e * window.devicePixelRatio),
                  (this.canvas.style.width = t + "px"),
                  (this.canvas.style.height = e + "px"),
                  (this.scale = Math.max(this.canvas.width / this.topImg.width, this.canvas.height / this.topImg.height)),
                  (this.drawX = this.canvas.width / 2 - (this.topImg.width / 2) * this.scale),
                  (this.drawY = this.canvas.height / 2 - (this.topImg.height / 2) * this.scale);
              },
            },
            {
              key: "resize",
              value: function () {
                var t, e;
                z.windowWidth, z.windowHeight, (t = z.windowWidth), (e = z.windowHeight), this.setSize(t, e), this.drawImage(this.prevIdx);
              },
            },
          ]),
          t
        );
      })(),
      no = (function () {
        function t() {
          var e = this;
          zn()(this, t),
            (this.parentWrapper = document.getElementById("emojis-wrapper")),
            this.parentWrapper && ((this.emojis = j(Array.prototype.slice.call(this.parentWrapper.querySelectorAll(".emoji")))), (this.emojiImages = this.parentWrapper.querySelectorAll("img")), (this.tweenArr = [])),
            (this.celebratoryWrapper = document.getElementById("celebratory-wrapper")),
            (this.celebratoryEmojis = j(Array.prototype.slice.call(this.celebratoryWrapper.querySelectorAll(".emoji")))),
            (this.celebratoryEmojiImages = this.celebratoryWrapper.querySelectorAll("img")),
            (this.celebratoryTweenArr = []),
            (this.celebrating = !1);
          var i = setInterval(function () {
            To &&
              (clearInterval(i),
              e.parentWrapper &&
                To.loadImages(e.emojiImages, "nodeList", function (t) {
                  e.setup();
                }),
              To.loadImages(e.celebratoryEmojiImages, "nodeList", function (t) {
                e.setupCelebration();
              }));
          }, 200);
        }
        return (
          Gn()(t, [
            {
              key: "setup",
              value: function () {
                Un.set(this.parentWrapper, { opacity: 0, force3D: !0 });
                for (var t = z.windowWidth > 767 ? 10 : 5, e = 0; e < t; e++) {
                  var i = this.emojis[e],
                    a = H(11, 15),
                    n = H(e, 3 * e),
                    r = H(0.5, 1),
                    s = H(-30, 30),
                    o = void 0;
                  (o = z.isMobile ? z.windowHeight + 162 + 140 : z.windowHeight + 162), Un.set(i, { scale: r, rotation: s });
                  var l = Un.fromTo(i, a, { y: 0 }, { y: -o, repeat: -1, delay: n, force3D: !0, ease: "none" });
                  l.pause(), this.tweenArr.push(l);
                }
              },
            },
            {
              key: "setupCelebration",
              value: function () {
                Un.set(this.celebratoryWrapper, { opacity: 0, force3D: !0 });
                for (var t = 0; t < this.celebratoryEmojis.length; t++) {
                  var e = this.celebratoryEmojis[t],
                    i = H(2, 3.5),
                    a = Math.round(H(3, 5)),
                    n = H(0.5, 1),
                    r = H(-30, 30),
                    s = void 0;
                  (s = z.isMobile ? z.windowHeight + 162 + 140 : z.windowHeight + 162), Un.set(e, { scale: n, rotation: r });
                  var o = Un.fromTo(e, i, { y: 0 }, { y: -s, delay: a, force3D: !0, ease: "sine.inOut" });
                  o.pause(0), this.celebratoryTweenArr.push(o);
                }
              },
            },
            {
              key: "celebrate",
              value: function () {
                var t = this;
                if (!this.celebrating) {
                  (this.celebrating = !0), Un.set(this.celebratoryWrapper, { opacity: 1 });
                  for (var e = 0; e < this.celebratoryTweenArr.length; e++) this.celebratoryTweenArr[e].play();
                  Un.delayedCall(3.5, function () {
                    for (var e = 0; e < t.celebratoryTweenArr.length; e++) t.celebratoryTweenArr[e].pause(0);
                    t.celebrating = !1;
                  });
                }
              },
            },
            {
              key: "activate",
              value: function () {
                for (var t = 0; t < this.tweenArr.length; t++) this.tweenArr[t].play();
                Un.to(this.parentWrapper, 0.7, { opacity: 1, ease: "sine.inOut", force3D: !0 });
              },
            },
            {
              key: "deactivate",
              value: function () {
                for (var t = 0; t < this.tweenArr.length; t++) this.tweenArr[t].pause();
                Un.to(this.parentWrapper, 0.7, { opacity: 0, ease: "sine.inOut", force3D: !0 });
              },
            },
          ]),
          t
        );
      })();
    function ro(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    Un.registerPlugin($s);
    var so = (function (t) {
      _s()(i, t);
      var e = ro(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          {
            key: "onEnter",
            value: function () {
              var t = navigator.userAgent.toLowerCase();
              if (-1 !== t.indexOf("tiktok") || -1 !== t.indexOf("musical_ly")) {
                document.querySelector(".view-add-something-positive").classList.add("tiktok-browser");
                for (var e = document.querySelectorAll(".replace-on-tiktok"), i = document.querySelectorAll(".tiktok-replacement"), a = 0; a < e.length; a++)
                  console.log(e[a].parentElement), e[a].parentElement.removeChild(e[a]), 0 === a ? i[a].classList.add("preload-critical") : i[a].classList.add("preload");
              }
              z.firstLoad
                ? (Un.set(K.header, { opacity: 0, pointerEvents: "none" }), Un.set(K.globalFooter, { display: "none" }))
                : Un.to(K.header, 0.35, {
                    opacity: 0,
                    pointerEvents: "none",
                    ease: "sine.inOut",
                    force3D: !0,
                    onComplete: function () {
                      Un.set(K.globalFooter, { display: "none" });
                    },
                  }),
                Un.delayedCall(1, function () {
                  !(function () {
                    for (
                      var t = document.querySelectorAll(".tiktok"),
                        e = function (e) {
                          var i = t[e],
                            a = i.querySelector(".slider"),
                            n = i.querySelector(".prev"),
                            r = i.querySelector(".next"),
                            s = U(a, { loop: !0, align: "start", inViewThreshold: 0.4 });
                          if (
                            ((function (t, e, i, a) {
                              if (
                                (i &&
                                  i.addEventListener("click", function () {
                                    t.scrollPrev();
                                  }),
                                a &&
                                  a.addEventListener("click", function () {
                                    t.scrollNext();
                                  }),
                                e)
                              ) {
                                for (
                                  var n = function (i) {
                                      e[i].addEventListener("click", function () {
                                        t.scrollTo(i);
                                      });
                                    },
                                    r = 0;
                                  r < e.length;
                                  r++
                                )
                                  n(r);
                                t.on("select", function () {
                                  e[t.previousScrollSnap()].classList.remove("active"), e[t.selectedScrollSnap()].classList.add("active");
                                });
                              }
                            })(s, !1, n, r),
                            i.querySelector(".tiktok-video"))
                          ) {
                            var o = i.querySelectorAll(".tiktok-video");
                            s.on("select", function () {
                              o[s.previousScrollSnap()].pause(), o[s.selectedScrollSnap()].play();
                            });
                          }
                        },
                        i = 0;
                      i < t.length;
                      i++
                    )
                      e(i);
                  })();
                });
              var n = setInterval(function () {
                z.loadASPImages && (clearTimeout(n), (to = new ao()));
              }, 200);
              document.documentElement.classList.add("no-scrollbar");
              var r,
                s = document.querySelector(".hero .scroll-note"),
                o = document.querySelector("section.tiktok");
              Un.delayedCall(7, function () {
                Un.to(s, 0.6, { opacity: 1, ease: "sine.inOut" }),
                  (r = Un.fromTo(s, 3.5, { y: -15 }, { immediateRender: !1, repeat: -1, y: 0, ease: $s.create("custom", "M0,0 C0.032,0.206 0.283,1 0.5,1 0.72,1 0.984,0.184 1,0"), force3D: !0 }));
              }),
                s.addEventListener("click", function () {
                  r.kill(), z.windowWidth > 767 ? _o.scrollTo(o.getBoundingClientRect().top + 80) : _o.scrollTo(o.getBoundingClientRect().top - 40), it("google", "send", "event", "click", "Add Something Positive", "Scroll Down");
                });
            },
          },
          {
            key: "onEnterCompleted",
            value: function () {
              window.addEventListener("beforeunload", function () {
                it("google", "send", "event", "exit", "Add Something Positive");
              });
              var t = new Un.timeline({ paused: !0 }),
                e = !1,
                i = !1,
                a = document.getElementById("easter-egg-trigger");
              t.fromTo(a, 0.7, { scale: 1 }, { scale: 1.4, ease: $s.create("custom", "M0,0 C0.032,0.206 0.283,1 0.5,1 0.72,1 0.984,0.184 1,0"), force3D: !0 }).fromTo(
                a,
                1,
                { rotation: 10 },
                {
                  rotation: 370,
                  ease: "expo.inOut",
                  force3D: !0,
                  onComplete: function () {
                    t.progress(0).pause(), (e = !1);
                  },
                },
                0
              ),
                a.addEventListener("click", function () {
                  e || i || ((e = !0), (i = !0), t.play(), it("google", "send", "event", "click", "Add Something Positive", "Emoji Trigger"));
                }),
                a.addEventListener("click", function () {
                  eo.celebrate();
                }),
                a.addEventListener("mouseenter", function () {
                  e || i || ((e = !0), (i = !0), t.play());
                }),
                a.addEventListener("mousemove", function () {
                  e || i || ((i = !0), (e = !0), t.play());
                }),
                a.addEventListener("mouseleave", function () {
                  i = !1;
                });
              var n = document.querySelector(".coupon-trigger"),
                r = document.querySelector(".coupon-modal"),
                s = document.querySelector(".asp-header"),
                o = r.querySelector(".close");
              n.addEventListener("click", function () {
                Un.to(r, 0.3, { autoAlpha: 1, pointerEvents: "all", force3D: !0, ease: "sine.inOut" }),
                  Un.to(s, 0.25, { autoAlpha: 0, pointerEvents: "none", force3D: !0, ease: "sine.inOut" }),
                  it("google", "send", "event", "click", "Add Something Positive", "Coupon Trigger"),
                  eo.celebrate();
              }),
                o.addEventListener("click", function () {
                  Un.to(r, 0.25, { autoAlpha: 0, pointerEvents: "none", force3D: !0, ease: "sine.inOut" }),
                    Un.to(s, 0.3, { autoAlpha: 1, pointerEvents: "all", force3D: !0, ease: "sine.inOut" }),
                    it("google", "send", "event", "click", "Add Something Positive", "Close Coupon Modal");
                });
              var l = document.querySelector(".coupon-modal .btn-group .btn:first-child"),
                c = document.querySelector(".code-wrapper p span").textContent;
              if (navigator.clipboard) {
                var h = l.textContent;
                l.addEventListener("click", function (t) {
                  t.preventDefault(),
                    navigator.clipboard.writeText(c),
                    it("google", "send", "event", "click", "Add Something Positive", "Coupon Copy"),
                    (l.innerText = "Copied to clipboard!"),
                    Un.delayedCall(1.8, function () {
                      l.innerText = h;
                    });
                });
              } else l.remove();
              eo = new no();
              var u = document.querySelectorAll(".tiktok .slider a");
              if (z.isMobile) u[0].querySelector("video") && u[0].querySelector("video").classList.add("auto");
              else
                for (
                  var d = function (t) {
                      var e = u[t].querySelector("video");
                      u[t].addEventListener("mouseenter", function () {
                        e.play();
                      }),
                        u[t].addEventListener("mouseleave", function () {
                          e.pause();
                        });
                    },
                    p = 0;
                  p < u.length;
                  p++
                )
                  d(p);
            },
          },
          {
            key: "onLeave",
            value: function () {
              document.documentElement.classList.remove("no-scrollbar");
            },
          },
          {
            key: "onLeaveCompleted",
            value: function () {
              Un.to(K.header, 0.35, {
                opacity: 1,
                pointerEvents: "all",
                force3D: !0,
                ease: "sine.inOut",
                onComplete: function () {
                  Un.set(K.globalFooter, { display: "block" });
                },
              });
            },
          },
        ]),
        i
      );
    })(m.Renderer);
    Un.registerPlugin(bs);
    var oo = (function () {
      function t() {
        var e = this,
          i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        zn()(this, t),
          (this.isMobile = z.isMobile),
          this.bindMethods(),
          (this.el = document.documentElement),
          (this.thisPagesTLs = []),
          (this.offsetVal = 0),
          (this.body = document.body),
          (this.direction = "untouched"),
          (this.transitioning = !1),
          (this.lottieAnimsLoaded = !1),
          Un.defaults({ ease: "Linear.easeNone" });
        var a = i.dataFromElems,
          n = void 0 === a ? this.el.querySelectorAll("[data-from]") : a,
          r = i.dataHeroFromElems,
          s = void 0 === r ? document.querySelectorAll("[data-h-from]") : r,
          o = i.heroMeasureEl,
          l = void 0 === o ? this.el.querySelector(".hero .measure-el") : o,
          c = i.scrollBasedElems,
          h = void 0 === c ? this.el.querySelectorAll("[data-entrance]") : c,
          u = i.sceneMeasureEl,
          d = void 0 === u ? this.el.querySelector(".scene-filler .scene-measure-el") : u,
          p = i.otherMeasureEls,
          f = void 0 === p ? this.el.querySelectorAll(".scene-filler .measure-el") : p,
          m = i.challengeMeasureEl,
          g = void 0 === m ? this.el.querySelector(".challenge-filler .count-measure-el") : m,
          y = i.challengeMeasureEls,
          v = void 0 === y ? this.el.querySelectorAll(".challenge-filler .measure-el") : y,
          A = i.threshold,
          b = void 0 === A ? 200 : A;
        if (
          ((this.dom = { el: this.el, dataFromElems: n, dataHeroFromElems: s, scrollBasedElems: h, challengeMeasureEl: g, challengeMeasureEls: v, sceneMeasureEl: d, otherMeasureEls: f, heroMeasureEl: l }),
          (this.dataFromElems = null),
          (this.dataHeroFromElems = null),
          (this.scrollBasedElems = null),
          (this.lottieAnimGroups = null),
          (this.raf = null),
          (this.state = { resizing: !1 }),
          (this.data = { threshold: b, current: this.el.scrollTop, last: 0, height: 0, max: 0, currentScrollY: this.el.scrollTop, window2x: 2 * z.windowHeight }),
          z.windowWidth > 767)
        )
          for (var w = this.dom.scrollBasedElems.length, C = 0; C < w; C++) {
            var S = this.dom.scrollBasedElems[C],
              k = S.dataset.entrance,
              E = new Un.timeline({ paused: !0 }),
              x = void 0;
            !(function () {
              switch (k) {
                case "count-up":
                  x = S.querySelectorAll(".s-el");
                  var t = S.querySelectorAll("[data-number]");
                  E.call(function () {
                    Array.prototype.slice.call(t).forEach(Ss);
                  }).fromTo(x, 0.8, { y: 40, opacity: 0 }, { y: 0, opacity: 1, ease: "power3.easeIn", clearProps: "transform", stagger: 0.2, force3D: !0 }),
                    e.thisPagesTLs.push(E);
                  break;
                case "reviews-high-fives":
                  E.add(function () {
                    er.forEach(function (t, e) {
                      Un.delayedCall(0.4 * e, function () {
                        t.goToAndPlay(0);
                      });
                    });
                  }),
                    e.thisPagesTLs.push(E);
                  break;
                case "stagger-fade":
                  (x = S.querySelectorAll(".s-el")),
                    E.fromTo(x, 0.5, { y: 18 }, { stagger: 0.06, y: 0, ease: "sine.out", force3D: !0 }).fromTo(x, 0.48, { opacity: 0 }, { stagger: 0.06, clearProps: "transform", opacity: 1, ease: "sine.out", force3D: !0 }, 0.21),
                    e.thisPagesTLs.push(E);
                  break;
                case "basic-fade-down":
                  E.fromTo(S, 1.5, { scale: 1.1, opacity: 0 }, { scale: 1, opacity: 1, clearProps: "transform", ease: "power3.easeOut", force3D: !0 }), e.thisPagesTLs.push(E);
                  break;
                case "basic-fade":
                  E.fromTo(S, 0.5, { y: 18 }, { y: 0, ease: "sine.out", force3D: !0 }).fromTo(S, 0.48, { opacity: 0 }, { opacity: 1, clearProps: "transform", ease: "sine.out", force3D: !0 }, 0.21), e.thisPagesTLs.push(E);
                  break;
                case "basic-fade-up":
                  E.fromTo(S, 1, { scale: 0.965, opacity: 0 }, { scale: 1, opacity: 1, clearProps: "transform", ease: "power3.easeOut", force3D: !0 }), e.thisPagesTLs.push(E);
              }
            })();
          }
        this.init();
      }
      return (
        Gn()(t, [
          {
            key: "bindMethods",
            value: function () {
              var t = this;
              ["run", "resize"].forEach(function (e) {
                return (t[e] = t[e].bind(t));
              });
            },
          },
          {
            key: "init",
            value: function () {
              this.on();
            },
          },
          {
            key: "on",
            value: function () {
              this.getBounding(), this.getCache(), this.requestAnimationFrame();
            },
          },
          {
            key: "setupLottieAnims",
            value: function () {
              var t = document.querySelectorAll(".js-lottie-holder");
              this.lottieAnimHolders = [];
              for (var e = 0; e < t.length; e++) {
                var i = t[e].getBoundingClientRect();
                if (!this.lottieAnimsLoaded) {
                  this.lottieAnimGroups = [];
                  for (var a = t[e].querySelectorAll(".js-lottie-anim"), n = [], r = 0; r < a.length; r++) {
                    var s = a[r],
                      o = Yn.a.loadAnimation({ container: s, renderer: "svg", loop: !0, autoplay: !1, path: s.dataset.animationPath });
                    n.push(o);
                  }
                  this.lottieAnimGroups.push(n);
                }
                this.lottieAnimHolders.push({ top: i.top, bottom: i.bottom, paused: !0 });
              }
              this.lottieAnimsLoaded = !0;
            },
          },
          {
            key: "playPauseLottieAnims",
            value: function () {
              if (this.lottieAnimGroups)
                for (var t = 0; t < this.lottieAnimGroups.length; t++) {
                  var e = this.lottieAnimHolders[t];
                  if (this.isVisible(e).isVisible && e.paused) {
                    for (var i = this.lottieAnimGroups[t], a = 0; a < i.length; a++) i[a].play();
                    e.paused = !1;
                  } else if (!this.isVisible(e).isVisible && !e.paused) {
                    for (var n = this.lottieAnimGroups[t], r = 0; r < n.length; r++) n[r].pause();
                    e.paused = !0;
                  }
                }
            },
          },
          {
            key: "run",
            value: function () {
              this.state.resizing ||
                this.transitioning ||
                (z.isMobile ? (this.data.current = this.el.scrollTop) : this.scrollTrigger.update(),
                (this.data.last = this.data.current),
                "add-something-positive" === z.namespace
                  ? ((this.data.currentScrollY = this.data.current), this.animateASPScene(), this.animateASPText(), this.animateChallenge(), this.hideShowChallenge(), this.hideShowEmojis(), this.hideShowASPHeader())
                  : (this.animateDataHeroFromElems(), this.animateHpHeroElems(), this.playPauseLottieAnims(), this.hideShowAtcBar()),
                this.animateDataFromElems(),
                this.checkScrollBasedLoadins(),
                this.checkScrolledMedia(),
                this.playPauseVideos(),
                this.requestAnimationFrame());
            },
          },
          {
            key: "getSceneData",
            value: function () {
              if (this.dom.sceneMeasureEl) {
                var t = this.dom.sceneMeasureEl.getBoundingClientRect();
                this.sceneMeasureData = { top: t.top + this.data.currentScrollY, bottom: t.bottom + this.data.currentScrollY, height: t.bottom - t.top, reset: !0, duration: 1, idx: 0, prevIdx: 0, progress: { current: 0 } };
              }
            },
          },
          {
            key: "hideShowASPHeader",
            value: function () {
              "untouched" !== this.direction &&
                this.aspHeaderLogo &&
                ("down" === this.direction && !this.headerScrolled && this.data.current >= this.adjustHeaderDist
                  ? ((this.headerScrolled = !0), Un.to(this.aspHeaderLogo, 0.3, { autoAlpha: 0, ease: "sine.inOut" }))
                  : "up" === this.direction && this.headerScrolled && this.data.current < this.adjustHeaderDist && ((this.headerScrolled = !1), Un.to(this.aspHeaderLogo, 0.3, { autoAlpha: 1, ease: "sine.inOut" })));
            },
          },
          {
            key: "animateASPScene",
            value: function () {
              if (this.sceneMeasureData && "untouched" !== this.direction) {
                var t = this.sceneMeasureData,
                  e = this.isVisible(t, 0.01),
                  i = e.isVisible,
                  a = e.start,
                  n = e.end;
                if (i) {
                  if ((t.reset && (t.reset = !1), this.intersectRatio(t, a, n), (t.idx = Math.ceil(60 * t.progress.current)), t.prevIdx === t.idx)) return;
                  if ("down" === this.direction && t.idx < t.prevIdx) return;
                  if ("up" === this.direction && t.idx > t.prevIdx) return;
                  to.drawImage(t.idx), (t.prevIdx = t.idx);
                } else t.reset || ((t.reset = !0), "down" === this.direction ? to.drawImage(60) : "up" === this.direction && to.drawImage(1));
              }
            },
          },
          {
            key: "getSceneTextData",
            value: function () {
              if (this.dom.otherMeasureEls.length > 0) {
                this.sceneTextData = [];
                for (
                  var t = document.querySelector(".fixed-text"), e = t.querySelector(".background"), i = t.querySelector(".message.one"), a = t.querySelector(".scale-number"), n = t.querySelector(".message.two"), r = 0;
                  r < this.dom.otherMeasureEls.length;
                  r++
                ) {
                  var s = this.dom.otherMeasureEls[r].getBoundingClientRect(),
                    o = new Un.timeline({ paused: !0 });
                  switch (r) {
                    case 0:
                      o.fromTo(e, 1, { autoAlpha: 0 }, { autoAlpha: 0.66, force3D: !0, ease: "none" }).fromTo(i, 0.9, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0);
                      break;
                    case 1:
                      o.to(i, 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(a, 0.8, { scale: 4, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                      break;
                    case 2:
                      o.to(a, 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(n, 0.8, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                  }
                  this.sceneTextData.push({ top: s.top + this.data.currentScrollY, bottom: s.bottom + this.data.currentScrollY, height: s.bottom - s.top, reset: !0, duration: 1, tl: o, progress: { current: 0 } });
                }
              }
            },
          },
          {
            key: "animateASPText",
            value: function () {
              if (0 !== this.sceneTextData.length && "untouched" !== this.direction)
                for (var t = 0; t < this.sceneTextData.length; t++) {
                  var e = this.sceneTextData[t],
                    i = this.isVisible(e, 0.01),
                    a = i.isVisible,
                    n = i.start,
                    r = i.end;
                  a ? (this.intersectRatio(e, n, r), e.tl.progress(e.progress.current), e.reset && (e.reset = !1)) : e.reset || ("down" === this.direction ? e.tl.progress(1) : e.tl.progress(0), (e.reset = !0));
                }
            },
          },
          {
            key: "getChallengeData",
            value: function () {
              if (this.dom.challengeMeasureEl) {
                var t = this.dom.challengeMeasureEl.getBoundingClientRect(),
                  e = document.querySelector(".pixels-scrolled"),
                  i = this.el.querySelector(".opening-message").dataset.pounds,
                  a = document.querySelector(".fixed-challenge .bar");
                (i = (i = i.replace(",", "")).replace(",", "")),
                  (i = parseInt(i.replace(",", ""))),
                  Un.set(a, { scaleY: 0 }),
                  (this.challengeCountData = {
                    el: e,
                    scaleEl: a,
                    top: t.top + this.data.currentScrollY,
                    bottom: t.bottom + this.data.currentScrollY,
                    height: t.bottom - t.top,
                    reset: !0,
                    poundsRemoved: i,
                    duration: 1,
                    count: 0,
                    progress: { current: 0 },
                  });
                var n = document.querySelector(".after-footer").getBoundingClientRect();
                this.challengeFooterData = { el: document.querySelector(".fixed-challenge"), challengeVisible: !1, top: n.top + this.data.currentScrollY, bottom: n.bottom + this.data.currentScrollY, height: n.bottom - n.top };
              }
              if (this.dom.challengeMeasureEls.length > 0) {
                this.challengeData = [];
                for (
                  var r = document.querySelector(".fixed-challenge"), s = r.querySelector(".opening-message"), o = r.querySelector(".pixels-scrolled"), l = r.querySelectorAll(".note"), c = r.querySelector(".coupon-trigger"), h = 0;
                  h < this.dom.challengeMeasureEls.length;
                  h++
                ) {
                  var u = this.dom.challengeMeasureEls[h].getBoundingClientRect(),
                    d = new Un.timeline({ paused: !0 });
                  switch (h) {
                    case 0:
                      d.fromTo(s, 0.5, { scale: 1, autoAlpha: 1 }, { scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo([o, l[0]], 0.8, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                      break;
                    case 1:
                      d.to(l[0], 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(l[1], 0.8, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                      break;
                    case 2:
                      d.to(l[1], 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(l[2], 0.8, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                      break;
                    case 3:
                      d.to(l[2], 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(l[3], 0.8, { scale: 0.85, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, force3D: !0, ease: "none" }, 0.2);
                      break;
                    case 4:
                      d.to(l[3], 0.5, { immediateRender: !1, scale: 0.85, autoAlpha: 0, force3D: !0, ease: "none" }).fromTo(
                        [l[4], c],
                        0.8,
                        { scale: 0.85, autoAlpha: 0, pointerEvents: "none" },
                        { scale: 1, autoAlpha: 1, pointerEvents: "all", force3D: !0, ease: "none" },
                        0.2
                      );
                  }
                  this.challengeData.push({ top: u.top + this.data.currentScrollY, bottom: u.bottom + this.data.currentScrollY, height: u.bottom - u.top, reset: !0, duration: 4 === h ? 0.35 : 1, tl: d, progress: { current: 0 } });
                }
              }
            },
          },
          {
            key: "getEmojiData",
            value: function () {
              var t = document.querySelector(".full-bleed.video").getBoundingClientRect(),
                e = document.querySelector(".scene-filler").getBoundingClientRect();
              this.emojiData = { emojisVisible: !1, startTop: t.top + this.data.currentScrollY, startBottom: t.bottom + this.data.currentScrollY, endTop: e.top + this.data.currentScrollY, endBottom: e.bottom + this.data.currentScrollY };
            },
          },
          {
            key: "hideShowChallenge",
            value: function () {
              if (!this.challengeFooterData || "untouched" !== this.direction) {
                var t = this.challengeFooterData;
                this.data.currentScrollY + z.windowHeight > t.top && !t.challengeVisible
                  ? ((t.challengeVisible = !0), Un.set(t.el, { zIndex: 3 }))
                  : this.data.currentScrollY + z.windowHeight < t.top && t.challengeVisible && ((t.challengeVisible = !1), Un.set(t.el, { zIndex: 1 }));
              }
            },
          },
          {
            key: "hideShowEmojis",
            value: function () {
              if (!this.emojiData || "untouched" !== this.direction) {
                var t = this.emojiData;
                this.data.currentScrollY + z.windowHeight > t.startTop && this.data.currentScrollY + z.windowHeight < t.endTop && !t.emojisVisible
                  ? ((t.emojisVisible = !0), eo.activate())
                  : (this.data.currentScrollY + z.windowHeight > t.endTop || this.data.currentScrollY + z.windowHeight < t.startTop) && t.emojisVisible && ((t.emojisVisible = !1), eo.deactivate());
              }
            },
          },
          {
            key: "animateChallenge",
            value: function () {
              if (this.challengeCountData.length > 0 || "untouched" !== this.direction) {
                var t = this.challengeCountData,
                  e = this.isVisible(t, 0.01),
                  i = e.isVisible,
                  a = e.start,
                  n = e.end;
                if (i) {
                  this.intersectRatio(t, a, n), t.reset && (t.reset = !1), Un.set(t.scaleEl, { scaleY: t.progress.current });
                  var r = Math.ceil(Y(t.progress.current, 0, 1, 0, t.poundsRemoved));
                  if (r === t.count) return;
                  (t.count = r), (t.el.innerText = r.toLocaleString());
                } else t.reset || ("down" === this.direction ? (t.el.innerText = t.poundsRemoved.toLocaleString()) : (t.el.innerText = "0"), (t.reset = !0));
              }
              if (0 !== this.challengeData.length && "untouched" !== this.direction)
                for (var s = 0; s < this.challengeData.length; s++) {
                  var o = this.challengeData[s],
                    l = this.isVisible(o, 0.01),
                    c = l.isVisible,
                    h = l.start,
                    u = l.end;
                  c ? (this.intersectRatio(o, h, u), o.tl.progress(o.progress.current), o.reset && (o.reset = !1)) : o.reset || ("down" === this.direction ? o.tl.progress(1) : o.tl.progress(0), (o.reset = !0));
                }
            },
          },
          {
            key: "getScrolledMedia",
            value: function () {
              if (((this.data.scrolledMediaCount = 0), (this.data.scrolledMediaFired = 0), (this.dom.scrolledMedia = this.el.querySelectorAll("[data-router-view]:last-child .mw")), this.dom.scrolledMedia)) {
                this.scrolledMediaData = [];
                for (var t = 0; t < this.dom.scrolledMedia.length; t++) {
                  var e = this.dom.scrolledMedia[t],
                    i = e.getBoundingClientRect(),
                    a = !1;
                  ("product-listing" !== z.namespace && "product-category" !== z.namespace && "collections" !== z.namespace) || (a = e.querySelector(".add-to-cart-form")),
                    this.data.scrolledMediaCount++,
                    this.scrolledMediaData.push({ el: e, mediaEls: e.querySelectorAll(".preload"), atcForm: a, loaded: !1, top: i.top + this.data.currentScrollY, bottom: i.bottom + this.data.currentScrollY, height: i.bottom - i.top });
                }
              }
            },
          },
          {
            key: "checkScrolledMedia",
            value: function () {
              var t = this,
                e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              if (("untouched" !== this.direction || e) && this.scrolledMediaData && this.data.scrolledMediaFired !== this.data.scrolledMediaCount)
                for (
                  var i = function (e) {
                      var i = t.scrolledMediaData[e];
                      if (i.loaded) return "continue";
                      t.data.current + t.data.window2x > i.top &&
                        (i.el.classList.remove("mw"),
                        To.loadImages(i.mediaEls, "nodeList", function () {}),
                        i.atcForm &&
                          Un.delayedCall(1, function () {
                            new Es(i.atcForm);
                          }),
                        t.data.scrolledMediaFired++,
                        (i.loaded = !0));
                    },
                    a = 0;
                  a < this.scrolledMediaData.length;
                  a++
                )
                  i(a);
            },
          },
          {
            key: "playPauseVideos",
            value: function () {
              if ("untouched" !== this.direction)
                for (var t = 0; t < this.videosDataLength; t++) {
                  var e = this.videosData[t],
                    i = this.isVisible(e, 50).isVisible;
                  i ? e.playing || (e.el.play(), (e.playing = !0)) : !i && e.playing && (e.el.pause(), (e.el.currentTime = 0), (e.playing = !1));
                }
            },
          },
          {
            key: "getVideos",
            value: function () {
              var t = document.querySelectorAll("video.auto");
              this.videosData = [];
              for (var e = 0; e < t.length; e++) {
                var i = t[e].getBoundingClientRect();
                this.videosData.push({ el: t[e], playing: !1, top: i.top + this.data.currentScrollY > this.data.height ? i.top + this.data.currentScrollY : this.data.height, bottom: i.bottom + this.data.currentScrollY });
              }
              this.videosDataLength = this.videosData.length;
            },
          },
          {
            key: "getScrollBasedSections",
            value: function () {
              if (this.dom.scrollBasedElems) {
                this.scrollBasedElems = [];
                for (var t = this.dom.scrollBasedElems.length, e = 0; e < t; e++)
                  if (!(e < this.offsetVal)) {
                    var i = this.dom.scrollBasedElems[e],
                      a = i.getBoundingClientRect();
                    this.scrollBasedElems.push({
                      el: i,
                      played: !1,
                      top: a.top + this.data.currentScrollY > this.data.height ? a.top + this.data.currentScrollY : this.data.height,
                      bottom: a.bottom + this.data.currentScrollY,
                      height: a.bottom - a.top,
                      offset: z.windowWidth < 768 ? i.dataset.offsetMobile * z.windowHeight : i.dataset.offset * z.windowHeight,
                    });
                  }
              }
            },
          },
          {
            key: "getHpHeroElems",
            value: function () {
              var t = document.getElementById("hp-hero-scroll");
              if (t) {
                var e = document.getElementById("hp-hero-shrink-measure"),
                  i = document.getElementById("hp-hero-img-1"),
                  a = document.getElementById("hp-hero-img-2"),
                  n = document.getElementById("hp-hero-img-3"),
                  r = t.getBoundingClientRect(),
                  s = z.windowHeight - r.top;
                Un.set(e, { top: s });
                var o = new Un.timeline({ paused: !0 });
                o.to([i, a, n], 1, { scale: 0.8, force3D: !0 });
                var l = e.getBoundingClientRect();
                this.hpHeroShrinkData = {
                  top: l.top + this.data.currentScrollY > this.data.height ? l.top + this.data.currentScrollY : this.data.height,
                  bottom: l.bottom + this.data.currentScrollY,
                  height: l.bottom - l.top,
                  tl: o,
                  progress: { current: 0 },
                  duration: 1,
                };
              }
            },
          },
          {
            key: "animateHpHeroShrink",
            value: function () {
              if ("untouched" !== this.direction && this.hpHeroShrinkData) {
                var t = this.isVisible(this.hpHeroShrinkData, 0.01),
                  e = t.isVisible,
                  i = t.start,
                  a = t.end;
                e && (this.hpHeroIntersect(this.hpHeroShrinkData, i, a), this.hpHeroShrinkData.tl.progress(this.hpHeroShrinkData.progress.current));
              }
            },
          },
          {
            key: "animateHpHeroElems",
            value: function () {
              this.animateHpHeroShrink();
            },
          },
          {
            key: "getAtcBarBounds",
            value: function () {
              var t,
                e,
                i = document.getElementById("pdp-atc-bar"),
                a = document.querySelector(".recirculation"),
                n = document.querySelector(".product-slider.other-products"),
                r = new Un.timeline({ paused: !0 });
              ((t =
                a && z.windowWidth > 767
                  ? a.getBoundingClientRect().top - z.windowHeight + 100
                  : n && z.windowWidth < 768
                  ? n.getBoundingClientRect().top - z.windowHeight + 60
                  : document.getElementById("main").getBoundingClientRect().bottom - 2 * z.windowHeight),
              z.windowWidth > 767)
                ? (e = 700)
                : (e = document.querySelector(".pdp-hero .add-to-cart").getBoundingClientRect().bottom - 70);
              if (z.windowWidth > 767) {
                var s = i.querySelector("img");
                r.fromTo(i, 0.45, { autoAlpha: 0, yPercent: 100 }, { autoAlpha: 1, yPercent: 0, ease: la.easeInOut }).fromTo(s, 0.35, { opacity: 0, y: 40 }, { opacity: 1, y: 0, ease: la.easeInOut }, 0.3);
              } else r.fromTo(i, 0.3, { autoAlpha: 0, yPercent: 100 }, { autoAlpha: 1, yPercent: 0, ease: la.easeInOut });
              this.atcBarBoundsData = { top: e, bottom: t, tl: r, visible: !1 };
            },
          },
          {
            key: "hideShowAtcBar",
            value: function () {
              "untouched" !== this.direction &&
                this.atcBarBoundsData &&
                ("down" === this.direction
                  ? !this.atcBarBoundsData.visible && this.data.current >= this.atcBarBoundsData.top && this.data.current <= this.atcBarBoundsData.bottom
                    ? ((this.atcBarBoundsData.visible = !0), this.atcBarBoundsData.tl.play())
                    : this.atcBarBoundsData.visible && this.data.current >= this.atcBarBoundsData.bottom && ((this.atcBarBoundsData.visible = !1), this.atcBarBoundsData.tl.reverse())
                  : "up" === this.direction &&
                    (this.atcBarBoundsData.visible && this.data.current <= this.atcBarBoundsData.top
                      ? ((this.atcBarBoundsData.visible = !1), this.atcBarBoundsData.tl.reverse())
                      : !this.atcBarBoundsData.visible && this.data.current <= this.atcBarBoundsData.bottom && this.data.current >= this.atcBarBoundsData.top && ((this.atcBarBoundsData.visible = !0), this.atcBarBoundsData.tl.play())));
            },
          },
          {
            key: "getDataFromElems",
            value: function () {
              if (this.dom.dataFromElems) {
                this.dataFromElems = [];
                for (var t = z.windowWidth < 768, e = this.dom.dataFromElems.length, i = 0; i < e; i++) {
                  var a = this.dom.dataFromElems[i],
                    n = void 0,
                    r = void 0,
                    s = void 0,
                    o = a.getBoundingClientRect(),
                    l = new Un.timeline({ paused: !0 });
                  t
                    ? ((n = a.dataset.mobileFrom ? JSON.parse(a.dataset.mobileFrom) : JSON.parse(a.dataset.from)),
                      (r = a.dataset.mobileTo ? JSON.parse(a.dataset.mobileTo) : JSON.parse(a.dataset.to)),
                      (s = a.dataset.mobileDur ? a.dataset.mobileDur : a.dataset.dur ? a.dataset.dur : 1))
                    : ((n = JSON.parse(a.dataset.from)), (r = JSON.parse(a.dataset.to)), (s = a.dataset.dur ? a.dataset.dur : 1)),
                    l.fromTo(a, 1, n, r),
                    this.dataFromElems.push({
                      el: a,
                      tl: l,
                      top: o.top + this.data.currentScrollY > this.data.height ? o.top + this.data.currentScrollY : this.data.height,
                      bottom: o.bottom + this.data.currentScrollY,
                      height: o.bottom - o.top,
                      from: n,
                      duration: s,
                      progress: { current: 0 },
                    });
                }
              }
            },
          },
          {
            key: "getHeroMeasureEl",
            value: function () {
              if (this.dom.heroMeasureEl) {
                var t = this.dom.heroMeasureEl.getBoundingClientRect();
                this.heroMeasureData = {
                  top: t.top + this.data.currentScrollY > this.data.height ? t.top + this.data.currentScrollY : this.data.height,
                  bottom: t.bottom + this.data.currentScrollY,
                  height: t.bottom - t.top,
                  progress: { current: 0 },
                };
              }
            },
          },
          {
            key: "getDataHeroFromElems",
            value: function () {
              if (this.dom.dataHeroFromElems) {
                this.dataHeroFromElems = [];
                for (var t = z.windowWidth < 768, e = 0; e < this.dom.dataHeroFromElems.length; e++) {
                  var i = this.dom.dataHeroFromElems[e],
                    a = void 0,
                    n = void 0,
                    r = new Un.timeline({ paused: !0 });
                  t
                    ? ((a = i.dataset.hMobileFrom ? JSON.parse(i.dataset.hMobileFrom) : JSON.parse(i.dataset.hFrom)), (n = i.dataset.mobileTo ? JSON.parse(i.dataset.mobileTo) : JSON.parse(i.dataset.to)))
                    : ((a = JSON.parse(i.dataset.hFrom)), (n = JSON.parse(i.dataset.to))),
                    r.fromTo(i, 1, a, n),
                    this.dataHeroFromElems.push({ el: i, tl: r, progress: { current: 0 } });
                }
              }
            },
          },
          {
            key: "animateDataHeroFromElems",
            value: function () {
              if ("untouched" !== this.direction && this.heroMeasureData && this.isVisible(this.heroMeasureData).isVisible) {
                var t = (this.data.current / this.heroMeasureData.height).toFixed(3);
                t <= 0 ? (t = 0) : t >= 1 && (t = 1);
                for (var e = this.dataHeroFromElems.length, i = 0; i < e; i++) {
                  this.dataHeroFromElems[i].tl.progress(t);
                }
              }
            },
          },
          {
            key: "animateDataFromElems",
            value: function () {
              if ("untouched" !== this.direction && this.dataFromElems)
                for (var t = this.dataFromElems.length, e = 0; e < t; e++) {
                  var i = this.dataFromElems[e],
                    a = this.isVisible(i, 0.01),
                    n = a.isVisible,
                    r = a.start,
                    s = a.end;
                  n && (this.intersectRatio(i, r, s), i.tl.progress(i.progress.current));
                }
            },
          },
          {
            key: "checkScrollBasedLoadins",
            value: function () {
              if ("untouched" !== this.direction && this.scrollBasedElems && this.thisPagesTLs.length !== this.offsetVal)
                for (var t = this.scrollBasedElems.length, e = 0; e < t; e++) {
                  var i = this.scrollBasedElems[e];
                  i.played || (this.data.current + i.offset > i.top && (this.thisPagesTLs[this.offsetVal].play(), this.offsetVal++, (i.played = !0)));
                }
            },
          },
          {
            key: "intersectRatio",
            value: function (t, e, i) {
              var a = e - this.data.height;
              if (!(a > 0)) {
                var n = (this.data.height + i + t.height) * t.duration;
                (t.progress.current = Math.abs(a / n)), (t.progress.current = Math.max(0, Math.min(1, t.progress.current)));
              }
            },
          },
          {
            key: "hpHeroIntersect",
            value: function (t, e, i) {
              var a = e - this.data.height;
              if (!(a > 0)) {
                var n = (i + t.height - this.data.height) * t.duration;
                (t.progress.current = Math.abs(a / n)), (t.progress.current = Math.max(0, Math.min(1, t.progress.current)));
              }
            },
          },
          {
            key: "isVisible",
            value: function (t, e) {
              var i = e || this.data.threshold,
                a = t.top - this.data.current,
                n = t.bottom - this.data.current,
                r = a < i + this.data.height && n > -i;
              return { isVisible: r, start: a, end: n };
            },
          },
          {
            key: "requestAnimationFrame",
            value: (function (t) {
              function e() {
                return t.apply(this, arguments);
              }
              return (
                (e.toString = function () {
                  return t.toString();
                }),
                e
              );
            })(function () {
              this.raf = requestAnimationFrame(this.run);
            }),
          },
          {
            key: "cancelAnimationFrame",
            value: (function (t) {
              function e() {
                return t.apply(this, arguments);
              }
              return (
                (e.toString = function () {
                  return t.toString();
                }),
                e
              );
            })(function () {
              cancelAnimationFrame(this.raf);
            }),
          },
          {
            key: "getCache",
            value: function () {
              var t = this;
              this.getVideos(),
                this.getScrollBasedSections(),
                this.getScrolledMedia(),
                "add-something-positive" === z.namespace
                  ? (this.getSceneData(), this.getSceneTextData(), this.getChallengeData(), this.getEmojiData(), (this.aspHeaderLogo = document.querySelector(".asp-header .logo")), (this.adjustHeaderDist = 150))
                  : (this.getDataHeroFromElems(), this.getHeroMeasureEl(), this.setupLottieAnims()),
                this.getDataFromElems(),
                "home" === z.namespace && this.getHpHeroElems(),
                "product" === z.namespace && this.getAtcBarBounds(),
                (this.scrollTrigger = bs.create({
                  trigger: this.el,
                  start: "top top",
                  end: "bottom bottom",
                  scrub: 0.6,
                  animation: Un.to(this.data, 1, { current: this.data.max, ease: oa.easeNone }),
                  onUpdate: function (e) {
                    t.direction = -1 === e.direction ? "up" : "down";
                  },
                })),
                this.checkScrolledMedia(!0);
            },
          },
          {
            key: "getBounding",
            value: function () {
              (this.data.height = z.windowHeight), (this.data.max = this.el.getBoundingClientRect().height - this.data.height);
            },
          },
          {
            key: "resize",
            value: function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              this.state.resizing || ((this.state.resizing = !0), t || "add-something-positive" === z.namespace || (this.getCache(), this.getBounding()), this.checkScrolledMedia(!0), (this.state.resizing = !1));
            },
          },
          {
            key: "scrollTo",
            value: function (t) {
              var e = this,
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "expo.inOut";
              (this.state.scrollingTo = !0),
                Un.to(this.el, i, {
                  scrollTop: t,
                  ease: a,
                  onComplete: function () {
                    e.state.scrollingTo = !1;
                  },
                });
            },
          },
          {
            key: "destroy",
            value: function () {
              (this.transitioning = !0), (this.state.rafCancelled = !0), this.cancelAnimationFrame(), (this.resize = null), (this.dom = null), (this.data = null), (this.raf = null), (this.lottieAnimGroups = null);
            },
          },
        ]),
        t
      );
    })();
    function lo(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var co = (function (t) {
        _s()(i, t);
        var e = lo(i);
        function i(t, a) {
          return zn()(this, i), e.call(this, t, a);
        }
        return (
          Gn()(i, [
            {
              key: "initSlides",
              value: function () {
                if ((this.createSlideObjects(), this.addCSS)) {
                  for (var t = 0; t < this.count; t++) this.slides[t].el.setAttribute("style", "position: absolute; top: 0; left: 0; bottom: 0; right: 0;");
                  for (var e = 0; e < this.count; e++) this.slides[e] !== this.current && (this.slides[e].el.style.opacity = 0);
                }
                this.count > 2 ? ((this.next = this.slides[1]), (this.previous = this.slides[this.count - 1])) : ((this.next = this.slides[1]), (this.previous = this.slides[1])),
                  this.current.el.classList.add("is-selected"),
                  this.next.el.classList.add("is-next");
                var i = z.windowWidth - 66;
                Un.set(this.next.el, { x: i });
              },
            },
            {
              key: "tweenSlides",
              value: function (t, e, i) {
                var a = this;
                (this.animating = !0), this.dots && this.updateDots(t, i);
                var n = t.el,
                  r = i.el,
                  s = z.windowWidth - 66;
                e > 0
                  ? (Un.to(r, { x: 0, autoAlpha: 1, ease: la.easeOut, duration: 0.2, delay: 0.18 }),
                    Un.to(n, {
                      x: s,
                      ease: la.easeOut,
                      duration: 0.3,
                      onComplete: function () {
                        (a.animating = !1), a.slideChangeEnd(a);
                      },
                    }))
                  : (Un.to(n, { x: -30, autoAlpha: 0, ease: la.easeOut, duration: 0.3 }),
                    Un.to(r, {
                      x: 0,
                      ease: la.easeOut,
                      duration: 0.3,
                      delay: 0.08,
                      onComplete: function () {
                        (a.animating = !1), a.slideChangeEnd(a);
                      },
                    }));
              },
            },
          ]),
          i
        );
      })(Cs),
      ho = function () {
        var t = document.querySelectorAll(".promo-card");
        if (!(t.length < 1)) for (var e = document.querySelector(".product-card:nth-child(2)").getBoundingClientRect().height, i = 0; i < t.length; i++) t[i].style.height = e - 33 + "px";
      },
      uo = function () {
        for (
          var t = document.querySelectorAll("[data-for]:not(.bound)"),
            e = document.querySelector(".popover-backdrop"),
            i = function (i) {
              var a = !1,
                n = t[i],
                r = document.getElementById(n.dataset.for),
                s = r.querySelector(".close"),
                o = n.classList.contains("sub-note-trigger");
              n.classList.add("bound"),
                o && (r.querySelector(".body").innerHTML = n.closest("form").dataset.subnote),
                !o || z.isMobile
                  ? n.addEventListener("click", function () {
                      a || ((a = !0), r.classList.add("open"), Un.to([r, e], 0.25, { autoAlpha: 1, ease: "sine.inOut" }));
                    })
                  : n.addEventListener("mouseenter", function () {
                      if (!a) {
                        var t = n.getBoundingClientRect();
                        (a = !0), r.classList.add("open"), Un.set(r, { right: z.windowWidth - t.right - 3, top: t.top - 12 }), Un.to([r, e], 0.25, { autoAlpha: 1, ease: "sine.inOut" });
                      }
                    }),
                s.addEventListener("click", function () {
                  a && ((a = !1), r.classList.remove("open"), Un.to([r, e], 0.25, { autoAlpha: 0, ease: "sine.inOut" }));
                }),
                e.addEventListener("click", function () {
                  a && ((a = !1), r.classList.remove("open"), Un.to([r, e], 0.25, { autoAlpha: 0, ease: "sine.inOut" }));
                });
            },
            a = 0;
          a < t.length;
          a++
        )
          i(a);
        document.addEventListener("keyup", function (t) {
          var e = t.key;
          if ("Escape" === e || "Esc" === e) {
            var i = document.querySelector(".popover.open .close");
            i && i.click();
          }
        });
      },
      po = function () {
        var t = s();
        if (t) {
          if (t.filters)
            t.filters.split("+").forEach(function (t) {
              var e = document.querySelector('[data-router-view]:last-child .cat-filters input[data-value="' + t + '"]');
              e && e.click();
            });
          if (t.flavors)
            t.flavors.split("+").forEach(function (t) {
              var e = document.querySelector('[data-router-view]:last-child .cat-filters input[data-value="' + t + '"]');
              e && e.click();
            });
        }
      },
      fo = (function () {
        function t(e) {
          zn()(this, t),
            (this.isProductSlider = e.classList.contains("product-slider")),
            (this.isTestimonialSlider = e.classList.contains("testimonials")),
            (this.isLeftAligned = e.classList.contains("left-aligned-mobile") && (z.windowWidth < 768 || r(document.body, "force-mobile"))),
            (this.btn = e.querySelector(".btn")),
            (this.el = e),
            (this.track = e.querySelector(".track")),
            (this.prevTrigger = e.querySelector(".arrow.prev")),
            (this.nextTrigger = e.querySelector(".arrow.next")),
            (this.dotsWrapper = e.querySelector(".dots")),
            (this.animating = !1),
            (this.slides = e.querySelectorAll(".slide")),
            (this.dots = e.querySelectorAll(".dot")),
            (this.count = this.slides.length),
            (this.origCount = this.slides.length),
            (this.timeline = new Un.timeline({ paused: !0 })),
            this.init();
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                this.slides.length > 0 && (this.setupDom(), this.getCache(), this.updateSlideContext(this.idx), this.bindEvents()), this.el.classList.add("slider-on");
              },
            },
            {
              key: "setupDom",
              value: function () {
                this.xShift = 0;
                var t,
                  e = window.getComputedStyle(this.el).display;
                if (
                  (this.el.parentElement.parentElement.classList.contains("product-selection") &&
                    ((t = window.getComputedStyle(this.el.parentElement.parentElement).display), Un.set(this.el.parentElement.parentElement, { clearProps: "display" })),
                  Un.set(this.el, { clearProps: "display" }),
                  this.isLeftAligned
                    ? ((this.origIdx = 0), (this.idx = 0))
                    : this.count % 2 == 0
                    ? ((this.origIdx = Math.floor(this.origCount / 2) - 1), (this.idx = Math.floor(this.origCount / 2) - 1))
                    : ((this.origIdx = Math.ceil((this.origCount - 1) / 2)), (this.idx = Math.ceil((this.origCount - 1) / 2))),
                  (this.marginWidth = 2 * Math.ceil(window.getComputedStyle(this.slides[0]).marginLeft.replace("px", ""))),
                  this.marginWidth || (this.marginWidth = 0),
                  (this.oneSlideWidth = this.slides[0].offsetWidth + this.marginWidth),
                  (this.colWidth = this.oneSlideWidth * this.count),
                  this.colWidth < n().width + 3 * this.oneSlideWidth)
                ) {
                  for (var i = Math.ceil((z.windowWidth + 3 * this.oneSlideWidth) / this.colWidth), a = 0; a < i; a++)
                    for (var r = 0; r < this.slides.length; r++) {
                      var s = this.slides[r].cloneNode(!0);
                      this.track.appendChild(s);
                    }
                  (this.slides = this.el.querySelectorAll(".slide")), (this.count = this.slides.length), (this.colWidth = this.oneSlideWidth * this.count);
                }
                if (this.isTestimonialSlider && this.origCount < 5) {
                  this.idx = Math.ceil((this.origCount - 1) / 2) + this.origCount;
                  for (var o = 0; o < this.slides.length; o++) this.track.children[o].setAttribute("data-true-idx", o);
                }
                z.isGreaterThan767 ? ((this.rightMax = z.windowWidth + 1.5 * this.oneSlideWidth), (this.leftMin = -1.5 * this.oneSlideWidth)) : ((this.rightMax = z.windowWidth + 1.5 * z.windowWidth), (this.leftMin = -1.5 * z.windowWidth)),
                  this.dots[this.idx % this.origCount].classList.add("active"),
                  this.isLeftAligned || (this.count % 2 == 0 && Un.set(this.track, { marginLeft: this.oneSlideWidth / 2 })),
                  Un.set(this.track, { width: this.colWidth }),
                  Un.set(this.el, { display: e }),
                  this.el.parentElement.parentElement.classList.contains("product-selection") && Un.set(this.el.parentElement.parentElement, { display: t });
              },
            },
            {
              key: "getCache",
              value: function () {
                this.slidesData = [];
                for (var t = 0; t < this.count; t++) {
                  var e = this.slides[t];
                  Un.set(e, { clearProps: "transform" });
                  var i = e.getBoundingClientRect(),
                    a = void 0,
                    n = void 0,
                    r = void 0;
                  i.left > z.windowWidth
                    ? ((n = -(i.left - z.windowWidth) + this.marginWidth), (r = "next"))
                    : i.left < 0
                    ? ((n = Math.abs(i.left) + z.windowWidth + this.marginWidth), (r = "prev"))
                    : ((n = z.windowWidth - i.left + this.marginWidth), (r = "next")),
                    (a = i.right > z.windowWidth ? -(i.right + this.marginWidth) : i.right < 0 ? Math.abs(i.right) - this.marginWidth : -(i.right + this.marginWidth)),
                    this.slidesData.push({ el: e, left: i.left, right: i.right, trueIdx: e.dataset.trueIdx, pinnedRightX: n, pinnedLeftX: a, isVisible: !1, beenVisible: !1, lastDirection: r, xOffset: 0 }),
                    this.isProductSlider &&
                      ((this.insideSubBuilder = "BUTTON" === this.btn.tagName),
                      this.insideSubBuilder
                        ? (this.slidesData[t].productData = { themeColor: e.dataset.color, accentColor: e.dataset.accentColor, shortName: e.dataset.flavor })
                        : (this.slidesData[t].productData = { href: e.dataset.href, themeColor: e.dataset.color, accentColor: e.dataset.accentColor, shortName: e.dataset.flavor }));
                }
              },
            },
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                this.prevTrigger.addEventListener("click", function () {
                  t.animating || ((t.animating = !0), t.prev());
                }),
                  this.nextTrigger.addEventListener("click", function () {
                    t.animating || ((t.animating = !0), t.next());
                  });
                for (
                  var e = function (e) {
                      t.dots[e].addEventListener("click", function () {
                        t.animating || t.idx === e || t.slideTo(e);
                      });
                    },
                    i = 0;
                  i < this.dots.length;
                  i++
                )
                  e(i);
                for (
                  var a = function (e) {
                      t.slides[e].addEventListener("click", function () {
                        var i = t.slidesData[e].trueIdx;
                        t.animating || t.idx === i || t.slideTo(i);
                      });
                    },
                    n = 0;
                  n < this.count;
                  n++
                )
                  a(n);
                z.isMobile &&
                  ((this.pageWidth = z.windowWidth),
                  (this.threshold = Math.max(1, Math.floor(0.01 * this.pageWidth))),
                  (this.limit = Math.tan(0.375 * Math.PI)),
                  (this.touchstartX = 0),
                  (this.touchstartY = 0),
                  (this.touchendX = 0),
                  (this.touchendY = 0),
                  this.el.addEventListener(
                    "touchstart",
                    function (e) {
                      (t.touchstartX = e.changedTouches[0].screenX), (t.touchstartY = e.changedTouches[0].screenY);
                    },
                    !1
                  ),
                  this.el.addEventListener(
                    "touchend",
                    function (e) {
                      (t.touchendX = e.changedTouches[0].screenX), (t.touchendY = e.changedTouches[0].screenY);
                      var i = t.touchendX - t.touchstartX,
                        a = t.touchendY - t.touchstartY,
                        n = (Math.abs(i / a), Math.abs(a / i));
                      if (Math.abs(i) > t.threshold || Math.abs(a) > t.threshold) {
                        if (n <= t.limit)
                          if (i < 0) {
                            if (t.animating) return;
                            (t.animating = !0), t.next();
                          } else {
                            if (t.animating) return;
                            (t.animating = !0), t.prev();
                          }
                        t.limit;
                      }
                    },
                    !1
                  ));
              },
            },
            {
              key: "prev",
              value: function () {
                var t = this;
                this.dots[this.idx % this.origCount].classList.remove("active"),
                  (this.idx = this.idx - 1 < 0 ? this.count - 1 : this.idx - 1),
                  this.dots[this.idx % this.origCount].classList.add("active"),
                  (this.xShift = this.xShift + this.oneSlideWidth),
                  this.updateSlideContext();
                for (var e = 0; e < this.slidesData.length; e++) {
                  var i = this.slidesData[e],
                    a = i.left + (this.xShift + i.xOffset),
                    n = this.xShift + i.xOffset;
                  if (a > this.leftMin && a < this.rightMax) i.isVisible || (i.isVisible = !0), i.beenVisible || (i.beenVisible = !0), Un.to(i.el, 0.25, { x: n, ease: "sine.out", force3D: !0 }), (i.lastDirection = "prev");
                  else if (i.isVisible && i.beenVisible) (i.isVisible = !1), (i.xOffset -= this.colWidth), Un.set(i.el, { x: i.pinnedLeftX }), (i.lastDirection = "prev");
                  else if ("next" === i.lastDirection) {
                    (i.isVisible = !1), (i.xOffset -= this.colWidth), Un.set(i.el, { x: i.pinnedLeftX });
                    var r = i.left + (this.xShift + i.xOffset),
                      s = this.xShift + i.xOffset;
                    r > this.leftMin && r < this.rightMax && (i.isVisible || (i.isVisible = !0), i.beenVisible || (i.beenVisible = !0), Un.to(i.el, 0.25, { x: s, ease: "sine.out", force3D: !0 })), (i.lastDirection = "prev");
                  }
                }
                Un.delayedCall(0.25, function () {
                  t.animating = !1;
                });
              },
            },
            {
              key: "next",
              value: function () {
                var t = this;
                this.dots[this.idx % this.origCount].classList.remove("active"),
                  (this.idx = this.idx + 1 === this.count ? 0 : this.idx + 1),
                  this.dots[this.idx % this.origCount].classList.add("active"),
                  (this.xShift = this.xShift - this.oneSlideWidth),
                  this.updateSlideContext();
                for (var e = 0; e < this.slidesData.length; e++) {
                  var i = this.slidesData[e],
                    a = i.left + (this.xShift + i.xOffset),
                    n = this.xShift + i.xOffset;
                  if (a > this.leftMin && a < this.rightMax) i.isVisible || (i.isVisible = !0), i.beenVisible || (i.beenVisible = !0), Un.to(i.el, 0.25, { x: n, ease: "sine.out", force3D: !0 }), (i.lastDirection = "next");
                  else if (i.isVisible && i.beenVisible) (i.isVisible = !1), (i.xOffset += this.colWidth), Un.set(i.el, { x: i.pinnedRightX }), (i.lastDirection = "next");
                  else if ("prev" === i.lastDirection) {
                    (i.isVisible = !1), (i.xOffset += this.colWidth), Un.set(i.el, { x: i.pinnedRightX });
                    var r = i.left + (this.xShift + i.xOffset),
                      s = this.xShift + i.xOffset;
                    r > this.leftMin && r < this.rightMax && (i.isVisible || (i.isVisible = !0), i.beenVisible || (i.beenVisible = !0), Un.to(i.el, 0.25, { x: s, ease: "sine.out", force3D: !0 })), (i.lastDirection = "next");
                  }
                }
                Un.delayedCall(0.25, function () {
                  t.animating = !1;
                });
              },
            },
            {
              key: "slideTo",
              value: function (t) {
                var e,
                  i,
                  a = this;
                this.idx < t ? ((e = -1 * (t - this.idx)), (i = "next")) : ((e = this.idx - t), (i = "prev")),
                  this.dots[this.idx % this.origCount].classList.remove("active"),
                  (this.idx = parseInt(t)),
                  this.dots[this.idx % this.origCount].classList.add("active");
                var n = this.xShift + this.oneSlideWidth * e;
                this.updateSlideContext(this.idx),
                  Un.to(this, 0.5, {
                    xShift: n,
                    ease: "sine.out",
                    onUpdate: function () {
                      a.renderSlides(i);
                    },
                  }),
                  Un.delayedCall(0.5, function () {
                    a.animating = !1;
                  });
              },
            },
            {
              key: "renderSlides",
              value: function (t) {
                for (var e = "next" === t ? "prev" : "next", i = 0; i < this.slidesData.length; i++) {
                  var a = this.slidesData[i],
                    n = a.left + (this.xShift + a.xOffset),
                    r = this.xShift + a.xOffset;
                  n > this.leftMin && n < this.rightMax
                    ? (a.isVisible || (a.isVisible = !0), a.beenVisible || (a.beenVisible = !0), Un.set(a.el, { x: r, force3D: !0 }), (a.lastDirection = t))
                    : a.isVisible && a.beenVisible
                    ? ((a.isVisible = !1), "next" === t ? (a.xOffset += this.colWidth) : (a.xOffset -= this.colWidth), Un.set(a.el, { x: "next" === t ? a.pinnedRightX : a.pinnedLeftX }), (a.lastDirection = t))
                    : a.lastDirection === e && ((a.isVisible = !1), "next" === t ? (a.xOffset += this.colWidth) : (a.xOffset -= this.colWidth), Un.set(a.el, { x: "next" === t ? a.pinnedRightX : a.pinnedLeftX }), (a.lastDirection = t));
                }
              },
            },
            {
              key: "updateSlideContext",
              value: function () {
                this.isProductSlider
                  ? (this.insideSubBuilder || (this.btn.href = this.slidesData[this.idx].productData.href),
                    (this.btn.innerText = this.slidesData[this.idx].productData.shortName),
                    Un.to(this.btn, 0.15, { backgroundColor: this.slidesData[this.idx].productData.themeColor, color: this.slidesData[this.idx].productData.accentColor }),
                    this.el.querySelector(".slide.active") && this.el.querySelector(".slide.active").classList.remove("active"),
                    this.slidesData[this.idx].el.classList.add("active"))
                  : (this.el.querySelector(".slide.active") && this.el.querySelector(".slide.active").classList.remove("active"), this.slidesData[this.idx].el.classList.add("active"));
              },
            },
            {
              key: "resize",
              value: function () {
                this.dots[this.idx % this.origCount].classList.remove("active"), this.setupDom(), this.getCache(), this.updateSlideContext(this.idx);
              },
            },
          ]),
          t
        );
      })(),
      mo = (function () {
        function t(e) {
          zn()(this, t),
            (this.parentEl = e),
            (this.allSteps = e.querySelectorAll(".step")),
            (this.progressDots = e.querySelectorAll(".point")),
            (this.pointSvgs = e.querySelectorAll(".point svg")),
            (this.pointWords = e.querySelectorAll(".point p")),
            (this.progressFill = e.querySelector(".fill")),
            (this.stepOneEl = e.querySelector(".cat-selection")),
            (this.stepOneTriggers = this.stepOneEl.querySelectorAll(".category")),
            (this.stepTwoEl = e.querySelector(".product-selection")),
            (this.stepTwoTriggers = this.stepTwoEl.querySelectorAll(".btn")),
            (this.sliders = this.stepTwoEl.querySelectorAll(".product-slider")),
            (this.stepTwoGroups = e.querySelectorAll(".product-slider")),
            (this.stepThreeEl = e.querySelector(".frequency-selection")),
            (this.stepIdx = 0),
            (this.catIdx = 0),
            (this.toStepTriggers = e.querySelectorAll("[data-to-step]")),
            (this.loadedCatImages = []),
            (this.subtitle = e.querySelector(".subtitle")),
            (this.chosenQuantity = 1),
            (this.animating = !1),
            this.init();
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                this.setupDom(), this.bindEvents();
              },
            },
            {
              key: "setupDom",
              value: function () {
                if (z.windowWidth < 768 || r(document.body, "force-mobile")) new fo(this.stepOneEl);
                for (var t = 0; t < this.sliders.length; t++) {
                  var e = new fo(this.sliders[t]);
                  z.currentSliders.push(e);
                }
                (this.scrollTop = this.subtitle.getBoundingClientRect().top + document.documentElement.scrollTop), Un.set([this.stepTwoEl, this.stepTwoGroups, this.stepThreeEl], { display: "none" });
              },
            },
            {
              key: "bindEvents",
              value: function () {
                for (
                  var t = this,
                    e = function (e) {
                      t.stepOneTriggers[e].addEventListener("click", function () {
                        t.animating || ((t.animating = !0), (t.catIdx = e), t.goToStep(1));
                      });
                    },
                    i = 0;
                  i < this.stepOneTriggers.length;
                  i++
                )
                  e(i);
                for (var a = 0; a < this.stepTwoTriggers.length; a++) {
                  this.stepTwoTriggers[a].addEventListener("click", function () {
                    t.animating || ((t.animating = !0), t.goToStep(2));
                  });
                }
                for (
                  var n = function (e) {
                      var i = t.toStepTriggers[e],
                        a = parseInt(i.dataset.toStep);
                      i.addEventListener("click", function () {
                        t.animating || a > t.stepIdx || a === t.stepIdx || ((t.animating = !0), t.goToStep(a));
                      });
                    },
                    r = 0;
                  r < this.toStepTriggers.length;
                  r++
                )
                  n(r);
              },
            },
            {
              key: "goToStep",
              value: function (t) {
                var e = this,
                  i = K.mainNav.classList.contains("pencil-closed") ? 77 : 104;
                switch ((_o.scrollTo(this.subtitle.getBoundingClientRect().top + document.documentElement.scrollTop - i), t)) {
                  case 0:
                    this.adjustProgressBar(0),
                      Un.to(this.allSteps[this.stepIdx], 0.15, {
                        autoAlpha: 0,
                        ease: "sine.easeOut",
                        onComplete: function () {
                          Un.set([e.allSteps[1], e.allSteps[2]], { display: "none" }),
                            Un.set(e.allSteps[t], { display: "flex" }),
                            Un.set(e.stepTwoGroups[e.catIdx], { display: "none" }),
                            Un.to(e.allSteps[t], 0.15, {
                              autoAlpha: 1,
                              ease: "sine.easeOut",
                              onComplete: function () {
                                e.animating = !1;
                              },
                            });
                        },
                      }),
                      (this.stepIdx = t);
                    break;
                  case 1:
                    this.adjustProgressBar(1);
                    if (this.loadedCatImages.includes(this.catIdx)) !0;
                    else {
                      this.loadedCatImages.push(this.catIdx);
                      var a = this.stepTwoGroups[this.catIdx].querySelectorAll(".preload");
                      To.loadImages(a, "nodeList", function (t) {
                        !0;
                      });
                    }
                    var n = this.allSteps[this.stepIdx],
                      r = this.allSteps[t],
                      s = this.stepTwoGroups[this.catIdx];
                    Un.to(n, 0.15, {
                      autoAlpha: 0,
                      ease: "sine.easeOut",
                      onComplete: function () {
                        Un.set(n, { display: "none" }),
                          Un.set(s, { display: "block" }),
                          Un.set(r, { display: "block" }),
                          Un.to(r, 0.15, {
                            autoAlpha: 1,
                            ease: "sine.easeOut",
                            onComplete: function () {
                              ((e.animating = !1), z.keyToggle) && s.querySelector("button").focus();
                            },
                          });
                      },
                    }),
                      (this.stepIdx = t);
                    break;
                  case 2:
                    this.adjustProgressBar(2);
                    var o = this.allSteps[this.stepIdx],
                      l = this.allSteps[t];
                    this.setSelectedProduct(),
                      Un.to(o, 0.15, {
                        autoAlpha: 0,
                        ease: "sine.easeOut",
                        onComplete: function () {
                          var t = setInterval(function () {
                            e.stepThreeReady &&
                              (clearInterval(t),
                              Un.set(o, { display: "none" }),
                              Un.set(l, { display: "flex" }),
                              Un.to(l, 0.15, {
                                autoAlpha: 1,
                                ease: "sine.easeOut",
                                onComplete: function () {
                                  ((e.animating = !1), z.keyToggle) && l.querySelector(".add-to-cart").focus();
                                },
                              }),
                              (e.stepThreeReady = !1));
                          }, 20);
                        },
                      }),
                      (this.stepIdx = t);
                }
              },
            },
            {
              key: "adjustProgressBar",
              value: function (t) {
                var e = this;
                switch (t) {
                  case 0:
                    (this.subtitle.textContent = "Select a category"),
                      (this.progressDots[0].style.cursor = "default"),
                      (this.progressDots[1].style.cursor = "default"),
                      Un.to(this.progressDots[2], 0.15, { backgroundColor: "#d8d8d8" }),
                      Un.to(this.pointSvgs[2], 0.15, { opacity: 0 }),
                      Un.to(this.pointWords[2], 0.15, { color: "#b5b5b5" }),
                      Un.to(this.progressFill, 0.3, { scaleX: 0.215 }),
                      Un.delayedCall(0.15, function () {
                        Un.to(e.pointSvgs[1], 0.15, { opacity: 0 }), Un.to(e.pointWords[1], 0.15, { color: "#b5b5b5" }), Un.to(e.progressDots[1], 0.15, { backgroundColor: "#d8d8d8" });
                      }),
                      Un.delayedCall(0.3, function () {
                        Un.to(e.pointSvgs[0], 0.15, { opacity: 0 });
                      });
                    break;
                  case 1:
                    (this.subtitle.textContent = "Select a flavor"),
                      (this.progressDots[0].style.cursor = "pointer"),
                      (this.progressDots[1].style.cursor = "default"),
                      Un.to(this.pointSvgs[0], 0.15, { opacity: 1 }),
                      Un.to(this.pointSvgs[2], 0.15, { opacity: 0 }),
                      Un.to(this.progressDots[2], 0.15, { backgroundColor: "#d8d8d8" }),
                      Un.to(this.pointWords[2], 0.15, { color: "#b5b5b5" }),
                      Un.to(this.progressFill, 0.3, { scaleX: 0.5 }),
                      Un.delayedCall(0.3, function () {
                        Un.to(e.progressDots[1], 0.15, { backgroundColor: "#000000" }), Un.to(e.pointWords[1], 0.15, { color: "#000000" });
                      });
                    break;
                  case 2:
                    (this.subtitle.textContent = "Add to cart"),
                      (this.progressDots[0].style.cursor = "pointer"),
                      (this.progressDots[1].style.cursor = "pointer"),
                      Un.to(this.pointSvgs[1], 0.15, { opacity: 1 }),
                      Un.to(this.progressFill, 0.3, { scaleX: 0.784 }),
                      Un.delayedCall(0.3, function () {
                        Un.to(e.progressDots[2], 0.15, { backgroundColor: "#000000" }), Un.to(e.pointWords[2], 0.15, { color: "#000000" });
                      });
                }
              },
            },
            {
              key: "setSelectedProduct",
              value: function () {
                (this.selectedProduct = this.stepTwoGroups[this.catIdx].querySelector(".slide.active")), this.getProduct(this.selectedProduct.dataset.handle);
              },
            },
            {
              key: "getProduct",
              value: function (t) {
                var e = this,
                  i = { handle: t };
                a("/v1/app/product/", { method: "POST", type: "json", data: JSON.stringify(i) }, function (t) {
                  var i = JSON.parse(t);
                  e.buildProductFrame(i);
                });
              },
            },
            {
              key: "buildProductFrame",
              value: function (t) {
                var e = this,
                  i = t.variants[0].compare_at_price ? "$" + Ll.splitForSup(parseFloat(t.variants[0].compare_at_price).toFixed(2)) : "",
                  a = "" !== i ? "($" + Math.round(parseFloat(t.variants[0].compare_at_price) - parseFloat(t.variants[0].price)) + " Off)" : "",
                  n = this.selectedProduct.querySelector("img").src,
                  r = !!t.metafields.custom_fields.subscription_note && t.metafields.custom_fields.subscription_note,
                  s = {
                    product_id: t.id,
                    variant_id: t.variants[0].id,
                    sku: t.variants[0].sku,
                    category: t.product_type.toLowerCase(),
                    name: t.title,
                    variant: "Default Title" !== t.variants[0].title ? t.variants[0].title : "",
                    brand: t.vendor,
                    price: t.variants[0].price,
                    quantity: 1,
                    url: "/products/" + t.product_type.toLowerCase().replace(/ /g, "-") + "/" + t.handle + "/",
                    image_url: t.image.src,
                  },
                  o = '\n            <div class="product-area '
                    .concat(s.category, '">\n                <div class="left">\n                    <a href="')
                    .concat(s.url, '" class="ar-wrapper">\n                        <img src="')
                    .concat(
                      n,
                      '" alt=""/>\n                    </a>\n                </div>\n            </div>\n            <div class="tile subscribe">\n                <div class="top">\n                    <p class="title">Description</p>\n                    <div class="wysiwyg">'
                    )
                    .concat(t.body_html, '</div>\n                    <p class="title">Rating</p>\n                    <div class="reviews-summary yotpo-baseline yotpo-reviews cache-only" data-product-id="')
                    .concat(t.id, '"></div>\n                </div>\n            </div>\n            <div class="tile one-time">\n                <p class="eyebrow">')
                    .concat(t.metafields.custom_fields && t.metafields.custom_fields.short_descriptor ? t.metafields.custom_fields.short_descriptor : t.product_type, '</p>\n                <p class="title">')
                    .concat(t.title, '</p>\n                <p class="price price-diff price-update-')
                    .concat(t.id, '">\n                    <span class="discount">$')
                    .concat(Ll.splitForSup(parseFloat(t.variants[0].price).toFixed(2)), " ")
                    .concat(a, '</span>\n                    <del class="orig">')
                    .concat(i, '</del>\n                </p>\n                <form class="add-to-cart-form" data-product-id="')
                    .concat(t.id, '" method="post" action="/v1/app/cart/add/" enctype="multipart/form-data" data-subnote="')
                    .concat(r, '">\n                    <input type="hidden" name="quantity" value="1" />\n                    <input type="hidden" name="data" value=\'')
                    .concat(JSON.stringify(s), "' />\n                    ");
                Array.prototype.slice.call(t.options).forEach(function (t, e) {
                  o += '<div class="hidden option option-'.concat(e, '">').concat(t.name, "</div>");
                });
                var l = !1;
                if (t.variants && t.variants.length > 0) {
                  o += '<select class="product-select '.concat(t.variants.length <= 1 ? "hidden" : "", '" name="id">');
                  for (var c = 0; c < t.variants.length; c++) {
                    for (var h = t.variants[c], u = h.image_id, d = "", p = 0; p < t.images.length; p++)
                      if (t.images[p].id == u) {
                        d = t.images[p].src;
                        break;
                      }
                    var f = !1;
                    ("continue" == h.inventory_policy || parseInt(h.inventory_quantity) > 0) && (f = !0);
                    var m = window.btoa("gid://shopify/ProductVariant/" + h.id);
                    h.compare_at_price
                      ? (o += "<option "
                          .concat(!1 === l && !0 === f ? "selected='selected'" : "", ' data-raw-id="')
                          .concat(h.id, '" value="')
                          .concat(m, '" data-original-price="')
                          .concat(h.compare_at_price, '" data-inventory="')
                          .concat(!1 === f ? 0 : h.inventory_quantity, '">')
                          .concat(h.title, "||")
                          .concat(h.price, "||")
                          .concat(d.replace(".png", "_1024x.png").replace(".jpg", "_1024x.jpg"), "||")
                          .concat(d.replace(".png", "_768x.png").replace(".jpg", "_768x.jpg"), "</option>"))
                      : (o += "<option "
                          .concat(!1 === l && !0 === f ? "selected='selected'" : "", ' data-raw-id="')
                          .concat(h.id, '" value="')
                          .concat(m, '" data-inventory="')
                          .concat(!1 === f ? 0 : h.inventory_quantity, '">')
                          .concat(h.title, "||")
                          .concat(h.price, "||")
                          .concat(d.replace(".png", "_1024x.png").replace(".jpg", "_1024x.jpg"), "||")
                          .concat(d.replace(".png", "_768x.png").replace(".jpg", "_768x.jpg"), "</option>")),
                      !1 === l && !0 === f && (l = !0);
                  }
                  o += "</select>";
                }
                (o += '\n                        <div class="fake-selects-wrapper"></div>\n                        <p class="eyebrow">Frequency</p>\n                        <div class="subscription-wrapper" data-price="'.concat(
                  t.variants[0].price,
                  '"></div>\n                        <p class="eyebrow">Quantity</p>\n                        <div class="increment-wrapper">\n                            <button name="decrease item quantity" aria-label="decrease item quantity" type="button" class="increment minus disabled" data-type="minus">\n                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"><path vector-effect="non-scaling-stroke" class="st0" d="M15.5,10.5h-4h-1h-4C6.2,10.5,6,10.7,6,11s0.2,0.5,0.5,0.5h4l1,0h4c0.3,0,0.5-0.2,0.5-0.5 C16,10.8,15.8,10.5,15.5,10.5 M11,21C5.5,21,1,16.5,1,11S5.5,1,11,1c5.5,0,10,4.5,10,10S16.5,21,11,21 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0"></path></svg>\n                            </button>\n                            <div class="count">1</div>\n                            <button name="increase item quantity" aria-label="increase item quantity" type="button" class="increment plus" data-type="plus">\n                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"><path vector-effect="non-scaling-stroke" class="st0" d="M15.5,10.5h-4v-4C11.5,6.2,11.3,6,11,6s-0.5,0.2-0.5,0.5v4h-4C6.2,10.5,6,10.7,6,11 s0.2,0.5,0.5,0.5h4v4c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-4h4c0.3,0,0.5-0.2,0.5-0.5C16,10.8,15.8,10.5,15.5,10.5 M11,21 C5.5,21,1,16.5,1,11S5.5,1,11,1c5.5,0,10,4.5,10,10S16.5,21,11,21 M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0"></path></svg>\n                            </button>\n                        </div>\n                    '
                )),
                  (o += !0 === l ? '<button name="add to cart" aria-label="add to cart" class="btn add-to-cart" type="submit">Add To Cart</button>' : '<button class="btn disabled">Sold Out</button>'),
                  (o += '\n                </form>\n                <div class="centered">\n                    <a class="view-details linked" href="/products/'
                    .concat(t.product_type.toLowerCase().replace(/ /g, "-"), "/")
                    .concat(
                      t.handle,
                      '/" class="view-details">View Details</a>\n                </div>\n            </div>\n            <div class="trigger-wrapper">\n                <p class="text-trigger" data-to-step="1">Return to flavors</p>\n            </div>\n        '
                    )),
                  (this.stepThreeEl.innerHTML = o);
                var g = this.stepThreeEl.querySelector(".add-to-cart-form"),
                  y = this.stepThreeEl.querySelector(".text-trigger");
                new Es(g);
                Pl.attach(this.stepThreeEl.querySelectorAll(".product-area a")), Oo.init();
                var v = this.stepThreeEl.querySelector(".linked");
                v.addEventListener("click", function (t) {
                  t.preventDefault(), Pl.redirect(v.href);
                }),
                  y.addEventListener("click", function () {
                    e.goToStep(1);
                  }),
                  (this.stepThreeReady = !0);
              },
            },
          ]),
          t
        );
      })();
    function go(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var yo = (function (t) {
        _s()(i, t);
        var e = go(i);
        function i(t, a) {
          var n;
          return zn()(this, i), ((n = e.call(this, t, a)).timer = n.slider.querySelector(".progress-ring__circle")), (n.timerTl = new Un.timeline({ paused: !0 })), (n.pauseOnMouse = n.options.pauseOnMouse || !1), n;
        }
        return (
          Gn()(i, [
            {
              key: "activateAutoplay",
              value: function () {
                var t = this;
                if (this.autoPlay) {
                  var e = 2 * this.timer.r.baseVal.value * Math.PI,
                    i = e - 0 * e,
                    a = e - 1 * e,
                    n = this.autoPlay / 1e3;
                  (this.timer.style.strokeDasharray = "".concat(e, " ").concat(e)),
                    this.timerTl.fromTo(
                      this.timer,
                      n,
                      { strokeDashoffset: i },
                      {
                        strokeDashoffset: a,
                        onComplete: function () {
                          t.slideForward(t);
                        },
                      }
                    ),
                    this.timerTl.play();
                }
              },
            },
            {
              key: "mouseListener",
              value: function () {
                var t = this;
                this.pauseOnMouse &&
                  (this.slider.addEventListener("mouseenter", function () {
                    (t.mouseover = !0), t.timerTl.pause();
                  }),
                  this.slider.addEventListener("mouseleave", function () {
                    (t.mouseover = !1), t.timerTl.play();
                  }));
              },
            },
            {
              key: "tweenSlides",
              value: function (t, e, i) {
                var a = this;
                this.timerTl.progress(0), (this.animating = !0), this.dots && this.updateDots(t, i);
                var n = t.el,
                  r = i.el;
                Un.to(n, 0.35, { x: e, autoAlpha: 0, ease: la.easeOut }),
                  Un.to(r, 0.55, { autoAlpha: 1, ease: la.easeIn, delay: 0.35 }),
                  Un.to(n, 0.01, {
                    x: 0,
                    delay: 0.7,
                    onComplete: function () {
                      (a.animating = !1), a.slideChangeEnd(a);
                    },
                  });
              },
            },
          ]),
          i
        );
      })(Cs),
      vo = i(13),
      Ao = i(15),
      bo = i(16),
      wo = i(14),
      Co = document.getElementById("product-reference").dataset.ref,
      So = JSON.parse(Co);
    function ko(t) {
      return Ao.filter(function (e) {
        return e.state === t;
      });
    }
    function Eo() {
      var t = vo[Math.floor(Math.random() * vo.length)],
        e = A.a.get("user_region_name"),
        i = "";
      if (void 0 !== e && "undetermined" !== e) {
        var a = ko(e);
        a.length < 15 &&
          (a = (function (t, e) {
            var i = e,
              a = bo.filter(function (e) {
                return e.state === t;
              });
            return (
              a[0] &&
                ((a = a[0].bordering),
                Array.prototype.slice.call(a).forEach(function (t, e) {
                  var a = ko(t);
                  Array.prototype.slice.call(a).forEach(function (t, e) {
                    i.push(t);
                  });
                })),
              i
            );
          })(e, a));
        var n = Math.floor(Math.random() * a.length);
        if (a[n] && a[n].city) i = " in " + a[n].city;
      }
      var r = Object.keys(So),
        s = So[r[Math.floor(Math.random() * r.length)]],
        o = s.name,
        l = s.color,
        c = wo[Math.floor(Math.random() * wo.length)];
      return { text: t + i + " just purchased " + o + ". " + (c = c.replace("[NAME]", t)), slide_background: l };
    }
    function xo(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var _o,
      To,
      Mo,
      Po = function () {
        var t = document.getElementById("press-slideshow");
        if (t) {
          var e = new yo(t, { slideSelector: ".slide", dots: ".slide-thumb", addCSS: !1, xOffset: 60, autoPlay: 4e3, hitPoints: !1 });
          if ((e.init(), !(z.windowWidth < 769))) {
            var i = document.querySelectorAll("#press-slideshow .slide-thumb");
            Array.prototype.slice.call(i).forEach(function (t) {
              t.addEventListener("click", function () {
                e.slideToTarget(t.dataset.index);
              });
            }),
              document.querySelector("#press-slideshow .slide-container").addEventListener("click", function () {
                e.slideForward(e);
              });
          }
        }
      },
      Do = (function (t) {
        _s()(i, t);
        var e = xo(i);
        function i(t, a) {
          return zn()(this, i), e.call(this, t, a);
        }
        return (
          Gn()(i, [
            {
              key: "createArrows",
              value: function () {
                if (this.arrows) {
                  var t = this.slider.querySelectorAll(this.arrows);
                  this.prevTrigger.push(t[0]), this.nextTrigger.push(t[1]);
                }
              },
            },
          ]),
          i
        );
      })(Cs),
      Io = function () {
        var t = document.getElementsByClassName("featured-reviews");
        if (t) {
          var e = document.querySelectorAll(".featured-review-slider-mobile");
          z.windowWidth < 768 &&
            Array.prototype.slice.call(e).forEach(function (t) {
              new Do(t, { slideSelector: ".review", addCSS: !1, hitPoints: !1, dots: ".dot", arrows: ".arrow", calcHeight: !0 }).init();
            });
          Array.prototype.slice.call(t).forEach(function (t) {
            var i = t.querySelectorAll(".filter-btn");
            if (i)
              for (
                var a = function (a) {
                    i[a].addEventListener("click", function () {
                      var n = t.querySelector(".featured-review-slider-mobile.active");
                      n === e[a] ||
                        t.classList.contains("is-animating") ||
                        (Array.prototype.slice.call(i).forEach(function (t) {
                          t.classList.remove("active");
                        }),
                        i[a].classList.add("active"),
                        (function (t, e) {
                          var i = t.querySelectorAll(".review"),
                            a = e.querySelectorAll(".review"),
                            n = new Un.timeline({ paused: !0 });
                          z.windowWidth < 768
                            ? n.to(t, 0.25, { autoAlpha: 0 }).to(e, 0.25, {
                                autoAlpha: 1,
                                onComplete: function () {
                                  t.parentElement.classList.remove("is-animating"), t.classList.remove("active"), e.classList.add("active"), "object" == y()(_o) && _o.resize();
                                },
                              })
                            : n
                                .to(i, 0.16, { opacity: 0, y: -20, stagger: 0.08 })
                                .set(i, { y: 0 })
                                .set(t, { autoAlpha: 0 })
                                .set(a, { opacity: 0 })
                                .set(e, { autoAlpha: 1 })
                                .to(a, 0.25, {
                                  opacity: 1,
                                  stagger: 0.08,
                                  ease: la.easeIn,
                                  onComplete: function () {
                                    t.parentElement.classList.remove("is-animating"), t.classList.remove("active"), e.classList.add("active");
                                  },
                                }),
                            t.parentElement.classList.add("is-animating"),
                            n.play();
                        })(n, e[a]));
                    });
                  },
                  n = 0;
                n < i.length;
                n++
              )
                a(n);
          });
        }
      },
      Lo = (function () {
        function t() {
          zn()(this, t), (this.reviews = {}), (this.per_page = 4);
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                var t = this,
                  e = document.getElementsByClassName("yotpo-reviews");
                (this.enqueue = { ids: [], promises: [] }),
                  this.getReviews(),
                  this.getFeatured(),
                  Promise.allSettled(this.enqueue.promises).then(function (i) {
                    t.setBaseline(),
                      Array.prototype.slice.call(e).forEach(function (e) {
                        r(e, "cache-only") || (t.writeReviews(e), t.bindReviewWrapperEvents(e));
                      }),
                      ir(),
                      Io();
                  });
              },
            },
            { key: "eventBindings", value: function () {} },
            {
              key: "getFeatured",
              value: function () {
                var t = this,
                  e = document.getElementsByClassName("yotpo-featured-review");
                Array.prototype.slice.call(e).forEach(function (e) {
                  var i = e.getAttribute("data-review-id"),
                    n = t.scanForReview(i);
                  if (n) t.buildFeaturedReview(e, n);
                  else {
                    var r = new Promise(function (n, r) {
                      var s = { review_id: i };
                      a("/v1/app/reviews/featured/", { method: "POST", type: "json", data: JSON.stringify(s) }, function (i) {
                        var a = JSON.parse(i);
                        t.buildFeaturedReview(e, a), n(a);
                      });
                    });
                    t.enqueue.promises.push(r);
                  }
                }),
                  ir();
              },
            },
            {
              key: "scanForReview",
              value: function (t) {
                var e = this,
                  i = !1;
                return (
                  Object.keys(this.reviews).forEach(function (a, n) {
                    for (var r = 0; r < e.reviews[a].reviews.length; r++)
                      if (e.reviews[a].reviews[r].id == t) {
                        i = e.reviews[a].reviews[r];
                        break;
                      }
                    if (!1 !== i) return i;
                  }),
                  i
                );
              },
            },
            {
              key: "getAtcFeaturedProduct",
              value: function (t, e, i, n, r) {
                var s = this,
                  o = { handle: t };
                a("/v1/app/product/", { method: "POST", type: "json", data: JSON.stringify(o) }, function (t) {
                  var a = JSON.parse(t),
                    o = {
                      product_id: a.id,
                      variant_id: a.variants[0].id,
                      sku: a.variants[0].sku,
                      category: a.product_type,
                      name: a.title,
                      variant: "Default Title" !== a.variants[0].title ? a.variants[0].title : "",
                      brand: a.vendor,
                      price: a.variants[0].price,
                      quantity: 1,
                      url: "/products/" + a.product_type.toLowerCase().replace(/ /g, "-") + "/" + a.handle + "/",
                      image_url: a.image.src,
                    };
                  (e += "</div>\n\t\t\t\t\t\t\t<p>"
                    .concat(n.score, '</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<button class="upvote" aria-label="up-vote this review">\n\t\t\t\t\t\t\t<span>')
                    .concat(n.votes_up, '</span>\n\t\t\t\t\t\t\t<span class="icon"></span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p class="review-body">“')
                    .concat(n.content, '”</p>\n\t\t\t\t\t<div class="featured-review-product">\n\t\t\t\t\t\t<div class="review-attribution">\n\t\t\t\t\t\t\t<p>')
                    .concat(n.user.display_name, '</p>\n\t\t\t\t\t\t\t<a href="')
                    .concat(n.product_url, '">')
                    .concat(n.product_name, '</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="review-atc-wrapper">\n\t\t\t\t\t\t\t<div class="ar-wrapper')
                    .concat(r, '">\n\t\t\t\t\t\t\t\t<img src="')
                    .concat(n.product_image, '" alt="" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="form-wrapper">')),
                    (e += '<form class="add-to-cart-form" data-product-id="'
                      .concat(a.id, '" method="post" action="/v1/app/cart/add/" enctype="multipart/form-data" >\n\t\t\t\t\t\t<input type="hidden" name="quantity" value="1" />\n\t\t\t\t\t\t<input type="hidden" name="data" value=\'')
                      .concat(JSON.stringify(o), "' />\n\t\t\t\t\t\t")),
                    Array.prototype.slice.call(a.options).forEach(function (t, i) {
                      e += '<div class="hidden option option-'.concat(i, '">').concat(t.name, "</div>");
                    });
                  var l = !1;
                  if (a.variants && a.variants.length > 0) {
                    e += '<select id="product-'.concat(a.id, '" class="product-select ').concat(a.variants.length <= 1 ? "hidden" : "", '" name="id">');
                    for (var c = 0; c < a.variants.length; c++) {
                      for (var h = a.variants[c], u = h.image_id, d = "", p = 0; p < a.images.length; p++)
                        if (a.images[p].id == u) {
                          d = a.images[p].src;
                          break;
                        }
                      var f = !1;
                      ("continue" == h.inventory_policy || parseInt(h.inventory_quantity) > 0) && (f = !0);
                      var m = window.btoa("gid://shopify/ProductVariant/" + h.id);
                      h.compare_at_price
                        ? (e += "<option "
                            .concat(!1 === l && !0 === f ? "selected='selected'" : "", ' data-raw-id="')
                            .concat(h.id, '" value="')
                            .concat(m, '" data-original-price="')
                            .concat(h.compare_at_price, '" data-inventory="')
                            .concat(!1 === f ? 0 : h.inventory_quantity, '">')
                            .concat(h.title, "||")
                            .concat(h.price, "||")
                            .concat(d.replace(".png", "_1024x.png").replace(".jpg", "_1024x.jpg"), "||")
                            .concat(d.replace(".png", "_768x.png").replace(".jpg", "_768x.jpg"), "</option>"))
                        : (e += "<option "
                            .concat(!1 === l && !0 === f ? "selected='selected'" : "", ' data-raw-id="')
                            .concat(h.id, '" value="')
                            .concat(m, '" data-inventory="')
                            .concat(!1 === f ? 0 : h.inventory_quantity, '">')
                            .concat(h.title, "||")
                            .concat(h.price, "||")
                            .concat(d.replace(".png", "_1024x.png").replace(".jpg", "_1024x.jpg"), "||")
                            .concat(d.replace(".png", "_768x.png").replace(".jpg", "_768x.jpg"), "</option>")),
                        !1 === l && !0 === f && (l = !0);
                    }
                    e += "</select>";
                  }
                  (e += '\n\t\t\t\t\t\t\t\t<div class="fake-selects-wrapper"></div>\n\t\t\t\t\t\t\t\t<p class="eyebrow">Frequency</p>\n\t\t\t\t\t\t\t\t<div class="subscription-wrapper" data-price="'.concat(
                    a.variants[0].price,
                    '"></div>\n\t\t\t\t\t\t\t\t<p class="eyebrow">Quantity</p>\n\t\t\t\t\t\t\t\t<div class="increment-wrapper">\n\t\t\t\t\t\t\t\t\t\t<button name="decrease item quantity" aria-label="decrease item quantity" type="button" class="increment minus disabled" data-type="minus">\n\t\t\t\t\t\t\t\t\t\t\t\t<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"><path vector-effect="non-scaling-stroke" class="st0" d="M15.5,10.5h-4h-1h-4C6.2,10.5,6,10.7,6,11s0.2,0.5,0.5,0.5h4l1,0h4c0.3,0,0.5-0.2,0.5-0.5 C16,10.8,15.8,10.5,15.5,10.5 M11,21C5.5,21,1,16.5,1,11S5.5,1,11,1c5.5,0,10,4.5,10,10S16.5,21,11,21 M11,0C4.9,0,0,4.9,0,11 s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0"></path></svg>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<div class="count">1</div>\n\t\t\t\t\t\t\t\t\t\t<button name="increase item quantity" aria-label="increase item quantity" type="button" class="increment plus" data-type="plus">\n\t\t\t\t\t\t\t\t\t\t\t\t<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"><path vector-effect="non-scaling-stroke" class="st0" d="M15.5,10.5h-4v-4C11.5,6.2,11.3,6,11,6s-0.5,0.2-0.5,0.5v4h-4C6.2,10.5,6,10.7,6,11 s0.2,0.5,0.5,0.5h4v4c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-4h4c0.3,0,0.5-0.2,0.5-0.5C16,10.8,15.8,10.5,15.5,10.5 M11,21 C5.5,21,1,16.5,1,11S5.5,1,11,1c5.5,0,10,4.5,10,10S16.5,21,11,21 M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0"></path></svg>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t'
                  )),
                    (e += !0 === l ? '<button name="add to cart" aria-label="add to cart" class="btn add-to-cart" type="submit">Add To Cart</button>' : '<button class="btn disabled">Sold Out</button>'),
                    (e += '</div>\n\t\t\t\t\t\t\t<a href="'.concat(n.product_url, '">View Details</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t')),
                    (i.innerHTML = e),
                    i.style.setProperty("--highlight-color", n.product_color);
                  var g = i.querySelector(".review-attribution a");
                  g.addEventListener("click", function (t) {
                    t.preventDefault(), Pl.redirect(g.href);
                  });
                  var y = i.querySelector(".review-atc-wrapper a");
                  y.addEventListener("click", function (t) {
                    t.preventDefault(), Pl.redirect(y.href);
                  }),
                    ir(),
                    s.bindReview(i, n.product_id, n.id);
                });
              },
            },
            {
              key: "buildFeaturedReview",
              value: function (t, e) {
                var i = !1;
                t.dataset.atc && "true" === t.dataset.atc && (i = !0);
                var a = "";
                e.product_name.includes("Variety") ? (a = " variety") : e.product_name.includes("Ground") ? (a = " grounds") : e.product_name.includes("Pod") ? (a = " pods") : e.product_name.includes("Creamer") && (a = " creamer");
                for (var n = '\n\t\t\t<div class="top-row">\n\t\t\t\t<div class="rating">\n\t\t\t\t\t<div class="stars">', r = 0; r < e.score; r++)
                  n +=
                    '<svg version="1.1" class="bolt-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 8 20" xml:space="preserve"><polygon points="6.8,0 0,11.7 3.7,11.1 1.6,20 8,8.4 4.7,8.7 "></polygon></svg>';
                if (i) {
                  var s = e.product_url.split("/"),
                    o = s[s.length - 2];
                  this.getAtcFeaturedProduct(o, n, t, e, a);
                }
                if (!i) {
                  (n += "</div>\n\t\t\t\t\t<p>"
                    .concat(e.score, '</p>\n\t\t\t\t</div>\n\t\t\t\t<button class="upvote" aria-label="up-vote this review">\n\t\t\t\t\t<span>')
                    .concat(e.votes_up, '</span>\n\t\t\t\t\t<span class="icon"></span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<p class="review-body">“')
                    .concat(e.content, '”</p>\n\t\t\t<div class="featured-review-product">\n\t\t\t\t<div class="review-attribution">\n\t\t\t\t\t<p>')
                    .concat(e.user.display_name, '</p>\n\t\t\t\t\t<a href="')
                    .concat(e.product_url, '">')
                    .concat(e.product_name, '</a>\n\t\t\t\t</div>\n\t\t\t\t<div class="ar-wrapper')
                    .concat(a, '">\n\t\t\t\t\t<img src="')
                    .concat(e.product_image, '" alt="" />\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t')),
                    (t.innerHTML = n),
                    t.style.setProperty("--highlight-color", e.product_color);
                  var l = t.querySelector(".review-attribution a");
                  l.addEventListener("click", function (t) {
                    t.preventDefault(), Pl.redirect(l.href);
                  }),
                    this.bindReview(t, e.product_id, e.id);
                }
              },
            },
            {
              key: "getReviews",
              value: function () {
                var t = this,
                  e = document.getElementsByClassName("yotpo-reviews");
                Array.prototype.slice.call(e).forEach(function (e) {
                  var i = e.getAttribute("data-product-id");
                  if (!t.reviews[i]) {
                    var n = new Promise(function (e, n) {
                      var r = { per_page: "100", page: "1", sort: "date", direction: "desc", product_id: i };
                      a("/v1/app/reviews/get/", { method: "POST", type: "json", data: JSON.stringify(r) }, function (a) {
                        var r = JSON.parse(a);
                        r.reviews ? ((t.reviews[i] = { baseline: r.baseline, reviews: r.reviews }), e(r)) : n(r);
                      });
                    });
                    t.enqueue.promises.push(n);
                  }
                });
              },
            },
            {
              key: "bindFormEvents",
              value: function (t) {
                var e = t.parentElement.querySelector(".ajax-form");
                if (e) {
                  var i = e.querySelectorAll(".fake-rating li"),
                    a = e.querySelector("[name='review_score']");
                  tt(e, !0, e.action, function (t) {}),
                    Array.prototype.slice.call(i).forEach(function (t) {
                      t.addEventListener("click", function (e) {
                        for (var i = t.parentElement, n = Array.prototype.slice.call(i.children).indexOf(t), r = 0; r < i.children.length; r++) i.children[r].classList.remove("active"), r <= n && i.children[r].classList.add("active");
                        a.value = n + 1;
                      });
                    });
                }
              },
            },
            {
              key: "setBaseline",
              value: function () {
                var t = this,
                  e = document.getElementsByClassName("yotpo-baseline");
                Array.prototype.slice.call(e).forEach(function (e) {
                  var i = e.getAttribute("data-product-id");
                  t.reviews[i] && (e.innerHTML = t.buildBaseline(t.reviews[i].baseline));
                });
              },
            },
            {
              key: "buildBaseline",
              value: function (t) {
                if (!t) return "";
                for (var e = '<div class="stars">', i = 0; i < Math.round(t.average_score); i++)
                  e +=
                    '<svg version="1.1" class="bolt-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 8 20" xml:space="preserve"><polygon points="6.8,0 0,11.7 3.7,11.1 1.6,20 8,8.4 4.7,8.7 "></polygon></svg>';
                return (
                  (e += "</div>"),
                  (e += '\n\t\t\t<p class="rating">'.concat((Math.round(10 * t.average_score) / 10).toFixed(1), '</p>\n\t\t\t<span class="v-bar"></span>\n\t\t\t<p class="review-count">').concat(t.total_review, " Reviews</p>\n\t\t"))
                );
              },
            },
            {
              key: "writeReviews",
              value: function (t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                  i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "score",
                  a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                  n = t.getAttribute("data-product-id");
                if (this.reviews[n]) {
                  var r = t.closest(".reviews").querySelector(".load-more"),
                    s = this.filterReviews(this.reviews[n].reviews, i, a);
                  if ((1 === e && ((t.innerHTML = ""), (r.style.display = "block"), r.setAttribute("data-page", 1)), (s.length <= 4 || e * this.per_page >= s.length) && (r.style.display = "none"), s.length <= 0)) {
                    var o = document.createElement("h4");
                    o.classList.add("no-reviews"), (o.textContent = a ? "We’re sorry, there are no reviews containing “".concat(a, "”") : "We’re sorry, there are no reviews yet"), t.appendChild(o);
                  }
                  for (var l = (e - 1) * this.per_page; l < e * this.per_page && s[l]; l++) {
                    var c = document.createElement("article");
                    c.classList.add("review"), (c.dataset.review_id = s[l].id), (c.style.opacity = 0), (c.innerHTML = this.buildReview(s[l])), t.appendChild(c), this.bindReview(c, n, s[l].id), Un.to(c, 0.5, { opacity: 1 });
                  }
                  ir();
                }
              },
            },
            {
              key: "buildReview",
              value: function (t) {
                for (var e = '\n\t\t\t<div class="top-row">\n\t\t\t\t<div class="rating">\n\t\t\t\t\t<div class="stars">', i = 0; i < t.score; i++)
                  e +=
                    '<svg version="1.1" class="bolt-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 8 20" xml:space="preserve"><polygon points="6.8,0 0,11.7 3.7,11.1 1.6,20 8,8.4 4.7,8.7 "></polygon></svg>';
                return (e += "</div>\n\t\t\t\t\t<p>"
                  .concat(t.score, '</p>\n\t\t\t\t</div>\n\t\t\t\t<button class="upvote" aria-label="up-vote this review">\n\t\t\t\t\t<span>')
                  .concat(t.votes_up, '</span>\n\t\t\t\t\t<span class="icon"></span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<h4 class="review-title">')
                  .concat(t.title, '</h4>\n\t\t\t<p class="review-body">&ldquo;')
                  .concat(t.content, '&rdquo;</p>\n\t\t\t<p class="review-attribution">')
                  .concat(t.user.display_name, "</p>\n\t\t"));
              },
            },
            {
              key: "bindReview",
              value: function (t, e, i) {
                var n = this,
                  r = t.querySelector(".upvote"),
                  s = r.children[0],
                  o = !1;
                r.addEventListener("click", function (t) {
                  if (!o) {
                    if (((o = !0), (s.textContent = parseInt(s.textContent) + 1), n.reviews[e]))
                      for (var r = 0; r < n.reviews[e].reviews.length; r++)
                        if (n.reviews[e].reviews[r].id == i) {
                          n.reviews[e].reviews[r].votes_up++;
                          break;
                        }
                    var l = { product_id: e, review_id: i };
                    a("/v1/app/reviews/upvote/", { method: "POST", type: "json", data: JSON.stringify(l) }, function (t) {
                      var e = JSON.parse(t);
                      e.status && 200 === e.status.code && (o = !1);
                    });
                  }
                });
              },
            },
            {
              key: "filterReviews",
              value: function (t, e, i) {
                var a = t.sort(function (t, i) {
                  var a = t[e],
                    n = i[e];
                  return a > n ? -1 : a < n ? 1 : 0;
                });
                if (!i) return a;
                var n = [];
                return (
                  Array.prototype.slice.call(a).forEach(function (t) {
                    (-1 === t.title.toLowerCase().indexOf(i) && -1 === t.content.toLowerCase().indexOf(i)) || n.push(t);
                  }),
                  n
                );
              },
            },
            {
              key: "bindReviewWrapperEvents",
              value: function (t) {
                var e = this,
                  i = t.getAttribute("data-product-id"),
                  a = t.closest(".reviews"),
                  n = a.querySelector(".load-more"),
                  s = a.querySelector(".filters .dropdown"),
                  o = a.querySelector(".filters .left"),
                  l = o.getElementsByTagName("button"),
                  c = o.querySelector(".active");
                n.addEventListener("click", function (a) {
                  var r = parseInt(n.getAttribute("data-page")),
                    o = c ? c.textContent.toLowerCase() : null;
                  e.writeReviews(t, r + 1, s.value, o), (r + 1) * e.per_page >= e.reviews[i].baseline.total_review && (n.style.display = "none"), n.setAttribute("data-page", r + 1);
                }),
                  s.addEventListener("change", function (i) {
                    var a = c ? c.textContent.toLowerCase() : null;
                    e.writeReviews(t, 1, s.value, a), n.setAttribute("data-page", 1);
                  }),
                  Array.prototype.slice.call(l).forEach(function (i) {
                    i.addEventListener("click", function (a) {
                      r(i, "active")
                        ? ((c = null), i.classList.remove("active"), e.writeReviews(t, 1, s.value))
                        : (c && c.classList.remove("active"), (c = i), i.classList.add("active"), e.writeReviews(t, 1, s.value, c.textContent.toLowerCase())),
                        n.setAttribute("data-page", 1);
                    });
                  });
              },
            },
          ]),
          t
        );
      })(),
      Ro = (function () {
        function t(e) {
          zn()(this, t),
            (this.choices = e.querySelectorAll(".choice input")),
            (this.results = e.querySelectorAll(".result")),
            (this.lottieAnims = []),
            (this.activeIdx = !1),
            (this.prevIdx = !1),
            (this.mobile = !1),
            z.isGreaterThan767 ||
              ((this.mobile = !0),
              (this.mobileBackdrop = e.querySelector(".mobile-backdrop")),
              (this.closeTriggers = e.querySelectorAll(".close")),
              (this.resultBounds = this.results[0].getBoundingClientRect()),
              (this.resultScrollTo = this.resultBounds.top),
              Un.set(this.results, { display: "none" })),
            this.bindEvents();
        }
        return (
          Gn()(t, [
            {
              key: "bindEvents",
              value: function () {
                for (
                  var t = this,
                    e = function (e) {
                      var i = t.choices[e],
                        a = i.parentElement.querySelector(".icon"),
                        n = Yn.a.loadAnimation({ container: a, renderer: "svg", loop: !1, autoplay: !1, path: a.dataset.animationPath });
                      t.lottieAnims.push(n),
                        i.addEventListener("click", function () {
                          !1 !== t.activeIdx && (t.choices[t.activeIdx].checked = !1), t.prevIdx === e ? ((t.prevIdx = !1), t.updateResult(!0), (t.activeIdx = !1)) : ((t.activeIdx = e), t.updateResult(), (t.prevIdx = t.activeIdx));
                        });
                    },
                    i = 0;
                  i < this.choices.length;
                  i++
                )
                  e(i);
                if (this.mobile) {
                  this.mobileBackdrop.addEventListener("click", function () {
                    (t.prevIdx = !1), t.updateResult(!0), (t.choices[t.activeIdx].checked = !1), (t.activeIdx = !1);
                  });
                  for (var a = 0; a < this.closeTriggers.length; a++)
                    this.closeTriggers[a].addEventListener("click", function () {
                      (t.prevIdx = !1), t.updateResult(!0), (t.choices[t.activeIdx].checked = !1), (t.activeIdx = !1);
                    });
                }
              },
            },
            {
              key: "updateResult",
              value: function () {
                var t = this;
                if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0]) {
                  var e = this.activeIdx;
                  Un.to(this.results[this.activeIdx], 0.2, {
                    autoAlpha: 0,
                    ease: "sine.inOut",
                    onComplete: function () {
                      Un.set(t.results[e], { display: "none" });
                    },
                  }),
                    this.mobile && Un.to(this.mobileBackdrop, 0.2, { autoAlpha: 0, ease: "sine.inOut" });
                } else {
                  var i = this.prevIdx;
                  !1 === this.prevIdx
                    ? (Un.set(this.results[this.activeIdx], { display: "flex" }), Un.to(this.results[this.activeIdx], 0.25, { autoAlpha: 1, ease: "sine.inOut" }))
                    : Un.to(this.results[this.prevIdx], 0.2, {
                        autoAlpha: 0,
                        ease: "sine.inOut",
                        onComplete: function () {
                          Un.set(t.results[i], { display: "none" }), Un.set(t.results[t.activeIdx], { display: "flex" }), Un.to(t.results[t.activeIdx], 0.25, { autoAlpha: 1, ease: "sine.inOut" });
                        },
                      }),
                    this.lottieAnims[this.activeIdx].goToAndPlay(0),
                    this.mobile && (Un.to(this.mobileBackdrop, 0.2, { autoAlpha: 1, ease: "sine.inOut" }), _o.scrollTo(this.resultScrollTo));
                }
              },
            },
          ]),
          t
        );
      })(),
      Fo = (function () {
        function t() {
          zn()(this, t), (this.faviconEl = document.getElementById("animatedFavicon"));
        }
        return (
          Gn()(t, [
            {
              key: "animateFavicon",
              value: function () {
                this.faviconEl;
                var t = [
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAIBJREFUWEdjZBhgwEhN+/Py8ownTZp0lhQzqeoAFhaWz3/+/OEdMAeQYjFMLVVDYKAd8J+BgYFkD5GsAY8vPzAwMAiQGgrUdACpdoPVjzqAKiEQHx9fvHDhwl5y4oAqDiDH4mFZDpAVEKNRMBoCoyEwGgKjITAaAqMhMBoCoyEAAOA+DiHC+eXpAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAIJJREFUWEftlNEJwCAMRGMG6Wp2AofJBM1oXSQtQn8qtJAo5Ofy7Xl3D2Oh5Ckr/UVkb60dnjuXBmBmMzPOCnARkbuQW/DTLjVAN+/jLuQWjARUdau1nmkBHuMQ/hCyjzeAAOkEPH/P6+z0FoSdo2szazjqQQAEQAAEQAAEQAAEQOAGnbATIbM9MvMAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAJNJREFUWEftlEEKgDAMBBOKfZu/KfYhlb7Gv1VKpAdFPAiJQi6bcze7O4EyOQ//6V9KWXLOq2bnrwFijHtrbfIKIESkLqQWvLRzDTDMx6gLqQVPArXWOaW0uQUgInN7E7IHgdPcvOvrCVwDXOYhBOq9m8qYRPczMLOIiHmPWaj57d7eIgAIgAAIgAAIgAAIgIA7gQNkMhohvvEo1AAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAKBJREFUWEftlMENwCAIAJEduogjdAxfncBhnKAvt+gKDtIhaOPDxPhoAzblA2+B41AdKIf7sn9KaYsx7pyanwIgIhERagFcAMAeiJ3wMJ0qQG1egz0QO2E0kHNeQwiHGgAAiKcXKRsMtObiWrMrUAXom/9roJSyeO/Pbh1ik9LEafUNXgIwdevHZywB4Hz1r2cNwAyYATNgBsyAGTAD6gZucMsZIbOX5goAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAANdJREFUWEftlLENwyAQRe8QRUqKZBE2yBS0mYBhPEFalvAIDBIpEm0Ui4tc2LJcWNwZhQbqu/v/vwMQGh+sqT8Mw8N7/+TMrGpAKZVzzqqVAQIAdiB2w0G6pgZm8fmwA7Eb9gRCCHfn3NjMAACI04uQ7Qgs4uJZZ1fQ1MBW/L8EYow3a+1rsw4xSWnjmt4Y804pXTm/37ZWYmAVJ6ILIn6k4tK9nXp2e7NcAlXFWQSISCPiV/LdHq2omIDWmqZpKq4vvRfVB5YKL3XdQCfQCXQCnUAn0JzAD1mYKyGjr7ZqAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOBJREFUWEftlMENAiEQRQewBTuwAjow2wA3rlawsRWpwOvetoG1BDqwAVtQwOxhDSHG7MAoHuDMzP//fQKDyodR6htjDn3fnzE7SQ1wzr33ntcyEAAAHQg98CFdVQOz+HzQgdADKYFhGPZa60s1AwCQnT4LWUJgEc/eVVpBVQOx+G8JWGu3UspbVEc2ydxBkvS52MjEiw0opY7jOJ4wf396F1sBaXoUgRDChjF2p3h4MQUMgVf6aZp2XdddS9Avs6sMCCEezjlBnR5VAUXadztWEfiWeCPQCDQCjUAj8BcEnt5HLCGYRJijAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOZJREFUWEftlT8KwjAUxl8hU2hGD5HVi3iHgouEHiYUHISewYs45w6uKZ0CSgel1iD9XgoBSfbvz/s9klSU+VRb5ltrj23bXhDPTQsIIUIIQeQq8CAieCBY8GO6rAWm8OnAA8GCJYGu6w7GmGtd1zQMA+wHCyIrYE/PQrYo8Apne6USyFrgHS6lpHEcWcOwRH3f75umuc3WwfJh742I5uhTfPB7GwnPXoCNn9N8iZ7j8XGTV7f33u+UUvfIQ7TaI/aPIOLNp0fwfYVrrc/OuRPy96cSSM2K6pEVlAKFQCFQCBQC/0ngCZyCKyGLisvHAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAOhJREFUWEftlUEKgzAQRUcIBIJZ9hDZ9iI9RRGKeBgRSuglepGuvUO3CYIQqLiwiE2LMwnNJlnnz///DZoCEp8ipn/btuemaW6YmVEDMMacc46lCvACAHQhtOBHu6QBZvP5oAuhBVsCXded6rq+l2UJ1lr0PLTAswJyexKyTYDFnDwrlEDSAG9zIQQMw0AqQxJprY9VVT1W6yDNIe8NANboQ+bgv1uPedoAnHMYx/FvK9iiD2qPEhtjDlLKp+dHRG6PChB790uRvek/0Culrn3fXzBvv+/u3gChPl/1OUAmkAlkAplAJjABAisuIV3OTLQAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPpJREFUWEftlDEOgkAURP9mswVYWVjYmJhQeRIvwAG4BgfgGhyAE3gRK2JjY6xshETENRQYIBvDHzbZZrefPzNvkhXk+Amb/kmSHPI8P3NuWg0gpXy2bbtyFUATEbsQW/CnndMAnXn32IXYgimBOI73RVFcwjC8VlW14+wPJTYYwO1tBOjN4VtLJ3Aa4GceBMGtrustd38YW5ZlmzRN7wNDmCQqHKKHi6DCFxGpCW60CP/jIKJRe6XUo2maNbI/QmCKHrkxyjobndZaCCE+hqazb5goccTW23PwvYlIDhtEUXQqy/KIbt/rOASWehn1PoAn4Al4Ap6AJ/AFZMMxIUrpG48AAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPhJREFUWEftlbENgzAQRc+SO6CKMkOaiCITsEHGcGHGMYW3yAgskAalyggp0gCdJSMKIstBke5sxY1d8+///84Ag8SHxfTvuk5IKTVmZtQAnHNjjOGpAlgAQBdCC360SxpgNV8PuhBa4BNQSl3btr2VZQnTNKHnoQU7KyC3JyHzAmzm5FmhBJIG+JgXRQHzPJPKkERa64sQ4u6sgzSHvDcAcNGHzMG/tzvmGwgSBYrIb//XAFHNUbsbx/FYVdXL/xBZaw+MsTfmD+g+i1lB9PYYAl/mdV0/h2E4UZsHXZxV3DTNo+/7c7IAocbBBHKATCATyAQygVgEFhOVMyHfnwRFAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQpJREFUWEftlT0KgzAUx5+QSXSzYPECmXuRnqK4iIcRF+klepHu9gBCKG5aJ8EitCLR1ryXlizJnPf/+D2iDhg+zi/9syw7pWl6xmj+NABjrO/7npkKMAAAuhB64Es7owFG8/GgC6EHZAJ5nh+TJLl4ngdt26L10AMrKyC3JyGTArzNyVq6BIwGmMxd14Wu60hlSENFURziOL7O1kHSIe8NAObodXTw73bFfPEwoii6VVXFVT7JFHRy+zUfZV3liy+XTXMhhBeG4UOlPWp3TdPsfN+/KwijSmEub7b/579gYc45r8qyjHSfIoaATH8IgkDUdb1XWMvHKzoBdHynWRvAErAELAFLwDiBJ/41OCHISF3HAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARBJREFUWEftVb0OgjAQviYdTAOjkxMbo/FFfIwO8Dgw9C18EQc3NiYXVwguTWpIxJDSSO/EdGnnu+/vOI5B4Me25K/rWhZFoTCYmwrgnGutNQ8lwAAA2hC64Yu7oAJG8vGhDaEb7ASqqjqXZXlJkgT6vkfjoRscIyC7J0VmCZjIyVi/JhBUwIdcCAHDMJDMkJqUUicp5XU2DhIOeW4AMI/+Fxz83jrIF4uRZdmtbdujzy+ZEp3t3sXjjetd+GZZJTfGCMbY08c9anZd1+3TNH14AKNMYYpX3f/zFizI8zy/N01zsBLBGKJdrxnhJquIVjwJMMbsrI+NhEVqchwkMg650WMbvEqigJhATCAmEDyBF1o5OSGPxyG0AAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATFJREFUWEftVb0KglAUPqKbOgYu0hjo1tJj9A4uDfoQ9yF0aPEZeo6gUYe2cJFWdVMKIUVM8p5zDQu88/1+j+cqwcxHmlI/CIKD67pHDOekBhRFKcuyVOYy8AAAdCA04EO6WQ3U4vVBB0ID+g34vr/3PO+kaRrkeY7mQwMGRkBOT6qsZ6ARJ3OJNjCrgVZcVVUoioIUhgQKw3DrOM6lMw4SD3luANCtXoQHv7cD4iDLMlRV1RZimuY1SZINz5NMqa6ffkiHm5f74ktlVDxNU80wjIInPWp2WZatdF2/cxCjQmEuj6b/5r/gTdyyrFscx+teI5hAtL9XR3CSVUQ7/lUD5CBkYPMgRVG0s237zLEdg1eEDVC+/K4TUQMieLEtYIyFjDGHWn2DE06wGFga+PsGnvfmRCFRNlqCAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAWZJREFUWEfFVj9qhTAcTsCp6ljHDoFScCn0CF7g3UGQDjr0KB10KIJn6AWeN+jQxeFRMnR0VekipDyoD+sLffl9puic72/8JeFs44/b1C+K4jFN0xcKp1UDjuOM4zg6WxlQjDFyIDLgj3SbGjiKHz9yIDJg2UCe57ssy149z2N935P5yADNFsDpocoWBiZxmGttA5saOIm7rsuGYYDCQKCqqh7iOH6bbQfEA+8bY2xe/Roe+txqxM8GQwhxkFLemRzJSHXL9DodY17jhT8qF8WVUlec8y+T9KS967ru2vf91oCYFIqy+GL6/7wLzsTDMPxsmuZm0QglEHZ7zQStjCLZsc4A55wppSAuCKSZCJgHBk4HUtu2t0EQfBhMh3YJZCCKon1d1xH6Cpo7gQzMjmMUf/KAEqx6BdlqADX/619ASaAn+KpbawJLKe+FEO/oX7/EkRtIkuS5LMunzQzYEp54yA3YNvANFhNOIXOOA7kAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVlJREFUWEfdVr1qhEAQnjU2gbM8SztJkUKw9CWutfaKwCn4LIIGDoK1ZZ7C7jhsAoedpa2Ba4wGiwuyJ3FnXCJk6/3m+xlnVgYrHyaTP0mSF9/3j5iaUgWoqvrVtu3DWgJ6AEAbQgN+cbeqgIF8OGhDaACfQBzHuyAI3hVFga7r0PXQgIkWkN2TIuME3MjJtZYmsKqAMfnfJpCmqe153mnUDnKSVKAU99TYePK7wTAM46OqqmeRlUxJYFYAZiFhBcyS13Wt6br+KeIe1YKmabaaptUChVGmMJdn3WOivxkRFXBHblnWpSiKJy4R0Xo/MDRgRChlFP+NALIREjAMw30URW9DO8qytE3TPAtMx+QVkgAAWPwKYqeAV7/oJ2RcbGkCVDx9DPu+3zDGGsrSmfoIKA6kxY96C7gFRBEuZwpc133NsuxAHTseh3KS5/mj4zhXWeTUFsjkh29EkUwhTSSlsgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAVFJREFUWEfllq1uhEAUhWfchrRiDWIFCZLUsX2GKh4ASbIOg+A5EJjWrEDyAJg+BMgiSUjWIGq6IXWzIVkIoTRwz5Cy2aJn7vnO/WM4W/njK+uzuwIQjNENLZYBRVFEXdfkeOQLv/QM5L6JJQ0QRdGL4zjvaCxpAMZY4x42IwvQiv9PgM59EASu7/tvyFKDSpBl2c40zVNPEIoD163XeC3DnwL0G28065qmfZRl+TSnJAj5JABlJ1ABJsWrqnpUVfU8xz2pB4QQW87554zAJFOUw5PuKamndu8Pccuy0iRJ9oOMUAzh+/sqOoQii5N6YKT2NwUAuYcz4HneIQzDYxMgz/NnwzDSGdMxegQll/4NU6dgSC/1COkHk80Aer9jIAcQQjxwzr+QpTPWBGQA2TfgEAIFQO4tMwW2bb/GceyiYyeVgaIoNrqufy8lDi+iJQEuFSNIIdEqOSkAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAASRJREFUWEftVr0OgjAQ7o0mymQYuzEYNydCwnuwu7nwLCxOPgDvQULY3HRgkhE3NHGsIZGkIgm9a0MTYufefT931yswywcs47M/gb8Ds3BAMEZvZl0HWvD2kPOQAz/AVgl04NM7kGUZD8PwJr2iZCepgbL6yR3og/+sE875paqqrcqeoTgwSgAzFVgCo+B1Xa9c132qqEfVrmmateM4d4XEKFGYy6PqMdZ3QpQIAIAQ4hvf9/1rURSbniNK+eQYdIAUbGQUZ0OALIQUGMfxPkmSU1uOsix3nuedFaZj8AqJAGPMyCJCvQM9+tprGDWGA97ZIyCEWALAg/LoDDUBpQeMqaf2gNYntO8C2oEoio5pmh6oY6dFIM/zRRAEL1Pg1BKYxGdvSfw9IU9EX5sAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAR1JREFUWEftlDELglAQxz1pCQqhwdEpJweh0W/i3Jgfx7Z2v4lrONhik1tCgxQ05YsXFfQKOv89kMI3393/d/93d2R0/KhjfaMH6B3oHegd+E0Hsiyzfd/fySsqhBgQ0Rm9qKgDQhFE60CnWBU3iEg68WByHGdTlqXHcQUhfwF4I8Suyw68iXwUr6pqbNv2kdO9jGED1HU9sSxrzyjMrtkKQA68bnE2gGmaTdM0T515nrfN83z67Ta0sksR07KKfwMANwIlRlE0j+N4Jb+kKIqZ67prxoC+DYEAlI1Aa1yB0OT7AKL5DzfQAt0BCCFGRHT4wr2nWUAc0NY9OgMSAAHXswVhGC6TJFmga6fmteokTdNhEAQnXeLoF+jUNy4OXUAhfubshgAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARdJREFUWEftlbEKwjAQhi/dBKXg0LGLdKmbY5+ku5v0cYqTD9An6eqWpbh0LDgUBbdEWrXaqHi5BgqSbIHL/f//5UgYjLzYyPpgDVgCloAlYAmYICAB6C/qEAONcLsYYyBltwXf93lZlkvMP0Mx8FT6roDuiy68a/0Ur6pq5nneGZO+pYctrOt67rruEVGP7qllAAB+ptcJ1M0PIhE4jiOEEL1kYRgeOOcL5bxWel0CqleViLb4XxkgpScTSJJknabprmlQFMUqCII9ZpY+1VCdv94/tcftFSU6fxignu9kqQ3GMyClnDLGTgPo9aBTCBhLT52BQf+/OnPaBOI43mZZtiEO79sxLQN5nk+iKLqYEqdegUl9uAI7aDghvQ03uAAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARpJREFUWEftlLEOgjAURdvIYqKjJCwshqmbbnwIYXdz4VtYnPwAwoewGSdciAsLSVdNXJrUYNBgg/p4JcGhzL33nnfbByUjf3TkfGIATAOmAdOAaUC7gTRN10EQHLC/dF0A2RXsuu6pLEsGgdIB6AxvQsG+4IPKNB/DOedz27avkOnrMxiAb5P39gQDVFW1cByH/5gM7Pf0AQksyxJCiEk7nDF2zvN8qQCB/Nqa3oKWWL0KlBdK1ED8FQB6EJQwiqJNHMf7uomiKFae5x2ha6eeQwEQQtr1Yz0eLFjxEwCrfxWBNRgPQEo5o5ReNNp7ewaYBgabHvsGagAMeOei9DYKw3CXJMkWu3Zaa5hl2dT3/dtQ4dgrGDKf3AEwFDghZAjrRAAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQdJREFUWEftVS0OwjAYbWUTsJNTq6pDznOHeRxmZ5lBcYCdgQPMoobp1OQshMmSkY2MDpL2dckIafX3ftsvpWThQxfWJ96Ab8A34BvwDfxFA0r/T8IwvNR1LUz+GacGoig6VVW1/SBkzGs8+CXNJH3TNOsgCG4m6bsZFwMT8V7UitNqeEjFGLu3bctcqh+wkAFCiBJCyLIsuWbCms8aMBLUrwDigkC9iZ8yAAeBgGma7rIsO3ZNSCk3nPOz6drpc5CB7hGOiFCOJwUKHgyg+Jd/lGA5A0qpFaX06tDe2zNAGpgtPfoGOgOI8Y+LYk2UJMkhz/M9unZOa1gUBYvjuJ1LHL2COfXJA1USNCEePv4iAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPxJREFUWEftlbENgzAQRc9JFmADj5GSLiJlCuqsAQPAGqmRUjslXcYIGzBBYuQoRA5ycf5Ygkim5f6/fw+bE7TwIxbuTzFAJBAJRAKRwP8TkFIeuq672TslSRLV9/2Rs2dCENCORmxfdqFrmrquZVEUD/ud1nojhHCFcgKZFYCIZk1vEoUO4O3nLRg5VlV1KsvyOuHq7ectsBpO8UNekOgTYlUB4EEgYZZle6XU3ZBommaX5/mT89Nx1UABJtcP9XjnQcXj90f1XxiowSoCoOF/jgJiYqZ/EdEWPXi2Dg2A6MIsozRNz23bXkJMj9wCMzl71XJCBkPJaeaqGQAl7S4h4nv08wAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAQNJREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkNg6IdASEhI7Zo1a5qQ6xQ5Oblrjx490iamnqFGCPzHYhHR5hKtEJtv5s6d65acnLwTWe7Vq1e8YmJiX4jxPUgNRQ5gYGCgyPe0cADJHiJZAyxou7q6+srKygrRgppk80jWgGQhevCTZRZZmqCOGFQOINsjZGnMz89Pnjhx4hxQSNy+fdtIVVX1PLHZDl0dWQ5Ay37kmgF2C7maYfFPrn54QJBrwMA54P///zyMjIyfKQg9lGRATghQzffkpgGQA8hxONaMQrJBERER01asWJFFbrajKBvev3+fQ1FR8Qe1LCc3CqhpPwMA3eEzIfATgugAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPVJREFUWEftVb0KwjAQToaAg65dS4eCs2/T2ak4dPUNnDtIF/c8jrN0KFm76iB0iBRsCYqQfHdQkHS+fr+9nhQLP3JhfhEFxARiAjGBmMBfJWCnu5Km6c0Ys/W5M5wJzAKE8L8xXAJm8r7vN0mSPHzcjzNkAUopOwyDyxeEGTT8wxUU/YRFFeCSQ4nCApqmOZZleXJSgbCgl96kZPdQZI5jUvekb6Cqqn1d15cRpG3bXZ7nV9+1+5xDK2BxT6lgEoAamINAAZYTYK1dSynvHH9RtAI29xQBaHVfyxIMVBTFWWt9QNeOtIZd162yLHtykaMVcPKLF7l0MCGK8eESAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAL5JREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkNgNASGVwhMmDAh2cPDY5WGhsZnYmtZaobAf6ilJJlJkmI8viLLcpB51HAAzHKyzKPUARRZTpaLkaIB2XKyzaIkBCj2Pdmubmpqsq6rqzsCMuDAgQNuDg4Ou4nNdujqyA0Bqvie7BBgYGAgO9tROwTIDUG4O8g1ABQC5OpFCQRyDKFa8JObBqjme7IcEBwcPG3t2rVZ5GY7aiVCatlPnYREiWsAkQ0dISw9Mt8AAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAMJJREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkNgNARGQ2A0BKgZAv8ZGEhvX1DkgMrKSq329var0FYVWWaRpQlqIcjHyIAss8jShMUBZJtDlsY5c+Z4p6SkbAE55OrVq9Ha2trLyG3ckuUABgYG5OAn1wywm8nVDHMAufrhAUauAQPngP////MwMjJ+piD0KM46VPM9uWmArBIPVy4hOQ3ExcWdXrRokSm52Q5dH0kOOHPmDKuJiclvallObhRQ034GAO4/ICH/4YKoAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAK1JREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkNgNARGQ2A0BEZDgOwQYGJi+v/v3z+y9cOagpQY8B9qCCVmkNcmbGtrs6yqqjoGcsDly5etdXV1wWxyALmuh/keZCe5ZoDdS65mqgT/0HTA////eRgZGT9TEHooSYWcKKBa8JMbBSAHkONwrJmEZIM8PDzW7tixI5icLIdND0kOOHPmDKuJiclvallObhRQ034GAGHlHiFoqjgXAAAAAElFTkSuQmCC",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAH5JREFUWEdjZBhgwDjA9jOMOmA0BEZDYDQERkNgNARGQ2A0BEZDYDQEyAqBjo4OuYqKikfUaNCS5QAGBob/DAzUadAOXQdMmDDBt6CgYAul0TAkQwAU/yBAruNRAo0cQ6iWAMnyhYaGxswbN26kUxr3MP3khAC17KZePFLiIgAhdxIhUI/2NwAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAGpJREFUWEft17ENgDAMRNFLySLsQ51lbhnX2YdFKEFCYgHLkgt+BvCdnpt4qPmN5nxRAAEEEEAAAQQQQACBlIDt3fZZ8aFNFZhzHhGx2gpUBH8zUgK/L3BLdQdNZgWXpK1qDZkCVdnvHAo8wY8KIT5PQRoAAAAASUVORK5CYII=",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==",
                  ],
                  e = 0;
                setInterval(function () {
                  document.querySelector("link").setAttribute("href", t[e]), e === t.length - 1 ? (e = 0) : e++;
                }, 35);
              },
            },
          ]),
          t
        );
      })(),
      Oo = new Lo(),
      Bo = [],
      qo = [],
      No = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        (z.namespace = t), (z.currentSliders = []), document.addEventListener("keydown", Qn);
        var e = document.querySelectorAll(".preload-critical");
        To.loadImages(e, "nodeList", function (e) {
          !(function () {
            if (!0 === z.firstLoad) {
              var t = new Un.timeline({ paused: !0 });
              if ("add-something-positive" === z.namespace) {
                var e = document.querySelector(".asp-loader"),
                  i = e.querySelector("video");
                e.addEventListener("wheel", function (t) {
                  t.preventDefault(), t.stopPropagation();
                }),
                  t.set(K.globalMask, { autoAlpha: 0 }).fromTo(
                    e,
                    0.8,
                    { opacity: 0 },
                    {
                      opacity: 1,
                      pointerEvents: "all",
                      force3D: !0,
                      onComplete: function () {
                        z.loadASPImages = !0;
                      },
                      ease: "sine.inOut",
                    }
                  ),
                  i
                    ? t
                        .add(function () {
                          i.play();
                        }, "-=.1")
                        .to(
                          e,
                          0.4,
                          {
                            immediateRender: !1,
                            opacity: 0,
                            ease: "sine.inOut",
                            force3D: !0,
                            clearProps: "transform",
                            onComplete: function () {
                              (z.transitionFinished = !0), i.pause();
                            },
                          },
                          "+=3"
                        )
                        .set(e, { pointerEvents: "none" }, "+=.5")
                    : t
                        .to(
                          e,
                          0.4,
                          {
                            immediateRender: !1,
                            opacity: 0,
                            ease: "sine.inOut",
                            force3D: !0,
                            clearProps: "transform",
                            onComplete: function () {
                              z.transitionFinished = !0;
                            },
                          },
                          "+=0.8"
                        )
                        .set(e, { pointerEvents: "none" }, "+=.5");
              } else
                t.fromTo(
                  K.header,
                  0.45,
                  { opacity: 0, y: -15 },
                  {
                    opacity: 1,
                    y: 0,
                    ease: "sine.inOut",
                    force3D: !0,
                    onComplete: function () {
                      z.transitionFinished = !0;
                    },
                  }
                );
              (z.firstLoad = !1), t.play();
            }
          })();
          var i = setInterval(function () {
            if (!0 === z.transitionFinished) {
              if ((clearInterval(i), "product" === t)) {
                var e = document.querySelector(".product-slider.other-products"),
                  a = document.querySelector(".pdp-hero .featured-image");
                e && new fo(e), (z.windowWidth < 768 || r(document.body, "force-mobile")) && new fo(a);
              }
              !(function () {
                if (!(z.windowWidth > 767)) {
                  var t = document.querySelectorAll(".recirculation");
                  t.length <= 0 ||
                    Array.prototype.slice.call(t).forEach(function (t) {
                      var e = t.querySelector(".product-grid");
                      if (t.classList.contains("staff-recs")) {
                        new Cs(e, { slideSelector: ".product-card", dots: ".dot", arrows: ".arrow", addCSS: !1, xOffset: 1, autoPlay: !1, hitPoints: !1, calcHeight: !0 }).init();
                        var i = t.querySelectorAll(".recommendation");
                        e.addEventListener("slideChangeStart", function (t) {
                          Un.to(i[t.data.index], 0.35, { autoAlpha: 0, ease: la.easeOut }), Un.to(i[t.data.target], 0.55, { autoAlpha: 1, ease: la.easeIn, delay: 0.35 });
                        });
                      } else new Cs(e, { slideSelector: ".product-card", dots: ".dot", arrows: ".arrow", addCSS: !1, xOffset: 1, autoPlay: !1, hitPoints: !1, calcHeight: !0 }).init();
                    });
                }
              })();
              var n = document.querySelector(".card-slider.testimonials");
              if (n) {
                var s = new fo(n);
                z.currentSliders.push(s);
              }
              var o = document.querySelector(".subscription-builder");
              o && new mo(o);
              var l = document.querySelector(".quick-quiz");
              if (
                (l && new Ro(l),
                Zn(),
                (_o = new oo({})).checkScrolledMedia(!0),
                (function () {
                  var t,
                    e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                    i = new Un.timeline({ paused: !0 });
                  "add-something-positive" !== z.namespace && i.set(K.header, { pointerEvents: "all" }).set(K.globalMask, { autoAlpha: 0 });
                  var a = z.windowWidth > 767 && !r(document.body, "force-mobile");
                  switch (e) {
                    case "product-category":
                      t = a ? document.querySelectorAll(".ee, .reward-progress, .product-card:nth-child(-n+3)") : document.querySelectorAll(".mee, .reward-progress, .product-card:nth-child(-n+2)");
                      break;
                    case "product-listing":
                      t = a
                        ? document.querySelectorAll(".ee, .reward-progress, .product-grid .category:first-child .section-header, .category:first-child .product-card:nth-child(-n+3)")
                        : document.querySelectorAll(".mee, .reward-progress, .product-grid .category:first-child .section-header, .product-card:nth-child(-n+2)");
                      break;
                    case "collections":
                      t = a ? document.querySelectorAll(".ee, .product-grid .product-card:nth-child(-n+3)") : document.querySelectorAll(".mee, .product-card:nth-child(-n+2)");
                      break;
                    case "subscribe-and-save":
                      t = a ? document.querySelectorAll(".ee, .image-with-content:nth-child(3)") : document.querySelectorAll(".mee, .image-with-content:nth-child(3)");
                      break;
                    default:
                      t = z.windowWidth > 767 && !r(document.body, "force-mobile") ? document.querySelectorAll(".ee") : document.querySelectorAll(".mee");
                  }
                  i
                    .set(K.globalMask, { autoAlpha: 0 })
                    .fromTo(t, 0.5, { y: 18 }, { stagger: 0.06, y: 0, ease: "sine.out", force3D: !0 })
                    .fromTo(t, 0.48, { opacity: 0 }, { stagger: 0.06, opacity: 1, clearProps: "transform", ease: "sine.out", force3D: !0 }, 0.21),
                    i.play();
                })(t),
                "product-listing" !== z.namespace && "product-category" !== z.namespace && "collections" !== z.namespace)
              ) {
                var c = document.getElementsByClassName("add-to-cart-form");
                c.length > 0 &&
                  ("product" === z.namespace
                    ? Array.prototype.slice.call(c).forEach(function (t) {
                        new Es(t);
                      })
                    : Un.delayedCall(1.5, function () {
                        Array.prototype.slice.call(c).forEach(function (t) {
                          new Es(t);
                        });
                      }));
              }
            }
          }, 20);
          To.loadImages(".preload-fixed", "string", function (t) {});
        }),
          Oo.init();
        var i = document.getElementsByClassName("product-click");
        document.querySelector(".emoji") && (Mo = new no()),
          Array.prototype.slice.call(i).forEach(function (e, i) {
            r(e, "bound-click") ||
              (e.classList.add("bound-click"),
              e.addEventListener("click", function (a) {
                e.href;
                var n = e.closest(".product-card").querySelector("[name='data']"),
                  r = JSON.parse(n.value),
                  s = "product-listing" === t ? "Products" : "product-category" === t ? document.querySelector(".short-hero h1").textContent : r.category;
                it("google", "ec:addImpression", { id: "" !== r.sku ? r.sku : r.variant_id, name: r.name, brand: r.brand, category: r.category, variant: r.variant, price: parseFloat(r.price), position: i + 1 }),
                  it("google", "ec:setAction", "click", { list: s }),
                  it("google", "send", "event", "click", "Clicked Product", r.category);
              }));
          });
      },
      Vo = function () {
        var t = "mobile",
          e = !1;
        (z.isGreaterThan767 || r(document.body, "force-mobile")) && (t = "desktop"), r(document.body, "instagram-browser") && (e = !0), (To = new jn("image-load", { size: t, forceNoWorkers: e }));
        var i = document.getElementById("product-reference"),
          a = JSON.parse(i.dataset.ref);
        z.productRef = a;
        var o = document.querySelector("[data-router-view]").dataset.routerView;
        if ("product" === o) {
          var l = document.querySelector(".pdp-hero .add-to-cart-form [name='data']");
          (l = JSON.parse(l.value)),
            it("google", "ec:addProduct", { id: "" !== l.sku ? l.sku : l.variant_id, name: l.name, brand: l.brand, category: l.category, variant: l.variant, price: parseFloat(l.price) }),
            it("google", "ec:setAction", "detail"),
            it("facebook", "track", "ViewContent", { content_name: l.name, content_category: l.category, content_ids: ["shopify_" + l.product_id + "_" + l.variant_id], content_type: "product", value: parseFloat(l.price), currency: "USD" });
        }
        if ("product-listing" === o || "product-category" === o) {
          var c = document.querySelectorAll(".product-grid .add-to-cart-form"),
            h = "product-listing" === o ? "Products" : document.querySelector(".short-hero h1").textContent;
          Array.prototype.slice.call(c).forEach(function (t, e) {
            var i = t.querySelector("[name='data']"),
              a = JSON.parse(i.value);
            it("google", "ec:addImpression", { id: "" !== a.sku ? a.sku : a.variant_id, name: a.name, brand: a.brand, category: a.category, variant: a.variant, list: h, price: parseFloat(a.price), position: e + 1 });
          });
        }
        z.isMobile || new Fo().animateFavicon();
        it("google", "send", "pageview");
        var u,
          d = 0.01 * n().height;
        if (
          (document.body.style.setProperty("--vh", "".concat(d, "px")),
          document.body.style.setProperty("--vhu", "".concat(d, "px")),
          No(o),
          document.querySelector("#footer .btt") &&
            document.querySelector("#footer .btt").addEventListener("click", function () {
              _o.scrollTo(0);
            }),
          (u = document.getElementById("skip-to-content")).addEventListener("focus", function () {
            Un.to(u, { xPercent: 100, duration: 0.25, ease: la.easeOut });
          }),
          u.addEventListener("blur", function () {
            Un.to(u, { xPercent: 0, duration: 0.25, ease: la.easeOut });
          }),
          z.windowWidth > 767)
        )
          for (var p = document.querySelectorAll(".nav-trigger"), f = 0; f < p.length; f++) {
            var m = new $n(p[f]);
            Bo.push(m);
          }
        else {
          !(function () {
            var t = document.getElementById("zip-trigger");
            if (t) {
              var e = document.getElementById("zip");
              t.addEventListener("click", function () {
                var t = null,
                  i = null;
                e.value.length > 0 && (t = "?MM=panel2&ZIP=".concat(e.value)), t ? ((i = window.location.origin + "/store-locator" + t), Pl.redirect(i)) : ((i = window.location.origin + "/store-locator/"), Pl.redirect(i));
              });
            }
          })();
          for (var g = document.querySelectorAll(".mobile-menu-trigger"), y = document.querySelectorAll(".mobile-menu--container"), A = 0; A < g.length; A++) {
            var b = new tr(g[A], y[A]);
            qo.push(b);
          }
          var w = document.getElementById("mobile-tiles-slider");
          new co(w, { slideSelector: ".tile", addCSS: !1, hitPoints: !1, dots: ".dot", infinite: !1 }).init();
        }
        (void 0 !== v.get("user_city") && void 0 !== v.get("user_region_name")) || (v.set("user_city", "undetermined", { expires: 7 }), v.set("user_region_name", "undetermined", { expires: 7 }));
        var C = document.querySelector("#footer .email-form");
        tt(C, !0, null, function (t) {
          C.innerHTML = '\n\t\t\t<p style="height:149px;">Thank you for subscribing!</p>\n\t\t';
        });
        var S = document.querySelector(".mc-lottie-anim");
        z.mcLottieAnim = Yn.a.loadAnimation({ container: S, renderer: "svg", loop: !0, autoplay: !1, path: S.dataset.animationPath });
        var k = s();
        (z.queryParams = k),
          (z.referrer = document.referrer),
          k &&
            k.cart &&
            "1" == k.cart &&
            Un.delayedCall(1.5, function () {
              Ll.openMiniCart();
            });
      },
      Wo = function () {
        !(function () {
          var t = document.querySelector("#pencil-bar"),
            e = document.getElementById("pencil-bar--close");
          document.getElementsByClassName("pencil-bar--scroll");
          e &&
            e.addEventListener("click", function () {
              Un.to("#pencil-bar", { autoAlpha: 0, ease: la.easeIn, duration: 0.25 }),
                Un.to("#main-navigation", { y: -30, ease: la.easeOut, duration: 0.25 }),
                Un.set("#main-navigation", { className: "+=pencil-closed" }),
                Un.set("body", { className: "+=pencil-closed" });
            });
          var i = t.querySelector(".default-copy"),
            a = t.querySelector(".mobile-copy"),
            n = i.getBoundingClientRect(),
            s = a.getBoundingClientRect();
          (i.style.width = n.width + 20 + "px"),
            (a.style.width = s.width + 20 + "px"),
            setTimeout(function () {
              if (r(t, "pencil-bar--scroll")) {
                var e = document.createElement("div");
                e.setAttribute("id", "pencil-bar-track"), e.setAttribute("class", "pencil-bar--track");
                for (var o = z.windowWidth > 767 ? n.width + 20 : s.width + 20, l = Math.ceil((2 * z.windowWidth) / o), c = 0; c < l; c++) {
                  var h = i.cloneNode(!0),
                    u = a.cloneNode(!0);
                  e.append(h), e.append(u);
                }
                t.append(e), e.getBoundingClientRect(), Un.fromTo(e, o / 8, { x: o / 2 }, { x: -o / 2, ease: "none", force3D: !0, repeat: -1 }, 0);
              }
            }, 300);
        })();
      };
    function Uo(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var Jo = (function (t) {
        _s()(i, t);
        var e = Uo(i);
        function i() {
          return zn()(this, i), e.apply(this, arguments);
        }
        return (
          Gn()(i, [
            { key: "onEnter", value: function () {} },
            {
              key: "onEnterCompleted",
              value: function () {
                var t, e, i, a, n, r, s, o;
                Po(),
                  (function () {
                    var t = document.getElementById("social-purchase-feed");
                    if (t) {
                      var e = new yo(t, { slideSelector: ".slide", addCSS: !1, xOffset: 1, autoPlay: 8e3, hitPoints: !1 });
                      e.init(),
                        Array.prototype.slice.call(e.slider.querySelectorAll(".slide p")).forEach(function (t, e) {
                          var i = Eo();
                          (t.dataset.backgroundColor = i.slide_background), (t.innerHTML = i.text);
                        }),
                        t.style.setProperty("--background", e.slider.querySelector(".is-selected p").dataset.backgroundColor),
                        e.slider.addEventListener("slideChangeStart", function () {
                          t.style.setProperty("--background", e.slider.querySelector(".is-next p").dataset.backgroundColor);
                        }),
                        e.slider.addEventListener("slideChangeEnd", function () {
                          var t = Eo();
                          (e.slider.querySelector(".is-next p").dataset.backgroundColor = t.slide_background), (e.slider.querySelector(".is-next p").innerHTML = t.text);
                        });
                    }
                  })(),
                  (t = document.getElementById("deal-share-1")),
                  (e = t.querySelector("input")),
                  (i = t.querySelector("button")),
                  (a = t.querySelector(".error")),
                  (n = document.getElementById("deal-share-2")),
                  (r = n.querySelector("textarea")),
                  (s = n.querySelector("button")),
                  (o = n.querySelector(".name")),
                  z.windowWidth < 768
                    ? (s.innerHTML = "Share Discount")
                    : s.addEventListener("click", function () {
                        r.select(), document.execCommand("copy"), (s.innerHTML = "Copied!");
                      }),
                  i.addEventListener("click", function () {
                    var i = !1;
                    if ((0 == e.value.length && ((i = !0), e.classList.add("has-error"), a.classList.add("has-error")), !i)) {
                      var l = e.value;
                      o.innerHTML = l;
                      var c = "Hey ".concat(l, "! ").concat(r.value);
                      if (((r.value = c), z.windowWidth < 768))
                        if (navigator.share)
                          s.addEventListener("click", function (t) {
                            navigator
                              .share({ title: "Super Coffee Offer", text: "".concat(c) })
                              .then(function () {})
                              .catch(console.error);
                          });
                        else {
                          (c = encodeURI(c)), s.remove();
                          var h = document.createElement("a"),
                            u = document.createTextNode("Share Discount");
                          (h.className = "btn"), h.appendChild(u), (h.title = "Share with a friend"), (h.href = "sms:?&body=".concat(c)), n.appendChild(h);
                        }
                      var d = new Un.timeline({ paused: !0 });
                      d.to(t, 0.25, { autoAlpha: 0 }).to(n, 0.35, { autoAlpha: 1 }), d.play();
                    }
                  });
              },
            },
            { key: "onLeave", value: function () {} },
            { key: "onLeaveCompleted", value: function () {} },
          ]),
          i
        );
      })(m.Renderer),
      zo = function (t) {
        arguments.length > 1 && void 0 !== arguments[1] && arguments[1], arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        var e = t.context ? t.context : "default",
          i = (t.error && t.error, document.querySelector(".processing")),
          a = document.querySelector(".errors"),
          n = document.querySelector(".address-forms .errors"),
          r = function (t) {
            var e = "";
            if (Array.isArray(t))
              Array.prototype.slice.call(t).forEach(function (t, i) {
                switch ((0 !== i && (e += "\n"), t.message)) {
                  case "Argument 'email' on InputObject 'CustomerCreateInput' is required. Expected type String!":
                    e += "Please enter an email. ";
                    break;
                  case "Argument 'password' on InputObject 'CustomerCreateInput' is required. Expected type String!":
                    e += "Please enter a password. ";
                    break;
                  case "Could not find customer":
                    e += "Customer not found. ";
                    break;
                  default:
                    t.message ? (e += t.message) : (e += t);
                }
              });
            else
              switch (t) {
                case "Argument 'password' on InputObject 'CustomerCreateInput' is required. Expected type String!":
                  e = "Please enter a password.";
                  break;
                default:
                  e = t;
              }
            return e;
          };
        switch (e) {
          case "password-recover":
            "" !== t.error
              ? ((i.textContent = "Recover password"), i.classList.remove("processing"), (a.textContent = r(t.error)))
              : ((i.textContent = "Email sent"),
                Un.delayedCall(3, function () {
                  (i.textContent = "Recover password"), i.classList.remove("processing");
                }));
            break;
          case "reset-password":
            "" !== t.error
              ? ((i.textContent = "Reset password"), i.classList.remove("processing"), (a.textContent = r(t.error)))
              : ((i.textContent = "Success..."),
                Un.delayedCall(3, function () {
                  Pl.redirect(z.domain + "/account/login/");
                }));
            break;
          case "customer-create":
            "" !== t.error ? ((i.textContent = "Save"), i.classList.remove("processing"), (a.textContent = r(t.error))) : Pl.redirect(z.domain + "/account/login/");
            break;
          case "customer-edit":
            "" !== t.error
              ? ((i.textContent = "Save"), i.classList.remove("processing"), (a.textContent = r(t.error)))
              : ((i.textContent = "Success"),
                (function (t, e) {
                  var i = "";
                  switch (t) {
                    case "customer-edit":
                      (i += "<p>" + e._firstName_ + " " + e._lastName_ + "</p>"),
                        (i += "<p>" + e._email_ + "</p>"),
                        (document.querySelector(".profile .tab-summary").innerHTML = i),
                        (document.querySelector(".logged-in-header h1").textContent = e._firstName_);
                      break;
                    case "address-edit":
                      i += "<p>{updatedData}</p>";
                  }
                })(e, t.updatedData),
                Un.delayedCall(3, function () {
                  (i.textContent = "Save"), i.classList.remove("processing");
                }));
            break;
          case "address-edit":
            "" !== t.error
              ? ((i.textContent = "Save"), i.classList.remove("processing"), (n.textContent = r(t.error)))
              : ((i.textContent = "Success"),
                Un.delayedCall(3, function () {
                  location.reload();
                }));
            break;
          case "address-create":
            (i.textContent = "Success..."),
              Un.delayedCall(3, function () {
                location.reload();
              });
            break;
          case "address-delete":
            (i.textContent = "Success..."),
              Un.delayedCall(3, function () {
                Un.delayedCall(1, function () {
                  location.reload();
                });
              });
            break;
          default:
            a.textContent = r(t.error);
        }
      };
    function Ko(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var Go = (function (t) {
      _s()(i, t);
      var e = Ko(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          { key: "onEnter", value: function () {} },
          {
            key: "onEnterCompleted",
            value: function () {
              !(function () {
                if (!document.querySelector(".logged-out")) {
                  var t = document.querySelectorAll(".tab-anchors .tab-anchor"),
                    e = document.querySelectorAll(".all-tabs .tab");
                  Un.set(e, { display: "none" }), Un.set(e[0], { display: "flex" });
                  var i = 0;
                  t.forEach(function (a, n) {
                    a.addEventListener("click", function () {
                      a.classList.contains("active") || (t[i].classList.remove("active"), (i = n), a.classList.add("active"), Un.set(e, { display: "none" }), Un.set(e[n], { display: "flex" }), "object" == y()(_o) && _o.resize());
                    });
                  });
                }
              })(),
                document.querySelectorAll(".view-account .submit-block .btn").forEach(function (t, e) {
                  t.addEventListener("click", function () {
                    t.classList.add("processing"), (t.textContent = "Processing...");
                  });
                });
              var t = document.getElementsByClassName("ajax-form");
              if (
                (Array.prototype.slice.call(t).forEach(function (t) {
                  tt(t, !1, null, function (t) {
                    t.logout && !0 === t.logout ? (window.location = "/account/login/?logout=true") : zo(t);
                  });
                }),
                document.querySelector(".edit-address"))
              ) {
                var e = document.getElementsByClassName("address-delete");
                Array.prototype.slice.call(e).forEach(function (t) {
                  t.addEventListener("click", function () {
                    !(function (t) {
                      if (!t.classList.contains("processing")) {
                        var e = t.getAttribute("data-address-id"),
                          i = document.getElementById("address-edit_" + e),
                          n = J(i, { hash: !0 });
                        (n.type = "address-delete"),
                          t.classList.add("processing"),
                          (t.textContent = "Processing..."),
                          a("/v1/app/address/delete/", { method: "post", type: "json", data: JSON.stringify(n) }, function (e) {
                            JSON.parse(e), zo(JSON.parse(e), t, i);
                          });
                      }
                    })(t);
                  });
                });
                var i = document.getElementsByClassName("edit-address");
                document.querySelector(".edit-forms .close").addEventListener("click", function () {
                  Un.set(document.querySelector(".edit-forms"), { display: "none" }), Un.set(document.querySelectorAll(".edit-forms form"), { display: "none" }), Un.set(document.querySelector(".add-form"), { display: "block" });
                }),
                  Array.prototype.slice.call(i).forEach(function (t, e) {
                    t.addEventListener("click", function () {
                      !(function (t, e) {
                        if (!t.classList.contains("processing")) {
                          t.getAttribute("data-address-id");
                          var i = document.querySelectorAll(".edit-forms form")[e];
                          Un.set(document.querySelector(".add-form"), { display: "none" }),
                            Un.set(document.querySelector(".edit-forms"), { display: "block" }),
                            Un.set(document.querySelectorAll(".edit-forms form"), { display: "none" }),
                            Un.set(i, { display: "block" });
                          var a = document.querySelector(".edit-forms").getBoundingClientRect().top + document.querySelector("main").scrollTop - 60;
                          "object" == y()(_o) && (_o.scrollTo(a), _o.resize());
                        }
                      })(t, e);
                    });
                  });
              }
            },
          },
          { key: "onLeave", value: function () {} },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function jo(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var Ho = !1,
      Yo = (function (t) {
        _s()(i, t);
        var e = jo(i);
        function i() {
          return zn()(this, i), e.apply(this, arguments);
        }
        return (
          Gn()(i, [
            {
              key: "onEnter",
              value: function () {
                for (var t = document.querySelector("[data-router-view]:last-child .other-types .drawer"), e = t.querySelectorAll("a"), i = [], a = [], n = 0; n < e.length; n++) {
                  var r = e[n].value;
                  (void 0 !== z.preloadedSlugs[r] && "" !== z.preloadedSlugs[r]) || (i.push(z.domain + r), a.push(e[n].dataset.img), z.preloadedSlugs.push(r));
                }
                i.length;
                t.addEventListener("change", function () {
                  Pl.redirect(z.domain + t.value);
                }),
                  Un.delayedCall(0.5, function () {
                    if (z.isMobile)
                      a.length > 0 &&
                        (Ho = setTimeout(function () {
                          To.loadImages(a, "array", function (t) {}), (Ho = !1);
                        }, 2e3));
                    else {
                      var e = !1;
                      t.addEventListener("mouseenter", function () {
                        e || ((e = !0), a.length > 0 && To.loadImages(a, "array", function (t) {}));
                      });
                    }
                  });
              },
            },
            {
              key: "onEnterCompleted",
              value: function () {
                (uo(), z.windowWidth < 768) &&
                  document.getElementById("atc-scrolltop").addEventListener("click", function () {
                    _o.scrollTo(0);
                  });
                var t = document.querySelector(".product-details.bundle .product-tabs");
                t &&
                  (function (t) {
                    for (
                      var e = 0,
                        i = t.querySelectorAll("li"),
                        a = document.querySelectorAll(".product-details .c-125:not(.product-tabs)"),
                        n = function (t) {
                          var n = i[t];
                          n.addEventListener("click", function () {
                            n.classList.contains("active") || (i[e].classList.remove("active"), a[e].classList.remove("active"), a[t].classList.add("active"), n.classList.add("active"), (e = t));
                          });
                        },
                        r = 0;
                      r < i.length;
                      r++
                    )
                      n(r);
                  })(t),
                  z.windowWidth > 767 &&
                    (function () {
                      for (
                        var t = document.querySelector(".pdp-hero .featured-image img"),
                          e = document.querySelectorAll(".thumbnails .thumbnail"),
                          i = 0,
                          a = function (a) {
                            var n = e[a],
                              r = n.querySelector("img");
                            n.addEventListener("click", function () {
                              e[i].classList.remove("active"), e[a].classList.add("active"), (i = a), (t.src = r.src);
                            });
                          },
                          n = 0;
                        n < e.length;
                        n++
                      )
                        a(n);
                    })();
                var e = document.querySelector("#pdp-atc-bar .add-to-cart"),
                  i = document.querySelector(".pdp-hero .add-to-cart");
                e &&
                  e.addEventListener("click", function (t) {
                    i && i.click();
                  });
                var a = document.querySelector(".pdp-hero .add-to-cart-form"),
                  n = a ? a.querySelector("[name='data']") : void 0,
                  r = n && "" !== n.value ? JSON.parse(n.value) : void 0;
                if (r) {
                  var s = { ProductName: r.name, ProductID: r.product_id, Categories: [r.category], ImageURL: r.image_url, URL: "https://drinksupercoffee.com" + r.url, Brand: r.brand, Price: parseFloat(r.price) },
                    o = { Title: s.ProductName, ItemId: s.ProductID, Categories: s.Categories, ImageUrl: s.ImageURL, Url: s.URL, Metadata: { Brand: s.Brand, Price: s.Price } };
                  it("klaviyo", "track", "Viewed Product", s), it("klaviyo", "trackViewedItem", o);
                }
              },
            },
            {
              key: "onLeave",
              value: function () {
                Ho && clearTimeout(Ho);
              },
            },
            { key: "onLeaveCompleted", value: function () {} },
          ]),
          i
        );
      })(m.Renderer);
    function Qo(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var Xo = (function (t) {
        _s()(i, t);
        var e = Qo(i);
        function i() {
          return zn()(this, i), e.apply(this, arguments);
        }
        return (
          Gn()(i, [
            { key: "onEnter", value: function () {} },
            {
              key: "onEnterCompleted",
              value: function () {
                setTimeout(function () {
                  ho();
                }, 1e3),
                  Io();
              },
            },
            { key: "onLeave", value: function () {} },
            { key: "onLeaveCompleted", value: function () {} },
          ]),
          i
        );
      })(m.Renderer),
      Zo = (function () {
        function t(e) {
          zn()(this, t),
            (this.useMobile = e),
            this.useMobile
              ? (this.filterSelect = document.querySelector(".cat-filters-mobile select"))
              : ((this.catFilters = document.querySelectorAll(".cat-filters .cat-filter .filter input")), (this.flavorFilters = document.querySelectorAll(".cat-filters .flavor-filter .filter input"))),
            (this.productCards = document.querySelectorAll(".product-card")),
            (this.productCardsData = []),
            (this.selectedTags = []),
            (this.selectedFlavors = []),
            (this.checkedFilters = 0),
            (this.activeCards = 0),
            (this.promoCards = document.querySelectorAll(".promo-card")),
            (this.clearFiltersTriggers = document.querySelectorAll(".clear-filters")),
            (this.emptyStateEl = document.querySelector(".product-grid .empty-state")),
            (this.countEyebrow = document.querySelector(".cat-filters .eyebrow .count")),
            (this.categoryWrappers = document.querySelectorAll(".product-grid .category")),
            (this.filtersActivated = !1),
            (this.showingEmptyState = !1),
            this.init();
        }
        return (
          Gn()(t, [
            {
              key: "init",
              value: function () {
                this.getCache(), this.bindEvents();
              },
            },
            {
              key: "getCache",
              value: function () {
                for (var t = 0; t < this.productCards.length; t++) {
                  var e = this.productCards[t],
                    i = void 0;
                  i = (i = e.dataset.filters.split(", ")).filter(function (t, e, i) {
                    return "" !== t;
                  });
                  var a = e.dataset.flavor;
                  this.productCardsData.push({ el: e, tags: i, flavor: a, tagHidden: !1, tagSelected: !1, flavorHidden: !1, flavorSelected: !1 });
                }
                (this.allProductsPage = !1), (this.categoryWrappersData = []);
                for (var n = 0; n < this.categoryWrappers.length; n++) {
                  this.allProductsPage || (this.allProductsPage = !0);
                  var r = this.categoryWrappers[n];
                  this.categoryWrappersData.push({ cat: r.dataset.category });
                }
                this.countEyebrow.textContent = this.productCardsData.length;
              },
            },
            {
              key: "bindEvents",
              value: function () {
                var t = this;
                if (this.useMobile)
                  this.filterSelect.addEventListener("change", function (e) {
                    var i = t.filterSelect.options[t.filterSelect.selectedIndex];
                    0 === t.filterSelect.selectedIndex
                      ? t.clearFilters()
                      : i.dataset.tag
                      ? ((t.selectedTags = []), (t.selectedFlavors = []), t.updateSelectedTags(i.dataset.tag, !0), t.selectedTags.length > 0 && t.filterByTag())
                      : ((t.selectedTags = []), (t.selectedFlavors = []), t.updateSelectedFlavors(i.dataset.flavor, !0), t.selectedFlavors.length > 0 && t.filterByFlavor());
                  });
                else {
                  for (
                    var e = function (e) {
                        var i = t.catFilters[e],
                          a = i.dataset.value;
                        i.addEventListener("click", function () {
                          t.updateSelectedTags(a, i.checked), t.selectedTags.length > 0 && t.filterByTag();
                        });
                      },
                      i = 0;
                    i < this.catFilters.length;
                    i++
                  )
                    e(i);
                  for (
                    var a = function (e) {
                        var i = t.flavorFilters[e],
                          a = i.dataset.value;
                        i.addEventListener("click", function () {
                          t.updateSelectedFlavors(a, i.checked), t.selectedFlavors.length > 0 && t.filterByFlavor();
                        });
                      },
                      n = 0;
                    n < this.flavorFilters.length;
                    n++
                  )
                    a(n);
                }
                for (var r = 0; r < this.clearFiltersTriggers.length; r++) {
                  this.clearFiltersTriggers[r].addEventListener("click", function () {
                    t.clearFilters(), t.hideEmptyState();
                  });
                }
              },
            },
            {
              key: "updateSelectedFlavors",
              value: function (t, e) {
                this.useMobile && this.clearTags(),
                  e
                    ? (this.filtersActivated || (Un.to(this.clearFiltersTriggers[0], 0.25, { pointerEvents: "all", opacity: 1, ease: "sine.inOut" }), (this.filtersActivated = !0)),
                      this.selectedFlavors.indexOf(t) < 0 && this.selectedFlavors.push(t),
                      this.checkedFilters++)
                    : (this.selectedFlavors.indexOf(t) > -1 &&
                        (this.selectedFlavors = this.selectedFlavors.filter(function (e, i, a) {
                          return e !== t;
                        })),
                      this.checkedFilters--,
                      0 === this.selectedFlavors.length && this.checkedFilters > 0 && this.clearFlavors(),
                      0 === this.checkedFilters && this.clearFilters());
              },
            },
            {
              key: "updateSelectedTags",
              value: function (t, e) {
                this.useMobile && this.clearFlavors(),
                  e
                    ? (this.filtersActivated || (Un.to(this.clearFiltersTriggers[0], 0.25, { pointerEvents: "all", opacity: 1, ease: "sine.inOut" }), (this.filtersActivated = !0)),
                      this.selectedTags.indexOf(t) < 0 && this.selectedTags.push(t),
                      this.checkedFilters++)
                    : (this.selectedTags.indexOf(t) > -1 &&
                        (this.selectedTags = this.selectedTags.filter(function (e, i, a) {
                          return e !== t;
                        })),
                      this.checkedFilters--,
                      0 === this.selectedTags.length && this.checkedFilters > 0 && this.clearTags(),
                      0 === this.checkedFilters && this.clearFilters());
              },
            },
            {
              key: "filterByTag",
              value: function () {
                "object" == y()(_o) && (_o.state.resizing = !0), (this.activeCards = 0), Un.set(this.promoCards, { display: "none" });
                for (var t = 0; t < this.productCardsData.length; t++) {
                  for (var e = this.productCardsData[t], i = !1, a = 0; a < this.selectedTags.length; a++) {
                    var n = this.selectedTags[a];
                    if (e.tags.indexOf(n) > -1) {
                      i = !0;
                      break;
                    }
                  }
                  i ? (e.flavorHidden || (this.activeCards++, Un.set(e.el, { display: "block" }), (e.tagSelected = !0)), (e.tagHidden = !1)) : (Un.set(e.el, { display: "none" }), (e.tagHidden = !0), (e.tagSelected = !1));
                }
                (this.countEyebrow.textContent = this.activeCards),
                  0 !== this.activeCards || this.showingEmptyState ? this.activeCards > 0 && this.showingEmptyState && ((this.showingEmptyState = !1), this.hideEmptyState()) : ((this.showingEmptyState = !0), this.showEmptyState()),
                  this.allProductsPage && this.hideEmptyCategories(),
                  "object" == y()(_o) && ((_o.state.resizing = !1), _o.resize());
              },
            },
            {
              key: "filterByFlavor",
              value: function () {
                "object" == y()(_o) && (_o.state.resizing = !0), Un.set(this.promoCards, { display: "none" }), (this.activeCards = 0);
                for (var t = 0; t < this.productCardsData.length; t++) {
                  for (var e = this.productCardsData[t], i = !1, a = !1, n = 0; n < this.selectedFlavors.length; n++) (a = this.selectedFlavors[n]), e.flavor === a && (i = !0);
                  i ? (e.tagHidden || (this.activeCards++, Un.set(e.el, { display: "block" }), (e.flavorSelected = !0)), (e.flavorHidden = !1)) : (Un.set(e.el, { display: "none" }), (e.flavorHidden = !0), (e.flavorSelected = !1));
                }
                (this.countEyebrow.textContent = this.activeCards),
                  0 !== this.activeCards || this.showingEmptyState ? this.activeCards > 0 && this.showingEmptyState && ((this.showingEmptyState = !1), this.hideEmptyState()) : ((this.showingEmptyState = !0), this.showEmptyState()),
                  this.allProductsPage && this.hideEmptyCategories(),
                  "object" == y()(_o) && ((_o.state.resizing = !1), _o.resize());
              },
            },
            {
              key: "hideEmptyState",
              value: function () {
                Un.set(this.emptyStateEl, { display: "none" });
              },
            },
            {
              key: "showEmptyState",
              value: function () {
                Un.set(this.emptyStateEl, { display: "flex" });
              },
            },
            {
              key: "hideEmptyCategories",
              value: function () {
                this.categoryWrappers.forEach(function (t, e) {
                  var i = 0,
                    a = t.querySelectorAll(".product-card");
                  Un.set(t, { display: "flex" }),
                    a.forEach(function (t) {
                      null !== t.offsetParent && i++;
                    }),
                    0 === i ? Un.set(t, { display: "none" }) : Un.set(t, { display: "flex" });
                });
              },
            },
            {
              key: "clearTags",
              value: function () {
                var t = this;
                (this.activeCards = 0),
                  this.productCardsData.forEach(function (e) {
                    (e.tagHidden = !1), (e.tagSelected = !1), e.flavorHidden || (t.activeCards++, Un.set(e.el, { display: "block" }));
                  }),
                  (this.countEyebrow.textContent = this.activeCards),
                  0 !== this.activeCards || this.showingEmptyState ? this.activeCards > 0 && this.showingEmptyState && ((this.showingEmptyState = !1), this.hideEmptyState()) : ((this.showingEmptyState = !0), this.showEmptyState()),
                  this.allProductsPage && this.hideEmptyCategories(),
                  "object" == y()(_o) && ((_o.state.resizing = !1), _o.resize());
              },
            },
            {
              key: "clearFlavors",
              value: function () {
                var t = this;
                (this.activeCards = 0),
                  this.productCardsData.forEach(function (e) {
                    (e.flavorHidden = !1), (e.flavorSelected = !1), e.tagHidden || (t.activeCards++, Un.set(e.el, { display: "block" }));
                  }),
                  (this.countEyebrow.textContent = this.activeCards),
                  0 !== this.activeCards || this.showingEmptyState ? this.activeCards > 0 && this.showingEmptyState && ((this.showingEmptyState = !1), this.hideEmptyState()) : ((this.showingEmptyState = !0), this.showEmptyState()),
                  this.allProductsPage && this.hideEmptyCategories(),
                  "object" == y()(_o) && ((_o.state.resizing = !1), _o.resize());
              },
            },
            {
              key: "clearFilters",
              value: function () {
                (this.filtersActivated = !1),
                  Un.to(this.clearFiltersTriggers[0], 0.25, { pointerEvents: "none", opacity: 0.4, ease: "sine.inOut" }),
                  Un.set(this.promoCards, { display: "block" }),
                  (this.selectedTags = []),
                  (this.selectedFlavors = []),
                  (this.countEyebrow.textContent = this.productCardsData.length),
                  this.productCardsData.forEach(function (t) {
                    var e = t.el;
                    (t.tagHidden = !1), (t.tagSelected = !1), (t.flavorHidden = !1), (t.flavorSelected = !1), Un.set(e, { display: "block" });
                  }),
                  this.useMobile ||
                    (this.catFilters.forEach(function (t) {
                      t.checked && (t.checked = !1);
                    }),
                    this.flavorFilters.forEach(function (t) {
                      t.checked && (t.checked = !1);
                    })),
                  this.allProductsPage && Un.set(this.categoryWrappers, { display: "flex" }),
                  "object" == y()(_o) && ((_o.state.resizing = !1), _o.resize());
              },
            },
          ]),
          t
        );
      })();
    function $o(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var tl = (function (t) {
      _s()(i, t);
      var e = $o(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          {
            key: "onEnter",
            value: function () {
              if (n().width > 767) {
                var t = Ll.checkForSubscriptionInShopifyCart(G.cart);
                (Fl.plp = !0), Fl.getPLPEls(document.querySelector("[data-router-view]:last-child .reward-progress .flow-progress")), z.firstLoad || Fl.updateProgress(G.cartTotal, !0, t);
              }
            },
          },
          {
            key: "onEnterCompleted",
            value: function () {
              setTimeout(function () {
                ho();
              }, 1e3);
              var t = z.windowWidth < 768 && !document.body.classList.contains("force-mobile");
              new Zo(t);
              po();
            },
          },
          {
            key: "onLeave",
            value: function () {
              Fl.plp = !1;
            },
          },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function el(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var il = (function (t) {
      _s()(i, t);
      var e = el(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          {
            key: "onEnter",
            value: function () {
              if (n().width > 767) {
                var t = Ll.checkForSubscriptionInShopifyCart(G.cart);
                (Fl.plp = !0), Fl.getPLPEls(document.querySelector("[data-router-view]:last-child .reward-progress .flow-progress")), z.firstLoad || Fl.updateProgress(G.cartTotal, !0, t);
              }
            },
          },
          {
            key: "onEnterCompleted",
            value: function () {
              setTimeout(function () {
                ho();
              }, 1e3);
              var t = z.windowWidth < 768;
              new Zo(t);
              po();
            },
          },
          {
            key: "onLeave",
            value: function () {
              Fl.plp = !1;
            },
          },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function al(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var nl = (function (t) {
      _s()(i, t);
      var e = al(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          { key: "onEnter", value: function () {} },
          {
            key: "onEnterCompleted",
            value: function () {
              var t, e, i, a;
              Po(),
                (t = document.querySelector(".full-image-hero")),
                (e = document.querySelector(".video-play-image")),
                (i = document.getElementById("video")),
                (a = document.querySelector(".video")),
                t.addEventListener("click", function () {
                  Un.set(a, { display: "block" }), Un.set(i, { display: "flex" }), (a.src = a.dataset.href), e.pause();
                }),
                (function () {
                  var t = document.querySelector(".video-play-image"),
                    e = document.querySelector(".lightbox-close"),
                    i = document.getElementById("video"),
                    a = document.querySelector(".video");
                  e.addEventListener("click", function () {
                    Un.set(i, { display: "none" }), (a.src = ""), t.play();
                  });
                })();
            },
          },
          { key: "onLeave", value: function () {} },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function rl(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var sl = (function (t) {
      _s()(i, t);
      var e = rl(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          { key: "onEnter", value: function () {} },
          {
            key: "onEnterCompleted",
            value: function () {
              Po(),
                a("https://api.yotpo.com/v1/apps/FN4jduiCHaequfB7kCGCmZZjat6gCW3mCYtnS87H/bottom_lines?count=100", { method: "GET", type: "json" }, function (t) {
                  for (var e = JSON.parse(t), i = e.response.bottomlines.length, a = 0, n = 0, r = 0; r < i; r++) (a += e.response.bottomlines[r].product_score), (n += e.response.bottomlines[r].total_reviews);
                  for (var s = Math.round((a / i) * 10) / 10, o = document.querySelector(".subscribe-hero .review-total"), l = '<div class="stars">', c = 0; c < Math.round(s); c++)
                    l +=
                      '<svg version="1.1" class="bolt-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 8 20" xml:space="preserve"><polygon points="6.8,0 0,11.7 3.7,11.1 1.6,20 8,8.4 4.7,8.7 "></polygon></svg>';
                  (l += "</div>\n\t\t\t\t<p>".concat(s, " | ").concat(n, " Reviews</p>\n\t\t\t")), (o.innerHTML = l);
                });
            },
          },
          { key: "onLeave", value: function () {} },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function ol(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var ll = (function (t) {
      _s()(i, t);
      var e = ol(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          {
            key: "onEnter",
            value: function () {
              var t = document.getElementById("mini-cart");
              t && (t.className += " hidden");
            },
          },
          {
            key: "onEnterCompleted",
            value: function () {
              var t = new Map();
              (t = Pl.cache).delete(window.location.href), (Pl.cache = t), Ll.bindCartEvents();
            },
          },
          { key: "onLeave", value: function () {} },
          {
            key: "onLeaveCompleted",
            value: function () {
              var t = document.getElementById("mini-cart");
              t && t.classList.remove("hidden");
            },
          },
        ]),
        i
      );
    })(m.Renderer);
    function cl(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var hl = null,
      ul = null,
      dl = 0;
    function pl(t) {
      for (var e = 0, i = 0; t && !isNaN(t.offsetLeft) && !isNaN(t.offsetTop); ) (e += t.offsetLeft - t.scrollLeft), (i += t.offsetTop - t.scrollTop), (t = t.offsetParent);
      return { top: i, left: e };
    }
    var fl = function (t) {
        var e = window.scrollY,
          i = 0,
          a = n().width <= 767 ? 110 : 155,
          r = document.querySelector(".blog-wrapper"),
          s = r.clientHeight,
          o = (e / (pl(r).top + s - n().height)) * 100,
          l = document.querySelector(".blog-progress-bar span");
        o <= 100 ? Un.set(l, { width: o + "%" }) : Un.set(l, { width: "100%" });
        for (var c = 0; c < hl.length; c++) e >= pl(hl[c]).top - a && (i = c);
        i !== dl && (ul[dl] && ul[dl].classList.remove("active"), ul[i].classList.add("active"), (dl = i));
      },
      ml = (function (t) {
        _s()(i, t);
        var e = cl(i);
        function i() {
          return zn()(this, i), e.apply(this, arguments);
        }
        return (
          Gn()(i, [
            { key: "onEnter", value: function () {} },
            {
              key: "onEnterCompleted",
              value: function () {
                var t, e;
                !(function () {
                  dl = -1e3;
                  var t = document.querySelector(".anchor-wrapper");
                  t &&
                    ((t.parentElement.style.height = t.clientHeight + 30 + "px"),
                    !(ul = document.querySelectorAll(".anchor-wrapper .buttons .button")) ||
                      ul.length <= 0 ||
                      ((hl = document.querySelectorAll(".blog-post-section-heading")),
                      window.addEventListener("scroll", fl, !1),
                      Array.prototype.slice.call(ul).forEach(function (t, e) {
                        t.addEventListener("click", function (i) {
                          if ((i.stopPropagation(), i.preventDefault(), !r("active", t))) {
                            var a = z.isGreaterThan767 ? 145 : 110;
                            _o.scrollTo(pl(hl[e]).top - a, 0.5);
                          }
                        });
                      })));
                })(),
                  (t = document.querySelector(".tag")),
                  (e = document.getElementById("overlay")),
                  t &&
                    t.addEventListener("click", function () {
                      Un.set(e, { display: "flex" });
                    }),
                  (function () {
                    var t = document.querySelector(".lightbox-close"),
                      e = document.getElementById("overlay");
                    t &&
                      t.addEventListener("click", function () {
                        Un.set(e, { display: "none" });
                      });
                  })(),
                  (function () {
                    var t = document.querySelector(".load");
                    if (t) {
                      var e = document.querySelector(".wide"),
                        i = document.getElementById("blog-reference");
                      t.addEventListener("click", function () {
                        var a = Array.prototype.slice.call(i.children, 0, 6);
                        a.length <= 5 && Un.set(t, { display: "none" }),
                          a.forEach(function (t) {
                            e.appendChild(t),
                              Un.fromTo(t, { duration: 0.5, y: 18 }, { stagger: 0.06, y: 0, ease: "sine.out", force3D: !0 }),
                              Un.fromTo(t, { duration: 0.48, opacity: 0 }, { stagger: 0.06, clearProps: "transform", opacity: 1, ease: "sine.out", force3D: !0 }, 0.21);
                          });
                      });
                    }
                  })(),
                  Po();
                var i = document.getElementsByClassName("share-trigger");
                Array.prototype.slice.call(i).forEach(function (t) {
                  "pinterest" == t.dataset.type &&
                    t.addEventListener("mouseenter", function (e) {
                      var i = t.clientWidth,
                        a = t.parentElement.clientWidth;
                      t.nextElementSibling && (t.nextElementSibling.style.left = (a - i) / 2 + 20 + "px");
                    }),
                    t.addEventListener("click", function (e) {
                      !(function (t) {
                        var e = t,
                          i = e.getAttribute("data-type"),
                          a = window.location.href,
                          r = e.parentElement.getAttribute("data-image"),
                          s = (e.parentElement.getAttribute("data-title"), e.parentElement.getAttribute("data-desc")),
                          o = (n().width - 575) / 2,
                          l = "status=1,width=575,height=570,top=" + (n().height - 570) / 2 + ",left=" + o;
                        switch (i) {
                          case "facebook":
                            var c = { method: "share", display: "popup", href: a };
                            "undefined" != typeof FB ? FB.ui(c, callback) : console.log("FB not defined");
                            break;
                          case "twitter":
                            var h = "https://twitter.com/intent/tweet/?text=" + encodeURIComponent(s) + "&url=" + a + "&via=DRINKSUPERCO";
                            window.open(h, "Share on Twitter", l);
                            break;
                          case "pinterest":
                            "undefined" != typeof PinUtils ? PinUtils.pinOne({ url: a, media: r, description: s }) : console.log("Pinterest not defined");
                            break;
                          default:
                        }
                      })(t);
                    });
                });
              },
            },
            {
              key: "onLeave",
              value: function () {
                window.removeEventListener("scroll", fl);
              },
            },
            { key: "onLeaveCompleted", value: function () {} },
          ]),
          i
        );
      })(m.Renderer);
    function gl(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var yl = (function (t) {
      _s()(i, t);
      var e = gl(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          { key: "onEnter", value: function () {} },
          { key: "onEnterCompleted", value: function () {} },
          { key: "onLeave", value: function () {} },
          { key: "onLeaveCompleted", value: function () {} },
        ]),
        i
      );
    })(m.Renderer);
    function vl(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var Al = (function (t) {
      _s()(i, t);
      var e = vl(i);
      function i() {
        return zn()(this, i), e.apply(this, arguments);
      }
      return (
        Gn()(i, [
          {
            key: "out",
            value: function (t) {
              t.from, t.trigger;
              var e = t.done;
              Un.set(K.header, { pointerEvents: "none" }),
                Un.fromTo(
                  K.globalMask,
                  0.3,
                  { autoAlpha: 0 },
                  {
                    autoAlpha: 1,
                    ease: "sine.inOut",
                    onComplete: function () {
                      e();
                    },
                  }
                );
            },
          },
          {
            key: "in",
            value: function (t) {
              var e = t.from,
                i = t.to,
                a = (t.trigger, t.done);
              (z.namespace = i.dataset.routerView), (document.body.scrollTop = 0), window.scroll(0, 0), e.remove(), (z.transitionFinished = !0), a();
            },
          },
        ]),
        i
      );
    })(m.Transition);
    function bl(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          a = Ds()(t);
        if (e) {
          var n = Ds()(this).constructor;
          i = Reflect.construct(a, arguments, n);
        } else i = a.apply(this, arguments);
        return Ms()(this, i);
      };
    }
    var wl = null,
      Cl = null,
      Sl = 0,
      kl = function (t) {
        for (var e = 0, i = 0; i < wl.length; i++) window.scrollY > wl[i].top - 200 && (e = i);
        e !== Sl && (Cl[Sl].classList.remove("active"), Cl[e].classList.add("active"), (Sl = e));
      },
      El = (function (t) {
        _s()(i, t);
        var e = bl(i);
        function i() {
          return zn()(this, i), e.apply(this, arguments);
        }
        return (
          Gn()(i, [
            { key: "onEnter", value: function () {} },
            {
              key: "onEnterCompleted",
              value: function () {
                setTimeout(function () {
                  var t;
                  (wl = Array.prototype.slice.call(document.querySelectorAll(".faq-content__section")).map(function (t) {
                    return t.getBoundingClientRect();
                  })),
                    (Cl = Array.prototype.slice.call(document.querySelectorAll(".faq-nav > div"))),
                    z.windowWidth < 768
                      ? (t = document.querySelector(".faq-dropdown select")).addEventListener("input", function (e) {
                          e.target.value.length > 0 && _o.scrollTo(wl[t.selectedIndex - 1].top - 160, 0.35);
                        })
                      : (function () {
                          window.addEventListener("scroll", kl);
                          for (
                            var t = document.querySelectorAll(".faq-nav button"),
                              e = function (e) {
                                t[e].addEventListener("click", function () {
                                  _o.scrollTo(wl[e].top - 180, 0.5);
                                });
                              },
                              i = 0;
                            i < t.length;
                            i++
                          )
                            e(i);
                        })();
                }, 500);
              },
            },
            {
              key: "onLeave",
              value: function () {
                window.removeEventListener("scroll", kl);
              },
            },
            { key: "onLeaveCompleted", value: function () {} },
          ]),
          i
        );
      })(m.Renderer);
    var Ol = i(24);
    (z.isMobile = Ol.any || ((/iPad|iPhone|iPod/.test(navigator.platform) || ("MacIntel" === navigator.platform && navigator.maxTouchPoints > 1)) && !window.MSStream)),
      z.isMobile && document.getElementsByTagName("html")[0].classList.add("touch"),
      z.reducedMotion &&
        window.matchMedia("(prefers-reduced-motion: reduce)").addEventListener("change", function () {
          z.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }),
      document.addEventListener(
        "DOMContentLoaded",
        function () {
          (z.windowHeight = n().height), (z.windowWidth = n().width), (z.isGreaterThan767 = z.windowWidth > 767 && !document.body.classList.contains("force-mobile")), Vo();
        },
        !1
      ),
      (window.onload = function () {
        Wo();
      });
    var Bl = setTimeout(function () {}, 0);
    (window.onresize = function () {
      clearTimeout(Bl),
        (Bl = setTimeout(function () {
          !(function () {
            var t = n().width,
              e = !1;
            z.windowWidth === t && z.isMobile && (e = !0), (z.windowHeight = n().height), (z.windowWidth = t);
            var i = 0.01 * z.windowHeight;
            switch ((e || document.body.style.setProperty("--vh", "".concat(i, "px")), document.body.style.setProperty("--vhu", "".concat(i, "px")), z.namespace)) {
              case "product-listing":
              case "product-category":
                ho();
            }
            if (!e) for (var a = 0; a < z.currentSliders.length; a++) z.currentSliders[a].resize();
            "add-something-positive" === z.namespace && to.resize(), "object" == y()(_o) && _o.resize(e);
          })();
        }, 250));
    }),
      (navigator.userAgent || navigator.vendor || window.opera).indexOf("Instagram") > -1 && (document.body.className += " instagram-browser force-mobile"),
      window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach),
      window.HTMLCollection && !HTMLCollection.prototype.forEach && (HTMLCollection.prototype.forEach = Array.prototype.forEach);
  },
]);
